import type { InterfaceAppString } from "./appStringTypes";

let AppStrings: InterfaceAppString = {

  // =====================================================================
  // PAM
  // =====================================================================
  PAM_APP_NAME: "Trivelta",
  PAM_GENERAL: "General",
  PAM_PRIMARY_CURRENCY_SHORTCODE_TOOLTIP: "Primary currency shortcode",
  PAM_AI: "AI",
  PAM_AI_ACTION_TOOLTIP:
    "Was this action completed by an AI tool using the MCP Connector",
  // Sidebar labels shared across product tabs (see src/utils/sidebarLabels.js)
  PAM_KPIS: "KPIs",
  PAM_COMPLIANCE: "Compliance",
  PAM_CONFIGURATIONS: "Configurations",
  PAM_REPORTING: "Reporting",
  PAM_MONITORING: "Monitoring",
  PAM_OPEN_NAVIGATION_MENU: "Open navigation menu",
  PAM_CLOSE_NAVIGATION_MENU: "Close navigation menu",
  PAM_STAFF_IP_ADDRESS: "IP Address",
  PAM_STAFF_IP_ADDRESS_PLACEHOLDER: "Enter IP Address",
  PAM_STAFF_IP_ADDRESS_INVALID: "Please enter a valid IPv4 or IPv6 address.",
  PAM_ACCESS_BLOCKED_IP: "PAM access blocked — IP not whitelisted",
  PAM_STAFF_IP_ADD_SUCCESS: "IP added successfully.",
  PAM_STAFF_IP_SEE_ALL: "See All",
  PAM_STAFF_IP_SEE_LESS: "See Less",
  PAM_IP_ACCESS_RESTRICTED_TITLE: "Access restricted",
  PAM_IP_ACCESS_RESTRICTED_DESCRIPTION:
    "Your IP address is not authorized to access this application. Contact your administrator.",
  PAM_IP_ACCESS_AFFILIATE_PROMPT: "Are you an Affiliate? Please click",
  PAM_IP_ACCESS_AFFILIATE_LINK: "here",
  PAM_CREATE_ACCOUNT: "Create Account",
  PAM_WITHDRAWN_PCT: "WITHDRAWN %",
  PAM_2FA_ENROLLMENT_TITLE: "Set up your Authenticator app",
  PAM_2FA_ENROLLMENT_DESCRIPTION:
    "Scan this QR code with your Authenticator app, then enter the six-digit code.",
  PAM_2FA_SCAN_QR_CODE: "Scan the QR code",
  PAM_2FA_MANUAL_KEY_LABEL: "Manual setup key",
  PAM_2FA_COPY_KEY: "Copy key",
  PAM_2FA_KEY_COPIED: "Key copied",
  PAM_2FA_CODE_LABEL: "Verification code",
  PAM_2FA_VERIFY: "Verify and continue",
  PAM_2FA_VERIFYING: "Verifying...",
  PAM_2FA_BACK_TO_LOGIN: "Back to login",
  PAM_2FA_COPY_FAILED: "The setup key could not be copied.",
  PAM_2FA_CHALLENGE_TITLE: "Enter your verification code",
  PAM_2FA_CHALLENGE_DESCRIPTION:
    "Enter the six-digit code from your Authenticator app.",
  PAM_2FA_LOST_DEVICE_HELP: "Lost your device? Contact an administrator.",
  PAM_2FA_CODE_MISMATCH: "The verification code is incorrect. Try again.",
  PAM_2FA_CODE_EXPIRED:
    "That code has expired. Enter the current code from your Authenticator app.",
  PAM_2FA_AUTH_SESSION_EXPIRED:
    "Your sign-in session expired. Enter your email and password again.",
  PAM_2FA_ENROLLMENT_TICKET_EXPIRED:
    "Your setup session expired. Enter your email and password again.",
  PAM_2FA_RATE_LIMITED:
    "Too many incorrect codes. Wait 15 minutes before trying again.",
  PAM_2FA_NOT_AVAILABLE:
    "Authenticator verification is unavailable. Please try again later.",
  PAM_2FA_FEATURE_DISABLED:
    "Authenticator setup is currently unavailable. Return to login and try again.",
  PAM_STAFF_RESET_MFA: "Reset two-factor authentication",
  PAM_STAFF_RESET_MFA_TITLE: "Reset two-factor authentication?",
  PAM_STAFF_RESET_MFA_DESCRIPTION:
    "Reset the Authenticator app for {staffName}?",
  PAM_STAFF_RESET_MFA_WARNING:
    "This will sign the staff member out of every session. They must set up their Authenticator app again the next time they sign in.",
  PAM_STAFF_RESET_MFA_CONFIRM: "Yes, reset 2FA",
  PAM_STAFF_RESET_MFA_RESETTING: "Resetting...",
  PAM_STAFF_RESET_MFA_SUCCESS:
    "Two-factor authentication was reset successfully.",
  PAM_STAFF_RESET_MFA_FAILED:
    "Two-factor authentication could not be reset. Please try again.",
  PAM_STAFF_2FA_STATUS: "2FA Status",
  PAM_STAFF_2FA_ENROLLED: "Enrolled",
  PAM_STAFF_2FA_NOT_ENROLLED: "Not enrolled",
  ADMIN_LOG_IN: "Admin Log In",
  EMAIL: "Email",
  PASSWORD: "Password",
  LOG_IN: "Log In",
  LANGUAGE_SELECTOR_LABEL: "Language",
  LANGUAGE_NAME_EN: "English",
  LANGUAGE_NAME_ES: "Español",
  LANGUAGE_NAME_DE: "Deutsch",
  LANGUAGE_NAME_PT_BR: "Português (Brasil)",
  EMAIL_PLACEHOLDER: "Email...",
  PASSWORD_PLACEHOLDER: "Password with 8 characters, symbol, #, and capital...",
  FIRST_NAME_PLACEHOLDER: "First name...",
  LAST_NAME_PLACEHOLDER: "Last name...",
  CUSTOMER_SUPPORT: "Customer Support",
  SUPER_ADMIN: "Super Admin",
  CREATE_ADMIN: "Create Admin",
  HELP_DESK_LIVE_CHAT_TOGGLE: "HelpDesk/LiveChat Toggle",
  SELECTED_MODE: "Selected Mode:",
  LIVE_CHAT: "LiveChat",
  HELP_DESK: "HelpDesk",
  EDIT_ADMIN: "Edit Admin",
  UPDATE_PERMISSIONS: "Update Permissions",
  REFERRAL_CODE_MESSAGE: "No data available yet for {code} referral code",
  DATE: "Date",
  AMOUNT: "Amount",
  REFERRAL_CODE: "Referral Code",
  MONEY_TYPE: "Money Type",
  SELECT_DATE_RANGE: "Select Date Range",
  LINE_GRAPH_BAR_LABLE: "Avg Life Time Value (LTV)",
  DAILY_FTDS: "Daily FTDs",
  REVENUE: "Revenue",
  MONTHLY_COMMISSION_BREAKDOWN: "Monthly Commission Breakdown",
  CPA: "Cpa",
  NUM_OWED_REFERRALS: "Num Owed Referrals",
  CPA_OWED: "Cpa Owed",
  TOTAL_SIGN_UPS: "Total Sign Ups",
  MONTHLY_SIGN_UPS: "Monthly Sign Ups",
  TOTAL_FDS: "Total FTDs",
  MONTHLY_FDS: "Monthly FTDs",
  TOTAL_COMMISSION_PAID_OUT: "Total Commission Paid Out",
  MONTHLY_COMMISSION_OWED: "Monthly Commission Owed",
  MONTHLY_LTV_PER_USER: "Monthly LTV Per User",
  STATISTICS: "Statistics",
  CLEAR_FILTERS: "Clear Filters",
  APPLY: "Apply",
  ACTIVE: "ACTIVE",
  HIDDEN: "HIDDEN",
  SEARCH: "Search",
  NOT_SELECTED: "Not Selected",
  PAM_FEATURE_QUICK_ACCESS: "Feature Quick Access",
  PAM_FEATURE_QUICK_ACCESS_TAB_CONFIGURATION: "Tab Configuration",
  PAM_CREATE_FEATURE: "Create Feature",
  PAM_EDIT_FEATURE: "Edit Feature",
  PAM_FEATURE_ID: "Feature ID",
  PAM_FEATURE_ID_HINT:
    "Lowercase letters, numbers, and underscores only — no spaces.",
  PAM_FEATURE_ID_DUPLICATE: "This ID already exists in the list.",
  PAM_FEATURE_ID_PLACEHOLDER: "e.g. my_feature",
  PAM_CREATE_FEATURE_DEV_NOTE:
    "Updates only PAM. The client app must support the new ID before the shortcut works. Feature creation is DEV only.",
  PAM_UPLOAD_ICON: "Upload Icon",
  PAM_DRAG_N_DROP_TO_UPLOAD_IMAGE: "Drag and drop to upload image",
  PAM_UPLOAD_ICON_SUPPORT_FORMATS: "Support: JPEG, JPG, PNG, SVG (max 512 KB)",
  PAM_UPLOAD_ICON_TOO_LARGE: "This image is too large — pick a smaller file.",
  PAM_FEATURE_QUICK_ACCESS_SAVE_SUCCESS: "Shortcuts saved.",
  PAM_FEATURE_QUICK_ACCESS_SAVE_ERROR: "Failed to save shortcuts",
  PAM_SHORTCUT_ICON_SESSION_EXPIRED:
    "Your session has expired — please log in again",
  PAM_SHORTCUT_ICON_UPLOAD_PERMISSION_DENIED:
    "You don't have permission to upload shortcut icons",
  PAM_SHORTCUT_ICON_UPLOAD_FAILED: "Failed to upload icon — please try again",
  PAM_SHORTCUT_ICON_INVALID_TYPE: "Icon must be a JPEG, JPG, PNG, or SVG",
  PAM_SHORTCUT_ICON_TOO_LARGE: "Icon must be {maxKb} KB or smaller",
  PAM_SHORTCUT_ICON_READ_FAILED: "Failed to read icon file",
  PAM_SHORTCUT_ICON_MISSING_URL: "Upload succeeded but no icon URL was returned",
  TODAY: "Today",
  YESTERDAY: "Yesterday",
  THIS_WEEK: "This Week",
  PRIOR_WEEK: "Prior Week",
  THIS_MONTH: "This Month",
  PRIOR_MONTH: "Prior Month",
  LAST_MONTH: "Last Month",
  LAST_3_MONTHS: "Last 3 Months",
  LAST_6_MONTHS: "Last 6 Months",
  LAST_12_MONTHS: "Last 12 Months",
  ALL_TIME: "All Time",
  DRAG_N_DROP_TO_UPLOAD_ICON: "Drag and drop to upload icon",
  DRAG_N_DROP_TO_UPLOAD_ICON_DESCRIPTION: "Upload icon size min 64x64px and max 120x120px. Support SVG, EPS, PNG",
  BROWSE_FILE: "Browse File",
  NEW_USERS: "New Users",
  AVERAGE_LTV: "Average LTV",
  CPA_AMOUNT: "CPA Amount",
  AFFILIATES: "Affiliates",
  NAME: "Name",
  CHURN_RATE: "Churn rate",
  TOTAL_WAGERS: "Total wagers",
  CHURN_RISK: "Churn Risk",
  NO_DATA: "No data",
  KEY_FEATURES_USAGE: "Key features usage",
  KEY_FEATURES_LABLE_1: "Rebet button",
  KEY_FEATURES_LABLE_2: "Social interactions",
  KEY_FEATURES_LABLE_3: "Easy to read lines",
  KEY_FEATURES_LABLE_4: "Peer to peer",
  VS_LAST_MONTH: "vs last month",
  CHANNEL_GROUPS_LABEL_1: "Direct",
  CHANNEL_GROUPS_LABEL_2: "Referral",
  CHANNEL_GROUPS_LABEL_3: "Organic Search",
  CHANNEL_GROUPS_LABEL_4: "Ads",
  CHANNEL_GROUPS_LABEL_5: "Email",
  CHANNEL_GROUPS_LABEL_6: "Socials",
  NUMBER_OF_USERS: "Number of Users",
  NEW_USERS_BY_CHANNEL_GROUP: "New users by channel group",
  REGISTERED_WITH_REFERRAL_CODE: "Registered with a referral code",
  REGISTERED_WITHOUT_REFERRAL_CODE: "Registered without a referral code",
  TOTAL_WAGERS_COUNT: "Total Wagers count",
  PROFIT_MARGINS: "Profit margins ($)",
  SPORT_PERFORMANCE_METRICS: "Sport performance metrics",
  TOP_SPORT: "Top Sport",
  TOP_GAMES: "Top Games",
  TOP_MARKETS: "Top Markets",
  SELECT_DOWN: "Select ▼",
  SELECT_UP: "Select ▲",
  SEARCH_REFERRAL_CODE: "Search Referral Code...",
  UNSELECT_ALL: "Unselect All",
  SELECT_ALL: "Select All",
  FIELD_IS_REQUIRED: "{title} is required.",
  NOTE_ACCORDING_TO_UPDATE: "Note according to the update",
  STATUS: "Status",
  STATUS_PENDING: "Pending",
  STATUS_APPROVED_INITIATED: "Approved / Initiated",
  STATUS_DECLINED: "Declined",
  // PAMENG-2535: Bitso penny-verification (CLABE verification) rows in the
  // user transactions table.
  PAM_STATUS_VERIFIED: "Verified",
  PAM_STATUS_INITIATION_FAILED: "Initiation Failed",
  PAM_VERIFICATION_DETAILS: "Verification Details",
  PAM_CLABE: "CLABE",
  PAM_HOLDER_NAME: "Holder Name",
  PAM_BITSO_PAYOUT_ID: "Bitso Payout ID",
  PAM_AML_FLAG: "AML Flag",
  PAM_AML: "AML",
  ACTIVITY: "Activity",
  ID: "ID",
  TOTAL_OWED: "Total Owed",
  AVERAGE_USERS_LTV: "Average Users LTV",
  TOTAL_FTDS: "Total FTDs",
  BETTORS_BETTING_BEHAVIOR: "Bettors betting behavior",
  BOTH: "Both",
  NEVER: "Never",
  DEVICE_TYPE_DISTRIBUTION: "Device type distribution",
  TOTAL_FREE_PLAY_CASH: "Total free play cash",
  TOTAL_FREE_CASH_PAID_OUT: "Total free cash paid out",
  TOTAL_COUNT: "Total trivelta free cash bets",
  TOTAL_WAGERED: "Total trivelta free cash wagered",
  KPIS: "Kpis",
  NET_OF_PURCHASES_AND_REDEMPTIONS: "Net of Purchases and Redemptions",
  TOTAL_PURCHASES: "Total Purchases",
  NET_DIFFERENCE: "Net difference",
  NON_WAGERED_APP_CASH: "Non-wagered Trivelta Cash",
  PURCHASE_APPROVAL_RATE: "Purchase Approval Rate",
  ALL: "All",
  TRANSACTIONS: "Transactions",
  PLATFORM: "Platform",
  DASHBOARD: "Dashboard",
  ADD_EVENT_CODE: "Add Event Code",
  EVENT_CODE: "Event Code",
  ENTER_8_DIGIT_EVENT_CODE: "Enter 8 digit event code",
  CREATING_EVENT: "Creating Event...",
  CREATE_EVENT: "Create Event",
  CODE: "Code",
  CREATED_BY: "Created By",
  UPDATED_AT: "Updated At",
  EVENTS: "Events",
  ADD_NEW_EVENT: "Add New Event",
  NEW_GAME: "New Game",
  GAME_NAME: "Game name",
  ADD_GAME: "Add Game",
  NO: "No",
  FEATURE_MANAGEMENT: "Feature Management",
  HTML_EDITOR: "HTML Editor",
  LEAVE_A_COMMENT: "Leave a comment",
  ADD_CODE: "Add Code",
  CANCEL: "Cancel",
  ADD: "Add",
  ADDED: "Added",
  CATEGORY_ROW: "categoryRow",
  INACTIVE: "Inactive",
  CATEGORY_ROW_2: "categoryRow2",
  FAILED_TO_UPDATE_GAME_ICON: "Failed to update game icon. Please try again.",
  PLEASE_UPLOAD_AN_ICON: "Please upload an icon",
  EDIT_GAME_ICON: "Edit Game Icon",
  SAVE_ICON: "Save Icon",
  REMOVE_THIS_GAME: "remove this game?",
  YES_REMOVE: "Yes, Remove",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE: " Are you sure you want to remove {game.name} from the {name} category?",
  DISABLED: "Disabled",
  NEW_CATEGORY: "New Category",
  ADD_CATEGORY: "Add Category",
  PLEASE_ENTER_A_CATEGORY_NAME: "Please enter a category name",
  FAILED_TO_SUBMIT_CATEGORY: "Failed to submit category. Please try again.",
  CATEGORY_NAME: "Category Name",
  NEW_COLLECTION: "New Collection",
  ADD_COLLECTION: "Add Collection",
  ERROR_TOGGLING_GAME_STATUS: "Error toggling game status",
  ADD_SPORT: "Add Sports",
  ALL_SPORTS: "All Sports",
  SELECT_A_SPORT_FIRST: "Select a sport first",
  SUBMIT_CHANGES: "Submit Changes",
  CATEGORIES: "Categories",
  COLLECTIONS: "Collections",
  LIVE: "Live",
  SPORT: "Sport",
  COUNTRY: "Country",
  LEAGUE: "League",
  MARKET: "Market",
  ICON: "Icon",
  ORDER: "Order",
  ENAME: "Ename",
  IS_ACTIVE: "Is Active",
  BLANK: "Blank",
  BONUS_PAID_OUT: "Bonus Paid Out",
  NUMBER_OF_FREEBETS_PLACED: "Number Of Freebets Placed",
  UNPLACED_FREEBETS: "Unplaced Freebets",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
  NUM_SPORTRADAR_BETS_BY_DAY: "Num Sportradar Bets By Day",
  NO_DATA_AVAILABLE: "No data available",
  PROFIT_BOOST_PAID_OUT: "Profit Boost Paid Out",
  NUMBER_OF_PROFIT_BOOSTS_PLACED: "Number Of Profit Boosts Placed",
  UNPLACED_PROFIT_BOOSTS: "Unplaced Profit Boosts",
  TOTAL_SPORTRADAR_WAGERS_BY_DAY: "Total Sportradar Wagers By Day",
  PURCHASES: "Purchases",
  COMPOSITE_FINANCIALS: "Composite Financials",
  NMI: "NMI",
  IF_PURCHASE_IS: "If purchase is",
  LESS: "Less",
  GREATER: "Greater",
  AND_IF_PURCHASE_IS: "And if purchase is",
  THAN: "Than",
  TOTAL_REVENUE: "Total Revenue",
  TOTAL_REDEEMABLE_AMOUNT: "Total Redeemable Amount",
  USERS: "Users",
  BETS: "Bets",
  FINANCIALS: "Financials",
  ACQUISITION: "Acquisition",
  STATES: "States",
  USERNAME: "Username",
  ATTEMPTS: "Attempts",
  REASON: "Reason",
  SEARCH_USER: "Search user...",
  CASH_IN: "Cash In",
  CASH_OUT: "Cash Out",
  COUNT: "Count",
  STATE: "State",
  TRANSACTIONS_BY_DAY: "Transactions By Day",
  TRANSACTIONS_BY_MONTH: "Transactions By Month",
  VERIFIED: "Verified",
  PENDING: "Pending",
  EMAIL_STATUS_BY_DAY: "Email Status By Day",
  CANCELED: "Canceled",
  EXPIRED: "Expired",
  NOT_VERIFIED: "Not Verified",
  PENDING_REVIEW: "Pending Review",
  TOTAL_USERS: "Total Users",
  FAILED: "Failed",
  USER_ID: "User ID",
  LOCATION: "Location",
  TIME: "Time",
  NOT_ACCEPTED: "Not Accepted",
  TERMS_OF_USE: "Terms of Use",
  PREV: "Prev",
  NEXT: "Next",
  DISABLE_THE_LOCATION_QUESTION: "Disable the location?",
  MAKE_SURE_THE_DECISION_IS_CORRECT_AND_DESCRIBE_THE_REASON_FOR_IT: "Make sure the decision is correct and describe the reason for it",
  ADD_NOTE: "Add note",
  YES_DISABLE: "Yes, Disable",
  REDEMPTION_RESTRICTIONS: "Redemption restrictions",
  ABILITY: "Ability",
  LOCATION_RESTRICTIONS: "Location Restrictions",
  CLICK_HERE: "Click here",
  DATE_TIME: "Date / Time",
  DESCRIPTION: "Description",
  ENTRY_TYPE: "Entry Type",
  MANAGER: "Manager",
  AGENT: "Agent",
  USER: "User",
  MANUAL_ENTRIES: "Manual Entries",
  MOVEMENT: "Movement",
  SUPPORT_AGENT: "Support Agent",
  TOTAL_VALUE: "Total Value",
  LOAD_MORE: "Load More",
  AFFILIATE_LIST: "Affiliate List",
  AFFILIATE_KPIS: "Affiliate KPIs",
  INDIVIDUALIZED_STATS: "Individualized Stats",
  SEARCH_NAME_CODE: "Search name, code...",
  ACTION_NETWORK: "Action Network",
  BARSTOOL_SPORTS: "Barstool Sports",
  RALPH_EDWARDS: "Ralph Edwards",
  BETQL: "BetQL",
  ROTOWORLD: "Rotoworld",
  NOT_CURRENTLY_AVAILABLE_FOR_MOBILE: "Unfortunately, this application is not current available on mobile devices, or destops below a certain width.",
  PLEASE_OPEN_IN_A_LARGER_WINDOW_TO_CONTINUE: "Please open in a larger window to continue!",
  TRANSACTION_DELETED_SUCCESSFULLY: "Transaction deleted successfully.",
  ERROR_DELETING_TRANSACTION: "Error deleting transaction.",
  DELETE_SELECTED_ROW_USERNAME_TRANSACTION: "Delete {selectedRow.username}'s transaction",
  I_UNDERSTAND_THAT_THIS_IS_PERMANENT: "I understand that this is permanent.",
  DELETING: "Deleting...",
  DELETE: "Delete",
  FETCHING: "Fetching...",
  PAYOUT_COMPLETED: "Payout completed.",
  PAYOUT_INITIATED_THIS_WILL_UPDATE_AUTOMATICALLY: "Payout initiated. This will update automatically.",
  PAYOUT_FAILED: "Payout failed.",
  USERS_AFFECTED: "Users affected",
  TOTAL_AMOUNT: "Total amount",
  TOTAL_TRANSACTIONS: "Total transactions",
  REMAINING_TRANSACTIONS: "Remaining transactions",
  PAYOUT_USERS: "Payout users",
  AMOUNT_DOLLAR: "Amount ($)",
  ACTION: "Action",
  ACCEPT_DECLINE: "Accept/Decline",
  CURRENT_STATUS: "Current Status",
  ENTER_REASON: "Enter reason",
  DECLINE: "Decline",
  ACCEPT: "Accept",
  SEARCH_BY: "Search by",
  REDEMPTION_MANUAL_REVIEW_TRACKING: "Redemption Manual Review Tracking",
  FAILURE_REASON: "Failure Reason",
  FEE: "Fee",
  SALES_TAX: "Sales Tax",
  PURPOSE: "Purpose",
  TRANSACTION_LOG: "Transaction Log",
  COMPLETED: "Completed",
  IN_PROGRESS: "In Progress",
  NEW_NOTE: "New Note",
  CLOSE: "Close",
  SAVE: "Save",
  EDIT_NOTE: "Edit Note",
  EDITED: "edited",
  PERSONAL_INFO: "Personal Info",
  USER_NAME: "User Name",
  FIRST_NAME: "First name",
  LAST_NAME: "Last name",
  PHONE: "Phone",
  DATE_OF_REGISTRATION: "Date of Registration",
  RANK: "Rank",
  NOTES: "Notes",
  ADDRESS: "Address",
  DETAILS: "Details",
  FRAUD_NOTE: "Fraud Note",
  USER_BALANCE: "User Balance",
  USER_ACTIVITY: "User Activity",
  PROMOTION_NAME: "Promotion Name",
  BONUS_TYPE: "Bonus Type",
  PURCHASE_PRICE: "Purchase Price",
  BONUS_RECEIVED: "Bonus Received",
  ALL_ACTIVITY: "All Activity",
  FRAUDULENT_OPERATIONS: "Fraudulent Operations",
  AGREEMENTS: "Agreements",
  PROMO: "Promo",
  USER_SUSPENSION: "User Suspension",
  SUSPECTED_ACTIVITY: "Suspected Activity",
  SPAMMING: "Spamming",
  FRAUD: "Fraud",
  OTHER: "Other",
  USER_DELETION: "User Deletion",
  DO_YOU_REALLY_WANT_TO_DELETE_THIS_USER: "Do you really want to delete this user?",
  YES: "Yes",
  TOTAL: "Total",
  PRIZE: "Prize",
  REDEMPTIONS: "Redemptions",
  LIFETIME: "Lifetime",
  VALUE: "Value",
  SUSPEND: "Suspend",
  FREE_CASH: "Free Cash",
  LIMITS: "Limits",
  NO_LIMITS: "No limits",
  ADD_LIMITS: "Add Limits",
  FINANCE: "Finance",
  IOS_PUSH: "IOS Push",
  SENDING_INFO: "Sending Info",
  EDIT_EMAIL_BODY: "Edit Email Body",
  EDIT_SENDING_INFO: "Edit Sending Info",
  FROM: "From",
  SUBJECT: "Subject",
  YOUR_EMAIL_BODY_UNSUBSCRIBE_LINK_MESSAGE: "Your email body does not include an unsubscribe link. This is required by law on all marketing emails. We recommend including Liquid tag:",
  FOR_MORE_INFO_SEE_OUR_DOCUMENTATION: "For more info, see our",
  DOCUMENTATION: "documentation",
  EMAIL_VARIANTS: "Email Variants",
  SAVE_AS_TEMPLATE: "Save As Template",
  VARIANT_1: "Variant 1",
  ADD_NEW: "Add new",
  SELECT_YOUR_EDITING_EXPERIENCE: "Select Your Editing Experience",
  CREATE_YOUR_IDEAL_EMAIL_WITH_OUR_HTML_EDITOR: "Create your ideal Email with our HTML Editor",
  FEATURE_RICH_HTML_EDITING_WITH_VISUAL_PREVIEW: "Feature-rich HTML editing with visual preview",
  COMMUNICATION_PREVIEW: "Communication Preview",
  NOTIFICATION: "Notification",
  LEARN_MORE: "Learn more",
  NOTIFICATION_TITLE: "Notification title",
  NOTIFICATION_MESSAGE: "Notification message",
  CALL_TO_ACTION: "Call to action",
  SELECT_ACTION: "Select Action",
  HIGHLIGHT_TEXT: "Highlight text",
  ACTION_1: "Action 1",
  ACTION_2: "Action 2",
  ACTION_3: "Action 3",
  PROMO_VARIANTS: "Promo Variants",
  BONUS_TIME_FRAMES: "Bonus Time Frames",
  ALLOCATED_TIME_TO_MAKE_A_PURCHASE: "Allocated Time To Make a Purchase",
  HOURS_OR_DAYS: "Hours or Days",
  BET_TYPES: "Bet Types",
  ELIGIBLE_BET_TYPE: "Eligible bet type",
  PREMATCH_LIVE: "Prematch/Live",
  MIN_LEGS: "Min. legs",
  MAX_LEGS: "Max. legs",
  TEAMS: "Teams",
  MIN_ODDS: "Min. odds",
  MAX_ODDS: "Max. odds",
  TIME_BASED_SCHEDULING_OPTIONS: "Time-Based Scheduling Options",
  SEND_AS_SOON_AS_PROMO_IS_LAUNCHED: "Send as soon as Promo is launched",
  SEND_AT_A_DESIGNATED_TIME: "Send at a designated time",
  HOW_OFTEN_TO_SEND: "How often to send?",
  SCHEDULED: "Scheduled",
  ACTION_BASED: "Action-Based",
  ENTER_PLAYERS_AT: "Enter players at",
  ENTER_PLAYER_WHEN_THEY: "Enter player when they",
  PERFORM_ACTIONS: "perform actions",
  SEND_PROMO_TO_PLAYERS_IN_THEIR_LOCAL_TIME_ZONE: "Send Promo to players in their local time zone",
  NEXT_SEND_TIME: "Next send time:",
  DELIVERY_CONTROLS: "Delivery Controls",
  NO_UPCOMING_MESSAGES_SCHEDULED: "No upcoming messages scheduled.",
  MANAGE_THE_NUMBER_OF_MESSAGES_YOUR_PLAYERS_WILL_RECEIVE: "Manage the number of messages your players will receive.",
  ALLOW_PLAYERS_TO_BECOME_RE_ELIGIBLE_TO_RECEIVE_PROMO: "Allow players to become re-eligible to receive promo",
  FREQUENCY_CAPPING: "Frequency Capping",
  YOU_HAVE_NOT_CREATED_ANY_FREQUENCY_CAPPING_RULES: "You have not created any Frequency Capping rules.",
  MANAGE_FREQUENCY_CAPPING_RULES: "Manage frequency capping rules.",
  CHOOSE_A_TIME_FOR_PLAYERS_TO_RECEIVE_THIS_MESSAGE: "Choose a time for players to receive this message.",
  DESIGNATED_TIMES: "Designated times",
  PROMO_DESCRIPTION: "Get +100% on your Trivelta Coins Bundle! Unlock Savings on Trivelta Cash Purchase!",
  END_DATE: "End date",
  PROMO_DETAILS: "Promo Details",
  ENTER_CAMPAIGN_NAME: "Enter Campaign Name",
  SUMMARY: "Summary",
  START_DATE: "Start date",
  EXPIRATION_PERIOD: "Expiration Period (Days)",
  MIN_BONUS_AMOUNT: "Min. bonus amount",
  MAX_BONUS_AMOUNT: "Max. bonus amount",
  MESSAGING: "Messaging",
  CHANNELS: "Channels",
  EDIT: "Edit",
  AND: "and",
  PURCHASE_MATCH: "Purchase Match",
  SHOW_MORE: "Show more",
  TARGET_AUDIENCES: "Target Audiences",
  TARGETING_OPTIONS: "Targeting Options",
  A_B_TESTING: "A/B Testing",
  TARGET_PLAYERS_BY_SEGMENT: "Target Players by Segment",
  PLAYERS_LOCATION: "Players Location",
  SCHEDULED_DELIVERY: "Scheduled Delivery",
  ADDITIONAL_FILTERS: "Additional filters",
  HAS_CONTROL_GROUP: "Has Control Group",
  CONTROL_GROUP: "Control Group",
  PROGRESSIVE_BOOST: "Progressive boost",
  SPORTS: "Sports",
  PROMOTION_TYPE: "Promotion Type",
  PREFORM_LIVE: "Prematch/Live",
  PLAYERS_RECEIVED: "Players Received",
  PLAYERS_USED_BETS: "Players Used (Bets)",
  PROMO_USAGE: "Promo Usage",
  PROMO_PARTICIPANTS: "Promo Participants",
  SEARCH_BY_EMAIL: "Search by email",
  EVENT_USED_ON: "Event Used On",
  PLAYER_ID: "Player ID",
  PLAYER_NAME: "Player Name",
  BONUS_AMOUNT: "Bonus Amount",
  TRANSACTION_DATES: "Transaction Dates",
  PROFIT: "Profit",
  PAID_OUT: "Paid out",
  FINISH_PROMO: "Finish Promo",
  FREE_SQUARES: "Free Squares",
  PROFIT_BOOST: "Profit Boost",
  INSURANCE_BETS: "Insurance Bets",
  PLAYERS_USED: "Players Used",
  PURCHASES_BY_TYPE: "Purchases by Type",
  PAM_PROMOTIONS: "Promotions",
  PROMOTIONS_MANAGEMENT: "Promotions Management",
  CREATE_NEW_PROMO_NOTIFICATION: "Create New Promo/Notification",
  CREATE_NEW_PROMO_NOTIFICATION_DESCRIPTION: "Create a new multi channel messaging campaign with the ability to add/send a promotion",
  ALL_PROMOTIONS: "All Promotions",
  SEARCH_BY_ID: "Search by ID",
  WAGERED: "Wagered",
  RECEIVED: "Received",
  ACTIVATED: "Activated",
  VOLUME: "Volume",
  BONUSES: "Bonuses",
  MAX_FREE_PLAY_CASH: "Max Free Play Cash",
  REFERRER_BONUS_AMOUNT: "Referrer Bonus Amount",
  UPDATE_VALUES: "Update Values",
  REPORTER: "Reporter",
  REPORTED_USER: "Reported User",
  REPORTER_MESSAGE: "Reporter Message",
  CONTEXT_BEFORE: "Context Before",
  CONTEXT_AFTER: "Context After",
  NO_REPORTS_YET: "There are no reports yet.",
  TOTAL_STAKE: "Total Stake",
  P_L: "P&L",
  MARGIN: "Margin",
  FILTERS_CLEARED: "Filters cleared.",
  FILTERS_APPLIED: "Filters applied.",
  LATEST_BETS_LIST: "Latest Bets List",
  EVENTS_LIST: "Events List",
  MATCH: "Match",
  MIN_BET_AMOUNT: "Min Bet Amount",
  BET_TYPE: "Bet Type",
  MARKET_TYPE: "Market Type",
  MIN_CCF: "Min CCF",
  MAX_CCF: "Max CCF",
  PRE_MATCH_LIVE: "Pre-match/Live",
  STRAIGHT: "Straight",
  ROUND_ROBIN: "Round Robin",
  GROUPED: "Grouped",
  CASH: "Cash",
  COIN: "Coin",
  PRE_MATCH: "Pre-match",
  FIVE_HUNDRED_TO_SIX_HUNDRED: "500 - 600",
  MONEYLINE: "Moneyline",
  SPREAD: "Spread",
  POTENTIAL_PAYOUT: "Potential Payout",
  BET_AMOUNT: "Bet Amount",
  CCF: "CCF",
  SELECTION: "Selection",
  BET_STATUSES: "Bet Statuses",
  BETS_TYPES_LIST: "Bets Types List",
  FILTER_BY: "Filter by",
  MONTHLY_FTDS: "Monthly FTDs",
  ACTIONS: "Actions",
  SUSPENDED: "Suspended",
  SEARCH_USERS: "Search users...",
  APP_USERS: "Trivelta Users",
  DELETE_USER: "Delete User",
  ENTER_USERNAME: "Enter username",
  DELETING_USER: "Deleting User...",
  USER_DELETED_SUCCESSFULLY: "User deleted successfully!",
  ERROR_DELETING_USER: "Error deleting user. Please try again.",
  UTC: "UTC",
  ALT_ODDS: "Alt Odds",
  TYPE: "Type",
  ODDS: "Odds",
  WAGER: "Wager",
  PAYOUT: "Payout",
  EDIT_BET: "Edit Bet",
  BET_ID: "Bet ID",
  SETTLEMENT_STATUS: "Settlement Status",
  CHANGE_TO: "Change To",
  FROM_TO: "from to",
  ADD_SUBTRACT: "Add/Subtract",
  MARKET_TYPES: "Market Types",
  TEAM_PERFORMANCE: "Team Performance",
  BETTING: "Betting",
  PROFITABILITY: "Profitability",
  WINNINGS_ODDS: "Winnings Odds",
  BACK_TO_EVENTS: "Back To Events",
  DATE_AND_TIME: "Date & Time",
  SPORTS_CATEGORY: "Sports Category",
  EVENT_KPI: "Event KPI",
  EVENT_TYPE: "Event Type",
  LEAGUE_DISTRIBUTION_BY_BETS: "League distribution by Bets",
  MARGIN_BY_BET_TYPE: "Margin by Bet Type",
  SINGLE: "Single",
  NUMBER_OF_BETS_BY_TYPE: "Number of Bets by Type",
  PREMATCH_VS_LIVE_STAKE_BREAKDOWN: "Prematch vs. Live Stake breakdown",
  PREMATCH_VS_LIVE_TICKET_BREAKDOWN: "Prematch vs. Live Ticket breakdown",
  SPORT_PERFORMANCE: "Sport Performance",
  SPORT_SELECTION_DISTRIBUTION: "Sport Selection Distribution",
  TICKET_LENGTH_BREAKDOWN: "Ticket Length Breakdown",
  TICKET_LENGTH_DISTRIBUTION: "Ticket Length Distribution",
  TOTAL_LIFECYCLE_STAGES: "Total - Lifecycle Stages",
  TURNOVER_BY_TYPE: "Turnover by Type",
  USERS_BY_STATE: "Users by State",
  TOTAL_EVENTS: "Total Events",
  PROFIT_AND_LOSS: "Profit & Loss",
  CASH_OUT_PROFIT_AND_LOSS: "Cash Out Profit and Loss",
  TURN_OVER_SMALL: "Turnover",
  FUTURE: "Future",
  TOTAL_BETS: "Total Bets",
  AVG_BET_AMOUNT: "Avg Bet Amount",
  PLAYERS_ENGAGED: "Players Engaged",
  NEW_ROUTE: "New Route",
  CARD: "Card",
  MIN_TRANSACTION_AMOUNT: "Min. transaction amount",
  MAX_TRANSACTION_AMOUNT: "Max. transaction amount",
  PLAYERS_FILTER: "Players filter",
  APPLY_FOR_ALL_PLAYERS: "Apply for all players",
  FILTER_BY_SEGMENTS: "Filter by segments",
  FILTER_BY_STATES: "Filter by states",
  PROCESSOR: "Processor",
  PERIOD: "Period",
  MIN_TRANSACTIONS: "Min. transactions",
  MAX_TOTAL_AMOUNT: "Max. total amount",
  ADD_PROCESSOR: "Add processor",
  USE_DEFAULT_PROCESSORS_PRIORITY_FOR_FURTHER_TRANSACTIONS: "Use default processors priority for further transactions",
  CREATE_ROUTE: "Create Route",
  REVENUE_UPPERCASE: "REVENUE",
  REDEEMABLE_CASH: "Redeemable Cash",
  PUSH2CARD_1_FEE: "Push2Card 1% Fee",
  REPORTS: "Reports",
  ALL_TRANSACTIONS: "All transactions",
  ACTION_REQUIRED: "Action required",
  MAX_BALANCE: "Max Balance",
  CREATE_NEW_ROUTE: "Create New Route",
  PROCESSORS: "Processors",
  PAM_AGENT_DASHBOARD: "PAM Agent Dashboard",
  CREATED_AT: "Created at",
  GROUP: "Group",
  EDIT_AGENT: "Edit Agent",
  ROLE: "Role",
  AGENT_DELETION: "Agent Deletion",
  DO_YOU_REALLY_WANT_TO_DELETE_THIS_ACCOUNT: "Do you really want to delete this account?",
  YES_DELETE: "Yes, Delete",
  AGENT_DELETED_SUCCESSFULLY: "Agent deleted successfully.",
  AGENT_UPDATED_SUCCESSFULLY: "Agent updated successfully!",
  ERROR_UPDATING_AGENT: "Error updating agent. Please try again",
  SEARCH_BETS: "Search bets...",
  SEARCH_BY_BET_ID: "Search by Bet ID",
  TOTAL_WAGER: "Total Wager",
  TOTAL_PAYOUT: "Total Payout",
  NET_REVENUE: "Net Revenue",
  BALANCE: "Balance",
  RESET_TABLE: "Reset Table",
  HAND_DETAILS: "Hand Details",
  SEARCH_BY_HAND_ID: "Search by Hand ID",
  HAND_ID: "Hand ID",
  ROUND_START_TIME: "Round Start Time",
  ROUND_END_TIME: "Round End Time",
  PLAYER_CARDS: "Player's Cards",
  PLAYER_HAND_COMBINATION: "Player's Hand Combination",
  DECISION: "Decision",
  LIST_EVERY_OTHER_PLAYER: "List Every Other Player",
  CARDS: "Cards",
  HAND_COMBINATION: "Hand Combination",
  WINNER_1: "Winner 1",
  WINNER_1_PAYOUT: "Winner 1 Payout",
  WINNER_2: "Winner 2",
  WINNER_2_PAYOUT: "Winner 2 Payout",
  COMMUNITY_CARDS: "Community Cards",
  USERNAME_GAME_HANDS: "{username}'s Game Hands",
  SEARCH_BY_GAME_ID: "Search by Game ID",
  TOTAL_BUY_IN: "Total Buy in",
  TOTAL_CASH_OUT: "Total Cash Out",
  PLAYER_NET_REVENUE: "Player Net Revenue",
  GAME_ID: "Game ID",
  START_TIME: "Start Time",
  PLAYER_JOIN_TIME: "Player join time",
  LEAVE_TIME: "Leave time",
  BUY_IN_AMOUNT: "Buy in amount",
  CASHOUT_AMOUNT: "Cashout amount",
  NICKNAME: "Nickname",
  SEAT_NUMBER: "Seat Number",
  NUMBER_OF_HANDS_PLAYED: "Number of Hands played",
  GAME_TURNOVER: "Game Turnover",
  GAME_P_L: "Game P&L",
  TIMESTAMP: "Timestamp",
  USERNAME_TRANSACTIONS: "{username}'s Transactions",
  SEARCH_TRANSACTIONS: "Search transactions...",
  TRANSACTION_METHOD: "Transaction Method",
  TOTAL_PURCHASED: "Total Purchased",
  REVENUE_KPI_TOOLTIP: "Total Purchased minus Total Withdrawn",
  DID_USERNAME_LEAVE_A_WRITTEN_REVIEW_ON_THE_APP_STORE: "Did {username} leave a written review on the app store?",
  APP_STORE_WRITTEN_REVIEW: "App Store Written Review",
  FAILED_TO_UPDATE_FEATURE_FLAG: "Failed to update feature flag.",
  NO_EXPIRATION_DATE_AVAILABLE: "No expiration date available",
  PROMOTION_SUCCESSFULLY_DELETED: "Promotion successfully deleted.",
  ERROR_DELETING_PROMOTION: "Error deleting promotion.",
  TO_CONFIRM_TYPE_DELETE_PROMOTION_IN_THE_BOX_BELOW: "To confirm, type \"delete promotion\" in the box below",
  AND_PRESS_ENTER: "and press ENTER",
  AVAILABLE_PROMOTIONS: "Available Promotions",
  CARD_DELETED_SUCCESSFULLY: "Card deleted succesfully!",
  ERROR_DELETING_CARD: "Error deleting card. Try again.",
  ALL_CARDS_DELETED_SUCCESSFULLY: "All cards deleted succesfully!",
  ERROR_DELETING_CARDS: "Error deleting cards. Try again.",
  CREDIT_CARDS: "Credit Cards",
  NO_CARDS_AVAILABLE: "No cards available",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CARD: "Are you sure you want to delete this card?",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALL_CARDS: "Are you sure you want to delete all cards?",
  DELETE_ALL_CARDS: "Delete All Cards",
  DELETE_USERNAME_ACCOUNT: "Delete {username}'s Account",
  USERNAME_EDITED_SUCCESSFULLY: "Username edited successfully!",
  EDIT_USERNAME: "Edit {username}",
  BIO: "Bio...",
  PHONE_NUMBER_INCLUDE_PLUS_CODE: "Phone number (include + code)...",
  USER_EMAIL: "User's email...",
  EDIT_USER: "Edit User",
  REDEEMABLE_BALANCE: "Redeemable Balance",
  TO: "to",
  I_WANT_TO: "I want to",
  EXPIRATION_TIME_FORMAT: "Expiration Time Format",
  HOURS: "Hours",
  DAYS: "days",
  EXPIRATION_TIME: "Expiration Time",
  ERROR_PROCESSING_REQUEST: "There was an error processing your request. Please try again.",
  DELETE_ALL: "Delete All",
  BACK: "Back",
  LIMITS_UPDATED_SUCCESSFULLY: "Limits updated successfully.",
  MAX_PURCHASE_AMOUNT_OF: "Max purchase amount of",
  MAX_NUMBERS_OF_DAYS_YOU_PLAY: "Max numbers of days you play",
  THE_GAMES_PER_WEEK: "the games per week",
  MAX_TIME_YOU_SPEND_PLAYING_PER_DAY: "Max time you spend playing per day",
  TIME_LIMITS: "Time Limits",
  EDIT_TIME_LIMITS: "Edit Time Limits",
  EDIT_CURRENCY_LIMITS: "Edit Currency Limits",
  EDIT_WAGGER_LIMITS: "Edit Wagger Limits",
  EDIT_LOSS_LIMITS: "Edit Loss Limits",
  MAX_NUMBERS_OF_DAYS_YOU_PLAY_THE_GAMES_PER_WEEK: "Max numbers of days you play the games per week",
  LOSS_LIMITS: "Loss Limits",
  WAGGER_LIMITS: "Wagger Limits",
  CURRENCY_LIMITS: "Currency Limits",
  DEFAULT: "Default",
  ADD_PROFIT_BOOST: "Add Profit Boost",
  PERCENTAGE: "Percentage",
  EXPIRY_HOURS: "Expiry hours",
  MINIMUM_PARLEY_LEGS: "Minimum Parley Legs",
  PROFIT_BOOST_ADDED_SUCCESSFULLY: "Profit Boost added successfully.",
  SUSPEND_UNSUSPEND: "Suspend/Unsuspend",
  ACTIVATE: "Activate",
  NOT_SUSPENDED: "Not Suspended",
  TOGGLE_ACH: "Toggle ACH",
  TURN_OFF: "Turn Off",
  TURN_ON: "Turn On",
  PERSONAL_LIMITS: "Personal Limits",
  GENERAL_INFO: "General Info",
  REFERRAL_CODE_USED: "Referral Code (Used)",
  REFERRAL_CODE_OWN: "Referral Code (Own)",
  FULL_NAME: "Full Name",
  SIGN_UP_DATE: "Sign Up Date",
  FTD_DATE: "FTD Date",
  NUM_REFERRALS: "Num Referrals",
  NUM_FOLLOWERS: "Num Followers",
  NUM_REBETS: "Num Rebets",
  BACK_TO_USERS: "Back To Users",
  OVERVIEW: "Overview",
  USER_STATUS: "User Status",
  EMAIL_STATUS: "Email Status",
  NEW_TOU: "New TOU",
  DEVICE_TYPE: "Device Type",
  REGISTRATION_DATE: "Registration Date",
  PLAYERS_LIST: "Players List",
  LAST_ENTRY: "Last Entry",
  LIMITATIONS: "Limitations",
  RESULT_PER_PAGE: "Result per page",
  SEARCH_TIMEZONES_PLACEHOLDER: "Search timezones",
  SET_TIME_ZONE: "Set Time Zone",
  RULES_TITLE: "Withdrawal Review Rules",
  PENDING_TAB: "Pending Requests",
  PROCESSED_TAB: "Processed Requests",
  REQUEST_DATE: "Request Date",
  PROCESSED_DATE: "Processed Date",
  TRANSACTION_ID: "Transaction ID",
  CARD_BANK_INFO: "Card/Bank Info",
  REQUEST_BEING_PROCESSED: "Your request is being processed.",
  DECLINE_MODAL_TITLE: "Decline Withdrawal",
  ENTER_REASON_PLACEHOLDER: "Enter reason",
  MODAL_TITLE: "Withdrawal Transaction",
  CARDHOLDER_NAME: "Cardholder's name",
  CARD_NUMBER: "Card number",
  PROCESSED_BY: "Processed By",
  RULES_MIN_TRX_AMOUNT: "Min Trx Amount",
  RULES_MAX_TRX_AMOUNT: "Max Trx Amount",
  RULES_NUMBER_OF_TRX: "Number of Trx",
  RULES_CREATED: "Created",
  ADD_NEW_RULE_BUTTON: "Add New Rule",
  CREATING_NEW_RULE_TITLE: "Creating New Rule",
  CONDITIONS_TITLE: "Conditions",
  RULE_NAME_PLACEHOLDER: "Enter rule name",
  MIN_TRANSACTION_PLACEHOLDER: "e.g. 10",
  MAX_TRANSACTION_PLACEHOLDER: "e.g. 500",
  NUMBER_OF_TRANSACTIONS_PLACEHOLDER: "e.g. 3",
  SELECT_PERIOD_PLACEHOLDER: "Select period",
  CREATE_BUTTON: "Create",
  EDIT_RULE_TITLE: "Edit Rule",
  SAVE_CHANGES_BUTTON: "Save Changes",
  SUSPEND_BUTTON: "Suspend",
  RULE_ADDED_TOAST: "Withdrawal Review Rule Added",
  RULE_UPDATED_TOAST: "Withdrawal Review Rule Updated",
  RULE_DELETED_TOAST: "Withdrawal Review Rule Deleted",
  RULE_SUSPENDED_TOAST: "Withdrawal Review Rule Suspended",
  SUMMARY_MIN_TRANSACTION_AMOUNT: "Min Transaction Amount",
  SUMMARY_MAX_TRANSACTION_AMOUNT: "Max Transaction Amount",
  SUMMARY_NUMBER_OF_TRANSACTIONS: "Number of Transactions",
  PERIOD_SINGLE_TRANSACTION: "Single Transaction",
  PERIOD_HOUR: "Hour",
  PERIOD_DAY: "Day",
  PERIOD_WEEK: "Week",
  PERIOD_MONTH: "Month",
  PERIOD_YEAR: "Year",
  PERIOD_ALL_TIME: "All Time",
  COUNTRY_CURRENCY_SYMBOL: "",
  DEPLOYED_BUILDS: "Deployed Builds",
  MARKETS: "Markets",
  EVENT: "Event",
  CREATE_NEW_SGP: "Create New SGP",
  MATCH_DETAILS: "Match Details",
  MATCH_DATE: "Match Date",
  NUMBER_OF_LEGS: "Number of Legs",
  LEG_DETAILS: "Leg Details",
  CLEAR: "Clear",
  MONEYLINE_INCL_OVERTIME: "Moneyline (incl. overtime)",
  TOTAL_POINTS: "Total Points",
  PLAYER_PROPS: "Player Props",
  TEAM_PROPS: "Team Props",
  TOTAL_ODDS: "Total Odds",
  STAKED_AMOUNT: "Staked Amount",
  BETS_BY_STATE: "Bets by State",
  ARCHIVE: "Archive",
  UPCOMING_SGPS: "Upcoming SGPs",
  LIVE_SGPS: "Live SGPs",
  SETTLED_SGPS: "Settled SGPs",
  HASH_BETS: "# Bets",
  STAKED: "Staked",
  PER_PAGE_OF_30000_EVENTS: "per page of 30,000 events",
  EXPOSURE_LIMIT_ON_MARKETS_BY_CCF_TITLE: "Exposure Limit on Markets by CCF",
  LIMITS_BY_SPORT_TITLE: "Limits by Sport",
  LIMITS_BY_LEAGUE_TITLE: "Limits by League",
  RANGES_LABEL: "Ranges",
  CCF_SCORE_LABEL: "CCF Score",
  DEFAULT_SGP_COMBO_LIMIT_LABEL: "Default SGP Combo Limit",
  LEAGUE_LABEL: "League",
  ADD_NEW_LIMIT_LABEL: "Add New Limit",
  LIMIT_UPDATED_SUCCESSFULLY: "Limit updated successfully",
  TOP_5_CATEGORIES: "Top 5 Categories",
  AT_RISK_PLAYERS_LEVEL: "At-risk players level",
  SPINS: "Spins",
  PROVIDER_DISTRIBUTION_BY_BETS: "Provider Distribution by Bets",
  THIS_YEAR: "This Year",
  LAST_YEAR: "Last Year",
  PROMOTIONS_DASHBOARD_LABEL: "Dashboard",
  PROMO_BUILDER_LABEL: "Promo Builder",
  BONUS_PLAYTHROUGH_POPOVER_TEXT: "Playthrough multiplier (e.g. 3x, 5x, 20x).",
  ADD_SHORTCUT: "Add Shortcut",
  NO_SHORTCUTS: "No shortcuts",
  DISPLAYED_NAME: "Displayed Name",
  ITEM: "Item",
  RENAME: "Rename",
  NO_ICON: "No icon",
  DRAG: "Drag",
  ICON_ALT: "{name} icon",
  DELETE_SHORTCUT: "Delete Shortcut",
  DELETE_SHORTCUT_CONFIRMATION: "Are you sure you want to delete this shortcut? This action cannot be undone.",
  RENAME_SHORTCUT: "Rename Shortcut",
  DISPLAY_NAME: "Display Name",
  DISPLAY_LOCATIONS: "Display Locations",
  DISPLAY_LOCATIONS_AUTOMATIC: "Automatic",
  DISPLAY_LOCATION_DISCOVER: "Discover",
  SHORTCUTS_REORDERED_SUCCESSFULLY: "Shortcuts reordered successfully",
  FAILED_TO_LOAD_SHORTCUTS: "Failed to load shortcuts",
  FAILED_TO_UPDATE_STATUS: "Failed to update status",
  SHORTCUT_DELETED: "Shortcut deleted",
  FAILED_TO_DELETE_SHORTCUT: "Failed to delete shortcut",
  SHORTCUT_RENAMED: "Shortcut renamed",
  FAILED_TO_RENAME: "Failed to rename",
  FAILED_TO_REORDER: "Failed to reorder",
  SHORTCUT_ACTIVATED: "Shortcut activated",
  SHORTCUT_DEACTIVATED: "Shortcut deactivated",
  BANNER_CREATION: "Banner Creation",
  PREVIEW: "Preview",
  NO_EXPIRATION_TIME: "No expiration time",
  SET_EXPIRATION_TIME: "Set expiration time",
  CHOOSE_LINK_TYPE: "Choose link type",
  SELECT_GAME: "Select game",
  USE_DEEP_LINK: "Use deeplink",
  USE_CODE: "Use code",
  REGION_STATES: "Region/States",
  SHOW_REGIONS: "Show regions",
  HIDE_REGIONS: "Hide regions",
  INCLUDED_REGIONS: "Included regions",
  TEXT: "Text",
  DEEP_LINK: "Deeplink",
  EXPIRATION_DATE: "Expiration date",
  DRAG_N_DROP_TO_UPLOAD_BANNER: "Drag and drop to upload banner",
  DRAG_N_DROP_TO_UPLOAD_BANNER_DESCRIPTION: "Upload here image size min 351x120 px and max 702x240 px. Supported formats: JPG, PNG.",
  SOCIAL_SIGNUP_PLATFORM: "Social Signup Platform",
  SHOW_COUNTDOWN: "Show count-down",
  LABEL_OPTIONAL: "Label (optional)",
  ALL_REGIONS: "All regions",
  LINK_TO: "Link to",
  CUSTOM_CODE: "Custom code",
  SAVE_AND_ADD_BANNER: "Save and add banner",
  RESTRICTION: "Restriction",
  ADD_COUNTRY: "Add Country",
  SELECT_COUNTRY: "Select Country",
  REMOVE_COUNTRY: "Remove Country",
  SELECT_STATE: "Select State",
  COUNTRY_DELETION: "Country Deletion",
  DO_YOU_REALLY_WANT_TO_DELETE_THIS_COUNTRY: "Do you really want to delete this country?",
  STAFF_MANAGEMENT: "Staff Management",
  NEW_STAFF: "New Staff",
  STAFF: "Staff",
  ROLES: "Roles",
  NEW_ROLE: "New Role",
  ROLE_NAME: "Role Name",
  ROLE_NAME_PLACEHOLDER: "Enter role name",
  ROLE_COLOR: "Role Color",
  PERMISSIONS: "Permissions",
  SAVE_CHANGES: "Save Changes",
  SIDEBAR_PREVIEW: "Sidebar Preview",
  DELETE_ROLE: "Delete Role",
  CANNOT_DELETE_ROLE_IN_USE: "Cannot delete role that is assigned to users",
  DELETE_THIS_ROLE: "Delete This Role?",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE: "Are you sure you want to delete",
  COLLAPSE_ALL: "Collapse All",
  EXPAND_ALL: "Expand All",
  BET_ACTIVITY: "Bet Activity",
  BACK_TO_STAFF: "Back to Staff",
  DISABLING_STAFF: "Disabling Staff",
  ARE_YOU_SURE_YOU_WANT_TO_DISABLE_THIS_STAFF: "Are you sure you want to disable this staff?",
  CHOOSE_A_REASON: "Choose a reason",
  SELECT_A_REASON: "Select a reason",
  ENTER_YOUR_COMMENT_HERE: "Enter your comment here",
  STAFF_SUSPENSION: "Staff Suspension",
  ARE_YOU_SURE_YOU_WANT_TO_SUSPEND_THIS_STAFF: "Are you sure you want to suspend this staff?",
  YES_SUSPEND: "Yes, Suspend",
  PASSWORD_RESET_LINK_SENT_TO_YOUR_EMAIL: "Password reset link sent to your email. Follow the email instructions.",
  CHANGE_EMAIL: "Change Email",
  CHANGING_STAFF_EMAIL: "Changing Staff Email",
  CHANGE_EMAIL_WARNING: "The new email becomes this staff member's login and password recovery address immediately. Their password stays the same.",
  CURRENT_EMAIL: "Current email",
  NEW_EMAIL: "New email",
  ENTER_NEW_EMAIL: "Enter the new email address",
  YES_CHANGE_EMAIL: "Yes, Change Email",
  STAFF_EMAIL_UPDATED_SUCCESSFULLY: "Staff email updated successfully",
  STAFF_EMAIL_ALREADY_IN_USE: "This email is already in use by another account.",
  STAFF_ACCOUNT_PROTECTED_EMAIL: "This account is protected and its email cannot be changed.",
  FAILED_TO_CHANGE_STAFF_EMAIL: "Failed to change staff email.",
  ACTIVITY_HISTORY: "Activity History",
  UNABLE_TO_LOAD_STAFF_MEMBER: "Unable to load this staff member. You can go back and try again.",
  PERSONAL_INFORMATION: "Personal information",
  ADD_EXPIRATION_DATE: "Add expiration date",
  CONTINUE: "Continue",
  CHOOSE_THE_ROLE: "Choose the role",
  ROLE_AND_PERMISSIONS: "Role & Permissions",
  POPULAR_TAB: "POPULAR",
  PROVIDERS_TAB: "PROVIDERS",
  SUBCATEGORY: "Subcategory",
  NO_GAMES_FOUND_IN: "No games found in {categoryName}",
  GAMES_WILL_APPEAR_HERE: "Games will appear here when added",
  DELETE_GAME: "Delete Game",
  DELETE_GAME_CONFIRMATION: "Delete \"{gameName}\"?",
  POPULAR_GAMES_REORDERED: "Popular games reordered",
  GAME_PIN_STATUS_UPDATED: "Game pin status updated",
  FAILED_TO_UPDATE_PIN_STATUS: "Failed to update pin status",
  ADD_GAME_TO_CATEGORY: "Add Game",
  MISSING_PROVIDER_OR_CATEGORY: "Missing provider or category to update game icon",
  ARENA: "Arena",
  PICKS_LIST: "Picks List",
  PHONE_NUMBER: "Phone number",
  PLEASE_UPLOAD_ICON: "Please upload an icon",
  CATEGORY_CREATED_SUCCESS: "Category created successfully!",
  CATEGORY_ICON_PREVIEW: "Category Icon Preview",
  UPLOAD_ICON_INSTRUCTIONS: "Upload new icon min 64x64px and max 1024x1024px. Support SVG",
  ENTER_CATEGORY_NAME: "Enter category name",
  NEW_SUBCATEGORY: "New Subcategory",
  ADDING_TO: "Adding to:",
  PLEASE_ENTER_SUBCATEGORY_NAME: "Please enter a subcategory name",
  SUBCATEGORY_CREATED_SUCCESS: "Subcategory created successfully!",
  FAILED_CREATE_SUBCATEGORY: "Failed to create subcategory. Please try again.",
  SUBCATEGORY_ICON_PREVIEW: "Subcategory Icon Preview",
  ENTER_SUBCATEGORY_NAME: "Enter subcategory name",
  ADD_SUBCATEGORY: "Add Subcategory",
  SUBCATEGORY_ADDED_SUCCESS: "Subcategory \"{name}\" added successfully",
  BANNERS_REORDERED_SUCCESS: "Banners reordered successfully",
  DELETE_CATEGORY_CONFIRMATION: "Are you sure you want to delete \"{name}\"? This will also remove the corresponding tab.",
  BANNER_DELETED_SUCCESS: "Banner deleted successfully",
  CATEGORY_ORDER_UPDATED: "Category order updated",
  ADD_BANNER: "Add banner",
  DRAG_TO_REORDER: "Drag to reorder",
  EDIT_BANNER: "Edit banner",
  DELETE_BANNER: "Delete banner",
  LINK_TO_URL: "Link to {link}",
  EDIT_ICON: "Edit icon",
  EDIT_NAME: "Edit name",
  DELETE_CATEGORY_ACTION: "Delete category",
  DELETE_CATEGORY_TITLE: "Delete Category",
  CATEGORY_ICON_REQUIRED: "Cannot set category to true without an image/icon",
  ENTITY_DELETE_BLOCKED: "The \"{name}\" entity cannot be deleted.",
  CANNOT_DELETE_LIVE_CATEGORY: "Cannot delete Live category",
  NO_CATEGORIES_FOUND: "No categories found",
  CLICK_NEW_CATEGORY_HINT: "Click \"+ New Category\" to create one",
  CATEGORIES_REORDERED_SUCCESS: "Categories reordered successfully",
  CATEGORY_CREATED_WITH_NAME: "Category \"{name}\" created successfully",
  CATEGORY_STATUS_CHANGED: "Category \"{name}\" {status}",
  DEACTIVATED: "deactivated",
  CATEGORY_DELETED_SUCCESS: "Category \"{name}\" deleted successfully",
  ALL_CATEGORIES: "All categories",
  ALL_ENTITIES: "All entities",
  SUBCATEGORIES_REORDERED_SUCCESS: "Subcategories reordered successfully",
  GAMES_REORDERED_SUCCESS: "Games reordered successfully",
  GAME_TYPE: "Game type",
  COLLAPSE: "Collapse",
  EXPAND: "Expand",
  DELETE_SUBCATEGORY: "Delete subcategory",
  REMOVE_GAME: "Remove game",
  SUBCATEGORY_NAME_REQUIRED: "Subcategory name cannot be empty",
  DELETE_SUBCATEGORY_TITLE: "Delete Subcategory",
  DELETE_SUBCATEGORY_CONFIRMATION: "Are you sure you want to delete \"{name}\"? This will also remove all games within this subcategory.",
  DELETE_GAME_FROM_SUBCATEGORY_TITLE: "Delete Game",
  DELETE_GAME_FROM_SUBCATEGORY_CONFIRMATION: "Are you sure you want to remove \"{name}\" from this subcategory?",
  NAVIGATION_TAB: "Navigation Tab",
  EDIT_SUBCATEGORY_ICON: "Edit Subcategory Icon",
  PIN_GAME: "Pin game",
  UNPIN_GAME: "Unpin game",
  NO_SUBCATEGORIES_FOUND: "No subcategories found",
  CLICK_NEW_SUBCATEGORY_HINT: "Click \"+ New subcategory\" to create one",
  NEW_SUBCATEGORY_BUTTON: "New subcategory",
  TAB_SETTINGS: "Tab settings",
  POPULAR: "POPULAR",
  THUMBNAIL: "Thumbnail",
  NO_GAMES_FOUND: "No games found in {categoryName}",
  NO_GAMES_EMPTY_LIST: "No games found",
  GAMES_WILL_APPEAR_HINT: "Games will appear here when added",
  PROVIDERS_REORDERED_SUCCESS: "Providers reordered successfully",
  MORE_OPTIONS: "More options",
  NO_PROVIDERS_FOUND: "No providers found in {categoryName}",
  PROVIDERS_WILL_APPEAR_HINT: "Providers will appear here when added",
  DRAG_N_DROP_TO_UPLOAD_ICON_DESCRIPTION_PROVIDERS: "Upload icon size min 64x64px and max 120x120px. Support PNG",
  ENABLED: "Enabled",
  GAMES_LABEL: "games",
  UNKNOWN: "Unknown",
  UNKNOWN_GAME: "Unknown Game",
  UNKNOWN_PROVIDER: "Unknown Provider",
  GAMES_SYNCED_SUCCESSFULLY: "Games synced successfully",
  FAILED_TO_FETCH_GAMES: "Failed to fetch games",
  FAILED_TO_SYNC_GAMES: "Failed to sync games",
  FAILED_TO_CREATE_GLOBAL_PROVIDER: "Failed to create global provider",
  FAILED_TO_LOAD_PROVIDER_DETAILS: "Failed to load provider details",
  FAILED_TO_ADD_GAME_TO_ALL_GAMES: "Failed to add game to all-games popular list",
  FAILED_TO_UPDATE_PROVIDER_GAMES: "Failed to update provider games for this game",
  FAILED_TO_REMOVE_GAME_FROM_ALL_GAMES: "Failed to remove game from all-games popular list",
  FAILED_TO_REMOVE_PROVIDER_WITH_NO_GAMES: "Failed to remove provider with no games",
  GAME_STATUS_UPDATED_SUCCESS: "Game {status} successfully",
  ENABLED_STATUS: "enabled",
  DISABLED_STATUS: "disabled",
  FAILED_TO_UPDATE_GAME_STATUS: "Failed to update game status",
  LIVE_GAMES: "Live Games",
  EDIT_CATEGORY_ICON: "Edit Category Icon",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_CATEGORY: "Are you sure you want to remove {name}?",
  FAILED_TO_UPDATE_ENTITY_ICON: "Failed to update entity icon. Please try again.",
  ADD_GAME_TO: "Add Game to",
  NO_GAMES_MATCH_YOUR_SEARCH: "No games match your search.",
  LOAD_NEW_GAMES: "Load New Games",
  NEW_ENTITY: "New Entity",
  ERROR_SEARCHING_BETS: "Error searching bets",
  ERROR_FETCHING_BET_DETAILS: "Error fetching bet details",
  PERFORMANCE: "Performance",
  RESTRICTIONS: "Restrictions",
  VS_YESTERDAY: "vs yesterday",
  PROVIDER_PERFORMANCE: "Provider Performance",
  MIN_ACTIVE_PLAYERS: "Min Active Players",
  ACTIVE_PLAYERS: "Active Players",
  WINNINGS: "Winnings",
  GAMES: "Games",
  PER_PAGE_OF: "per page of",
  BOOMING: "BOOMING",
  POPULAR_SPGS: "Popular SPGs",
  GAME_PERFORMANCE: "Game Performance",
  BACK_TO_GAMES_LIST: "Back To Games List",
  OF_ALL_PLAYERS: "of all players",
  TOTAL_PLAYERS: "Total Players",
  TOTAL_TURNOVER: "Total Turnover",
  TOTAL_GGR: "Total GGR",
  TOP_PLAYERS: "Top Players",
  CONFIGURATION: "Configuration",
  UNABLE_TO_UPDATE_DESCRIPTION: "Unable to update description without a game ID.",
  DESCRIPTION_UPDATED_SUCCESSFULLY: "Description updated successfully.",
  FAILED_TO_UPDATE_DESCRIPTION: "Failed to update description. Please try again.",
  DESCRIPTION_CANNOT_EXCEED_MAXCHARACTERS: "Description cannot exceed {maxCharacters} characters",
  ADD_A_SHORT_DESCRIPTION: "Add a short description for the game",
  MULTIPLIER: "Multiplier",
  GO_TO_CONFIGURATION: "Go to configuration",
  COLLECTION: "Collection",
  ADDING___: "Adding...",
  ADD_MARKET_GAME_CARD: "Add Market/Game Card",
  ADD_MARKET_TAB: "Add Market Tab",
  ADD_MARKET_TO_TAB: "Add market to tab",
  ADD_TAB: "Add Tab",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_MARKET_TAB: "Are you sure you want to delete market tab \"{tabName}\"?",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_MARKET_FROM_THE_TAB: "Are you sure you want to delete this market from the tab?",
  CARD_ADDED_TO_TAB: "Card added to tab",
  CARD_DELETED: "Card deleted",
  CARD_ORDER_UPDATED: "Card order updated",
  CREATING___: "Creating...",
  DELETE_MARKET_TAB: "Delete Market Tab",
  DELETE_TAB: "Delete tab",
  DELETING___: "Deleting...",
  DISPLAY_MARKET_NAME: "Display market name",
  EDIT_MARKET_NAME: "Edit Market Name",
  EDIT_MARKET_TAB: "Edit Market Tab",
  EDIT_TAB: "Edit tab",
  FAILED_TO_UPDATE_TAB: "Failed to update tab",
  TAB_UPDATED: "Tab updated",
  FAILED_TO_ADD_CARD: "Failed to add card",
  FAILED_TO_CREATE_TAB: "Failed to create tab",
  FAILED_TO_DELETE_CARD: "Failed to delete card",
  FAILED_TO_RENAME_MARKET: "Failed to rename market",
  FAILED_TO_UPDATE_CARD_ORDER: "Failed to update card order",
  FAILED_TO_UPDATE_MARKET_ORDER: "Failed to update market order",
  FAILED_TO_ADD_MARKET: "Failed to add market",
  FAILED_TO_DELETE_MARKET: "Failed to delete market",
  FAILED_TO_UPDATE_TAB_ORDER: "Failed to update tab order",
  LOADING_MARKETS___: "Loading markets...",
  FAILED_TO_LOAD_MARKETS: "Failed to load markets",
  MANAGE_MARKET_CARD_TITLES_AND_THEIR_PLACEMENT: "Manage market/card titles and their placement within tabs. Each market/card has a UOF ID for backend communication.",
  MANAGE_THE_TAB_TITLES_DISPLAYED: "Manage the tab titles displayed on the frontend for events. Drag to reorder tabs.",
  MARKET_RENAMED: "Market renamed",
  MARKET_TABS: "Market Tabs",
  MARKETS_GAME_CARDS: "Markets/Game Cards",
  FUTURES_MARKETS: "Markets",
  FUTURES_ADD_MARKET: "Add Market",
  FUTURES_SPORT_PLACEHOLDER: "Select sport",
  FUTURES_MANAGE_MARKET_TITLES_AND_THEIR_PLACEMENT: "Manage market titles and their placement within tabs. Each market has a UOF ID for backend communication.",
  NO_ACTIVE_SPORT_SELECTED: "No active sport selected",
  NO_MARKET_TABS_FOUND_FOR_THIS: "No market tabs found for this",
  ORIGINAL_NAME: "Original name",
  START_TYPING_TO_SEARCH: "Start typing to search for a market or game card...",
  SAVING: "Saving...",
  TAB_CREATED: "Tab created",
  TAB_DELETED: "Tab deleted",
  TAB: "Tab",
  ENTER_TAB_NAME: "Enter tab name",
  TAB_NAME: "Tab Name",
  TAB_ORDER_UPDATED: "Tab order updated",
  THERE_ARE_NO_MARKETS_FOR_THIS_MARKET_TAB: "There are no markets for this market tab",
  THIS_TAB: "this tab",
  FAILED_TO_DELETE_TAB: "Failed to delete tab",
  ADD_LEAGUE: "Add League",
  ADDING: "Adding...",
  EVENT_MARKETS: "Event Markets",
  LIVE_SPORTS: "Live Sports",
  EVENT_STATUS_UPDATED: "Event status updated",
  POPULAR_TABS: "Popular Tabs",
  UPCOMING_TABS: "Upcoming Tabs",
  ADD_MARKET: "Add Market",
  LIVE_SPORTS_V2: "Live Sports v2",
  ADD_ITEM: "Add Item",
  ADD_POPULAR_TAB: "Add Popular Tab",
  ADD_MATCH_BY_ID: "Add Match by ID",
  MATCH_ID: "Match ID",
  ENTER_MATCH_ID: "Enter match ID (e.g., 12345678)",
  ADD_MATCH_BY_ID_HINT: "Enter the numeric match ID to add it directly to Popular Tabs.",
  ADD_MATCH: "Add Match",
  MATCH_ADDED_SUCCESSFULLY: "Match added successfully",
  FAILED_TO_ADD_MATCH: "Failed to add match. Please check the ID and try again.",
  RENAME_POPULAR_TAB: "Rename Popular Tab",
  RENAME_UPCOMING_TAB: "Rename Upcoming Tab",
  RENAME_TOP_MARKET: "Rename Top Market",
  RENAME_TOP_LEAGUE: "Rename Top League",
  RENAME_LIVE_LEAGUE: "Rename Live League",
  RENAME_LIVE_SPORT: "Rename Live Sport",
  ITEM_RENAMED_SUCCESSFULLY: "Item renamed successfully",
  FAILED_TO_RENAME_ITEM: "Failed to rename item",
  NO_RESULTS_FOUND: "No results found",
  FAILED_TO_SEARCH: "Failed to search",
  BET_LIMITS: "Bet Settings",
  BET_SETTINGS_TITLE: "Bet Settings",
  SET_BET_LIMITS_FOR_USERS: "Set Bet Limits For {clientName} Users",
  SET_LIMITS: "Set Limits",
  MINIMUM_BET_AMOUNT: "Minimum Bet Amount",
  MAXIMUM_BET_AMOUNT: "Maximum Bet Amount",
  RESET: "Reset",
  BET_LIMITS_TRY_AGAIN: "Try again",
  FAILED_TO_LOAD_BET_LIMITS: "Failed to load bet limits",
  FAILED_TO_SAVE_BET_LIMITS: "Failed to save bet limits",
  SAVE_BET_LIMITS_SUCCESS: "Saved successfully",
  QUICK_BET_DEFAULTS: "Quick Bet Defaults",
  QUICK_BET_DEFAULTS_DESCRIPTION: "Set default quick bets that appear when players type their amounts in the bet slip. Users can always modify these to fit their betting style.",
  QUICK_BET_DEFAULT_LABEL: "Default {index}",
  FAILED_TO_LOAD_QUICK_BET_DEFAULTS: "Failed to load quick bet defaults",
  FAILED_TO_SAVE_QUICK_BET_DEFAULTS: "Failed to save quick bet defaults",
  SAVE_QUICK_BET_DEFAULTS_SUCCESS: "Saved successfully",
  SAVE_QUICK_BET_DEFAULTS_TOOLTIP: "Saves all quick bet default amounts",
  QUICK_BET_DEFAULTS_POSITIVE_ERROR: "Quick bet defaults must be greater than zero",
  QUICK_BET_DEFAULTS_ASCENDING_ERROR: "Quick bet defaults must be in ascending order",
  PROMOS: "Promos",
  SUSPENSIONS: "Suspensions",
  DELTA_SYMBOL: "∆",
  TOTAL_REBET_CASH: "Rebet Cash",
  PROMOS_ADDED: "Total Withdrawal Amount Approved",
  USERS_SUSPENDED: "Users Suspended",
  USERS_UNSUSPENDED: "Users Unsuspended",
  TOTAL_REBET_FREE_CASH_ADDED: "Total Rebet Free Cash Added",
  COMPLIANCE_AGENT: "Compliance Agent",
  NUMBER_OF_PROMOS_ADDED: "# of promos Added",
  PROMOS_ADDED_TITLE: "Promos Added",
  NUMBER_OF_PROMOS_ADDED_UPPER: "# of PROMOS ADDED",
  NUMBER_OF_PROMOS: "number of promos",
  NUMBER_OF_PROFIT_BOOSTS: "# of Profit Boosts",
  NUMBER_OF_FREE_SPINS: "# of Free Spins",
  PROMO_TYPE: "Promo Type",
  PROMO_NAME: "Promo Name",
  TIME_CLAIMED: "Time Claimed",
  AGENT_PERFORMANCE_VIEW: "Agent Performance View",
  AGENT_AUDIT_LOG: "Agent Audit Log",
  PAM_AGENT: "PAM Agent",
  SHOW_KPIS: "Show KPIs",
  ACTION_TYPE: "Action Type",
  AVG_TIME_REQUEST_TO_DECISION: "Avg Time: Request To Decision",
  AVG_TIME_REVIEW_START_TO_DECISION: "Avg Time: Review Start To Decision",
  SUBTRACTED: "Subtracted",
  WEEKLY_CHALLENGES: "Weekly Challenges",
  MONTHLY_CHALLENGES: "Monthly Challenges",
  ROOKIE_LEAGUE: "Rookie League",
  VARSITY_LEAGUE: "Varsity League",
  PRO_LEAGUE: "Pro League",
  ALL_STAR_LEAGUE: "All-Star League",
  CHALLENGE_ID: "Challenge ID",
  CHALLENGE_NAME: "Challenge Name",
  REWARD: "Reward",
  TASKS: "Tasks",
  PROGRESS: "Progress",
  TIER: "Tier {index}",
  SELECT: "Select",
  COMPLETED_BEFORE_TRACKED: "Completed before tracked",
  NOT_AVAILABLE: "N/A",
  XP: "XP",
  MONTHLY_CHALLENGE_STATUS: "Monthly Challenge Status",
  ACTIVE_DAYS: "Active Days",
  CONSECUTIVE_DAYS: "Consecutive Days",
  INITIAL_FOLLOWERS: "Initial Followers",
  CURRENT_FOLLOWERS: "Current Followers",
  INITIAL_REFERRALS: "Initial Referrals",
  CURRENT_REFERRALS: "Current Referrals",
  DAILY_CHALLENGES: "Daily challenges",
  EMPTY_REASON: "-",
  PREMIUM_ENABLED_FOR: "Is Game Pass Premium Enabled for {username}?",
  FEATURE_FLAG_UPDATE_ERROR: "Failed to update feature flag.",
  MANUAL_PASS_USER: "Manual Pass User",
  MANUAL_PASS_SUCCESS: "Manual pass user added successfully!",
  ERROR_ADDING_MANUAL_PASS: "Error adding manual pass user. Please try again.",
  MANUAL_PASS: "Manual Pass",
  ADDING_MANUAL_PASS: "Adding Manual Pass...",
  BET_LIMITS_TIER_UPDATED: "Bet limits tier updated successfully",
  MORE_ACTIONS: "More Actions",
  GLOBAL_CHAT_TOGGLE: "Global Chat Toggle",
  FOLLOWERS: "Followers",
  SUSPENSION_REASON: "Suspension Reason",
  DELETED: "Deleted",
  GLOBAL_CHAT_ENABLED: "Global Chat Enabled",
  SEND: "Send",
  MEMBERS_REFERRED: "Members Referred",
  NUM_OF_DUPLICATE_BETS: "# of Duplicate Bets",
  DATE_OF_BIRTH: "Date of Birth",
  MM_DD_YYYY: "MM/DD/YYYY",
  USER_DELETED_ACCOUNT: "User Deleted Account",
  ACCOUNT_DELETED_BY: "Account Deleted By",
  DELETED_REASON: "Deleted Reason",
  FTW: "FTW",
  ACCEPTED_TOU: "Accepted TOU",
  LOCK_USER_LIMITS: "Lock user limits",
  CANNOT_ADJUST_BALANCE_FOR_SUSPENDED_ACCOUNT: "Cannot adjust balance for a suspended account.",
  CASH_BALANCE: "Cash Balance",
  REDEEMABLE_CASH_BALANCE: "Redeemable Cash Balance",
  VIEW_USER: "View User",
  SELECT_CURRENCY: "Select Currency",
  USER_BALANCE_UPDATED_SUCCESSFULLY: "User balance updated successfully.",
  PROFIT_BOOST_MODAL: "Profit Boost Modal",
  SETTLE_BET: "Settle Bet",
  LEG: "Leg",
  UNSETTLED: "Unsettled",
  WON: "Won",
  LOST: "Lost",
  VOID: "Void",
  CANCEL_BET: "Cancel Bet",
  DO_YOU_REALLY_WANT_TO_CANCEL_THIS_BET: "Do you really want to cancel this bet?",
  BET_CANCELLED_SUCCESSFULLY: "Bet cancelled successfully",
  FAILED_TO_CANCEL_BET: "Failed to cancel bet",
  PROFIT_LOSS: "Profit & Loss",
  CASH_OUT_PROFIT_LOSS: "Cash Out Profit & Loss",
  RECENT_BETS: "Recent Bets",
  WAGER_AMOUNT: "Wager Amount",
  FINALIZED_PAYOUT: "Finalized Payout",
  FINAL_MULTIPLIER: "Final Multiplier",
  POTENTIAL_ODDS: "Potential Odds",
  SUPER_PICK: "Super Pick",
  SAFE_SLIP: "Safe Slip",
  NUM_OF_LEGS: "# of Legs",
  NUM_OF_BETS: "# of Bets",
  HASH_OF_BETS: "# of BETS",
  STOLEN_CARD_FRAUD: "Stolen Card Fraud",
  FRIENDLY_FRAUD: "Friendly Fraud",
  ATO: "ATO",
  MULTI_ACCOUNTING: "Multi Accounting",
  ACCOUNT_SHARING: "Account Sharing",
  ACCOUNT_SELLING: "Account Selling",
  REFERRAL_ABUSE: "Referral Abuse",
  REGISTRATION_DECLINE_BY_SEON: "Registration Decline by SEON",
  CHARGEBACK_REPORTED_AERO_PAY: "Chargeback reported - AeroPay",
  CHARGEBACK_REPORTED_MAVERICK: "Chargeback reported - Maverick",
  SELF_EXCLUDE: "Self Exclude",
  UNSUSPEND: "Unsuspend",
  FREE_SPINS: "# of Free Spins",
  FREE_SPINS_ADDED_SUCCESSFULLY: "Free spins added successfully.",
  ADD_FREE_SPINS: "Add Free Spins",
  SELECT_PROVIDER: "Select Provider",
  SELECT_PROVIDER_FIRST: "Select provider first",
  VALUE_REQUIRED_FOR_THREEOAKS: "Value is required for ThreeOaks",
  ERROR_FETCHING_GAMES: "Error fetching games",
  INVALID_VALUE: "Invalid value, they must be greater than 0.",
  BGAMING: "BGaming",
  THREEOAKS: "ThreeOaks",
  ERROR_GAME_NOT_IN_ALLOWED_LIST: "Game is not in allowed/active list",
  ERROR_VALUE_NOT_FOR_BGAMING: "Value should not be sent for BGaming",
  ERROR_VALUE_REQUIRED_THREEOAKS: "Value is required for ThreeOaks",
  ERROR_BET_FACTOR_MISMATCH: "Value does not match game bet factor rule",
  ERROR_PROVIDER_FAILED: "Provider/upstream failed",
  BET_FACTOR: "Bet factor",
  VERIFIED_EMAILS: "Verified Emails",
  UNVERIFIED_EMAILS: "Unverified Emails",
  FTDS: "FTDs",
  PLAYERS_BY_STATES: "Players by States",
  PAM_SEGMENTS_TITLE: "Segments",
  PAM_SEGMENTS_CREATE_TITLE: "Create Segment",
  PAM_SEGMENTS_BACK_TO_SEGMENTS: "Back to Segments",
  PAM_SEGMENTS_WIZARD_ARIA: "Create segment steps",
  PAM_SEGMENTS_WIZARD_STEP_MEMBERSHIP_RULE: "Membership Rule",
  PAM_SEGMENTS_NAME_PLACEHOLDER: "Segment name",
  PAM_SEGMENTS_MEMBERSHIP_RULE_HINT:
    "Optional — pick a trigger event to add a membership rule, or leave it blank to create a segment without rules.",
  PAM_SEGMENTS_TRIGGER_EVENTS_LOADING: "Loading trigger events…",
  PAM_SEGMENTS_TRIGGER_EVENT_PLACEHOLDER: "Select a trigger event",
  PAM_SEGMENTS_TRIGGER_KEY_LABEL: "Trigger Key",
  PAM_SEGMENTS_TRIGGER_KEY_PLACEHOLDER: "Select a trigger key",
  PAM_SEGMENTS_FIELD_LABEL: "Field",
  PAM_SEGMENTS_FIELD_PLACEHOLDER: "Select a field",
  PAM_SEGMENTS_OPERATOR_LABEL: "Operator",
  PAM_SEGMENTS_OPERATOR_PLACEHOLDER: "Select operator",
  PAM_SEGMENTS_VALUE_PLACEHOLDER: "e.g. 100",
  PAM_SEGMENTS_TTL_PLACEHOLDER: "e.g. 30",
  PAM_SEGMENTS_SUMMARY_TITLE: "Segment",
  PAM_SEGMENTS_OPERATOR_EQ: "Equals",
  PAM_SEGMENTS_OPERATOR_NE: "Not equals",
  PAM_SEGMENTS_OPERATOR_GT: "Greater than",
  PAM_SEGMENTS_OPERATOR_GTE: "Greater than or equal",
  PAM_SEGMENTS_OPERATOR_LT: "Less than",
  PAM_SEGMENTS_OPERATOR_LTE: "Less than or equal",
  PAM_SEGMENTS_OPERATOR_EXISTS: "Exists",
  PAM_SEGMENTS_OPERATOR_IN: "In",
  PAM_SEGMENTS_STATUS_PAUSED: "Paused",
  PAM_SEGMENTS_STATUS_ARCHIVED: "Archived",
  PAM_SEGMENTS_ESTIMATED_REACH: "Estimated Reach",
  PAM_SEGMENTS_LOOKBACK_WINDOW_DAYS: "Lookback Window (days)",
  PAM_SEGMENTS_USED_ON: "Used on",
  PAM_SEGMENTS_FILTER_ARIA_LABEL: "Filter segments by status",
  PAM_SEGMENTS_LOAD_ERROR: "Failed to load segments.",
  PAM_DYNAMIC_BONUS_EVENTS_LOAD_ERROR: "Failed to load trigger events.",
  PAM_CAMPAIGNS_FILTER_ARIA_LABEL: "Filter campaigns by status",
  PAM_CAMPAIGNS_LOAD_ERROR: "Failed to load campaigns.",
  PAM_CAMPAIGNS_SERIES_LOAD_ERROR: "Failed to load series.",
  PAM_DYNAMIC_BONUS_STATUS_DRAFT: "Draft",
  PAM_BONUS_TEMPLATES_TITLE: "Bonus Templates",
  PAM_TEMPLATES_LOAD_ERROR: "Failed to load templates.",
  PAM_TEMPLATES_EMPTY: "No templates available yet.",
  PAM_TEMPLATES_TRIGGER_TYPE: "Trigger Type",
  PAM_TEMPLATES_CREATED: "Created",
  PAM_TEMPLATES_UPDATED: "Updated",
  PAM_BACK_TO_CAMPAIGNS: "Back to Campaigns",
  CREATE_SEGMENT: "Create Segment",
  CREATE_CAMPAIGN: "Create Campaign",
  PAM_CREATE_TEMPLATE: "Create Template",
  TAG_AS: "Tag As",
  SELECT_TAGS: "Select Tags",
  LAST_EDITED_BY: "Last Edited By",
  TAGS: "Tags",
  NO_LIMIT: "No Limit",
  UP_TO_$10K: "Up to 10k",
  UP_TO_$50K: "Up to 50k",
  UP_TO_$100K: "Up to 100k",
  UP_TO_$200K: "Up to 200k",
  UP_TO_$300K: "Up to 300k",
  UP_TO_$400K: "Up to 400k",
  UP_TO_$500K: "Up to 500k",
  MINIMUM_PARLAY_LEGS: "Minimum # of Parlay Legs",
  MINIMUM_ODDS: "Minimum Odds",
  MAX_FREE_PLAY_CASH_POPOVER_TEXT: "Maximum amount the referred user can purchase and get matched in free casino cash.",
  REFERRER_BONUS_AMOUNT_POPOVER_TEXT: "This is the reward in Free Cash that the user, who referred a friend, receives once the referred user makes a deposit.",
  MINIMUM_REQUIRED_PURCHASE_POPOVER_TEXT: "Minimum qualifying purchase amount (how much their referral must purchase: e.g. $10 or $15).",
  MINIMUM_NUMBER_OF_PARLAY_LEGS_POPOVER_TEXT: "The number of bets a player needs to make together to form a parlay. A single leg parlay is a straight bet.",
  FAILED_TO_FETCH_VALUES: "Failed to fetch values. Please try again.",
  FAILED_TO_UPDATE_VALUES: "Failed to update values. Please try again.",
  VALUES_UPDATED_SUCCESSFULLY: "Values updated successfully.",
  BONUS_PLAY_THROUGH_REQUIREMENT_POPOVER_TEXT: "Playthrough multiplier (e.g. 3x, 5x, 20x).",
  REFERRAL_BONUSES: "Referral Bonuses",
  BONUS_PLAY_THROUGH_REQUIREMENT: "Bonus Play Through Requirement",
  MINIMUM_REQUIRED_PURCHASE: "Minimum Required Purchase",
  TRANSACTIONS_UNDER: "Transactions under",
  TRANSACTIONS_BETWEEN: "Transactions between",
  TRANSACTIONS_OVER: "Transactions over",
  WORLD_PAY: "World Pay",
  LOADING_MOBILE_BUILDS: "Loading mobile builds...",
  FAILED_TO_FETCH_MOBILE: "Failed to fetch mobile builds",
  RETRY: "Retry",
  ALL_PLATFORMS: "All Platforms",
  ANDROID: "Android",
  IOS: "iOS",
  VERSION: "Version",
  BUILD_DATE: "Build Date",
  FILE_SIZE: "File Size",
  LATEST: "LATEST",
  DOWNLOAD_BUILD: "Download Build",
  NO_BUILDS_AVAILABLE_FOR: "No builds available for the selected platform.",
  SORT: "Sort",
  DROPDOWN: "Dropdown",
  RNG: "RNG",
  LINK: "Link",
  SEARCH_GAMES_BY_NAME_OR_PROVIDER: "Search games by name or provider...",
  FAILED_TO_CREATE: "Failed to create",
  NO_RESULTS: "No results",
  DISCARD_CHANGES: "Discard changes",
  CATEGORY: "Category",
  ABOUT_CONDITIONS: "About conditions",
  ABOUT_CONTRACT: "About contract",
  ABOUT_MINIMUM_PROFIT: "About minimum profit",
  ADD_AFFILIATE: "Add Affiliate",
  AFFILIATES_BY_STATE: "Affiliates by State",
  AFFILIATE_CODES: "Affiliate Codes",
  AFFILIATE_CONTACT: "Contact",
  AFFILIATE_CONTRACT: "Contract",
  AFFILIATE_CONTRACT_FILE: "File",
  AFFILIATE_CONTRACT_RENEWAL_DATE: "Renewal Date",
  AFFILIATE_CONTRACT_SIGNED: "Signed",
  AFFILIATE_DATE_JOINED: "Date Joined",
  AFFILIATE_INFO: "Affiliate Info",
  PAM_AFFILIATE_CHANGE_EMAIL: "Change affiliate email",
  PAM_AFFILIATE_CHANGE_EMAIL_WARNING:
    "The new email becomes this affiliate's sign-in and recovery address. An invite or password reset may be sent to the new address.",
  PAM_AFFILIATE_CHANGE_EMAIL_SUCCESS: "Affiliate email updated",
  PAM_AFFILIATE_CHANGE_EMAIL_FAILED: "Failed to change affiliate email",
  PAM_AFFILIATE_RESEND_INVITE: "Resend invite",
  PAM_AFFILIATE_RESEND_INVITE_SUCCESS: "Affiliate invite sent",
  PAM_AFFILIATE_RESEND_INVITE_FAILED: "Failed to resend affiliate invite",
  PAM_AFFILIATE_EMAIL_CHANGED_RESEND_FAILED:
    "Email changed, but the invite could not be sent. Use Resend invite to try again.",
  PAM_AFFILIATE_INVALID_EMAIL: "Please enter a valid email address.",
  AFFILIATE_PAYMENT: "Payment",
  AFFILIATE_PAYMENT_CPA: "CPA",
  AFFILIATE_PAYMENT_FLAT_FEE: "Flat Fee",
  AFFILIATE_PAYMENT_HYBRID: "Hybrid",
  AFFILIATE_PAYMENT_HYBRID_DESCRIPTION_LONG: "Get paid a portion of the income generated and when users complete specific actions",
  AFFILIATE_PAYMENT_MIN_CASINO_REVENUE: "Minimum Casino Revenue",
  AFFILIATE_PAYMENT_MIN_SPORTSBOOK_REVENUE: "Minimum Sportsbook Revenue",
  AFFILIATE_PAYMENT_MODEL: "Payment Model",
  AFFILIATE_PAYMENT_PER_FIRST_TIME_DEPOSIT: "Per First Time Deposit",
  AFFILIATE_PAYMENT_PER_USER_SIGNUP: "Per User Signup",
  AFFILIATE_PAYMENT_REV_SHARE: "Rev Share",
  AFFILIATE_PAYMENT_REV_SHARE_CASINO: "Rev Share Casino",
  AFFILIATE_PAYMENT_REV_SHARE_SPORTSBOOK: "Rev Share Sportsbook",
  AFFILIATE_PAYMENT_SCOPE_CASINO: "Casino",
  AFFILIATE_PAYMENT_SCOPE_SPORTSBOOK: "Sportsbook",
  AFFILIATE_PAYMENT_SCOPE_SPORTSBOOK_AND_CASINO: "Sportsbook and Casino",
  AFFILIATE_PAYMENT_TOGGLE_DETAILS: "Toggle payment plan details",
  AFFILIATE_WEBSITE_URL: "Website URL",
  ALL_AFFILIATES: "All Affiliates",
  ALL_CODES: "All Codes",
  APPLINK: "App Link",
  APPLINK_COPIED: "App link copied",
  APPLINK_COPY: "Copy link",
  APPLINK_DELETED: "Deleted",
  APPLINK_FAILED: "Failed",
  APPLINK_PENDING: "Pending",
  APPLINK_READY: "Ready",
  BACK_TO_AFFILIATES_LIST: "Back to Affiliates List",
  CHOOSE_HOW_THIS_AFFILIATE: "Choose how this affiliate gets compensated.",
  CHOOSE_TYPE: "Choose type:",
  COMPLETE_CONTACT_INFORMATION_BEFORE: "Complete Contact Information before adding the affiliate.",
  COMPLETE_PAM_ACCOUNT_BEFORE_ADDING: "Pick at least one column for the Affiliate PAM Account before adding the affiliate.",
  CONTRACT_FILE_INPUT: "Contract file upload",
  CPA_AMT: "CPA Amt.",
  DAILY_USERS_AND_FTDS: "Daily Users And FTDs",
  DATE_JOINED: "Date Joined",
  DEACTIVATE: "Deactivate",
  DEACTIVATED_LABEL: "Deactivated",
  DEACTIVATED_SUCCESS: "Affiliate deactivated",
  DEACTIVATE_AFFILIATE_TITLE: "Deactivate Affiliate",
  DEACTIVATE_CONFIRM_BODY: "Deactivate this affiliate? Their portal access will be revoked immediately, but their existing promo links keep attributing traffic.",
  DOWNLOAD: "Download",
  DRAG_AND_DROP: "Drag-and-Drop",
  DRAG_AND_DROP_A_FILE: "Drag-and-drop a file or upload a file",
  EDIT_AFFILIATE_NO_CHANGES: "No changes to save",
  EDIT_PORTAL_VIEW: "Edit Affiliate view",
  EDIT_PORTAL_VIEW_SUBTITLE: "Update what the affiliate sees when they sign in to their portal.",
  FILE_TOO_LARGE: "File is too large. Maximum size is 10 MB.",
  FTD_FILTER_LABEL: "FTD",
  FTD_QUESTION: "FTD?",
  FTD_RATE: "FTD Rate",
  INFO_REQUIRES_DEACTIVATED: "Deactivate the affiliate first to edit profile info.",
  LIFECYCLE_FAILED: "Action failed",
  METRIC: "Metric",
  MINIMUM_MONTHLY_PROFIT_THRESHOLD: "Minimum monthly profit threshold before this revenue source pays out.",
  MUST_BE_BETWEEN_1_AND_100: "Must be between 1 and 100",
  MUST_BE_GREATER_THAN_0: "Must be greater than 0",
  MUST_BE_WHOLE_NUMBER: "Must be a whole number",
  NEW_AFFILIATE: "New Affiliate",
  NEW_AFFILIATE_ADDRESS_LINE_1: "Line 1",
  NEW_AFFILIATE_ADDRESS_LINE_1_PLACEHOLDER: "Street",
  NEW_AFFILIATE_ADDRESS_LINE_2: "Line 2",
  NEW_AFFILIATE_ADDRESS_LINE_2_PLACEHOLDER: "Apartment, suite, unit, building, etc",
  NEW_AFFILIATE_CITY: "City",
  NEW_AFFILIATE_CITY_PLACEHOLDER: "New York",
  NEW_AFFILIATE_CONFIRMATION_AFFILIATE_ID: "Affiliate ID",
  NEW_AFFILIATE_CONFIRMATION_AFFILIATE_ID_COPIED: "Affiliate ID copied",
  NEW_AFFILIATE_CONFIRMATION_APPLINK_STATUS_COLUMN: "AppLink Status",
  NEW_AFFILIATE_CONFIRMATION_COPY: "Copy",
  NEW_AFFILIATE_CONFIRMATION_COPY_AFFILIATE_ID_ARIA: "Copy affiliate id",
  NEW_AFFILIATE_CONFIRMATION_COPY_FAILED: "Copy failed",
  NEW_AFFILIATE_CONFIRMATION_COPY_USERNAME_ARIA: "Copy sign-in username",
  NEW_AFFILIATE_CONFIRMATION_EMAIL_SENT: "We sent a sign-in invite to {email}. They'll set their password from the email.",
  NEW_AFFILIATE_CONFIRMATION_NO_PROMO_CODES: "No promo codes were created with this affiliate.",
  NEW_AFFILIATE_CONFIRMATION_PROMO_CODE_COLUMN: "Promo Code",
  NEW_AFFILIATE_CONFIRMATION_SIGN_IN_USERNAME: "Sign-in username",
  NEW_AFFILIATE_CONFIRMATION_STATUS_FAILED: "Failed — will retry",
  NEW_AFFILIATE_CONFIRMATION_STATUS_PENDING: "AppLink generation queued",
  NEW_AFFILIATE_CONFIRMATION_STATUS_PROVISIONED: "Ready",
  NEW_AFFILIATE_CONFIRMATION_TITLE: "Affiliate created",
  NEW_AFFILIATE_CONFIRMATION_USERNAME_COPIED: "Username copied",
  NEW_AFFILIATE_CONTACT_INFORMATION: "Contact information",
  NEW_AFFILIATE_CONTRACT_UPLOAD_FAILED: "Contract upload failed — affiliate will be created without the contract attached.",
  NEW_AFFILIATE_CREATE_FAILED: "Failed to create affiliate",
  NEW_AFFILIATE_CREATE_PROMO_CODE: "Create Promo Code",
  NEW_AFFILIATE_EDIT_PROMO_CODE: "Edit Promo Code",
  NEW_AFFILIATE_EMAIL_PLACEHOLDER: "name@example.com",
  NEW_AFFILIATE_NAME_PLACEHOLDER: "Full name or Company name",
  NEW_AFFILIATE_PAM_ACCESS: "Affiliate PAM Access",
  NEW_AFFILIATE_PAM_ACCOUNT: "Affiliate PAM Account",
  NEW_AFFILIATE_PAM_ACCOUNT_KPI_BADGE: "KPI",
  NEW_AFFILIATE_PAM_ACCOUNT_KPI_BADGE_LABEL: "Also displayed as a KPI card",
  NEW_AFFILIATE_PAM_ACCOUNT_PREVIEW_PLACEHOLDER: "Pending",
  NEW_AFFILIATE_PAM_ACCOUNT_SUBTITLE: "Pick the metrics and columns the affiliate will see in their read-only portal. They can be changed later from the affiliate's profile.",
  NEW_AFFILIATE_PAM_ACCOUNT_TITLE: "Configure the affiliate's PAM view",
  NEW_AFFILIATE_PHONE_PLACEHOLDER: "Phone number",
  NEW_AFFILIATE_PROMO_CODES: "Promo codes",
  NEW_AFFILIATE_PROMO_CODES_INFO_LABEL: "About promo codes",
  NEW_AFFILIATE_PROMO_CODES_TOOLTIP: "Promo codes the affiliate can share with their audience. Each code generates a tracked URL for attribution.",
  NEW_AFFILIATE_PROMO_CODE_COPY_URL_LABEL: "Copy promo code URL",
  NEW_AFFILIATE_PROMO_CODE_DUPLICATE: "Duplicate Code",
  NEW_AFFILIATE_PROMO_CODE_EDIT: "Edit",
  NEW_AFFILIATE_PROMO_CODE_LABEL: "Promo code",
  NEW_AFFILIATE_SUMMARY_ARIA_LABEL: "Affiliate summary",
  NEW_AFFILIATE_TIMEZONE: "Time zone",
  NEW_AFFILIATE_TIMEZONE_PLACEHOLDER: "Select a time zone",
  NEW_AFFILIATE_VALIDATION_INVALID_WEBSITE_URL: "Please enter a valid website URL.",
  NEW_AFFILIATE_VALIDATION_REQUIRED_NAME: "Please enter the affiliate's name.",
  NEW_AFFILIATE_WEBSITE_URL_PLACEHOLDER: "https://example.com",
  NEW_AFFILIATE_ZIP_CODE: "Zip Code",
  NEW_AFFILIATE_ZIP_CODE_PLACEHOLDER: "Postal code",
  NEW_CODE: "New Code",
  ONLY_PDF_FILES_ARE: "Only PDF files are supported.",
  OPTIONAL: "optional",
  PAY_A_FIXED_AMOUNT: "Pay a fixed amount for each qualifying user action.",
  PER_ACTION: "Per Action",
  PLAN_REQUIRES_ACTIVE: "Reactivate the affiliate first to edit the commission plan.",
  PORTAL_VIEW_UPDATED: "Affiliate view updated",
  PORTAL_VIEW_UPDATE_FAILED: "Failed to update Affiliate view",
  PROMO_CODE: "Promo Code",
  PROMO_CODES: "Promo Codes",
  PROMO_CODE_ADD_FAILED: "Failed to add promo code",
  PROMO_CODE_ADD_SOCIAL_META_TAGS: "Add social meta tags",
  PROMO_CODE_ADD_SOCIAL_META_TAGS_INFO_LABEL: "About social meta tags",
  PROMO_CODE_ADD_SOCIAL_META_TAGS_TOOLTIP: "Used by social platforms to render rich link previews (Open Graph / Twitter cards).",
  PROMO_CODE_ANDROID: "Android",
  PROMO_CODE_APP_LINK_NAME: "AppLink Name",
  PROMO_CODE_APP_LINK_NAME_PLACEHOLDER: "Enter AppLink Name",
  PROMO_CODE_BONUS_SELECTION: "Bonus Selection",
  PROMO_CODE_BONUS_SELECTION_PLACEHOLDER: "Select...",
  PROMO_CODE_DEEP_LINK_URL: "Deep link URL",
  PROMO_CODE_DEEP_LINK_URL_PLACEHOLDER: "yourappname.com",
  PROMO_CODE_DEFINE_LINK_BEHAVIOR_ANDROID: "Define link behavior for Android",
  PROMO_CODE_DEFINE_LINK_BEHAVIOR_IOS: "Define link behavior for iOS",
  PROMO_CODE_IF_NOT_INSTALLED: "If your app is not installed, send the user to",
  PROMO_CODE_IF_NOT_INSTALLED_APP_STORE: "App Store",
  PROMO_CODE_IF_NOT_INSTALLED_CUSTOM_URL: "Custom URL",
  PROMO_CODE_IF_NOT_INSTALLED_GOOGLE_PLAY: "Google play page",
  PROMO_CODE_IOS: "iOS",
  PROMO_CODE_LINK_BEHAVIOR_ANDROID_APP: "Open the deep link URL in Android App",
  PROMO_CODE_LINK_BEHAVIOR_BROWSER: "Open the deep link URL in a browser",
  PROMO_CODE_LINK_BEHAVIOR_IOS_APP: "Open the deep link URL in iOS App",
  PROMO_CODE_NAME: "Promo Code Name",
  PROMO_CODE_NAME_PLACEHOLDER: "Name",
  PROMO_CODE_PREVIEW_DESCRIPTION: "Preview Description",
  PROMO_CODE_PREVIEW_DESCRIPTION_PLACEHOLDER: "Add a short description",
  PROMO_CODE_PREVIEW_IMAGE_URL: "Preview Image URL",
  PROMO_CODE_PREVIEW_IMAGE_URL_PLACEHOLDER: "https://example.com/image.jpg",
  PROMO_CODE_PREVIEW_TITLE: "Preview Title",
  PROMO_CODE_PREVIEW_TITLE_PLACEHOLDER: "Enter Preview Title",
  PROMO_CODE_QUEUED: "Promo code \"{name}\" queued",
  PROMO_CODE_REWARD: "Reward",
  PROMO_CODE_REWARD_INFO_LABEL: "About rewards",
  PROMO_CODE_REWARD_TOOLTIP: "Pick the bonus types this promo code grants. Multiple bonuses can be combined (e.g. deposit match + free bet).",
  PROMO_CODE_SAVE_CODE: "Save Code",
  PROMO_CODE_SET_UP_APP_LINK: "Set up AppLink",
  PROMO_CODE_SET_UP_APP_LINK_INFO_LABEL: "About AppLinks",
  PROMO_CODE_SET_UP_APP_LINK_TOOLTIP: "AppLinks route taps to your iOS / Android apps when installed and fall back to the configured destination otherwise.",
  PROMO_CODE_VALIDATION_MAX_LENGTH_NAME: "Promo code name must be 16 characters or less.",
  PROMO_CODE_VALIDATION_REQUIRED_APP_LINK_NAME: "Please enter the AppLink name.",
  PROMO_CODE_VALIDATION_REQUIRED_BONUS_SELECTION: "At least 1 option required",
  PROMO_CODE_VALIDATION_REQUIRED_DEEP_LINK_URL: "Please enter a deep link URL.",
  PROMO_CODE_VALIDATION_REQUIRED_NAME: "Please enter a promo code name.",
  REACTIVATE: "Reactivate",
  REACTIVATED_SUCCESS: "Affiliate reactivated",
  REACTIVATE_AFFILIATE_TITLE: "Reactivate Affiliate",
  REACTIVATE_CONFIRM_BODY: "Reactivate this affiliate? Portal access will be restored.",
  REGISTRATION_STATE: "Registration State",
  REMOVE_FILE: "Remove file",
  REQUIRED: "Required",
  REVENUE_PCT: "Revenue %",
  REVENUE_SOURCE: "Revenue Source",
  SEARCH_BY_CODE: "Search by code",
  SEARCH_BY_NAME: "Search by name",
  SEARCH_BY_USERNAME: "Search by username",
  SEARCH_BY_USER_ID: "Search by User ID",
  SELECT_CHART_DATA_TO_SHARE: "Select Chart Data to share with affiliate",
  SET_THE_RULES_THAT: "Set the rules that trigger payouts.",
  SHARE_A_PERCENTAGE_OF: "Share a percentage of net revenue with the affiliate.",
  SOURCE: "Source",
  TOP_5_AFFILIATES: "Top 5 Affiliates",
  TOP_5_CODES: "Top 5 Codes",
  UPLOAD_AN_OPTIONAL_CONTRACT: "Upload an optional contract document for this affiliate.",
  UPLOAD_FILE: "Upload File",
  USERS_ITEM_LABEL: "users",
  USER_SIGNUPS: "User Signups",
  VALIDATION_INVALID_EMAIL: "Please enter a valid email.",
  VALIDATION_REQUIRED_EMAIL: "Please enter the email.",
  VALIDATION_REQUIRED_TIMEZONE: "Please select a time zone.",
  WELCOME_BONUS: "Welcome Bonus",
  ACCEPTANCE_RATE: "Acceptance Rate",
  ACCOUNT_CONFIG: "Account Config",
  ACCOUNT_CONFIG_GAME_STOP_TIP_COMPLIANCE_LOCKED: "This state is controlled outside PAM",
  ACCOUNT_CONFIG_GAME_STOP_TIP_NON_COMPLIANT: "Non Compliant",
  ACCOUNT_CONFIG_GAME_STOP_TIP_NOT_APPROVED: "Not Approved",
  ACCOUNT_CONFIG_GAME_STOP_TIP_NO_PERMISSION: "You do not have permission to edit this setting",
  ACCOUNT_CONFIG_GAME_STOP_TIP_SAVING: "Saving…",
  ACCOUNT_CONFIG_ROW_UPDATED: "Configuration row updated",
  AFFILIATE_REPORT_DOWNLOAD_FAILED: "Couldn't generate the download. Please try again.",
  CREATE_TASK_TASK_TYPE_SOCIALS: "Socials",
  EARLY_PAYOUT: "Early Payout",
  FAILED_TO_LOAD_ACCOUNT_CONFIG: "Failed to load account configuration",
  FAILED_TO_SAVE_ACCOUNT_CONFIG_ROW: "Failed to save account configuration row",
  REPORTING_ACCEPTED_TURNOVER: "Accepted Turnover",
  REPORTING_AVG_STAKE: "Avg. Stake",
  REPORTING_FILTERS_BET_STATUS: "Bet Status",
  REPORTING_FILTERS_LEAGUE: "League",
  REPORTING_FILTERS_MONEY_TYPE: "Money Type",
  REPORTING_FILTERS_SPORT: "Sport",
  REPORTING_FILTERS_STATE: "State",
  REPORTING_FILTERS_TOGGLE_ARIA: "Toggle filters",
  REPORTING_PAGINATION_PER_PAGE: "per page",
  REPORTING_PL_COLUMN: "P&L",
  REPORTING_PROFITABILITY_EVENTS_BOTTOM_20: "Events / Bottom 20 (By Profit)",
  REPORTING_PROFITABILITY_EVENTS_TOP_20: "Events / Top 20 (By Profit)",
  REPORTING_PROFITABILITY_INVALID_DATE: "Invalid date in URL. Expected YYYY-MM-DD.",
  REPORTING_PROFITABILITY_REPORTS: "Profitability Reports",
  REPORTING_PROFITABILITY_SPORTS_PREMATCH: "Sports (Pre-match)",
  REPORTING_PROFITABILITY_STRAIGHT: "Straight",
  REPORTING_PROFITABILITY_STRAIGHTS_AND_PARLAYS: "Straights & Parlays",
  REPORTING_PROFITABILITY_TOTALS_ROW: "Totals",
  REPORTING_SUMMARY_EXPORT_ERROR: "Could not export reporting summary. Try again or contact support.",
  REPORTING_SUMMARY_EXPORT_PENDING: "No rows to export on this page.",
  REPORTING_SUMMARY_FETCH_ERROR: "Could not load reporting summary. Try again or contact support.",
  REPORTING_SUMMARY_RANGE_CLAMPED: "Date range was limited to 100 days for this report.",
  REWARD_TYPE_REBET_CASH: "Rebet Cash",
  REWARD_TYPE_REBET_COINS: "Rebet Coins",
  SEASON_COUNTDOWN_ENDS_IN: "Ends in",
  SEASON_COUNTDOWN_STARTS_IN: "Starts in",
  SEASON_METRIC_CHALLENGES: "Challenges",
  SEASON_METRIC_TASKS: "Tasks",
  SEASON_SCHEDULE_CHALLENGE_NO_TASKS: "Add at least 1 task to the challenge \"{challengeName}\" before scheduling this season.",
  SEASON_SCHEDULE_CHALLENGE_NO_TASKS_GENERIC: "Add at least 1 task to every challenge before scheduling this season.",
  SEASON_SCHEDULE_CONFLICT_GENERIC: "These dates overlap with an existing active or scheduled season. Choose a start and end date that don't conflict.",
  SEASON_SCHEDULE_CONFLICT_NAMED: "These dates overlap with \"{seasonName}\". Choose a start and end date that don't conflict with an existing active or scheduled season.",
  MONTHLY_SCHEDULE_CONFLICT_GENERIC: "These dates overlap with an existing active or scheduled monthly challenge. Choose a start and end date that don't conflict.",
  MONTHLY_SCHEDULE_CONFLICT_NAMED: "These dates overlap with \"{challengeName}\". Choose a start and end date that don't conflict with an existing active or scheduled monthly challenge.",
  SEASON_SCHEDULE_NO_CHALLENGES: "Add at least 1 challenge before scheduling this season.",
  SEASON_STATUS_ACTIVE: "Active",
  SEASON_STATUS_CANCELED: "Canceled",
  SEASON_STATUS_COMPLETED: "Completed",
  SEASON_STATUS_DRAFT: "Draft",
  SEASON_STATUS_UP_NEXT: "Up Next",
  TOP_USERS: "Top Users",
  ACCOUNT_SELLING_SHARING: "Account Selling / Sharing",
  DUPLICATE_REDEMPTION: "Duplicate Redemption",
  MAINTENANCE_MODE: "Maintenance Mode",
  MAINTENANCE_MODE_WEB_APP: "Web App",
  MAINTENANCE_MODE_MOBILE_APP: "Mobile App",
  MAINTENANCE_MODE_DESCRIPTION: "When enabled, the selected app shows a maintenance screen to players.",
  MAINTENANCE_MODE_LOAD_ERROR: "Something went wrong, please try again later.",
  MAINTENANCE_MODE_UPDATE_ERROR: "Something went wrong, please try again later.",
  MAINTENANCE_MODE_UPDATE_SUCCESS: "Maintenance mode updated.",
  MAINTENANCE_MODE_TRY_AGAIN: "Try again",
  MAXIMUM_WIN_AMOUNT: "Maximum Win Amount",
  MAXIMUM_WIN_AMOUNT_HINT: "Enter 0 for no cap",
  MULTIACCOUNTING: "Multiaccounting",
  RECOGNIZED_PATTERNS_WITH_IMPROPER_WAGERS: "Recognized Patterns with Improper Wagers",
  REFERRAL_BONUS_ABUSE: "Referral Bonus Abuse",
  SAVE_CURRENCY_TOOLTIP: "Saves limits for this currency",
  STOLEN_CARDS: "Stolen Cards",
  STUCK_REDEMPTIONS: "Stuck Redemptions",
  CREATE_TASK_ACTION_PLAY: "Play",
  CREATE_TASK_ACTION_WIN: "Win",
  CREATE_TASK_BET_CURRENCY_REBET_CASH: "Rebet Cash",
  CREATE_TASK_BET_CURRENCY_REBET_COINS: "Rebet Coins",
  CREATE_TASK_BET_TYPE_ANY: "Any",
  CREATE_TASK_BET_TYPE_LIVE: "Live",
  CREATE_TASK_BET_TYPE_PARLAY: "Parlay",
  CREATE_TASK_BET_TYPE_SGP: "SGP",
  CREATE_TASK_BET_TYPE_SINGLE: "Single",
  CREATE_TASK_QUALIFIER_ANY_SETTLED: "Any Settled",
  CREATE_TASK_QUALIFIER_WIN: "Win",
  CREATE_TASK_QUALIFIER_WIN_OR_PUSH: "Win or Push",
  CREATE_TASK_SOCIAL_TASK_TYPE_CONSECUTIVE_LOGIN_DAYS: "Consecutive Login Days",
  CREATE_TASK_SOCIAL_TASK_TYPE_CONSECUTIVE_PICK_DAYS: "Consecutive Days Playing a Pick",
  CREATE_TASK_SOCIAL_TASK_TYPE_FOLLOW_X_FOLLOWERS: "Follow X Followers",
  CREATE_TASK_SOCIAL_TASK_TYPE_USER_REFERRED: "Refer a User",
  MARGIN_PCT: "Margin %",
  OVERVIEW_AVG_FTD_AMOUNT: "AVG FTD AMOUNT",
  OVERVIEW_FTD_AMOUNT: "FTD AMOUNT",
  OVERVIEW_FTD_COUNT: "FTD COUNT",
  OVERVIEW_GGR: "GGR",
  OVERVIEW_NEW_USERS: "NEW USERS",
  OVERVIEW_NON_WAGERED_CASH: "NON-WAGERED CASH",
  OVERVIEW_NON_WAGERED_CASH_TOOLTIP: "This is the cash balance of all users that has NOT been wagered. The percent change metric is comparing the Non-Wagered Balance against the value yesterday.",
  OVERVIEW_PROFITABILITY_PCT: "PROFITABILITY %",
  OVERVIEW_REDEEMABILITY_PCT: "REDEMPTION %",
  OVERVIEW_REDEEMABLE_CASH: "REDEEMABLE CASH",
  OVERVIEW_REDEEMABLE_CASH_TOOLTIP: "This is the cash balance of all users that has been wagered at least once. The percent change metric is comparing the Redeemable Cash metric today against its value yesterday.",
  OVERVIEW_REVENUE: "REVENUE",
  OVERVIEW_TOTAL_CASH_BALANCE: "TOTAL CASH BALANCE",
  OVERVIEW_TOTAL_CASH_BALANCE_TOOLTIP: "This is the current Total Cash Balance of all users put together. The Percent change metric is comparing today's cash balance against the balance from yesterday.",
  OVERVIEW_TOTAL_ROUNDS: "TOTAL ROUNDS",
  OVERVIEW_TOTAL_USERS: "TOTAL USERS",
  REWARD_TYPE_FREE_CASH_PICK: "Free Cash Pick",
  REWARD_TYPE_NIRA: "Nira",
  REWARD_TYPE_PROFIT_BOOST: "Profit Boost",
  REWARD_TYPE_USD: "USD",
  REWARD_TYPE_XP: "XP",
  TOTAL_ACTIVE_USERS: "Total Active Users",
  TOTAL_USERS_ALL_TIME_TOOLTIP: "This metric shows Total Users All Time, ignoring the time filter.",
  ACTIVATE_SEASON_CONFIRM_BODY_PREFIX: "Are you sure you would like to activate",
  ACTIVATE_SEASON_CONFIRM_BODY_SUFFIX: "? Players will be able to make progress on this season.",
  ACTIVATE_SEASON_CONFIRM_CTA: "Activate Season",
  ACTIVATE_SEASON_FORCE_BODY_PREFIX: "This season still has challenge groups without tasks configured for",
  ACTIVATE_SEASON_FORCE_BODY_SUFFIX: ". Activate anyway?",
  ACTIVATE_SEASON_FORCE_CTA: "Activate Anyway",
  ACTIVATE_SEASON_FORCE_MODAL_TITLE: "Activate Anyway?",
  ACTIVATE_SEASON_MODAL_TITLE: "Activate Season",
  ACTIVE_SEASON: "Active Season",
  ACTIVE_SEASON_EMPTY_TITLE: "You don't have any active seasons",
  ADD_ANOTHER_REWARD: "+ Add another Reward",
  ADD_CHALLENGE: "Add Challenge",
  ADD_CHALLENGE_FINISH_DRAFT_FIRST: "Save or close your current challenge before adding another",
  ADD_TASK: "Add Task",
  ADD_TASK_REQUIRES_SAVE: "Save the challenge before adding tasks",
  AUTO_START_AFTER: "Auto-start after previous season ends",
  AUTO_START_NO_ACTIVE_SEASON: "There's no active season to auto-start after.",
  CANCELED_SEASON_EMPTY_TITLE: "You don't have any canceled seasons",
  CANCEL_SEASON: "Cancel Season",
  CANCEL_SEASON_CONFIRM_BODY_PREFIX: "Are you sure you would like to cancel",
  CANCEL_SEASON_CONFIRM_BODY_SUFFIX: "? This action is permanent and cannot be undone.",
  CANCEL_SEASON_CONFIRM_CTA: "Cancel Season",
  CANCEL_SEASON_MODAL_TITLE: "Cancel Season",
  CHALLENGES_AND_TASKS: "Challenges & Tasks",
  CHALLENGES_TIER_FREE: "Free",
  CHALLENGES_TIER_PREMIUM: "Premium",
  CHALLENGES_TIER_TABS_ARIA: "Challenge tier",
  CHALLENGE_CLOSE: "Close",
  CHALLENGE_DELETE: "Delete Challenge",
  CHALLENGE_DESCRIPTION: "Challenge Description",
  CHALLENGE_DESCRIPTION_PLACEHOLDER: "Describe what users need to do",
  CHALLENGE_DRAG_HANDLE: "Reorder challenge",
  CHALLENGE_DUPLICATE: "Duplicate",
  CHALLENGE_DUPLICATE_NAME_SUFFIX: " (copy)",
  CHALLENGE_EDIT: "Edit",
  CHALLENGE_EDIT_TASK: "Edit task",
  CHALLENGE_ICON: "Challenge Icon",
  CHALLENGE_ICON_HINT: "PNG or JPG, recommended 96×96.",
  CHALLENGE_ICON_UPLOAD: "Upload Icon",
  CHALLENGE_LABEL_PREFIX: "Challenge",
  CHALLENGE_LIST_ARIA: "Challenges list",
  CHALLENGE_NAME_PLACEHOLDER: "Enter challenge name",
  CHALLENGE_REORDER_FAILED: "Failed to update challenge order",
  CHALLENGE_REORDER_SAVING: "Saving challenge order",
  CHALLENGE_REORDER_SUCCESS: "Challenge order updated",
  CHALLENGE_SAVE: "Save",
  CHALLENGE_TASK_COPY: "Copy task",
  CHALLENGE_TASK_DRAG_HANDLE: "Reorder task",
  CHALLENGE_TASK_IMAGE_ALT: "",
  CHALLENGE_TASK_VIEW: "View task",
  COMPLETED_SEASON_EMPTY_TITLE: "You don't have any completed seasons",
  CREATE_CHALLENGES: "Create Challenges",
  CREATE_CHALLENGES_DESCRIPTION: "Each challenge contains a series of tasks that players must complete. Once all tasks within a challenge are finished, players can collect their rewards and unlock the next challenge in the sequence.",
  CREATE_CHALLENGE_SUCCESS: "Challenge created successfully",
  CREATE_SEASON: "Create Season",
  CREATE_SEASON_BACK_BUTTON_ARIA: "Back to Game Pass season configuration",
  CREATE_SEASON_STEPS_ARIA: "Create Season steps",
  CREATE_SEASON_TASK_SUBMISSION_AUTO: "Auto",
  CREATE_SEASON_TASK_SUBMISSION_MANUAL: "Manual",
  MONTHLY_CHALLENGE_PAGE_TITLE: "Create Monthly Challenge",
  MONTHLY_CHALLENGE_CREATE_CTA: "Create Monthly Challenge",
  MONTHLY_CHALLENGE_BACK_BUTTON_ARIA: "Back to Game Pass configuration",
  MONTHLY_CHALLENGE_STEPS_ARIA: "Create Monthly Challenge steps",
  MONTHLY_CHALLENGE_STEP_CHALLENGES: "Challenges",
  MONTHLY_CHALLENGE_CREATE_SUCCESS: "Monthly challenge created",
  MONTHLY_CHALLENGE_CREATE_ERROR: "Failed to create monthly challenge",
  MONTHLY_CHALLENGE_DELETE: "Delete Monthly Challenge",
  MONTHLY_CHALLENGE_DELETE_ARIA: "Delete monthly challenge",
  MONTHLY_CHALLENGE_DELETE_CONFIRM_BODY: "Are you sure you want to delete this monthly challenge? This can't be undone.",
  MONTHLY_CHALLENGE_DELETE_GO_BACK: "Go Back",
  MONTHLY_CHALLENGE_DELETE_ERROR: "Failed to delete monthly challenge",
  MONTHLY_CHALLENGE_UPDATE_SUCCESS: "Challenge updated",
  MONTHLY_CHALLENGE_UPDATE_ERROR: "Failed to update challenge",
  MONTHLY_CHALLENGE_NAME_LABEL: "Monthly Challenge Name",
  MONTHLY_CHALLENGE_NAME_PLACEHOLDER: "Name",
  MONTHLY_CHALLENGE_LIST_ARIA: "Monthly challenges list",
  MONTHLY_CHALLENGE_CARD_TITLE_PREFIX: "Challenge",
  MONTHLY_CHALLENGE_CARD_NAME_PLACEHOLDER: "Challenge Name",
  MONTHLY_CHALLENGE_CARD_DESCRIPTION_PLACEHOLDER: "Challenge Description",
  MONTHLY_CHALLENGE_TASK_DETAILS: "Task Details",
  MONTHLY_CHALLENGE_TASK_TYPE_LABEL: "Task Type",
  MONTHLY_CHALLENGE_TASK_TYPE_INFO: "The action players must take to make progress on this challenge. Each task type unlocks its own set of fields.",
  MONTHLY_CHALLENGE_TASK_TYPE_FOLLOW_FOR_FOLLOW: "Follow for follow",
  MONTHLY_CHALLENGE_TASK_TYPE_REBETS: "Rebets",
  MONTHLY_CHALLENGE_TASK_TYPE_REFERRAL_BONUS: "Referral Bonus",
  MONTHLY_CHALLENGE_PROVIDER_LABEL: "Provider",
  MONTHLY_CHALLENGE_PROVIDER_INFO: "Only plays on games from this casino provider will count toward the challenge.",
  MONTHLY_CHALLENGE_PROVIDER_PLACEHOLDER: "Select provider",
  MONTHLY_CHALLENGE_GAME_TITLE_LABEL: "Game Title",
  MONTHLY_CHALLENGE_GAME_TITLE_PLACEHOLDER: "Game Title",
  MONTHLY_CHALLENGE_GAME_TITLE_SELECT_PROVIDER_FIRST: "Select a provider first",
  MONTHLY_CHALLENGE_ACTION_LABEL: "Action",
  MONTHLY_CHALLENGE_ACTION_PLAY: "Play",
  MONTHLY_CHALLENGE_ACTION_WIN: "Win",
  MONTHLY_CHALLENGE_MIN_BET_LABEL: "Minimum Bet Amount",
  MONTHLY_CHALLENGE_MIN_BET_PLACEHOLDER: "$10",
  MONTHLY_CHALLENGE_MIN_BET_INFO: "Only plays with a bet of at least this amount will count toward the challenge.",
  MONTHLY_CHALLENGE_WAGER_CURRENCY_LABEL: "Wager Currency",
  MONTHLY_CHALLENGE_WAGER_CURRENCY_PLACEHOLDER: "Select Currency",
  MONTHLY_CHALLENGE_WAGER_CURRENCY_INFO: "Only plays wagered in this currency will count toward the challenge.",
  MONTHLY_CHALLENGE_PICK_TYPE_LABEL: "Pick Type",
  MONTHLY_CHALLENGE_PICK_TYPE_ANY: "Any",
  MONTHLY_CHALLENGE_PICK_TYPE_SINGLE: "Single",
  MONTHLY_CHALLENGE_PICK_TYPE_PARLAY: "Parlay",
  MONTHLY_CHALLENGE_PICK_TYPE_LIVE: "Live",
  MONTHLY_CHALLENGE_SPORTS_LABEL: "Sports",
  MONTHLY_CHALLENGE_SPORTS_PLACEHOLDER: "Select Sports",
  MONTHLY_CHALLENGE_TIERS_LABEL: "Tiers",
  MONTHLY_CHALLENGE_TIER_PREFIX: "Tier",
  MONTHLY_CHALLENGE_TIER_VALUE_PLACEHOLDER: "e.g. 10",
  MONTHLY_CHALLENGE_TIER_REWARD_LABEL: "Reward",
  MONTHLY_CHALLENGE_TIER_REWARD_PLACEHOLDER: "e.g. 50",
  MONTHLY_CHALLENGE_TIER_REWARD_TYPE_ARIA: "Reward type",
  MONTHLY_CHALLENGE_TIER_REMOVE_ARIA: "Remove tier",
  MONTHLY_CHALLENGE_ADD_STEP: "Add Step",
  MONTHLY_CHALLENGE_SAVE: "Save Challenge",
  MONTHLY_CHALLENGE_EDIT_ARIA: "Edit challenge",
  MONTHLY_CHALLENGE_CLOSE_ARIA: "Close challenge",
  MONTHLY_CHALLENGE_LOCKED_INFO: "This challenge is locked while the monthly challenge is active and can no longer be edited.",
  MONTHLY_DETAILS_END: "End Monthly Challenge",
  MONTHLY_DETAILS_END_ARIA: "End monthly challenge",
  MONTHLY_DETAILS_END_CONFIRM_TITLE: "End this monthly challenge?",
  MONTHLY_DETAILS_END_CONFIRM_BODY_PREFIX: "Ending ",
  MONTHLY_DETAILS_END_CONFIRM_BODY_SUFFIX: " completes it immediately for all enrolled players. This can't be undone.",
  MONTHLY_DETAILS_END_CONFIRM_GO_BACK: "Go Back",
  MONTHLY_DETAILS_END_CONFIRM_CTA: "End Challenge",
  MONTHLY_DETAILS_END_SUCCESS: "Monthly challenge ended",
  MONTHLY_DETAILS_END_ERROR: "Failed to end monthly challenge",
  MONTHLY_DETAILS_UNSCHEDULE: "Unschedule",
  MONTHLY_DETAILS_UNSCHEDULE_ARIA: "Unschedule monthly challenge",
  MONTHLY_DETAILS_UNSCHEDULE_CONFIRM_TITLE: "Unschedule this monthly challenge?",
  MONTHLY_DETAILS_UNSCHEDULE_CONFIRM_BODY_PREFIX: "Unscheduling ",
  MONTHLY_DETAILS_UNSCHEDULE_CONFIRM_BODY_SUFFIX: " returns it to draft. It won't go live until it's scheduled again.",
  MONTHLY_DETAILS_UNSCHEDULE_CONFIRM_GO_BACK: "Go Back",
  MONTHLY_DETAILS_UNSCHEDULE_CONFIRM_CTA: "Unschedule",
  MONTHLY_DETAILS_UNSCHEDULE_SUCCESS: "Monthly challenge unscheduled",
  MONTHLY_DETAILS_UNSCHEDULE_ERROR: "Failed to unschedule monthly challenge",
  MONTHLY_DETAILS_SCHEDULE_CTA: "Schedule",
  MONTHLY_DETAILS_SCHEDULE_SUCCESS: "Monthly challenge scheduled",
  MONTHLY_DETAILS_SCHEDULE_ERROR: "Failed to schedule monthly challenge",
  MONTHLY_DETAILS_DELETE_CHALLENGE_CONFIRM_TITLE: "Delete this challenge?",
  MONTHLY_DETAILS_DELETE_CHALLENGE_CONFIRM_BODY_PREFIX: "Deleting ",
  MONTHLY_DETAILS_DELETE_CHALLENGE_CONFIRM_BODY_SUFFIX: " removes it and its task from this monthly challenge. This can't be undone.",
  MONTHLY_DETAILS_DELETE_CHALLENGE_CONFIRM_GO_BACK: "Go Back",
  MONTHLY_DETAILS_DELETE_CHALLENGE_CONFIRM_CTA: "Delete Challenge",
  MONTHLY_DETAILS_DELETE_CHALLENGE_SUCCESS: "Challenge deleted",
  MONTHLY_DETAILS_DELETE_CHALLENGE_ERROR: "Failed to delete challenge",
  MONTHLY_DETAILS_CREATE_CHALLENGE_SUCCESS: "Challenge added",
  MONTHLY_DETAILS_CREATE_CHALLENGE_ERROR: "Failed to add challenge",
  MONTHLY_DETAILS_GENERAL: "General",
  MONTHLY_DETAILS_CHALLENGES_HEADING: "Challenges",
  MONTHLY_DETAILS_BACK_ARIA: "Back to Monthly challenges",
  MONTHLY_DETAILS_BREADCRUMB: "Monthly",
  MONTHLY_DETAILS_EDIT_GENERAL_ARIA: "Edit monthly challenge details",
  MONTHLY_DETAILS_LOCKS_INFO_ARIA:
    "Locks once the start date is reached. After that the monthly challenge can no longer be edited.",
  MONTHLY_DETAILS_NOT_FOUND_TITLE: "Monthly challenge not found",
  MONTHLY_DETAILS_NOT_FOUND_DESCRIPTION: "We couldn't find this monthly challenge. It may have been removed or the link is out of date.",
  CREATE_TASK: "Create Task",
  CREATE_TASK_ACTION: "Action",
  CREATE_TASK_ACTION_AMOUNT: "Action Amount",
  CREATE_TASK_ACTION_AMOUNT_INFO: "How many qualifying plays / wins are required to complete this task.",
  CREATE_TASK_ACTION_AMOUNT_PLACEHOLDER: "e.g. 3",
  CREATE_TASK_BET_CURRENCY: "Bet Currency",
  CREATE_TASK_BET_CURRENCY_PLACEHOLDER: "Select currencies",
  CREATE_TASK_DESCRIPTION: "Task Description",
  CREATE_TASK_DESCRIPTION_COUNTER_ARIA: "Description character count",
  CREATE_TASK_DESCRIPTION_PLACEHOLDER: "Describe the task",
  CREATE_TASK_FAILED: "Failed to create task",
  CREATE_TASK_GENERAL: "General",
  CREATE_TASK_LEAGUE: "League",
  CREATE_TASK_LEAGUE_PLACEHOLDER: "Select League",
  CREATE_TASK_LEAGUE_SEARCH_PLACEHOLDER: "Search leagues",
  CREATE_TASK_MAX_ODDS: "Maximum Odds",
  CREATE_TASK_MIN_BET_AMOUNT: "Minimum Bet Amount",
  CREATE_TASK_MIN_BET_AMOUNT_FLOOR_PREFIX: "Minimum",
  CREATE_TASK_MIN_BET_AMOUNT_FLOOR_SUFFIX: "required",
  CREATE_TASK_MIN_BET_AMOUNT_PLACEHOLDER: "Amount",
  CREATE_TASK_MIN_ODDS: "Minimum Odds",
  CREATE_TASK_MORE_CONDITIONS: "More Conditions",
  CREATE_TASK_NUMBER_OF_BETS: "Number of Bets",
  CREATE_TASK_NUMBER_OF_BETS_PLACEHOLDER: "e.g. 3",
  CREATE_TASK_NUMBER_OF_LEGS: "Number of Legs",
  CREATE_TASK_NUMBER_OF_LEGS_MIN_HINT: "Number of Legs must be 2 or more",
  CREATE_TASK_NUMBER_OF_LEGS_PLACEHOLDER: "e.g. 3",
  CREATE_TASK_PICKER_NO_RESULTS: "No results found.",
  CREATE_TASK_QUALIFIER: "Qualifier",
  CREATE_TASK_REMOVE_CONDITION: "Remove condition",
  CREATE_TASK_REWARD: "Reward",
  CREATE_TASK_SOCIAL_TASK_TYPE_LABEL: "Social Task Type",
  CREATE_TASK_SOCIAL_TASK_TYPE_PLACEHOLDER: "Select a task type",
  CREATE_TASK_SPORT_SPECIFIC: "Sport Specific",
  CREATE_TASK_SPORT_SPECIFIC_PLACEHOLDER: "All Sports",
  CREATE_TASK_SPORT_SPECIFIC_SEARCH_PLACEHOLDER: "Search sports",
  CREATE_TASK_STREAK: "Streak",
  CREATE_TASK_STREAK_DAYS: "Streak(days)",
  CREATE_TASK_SUBMIT: "Create Task",
  CREATE_TASK_SUCCESS: "Task created successfully",
  CREATE_TASK_TASK_NAME: "Task Name",
  CREATE_TASK_TASK_NAME_PLACEHOLDER: "Enter task name",
  CREATE_TASK_TASK_TYPE: "Task Type",
  CREATE_TASK_TRIGGER: "Trigger",
  CREATE_TASK_TYPE_OF_BET: "Type of Bet",
  CREATE_TASK_UPLOAD_IMAGE: "Upload Image",
  CREATE_TASK_WAGER_AMOUNT: "Wager Amount",
  CREATE_TASK_WAGER_AMOUNT_INFO: "The total amount the user must wager to complete this task. Coming soon — this value is not saved yet and will be persisted in a future release.",
  CREATE_TASK_WAGER_AMOUNT_PLACEHOLDER: "e.g. 100",
  CREATE_TASK_XP_AMOUNT: "XP Amount",
  CREATE_TASK_XP_AMOUNT_INFO: "Experience points awarded to the user when this task is completed.",
  CREATE_TASK_XP_AMOUNT_PLACEHOLDER: "e.g. 100",
  CREATE_TASK_X_AMOUNT: "X Amount",
  CREATE_TASK_X_AMOUNT_INFO: "The target value the user must reach to complete this social task.",
  CREATE_TASK_X_AMOUNT_PLACEHOLDER: "e.g. 50",
  CREATE_WIZARD_REQUIRED_FIELDS_HINT: "Required to continue:",
  PAM_DYNAMIC_BONUS_APPLIED_OFFER_TOGGLE_ON: "Step 1 Promo Applied Sportsbet",
  PAM_DYNAMIC_BONUS_APPLIED_OFFER_TOGGLE_OFF: "Any User Sportsbet",
  DYNAMIC_BONUS_SPLIT_APPLIED_OFFER_HINT: "Turn on \u201CStep 1 Promo Applied Sportsbet\u201D so only the bet the user applied the step-1 promo to qualifies.",
  DYNAMIC_BONUS_SPLIT_MONEY_TYPE_HINT: "Bonus-funded bets (free picks) also fire this trigger. Add condition event_field_equals · money_type = rebet_cash so only cash stakes qualify.",
  DYNAMIC_BONUS_PRESET_NO_SWEAT_BET: "No Sweat Bet",
  DYNAMIC_BONUS_PRESET_PARLAY_INSURANCE: "Parlay Insurance",
  // BONENG-788: additional Dynamic Bonus Builder labels (result NL names for
  // Free Pick / Profit Boost / Free Spin / Refund on Loss already exist below).
  PAM_DYNAMIC_BONUS_RESULT_CASH: "Cash",
  PAM_DYNAMIC_BONUS_CASHBACK_PERCENTAGE: "Cashback Percentage",
  PAM_DYNAMIC_BONUS_CASHBACK_PERIOD: "Calculation Period",
  PAM_DYNAMIC_BONUS_CASHBACK_PERIOD_WEEKLY: "Weekly",
  PAM_DYNAMIC_BONUS_CASHBACK_PERIOD_MONTHLY: "Monthly",
  PAM_DYNAMIC_BONUS_CASHBACK_MIN_LOSS: "Minimum Loss Threshold",
  PAM_DYNAMIC_BONUS_CASHBACK_MAX_AMOUNT: "Maximum Cashback Amount",
  PAM_DYNAMIC_BONUS_CASHBACK_PERCENTAGE_HELP:
    "Percent of the period's net loss (wagered minus returned) to return. Must be greater than 0 and at most 100.",
  PAM_DYNAMIC_BONUS_CASHBACK_PERIOD_HELP:
    "Weekly evaluates at midnight Sunday UTC. Monthly evaluates at midnight on the 1st UTC. The trigger event follows this period.",
  PAM_DYNAMIC_BONUS_CASHBACK_MIN_LOSS_HELP:
    "Skip the grant when the period's net loss is below this amount. Leave blank for no threshold.",
  PAM_DYNAMIC_BONUS_CASHBACK_MAX_AMOUNT_HELP:
    "Cap on the cashback grant. Leave blank for no cap. Must be at least the minimum loss threshold when both are set.",
  PAM_DYNAMIC_BONUS_CASHBACK_MAX_BELOW_MIN:
    "Maximum Cashback Amount must be at least the Minimum Loss Threshold",
  PAM_DYNAMIC_BONUS_CASHBACK_EVENT_WEEKLY: "Weekly cashback period ends",
  PAM_DYNAMIC_BONUS_CASHBACK_EVENT_MONTHLY: "Monthly cashback period ends",
  PAM_DYNAMIC_BONUS_RESULT_CASINO_CASH: "Casino Cash",
  PAM_DYNAMIC_BONUS_WALLET_REBET_FREE_CASH: "Rebet Free Cash",
  PAM_DYNAMIC_BONUS_PARAM_AMOUNT: "Amount",
  PAM_DYNAMIC_BONUS_PARAM_PERCENT_OF_TRIGGER_AMOUNT: "% of trigger amount",
  PAM_DYNAMIC_BONUS_PARAM_MAX_AMOUNT: "Max amount",
  PAM_DYNAMIC_BONUS_SIZING_MODE_LABEL: "How the award is sized",
  PAM_DYNAMIC_BONUS_SIZING_FIXED_AMOUNT: "Fixed amount",
  PAM_DYNAMIC_BONUS_CAP_THE_AMOUNT: "Cap the amount",
  PAM_DYNAMIC_BONUS_CAP_OPTIONAL: "optional",
  PAM_DYNAMIC_BONUS_PERCENT_HINT_FREE_PICKS:
    "The free pick is this percent of the original bet or deposit that triggered it, not the to-win amount.",
  PAM_DYNAMIC_BONUS_PERCENT_HINT_FREE_CASH:
    "The cash award is this percent of the deposit or original bet that triggered it, not the to-win amount.",
  PAM_DYNAMIC_BONUS_PERCENT_HINT_REFUND:
    "The refund is this percent of the original bet amount (stake), not the to-win / potential payout.",
  PAM_DYNAMIC_BONUS_PERCENT_HELP_FREE_PICKS:
    "Grants this percentage of the triggering deposit or original bet amount instead of a fixed Amount.",
  PAM_DYNAMIC_BONUS_PERCENT_HELP_FREE_CASH:
    "Credits this percentage of the triggering deposit or original bet amount instead of a fixed Amount.",
  PAM_DYNAMIC_BONUS_PERCENT_HELP_REFUND:
    "Refunds this percentage of the original losing bet amount (stake) instead of a capped dollar amount.",
  PAM_DYNAMIC_BONUS_PARAM_MAX_AMOUNT_HELP:
    'Caps the "% of trigger amount" award at this dollar amount.',
  PAM_DYNAMIC_BONUS_PARAM_CURRENCY: "Currency",
  PAM_DYNAMIC_BONUS_PARAM_CURRENCY_HELP:
    "Defaults to this provider's cash currency. Other currencies for this provider appear in the dropdown when available.",
  PAM_DYNAMIC_BONUS_CURRENCY_LOADING: "Loading currencies…",
  PAM_DYNAMIC_BONUS_CURRENCY_SELECT_PROVIDER: "Select a provider first",
  PAM_DYNAMIC_BONUS_CURRENCY_UNAVAILABLE:
    "Currencies unavailable for this provider. Try again shortly.",
  PAM_DYNAMIC_BONUS_PARAM_WALLET: "Wallet",
  PAM_DYNAMIC_BONUS_PARAM_TRANSACTION_TITLE: "Transaction Title",
  PAM_DYNAMIC_BONUS_PARAM_TRANSACTION_TITLE_HELP:
    "Shown in the user's transaction history.",
  PAM_DYNAMIC_BONUS_PARAM_BOOST_PERCENTAGE: "Boost Percentage",
  PAM_DYNAMIC_BONUS_PARAM_MIN_LEGS: "Minimum Legs",
  PAM_DYNAMIC_BONUS_PARAM_MIN_ODDS: "Minimum Odds",
  PAM_DYNAMIC_BONUS_PARAM_MIN_ODDS_AMERICAN: "Minimum Odds (American)",
  PAM_DYNAMIC_BONUS_PARAM_MIN_ODDS_HELP: "American odds, e.g. 150 or -110.",
  PAM_DYNAMIC_BONUS_PARAM_WAGER_CAP: "Wager Cap",
  PAM_DYNAMIC_BONUS_PARAM_WAGER_CAP_PLACEHOLDER: "Blank for no limit",
  PAM_DYNAMIC_BONUS_PARAM_MIN_BET_AMOUNT: "Min Wager",
  PAM_DYNAMIC_BONUS_PARAM_TOURNAMENT_IDS: "Tournament IDs",
  PAM_DYNAMIC_BONUS_PARAM_MATCH_IDS: "Match IDs",
  PAM_DYNAMIC_BONUS_PARAM_MARKET_IDS: "Market IDs",
  PAM_DYNAMIC_BONUS_SELECT_RESULT_TYPE: "Select a result type",
  PAM_DYNAMIC_BONUS_TYPE_BET_AND_GET: "Bet & Get",
  PAM_DYNAMIC_BONUS_TYPE_CATEGORY_SPORTSBOOK: "Sportsbook",
  PAM_DYNAMIC_BONUS_TYPE_CATEGORY_CASINO: "Casino",
  PAM_DYNAMIC_BONUS_TYPE_CATEGORY_GENERAL: "General",
  PAM_DYNAMIC_BONUS_CAMPAIGN_TYPE_PAM: "PAM",
  PAM_DYNAMIC_BONUS_CAMPAIGN_TYPE_BRAZE: "Braze",
  PAM_DYNAMIC_BONUS_CAMPAIGN_TYPE_DISPLAY_BANNER: "Display Info Banner",
  PAM_DYNAMIC_BONUS_CAMPAIGN_TYPE_LABEL: "Campaign Source",
  PAM_DYNAMIC_BONUS_CAMPAIGN_SOURCE_PICK_LABEL: "Pick a Campaign Source",
  PAM_DYNAMIC_BONUS_CAMPAIGN_SOURCE_REQUIRED:
    "Select Braze or PAM before choosing a template.",
  PAM_DYNAMIC_BONUS_MESSAGE_TYPE_TOOLTIP:
    "Choose whether this campaign is delivered by Braze or PAM.",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_SECTION_TITLE: "Banner creative",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_SECTION_HINT:
    "Place an image and a button anywhere on the banner canvas. No bonus is attached.",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_IMAGE_HINT:
    "Upload or paste a creative. Size the image to match the banner aspect ratio.",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_IMAGE_REQUIRED: "Image is required",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_LABEL: "Button label",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_HINT:
    "Toggle the button, style it, set width/height, and drag it on the canvas. Position is stored as % of the banner.",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_PLACEHOLDER: "Play now",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_SECTION: "Button",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_SIZE: "Size",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_WIDTH: "Width %",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_HEIGHT: "Height %",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_POSITION: "Position",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_POSITION_HINT:
    "Drag the button on the preview. Values are percentages of the banner.",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_POS_X: "X",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_POS_Y: "Y",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_BUTTON_STYLE: "Style",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_DROP_IMAGE: "Upload or paste an image URL",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_SURFACES_HINT:
    "Choose which surfaces show this banner. Priority uses the same ordering as bonus banners.",
  PAM_DYNAMIC_BONUS_DISPLAY_BANNER_SURFACES_REQUIRED:
    "Select at least one display surface",
  PAM_DYNAMIC_BONUS_NAME_LABEL: "Name",
  PAM_DYNAMIC_BONUS_NAME_TOOLTIP: "Internal name used to identify this campaign.",
  PAM_DYNAMIC_BONUS_PRIORITY_LABEL: "Priority",
  PAM_DYNAMIC_BONUS_PRIORITY_TOOLTIP:
    "Higher priority campaigns take precedence when multiple campaigns compete.",
  PAM_DYNAMIC_BONUS_RUN_FOR_LABEL: "Run for",
  PAM_DYNAMIC_BONUS_RUN_FOR_TOOLTIP:
    "How long the campaign stays available after it starts.",
  PAM_DYNAMIC_BONUS_SELECT_AUDIENCE_LABEL: "Select Audience",
  PAM_DYNAMIC_BONUS_SELECT_AUDIENCE_TOOLTIP:
    "Choose who this campaign applies to. Segment membership is evaluated when the trigger fires.",
  PAM_DYNAMIC_BONUS_AUDIENCE_ALL_USERS: "All users",
  PAM_DYNAMIC_BONUS_AUDIENCE_ALL_USERS_DESCRIPTION:
    "Every eligible user can receive this campaign",
  PAM_DYNAMIC_BONUS_AUDIENCE_SEGMENT: "Segment",
  PAM_DYNAMIC_BONUS_AUDIENCE_SEGMENT_DESCRIPTION:
    "Only users in a selected segment qualify.",
  PAM_DYNAMIC_BONUS_SELECT_SEGMENT: "Select Segment",
  PAM_DYNAMIC_BONUS_SELECT_SEGMENT_REQUIRED: "Select a segment",
  PAM_DYNAMIC_BONUS_LOADING_SEGMENTS: "Loading segments…",
  PAM_DYNAMIC_BONUS_DURATION_HOURS: "Hours",
  PAM_DYNAMIC_BONUS_DURATION_DAYS: "Days",
  PAM_DYNAMIC_BONUS_DURATION_NEVER_EXPIRES: "Never expires",
  PAM_DYNAMIC_BONUS_DURATION_CUSTOM: "Custom",
  PAM_DYNAMIC_BONUS_TRIGGER_BASIC: "Campaign Start",
  PAM_DYNAMIC_BONUS_TRIGGER_EVENT: "Event",
  PAM_DYNAMIC_BONUS_TRIGGER_FRIEND_REFERRAL: "Referral",
  PAM_DYNAMIC_BONUS_TRIGGER_AFFILIATE_REFERRAL: "Affiliate Referral",
  PAM_DYNAMIC_BONUS_CAMPAIGN_TRANSITION_CONFIRM_TITLE: "{action} this campaign?",
  PAM_DYNAMIC_BONUS_TRIGGER_TYPE_LABEL: "Campaign Type",
  PAM_DYNAMIC_BONUS_TRIGGER_TYPE_TOOLTIP:
    "Campaign Start runs when the campaign begins. Event waits for a user action. Referral awards when a referred user signs up. Affiliate Referral awards on a tracked affiliate referral. Display Info Banner creates a standalone PAM banner.",
  PAM_DYNAMIC_BONUS_TRIGGER_SUMMARY_NONE: "None",
  PAM_DYNAMIC_BONUS_TRIGGER_SUMMARY_CAMPAIGN_START: "Campaign Start",
  PAM_DYNAMIC_BONUS_COLUMN_TRIGGER: "Trigger",
  PAM_DYNAMIC_BONUS_SEGMENT_TRIGGER_DEPOSIT_COMPLETED: "Deposit completed",
  PAM_DYNAMIC_BONUS_SEGMENT_TRIGGER_BET_SETTLED: "Bet settled",
  PAM_DYNAMIC_BONUS_SEGMENT_TRIGGER_USER_SIGNUP: "User signup",
  PAM_DYNAMIC_BONUS_SEGMENT_TRIGGER_KYC_VERIFIED: "KYC verified",
  PAM_DYNAMIC_BONUS_REVIEW_AUDIENCE_LABEL: "Audience",
  PAM_DYNAMIC_BONUS_REVIEW_TRIGGER_LABEL: "Trigger",
  PAM_DYNAMIC_BONUS_REVIEW_AFFILIATE_CODE_LABEL: "Affiliate code",
  PAM_DYNAMIC_BONUS_REVIEW_STEPS_LABEL: "Steps",
  PAM_DYNAMIC_BONUS_REVIEW_STEP_EVENT: "Step {n} event",
  PAM_DYNAMIC_BONUS_REVIEW_ACTIVATE_TITLE: "Review Details & Activate",
  PAM_DYNAMIC_BONUS_REVIEW_NAME_LABEL: "Name",
  PAM_DYNAMIC_BONUS_REVIEW_STARTS_LABEL: "Starts",
  PAM_DYNAMIC_BONUS_REVIEW_ENDS_LABEL: "Ends",
  PAM_DYNAMIC_BONUS_REVIEW_STARTS_IMMEDIATE: "Immediately (on create)",
  PAM_DYNAMIC_BONUS_REVIEW_BANNER_LABEL: "Banner {n}",
  PAM_DYNAMIC_BONUS_EMPTY_VALUE: "—",
  PAM_DYNAMIC_BONUS_CREATE_CAMPAIGN_MODAL_TITLE: "Create Campaign",
  PAM_DYNAMIC_BONUS_BACK_TO_TEMPLATES: "Back to Templates",
  PAM_DYNAMIC_BONUS_BACK_TO_SERIES: "Back to series",
  PAM_DYNAMIC_BONUS_BACK_TO_CAMPAIGNS: "Back to Campaigns",
  PAM_DYNAMIC_BONUS_PRIORITY_LOW: "Low",
  PAM_DYNAMIC_BONUS_PRIORITY_MEDIUM: "Medium",
  PAM_DYNAMIC_BONUS_PRIORITY_HIGH: "High",
  PAM_DYNAMIC_BONUS_PRIORITY_ARIA: "Campaign priority",
  PAM_DYNAMIC_BONUS_NAME_REQUIRED: "Name is required",
  PAM_DYNAMIC_BONUS_TEMPLATE_NAME_PLACEHOLDER: "Template name",
  PAM_DYNAMIC_BONUS_SERIES_NAME_PLACEHOLDER: "Series name",
  PAM_DYNAMIC_BONUS_CAMPAIGN_NAME_PLACEHOLDER: "Campaign name",
  PAM_DYNAMIC_BONUS_BANNER_NAME_PLACEHOLDER: "Banner name",
  PAM_DYNAMIC_BONUS_CREATE_DISPLAY_BANNER: "Create Display Info Banner",
  PAM_DYNAMIC_BONUS_DESCRIPTION_PLACEHOLDER: "Optional description",
  PAM_DYNAMIC_BONUS_CUSTOM_SCHEDULE_REQUIRED:
    "Select start and end dates for a custom schedule",
  PAM_DYNAMIC_BONUS_DURATION_ARIA: "Campaign duration",
  PAM_DYNAMIC_BONUS_DURATION_AMOUNT_ARIA: "Duration amount",
  PAM_DYNAMIC_BONUS_DURATION_UNIT_ARIA: "Duration unit",
  PAM_DYNAMIC_BONUS_SCHEDULE_ENDS_4H: "4 hours after campaign start",
  PAM_DYNAMIC_BONUS_SCHEDULE_ENDS_12H: "12 hours after campaign start",
  PAM_DYNAMIC_BONUS_SCHEDULE_ENDS_24H: "24 hours after campaign start",
  PAM_DYNAMIC_BONUS_SCHEDULE_ENDS_7D: "7 days after campaign start",
  PAM_DYNAMIC_BONUS_SCHEDULE_ENDS_30D: "30 days after campaign start",
  PAM_DYNAMIC_BONUS_SCHEDULE_ENDS_N_HOURS: "{n} hours after campaign start",
  PAM_DYNAMIC_BONUS_SCHEDULE_ENDS_N_DAYS: "{n} days after campaign start",
  PAM_DYNAMIC_BONUS_SCHEDULE_NEVER_OPEN_ENDED: "Never (open-ended)",
  PAM_DYNAMIC_BONUS_SCHEDULE_START_LOCKED:
    "Start is locked because this campaign has already begun — you can still change when it ends.",
  PAM_DYNAMIC_BONUS_CAMPAIGN_LOAD_ERROR: "Failed to load campaign.",
  PAM_DYNAMIC_BONUS_CLONE_CAMPAIGN_LOAD_ERROR:
    "Failed to load the campaign to duplicate.",
  PAM_DYNAMIC_BONUS_CLONE_TEMPLATE_LOAD_ERROR:
    "Failed to load the template to duplicate.",
  PAM_DYNAMIC_BONUS_AFFILIATE_CAMPAIGN_TITLE: "New Affiliate Referral Campaign",
  PAM_DYNAMIC_BONUS_WIZARD_ARIA_AFFILIATE_CAMPAIGN: "Create affiliate campaign steps",
  PAM_DYNAMIC_BONUS_WIZARD_STEP_REWARD: "Reward",
  PAM_DYNAMIC_BONUS_WIZARD_STEP_TIMING: "Timing",
  PAM_DYNAMIC_BONUS_AFFILIATE_STEP_HINT:
    "Search for an affiliate by name, then pick one of their active referral codes. Any new user who signs up with that code receives the bonus configured in the next step.",
  PAM_DYNAMIC_BONUS_CAMPAIGN_NAME_LABEL: "Campaign Name",
  PAM_DYNAMIC_BONUS_CAMPAIGN_NAME_REQUIRED: "Campaign name is required",
  PAM_DYNAMIC_BONUS_AFFILIATE_CAMPAIGN_NAME_PLACEHOLDER:
    "e.g. Affiliate Bonus — PartnerX Q3",
  PAM_DYNAMIC_BONUS_AFFILIATE_SELECT_REQUIRED: "Select an affiliate",
  PAM_DYNAMIC_BONUS_AFFILIATE_SEARCH_PLACEHOLDER: "Search by name…",
  PAM_DYNAMIC_BONUS_AFFILIATE_NOT_FOUND: "No affiliates found",
  PAM_DYNAMIC_BONUS_REFERRAL_CODE_REQUIRED: "Select a referral code",
  PAM_DYNAMIC_BONUS_REFERRAL_CODE_ACTIVE_TOOLTIP:
    "Only active, non-disabled codes are shown",
  PAM_DYNAMIC_BONUS_SELECT_AFFILIATE_FIRST: "Select an affiliate first",
  PAM_DYNAMIC_BONUS_LOADING_CODES: "Loading codes…",
  PAM_DYNAMIC_BONUS_NO_ACTIVE_CODES: "No active codes",
  PAM_DYNAMIC_BONUS_PICK_A_CODE: "Pick a code",
  PAM_DYNAMIC_BONUS_REWARD_STEP_HINT:
    "Choose what the referred user receives when they sign up.",
  PAM_DYNAMIC_BONUS_REWARD_TYPE_LABEL: "Reward Type",
  PAM_DYNAMIC_BONUS_REWARD_TYPE_REQUIRED: "Pick a reward type",
  PAM_DYNAMIC_BONUS_RESULT_FREE_SPINS: "Free Spins",
  PAM_DYNAMIC_BONUS_REWARD_FREE_CASH_DESCRIPTION:
    "Credit the referred user's account with free cash.",
  PAM_DYNAMIC_BONUS_REWARD_FREE_SPINS_DESCRIPTION:
    "Grant the referred user free spins on selected games.",
  PAM_DYNAMIC_BONUS_MAX_AWARDS_PER_USER: "Max awards per user",
  PAM_DYNAMIC_BONUS_MAX_AWARDS_TOOLTIP:
    "Counts each award step of a campaign run. Leave blank for no cap.",
  PAM_DYNAMIC_BONUS_MAX_AWARDS_BELOW_STEPS:
    "Max awards per user must be at least {count} — this campaign has {count} award steps.",
  PAM_DYNAMIC_BONUS_MAX_AWARDS_PLACEHOLDER: "e.g. 1",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY: "Award Frequency",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_ONE_TIME: "One-time",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_DAILY: "Daily",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_WEEKLY: "Weekly",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_MONTHLY: "Monthly",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_CUSTOM: "Custom",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_NO_LIMIT: "No frequency limit",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_TOOLTIP:
    "How often a user can receive this award.",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_HINT:
    "Daily, Weekly, and Monthly are rolling windows (24 hours / 7 days / 30 days since the last award), not calendar resets.",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_CUSTOM_AMOUNT: "Frequency amount",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_CUSTOM_UNIT: "Frequency unit",
  PAM_DYNAMIC_BONUS_AWARD_FREQUENCY_CUSTOM_REQUIRED: "Enter a frequency amount",
  PAM_DYNAMIC_BONUS_FIELD_REQUIRED: "{title} is required",
  PAM_DYNAMIC_BONUS_SELECT_FIELD: "Select {title}",
  PAM_DYNAMIC_BONUS_TIMING_STEP_HINT:
    "Set how long this campaign runs. Leave the end date blank for an ongoing campaign.",
  PAM_DYNAMIC_BONUS_CAMPAIGN_PERIOD_LABEL: "Campaign Period",
  PAM_DYNAMIC_BONUS_AFFILIATE_PRIORITY_TOOLTIP:
    "Higher number wins when multiple campaigns overlap (default 0)",
  PAM_DYNAMIC_BONUS_PRIORITY_PLACEHOLDER: "e.g. 10",
  PAM_DYNAMIC_BONUS_AFFILIATE_REVIEW_HINT:
    "Review your affiliate campaign before creating it.",
  PAM_DYNAMIC_BONUS_REVIEW_CAMPAIGN_NAME: "Campaign name",
  PAM_DYNAMIC_BONUS_REVIEW_REWARD_TYPE: "Reward type",
  PAM_DYNAMIC_BONUS_REVIEW_MAX_AWARDS: "Max awards / user",
  PAM_DYNAMIC_BONUS_NO_CAP: "No cap",
  PAM_DYNAMIC_BONUS_OPEN_ENDED: "Open-ended",
  PAM_DYNAMIC_BONUS_WIZARD_STEP_REVIEW: "Review",
  PAM_DYNAMIC_BONUS_REVIEW_STARTS_AT: "Starts at",
  PAM_DYNAMIC_BONUS_REVIEW_ENDS_AT: "Ends at",
  PAM_CAMPAIGNS_COLUMN_START: "Start",
  PAM_DYNAMIC_BONUS_AFFILIATE_WHAT_WILL_BE_CREATED_TITLE: "What will be created:",
  PAM_DYNAMIC_BONUS_AFFILIATE_WHAT_WILL_BE_CREATED:
    "A campaign that fires whenever a new user registers using affiliate code {code}. The referred user automatically receives a {reward} award. Duplicate awards are blocked by Max awards / user{maxAwards}.",
  PAM_DYNAMIC_BONUS_REWARD_TYPE_UNAVAILABLE: "Reward type unavailable",
  PAM_DYNAMIC_BONUS_REWARD_CATALOG_MISMATCH:
    '"{reward}" isn\'t recognized by the current catalog. Go back to the Reward step and pick a different reward before submitting.',
  PAM_DYNAMIC_BONUS_REWARD_CATALOG_ERROR:
    "This reward type isn't recognized by the current catalog. Go back to the Reward step and pick a different reward.",
  PAM_DYNAMIC_BONUS_SUMMARY_MAX_PER_USER: "Max / user",
  PAM_DYNAMIC_BONUS_BANNER_PREVIEW: "Banner preview",
  PAM_DYNAMIC_BONUS_BANNER_HIDE_CUSTOMIZATION: "Hide customization",
  PAM_DYNAMIC_BONUS_BANNER_DESIGN_HEADING: "Banner design",
  PAM_DYNAMIC_BONUS_BANNER_BG_GRADIENT: "Background gradient",
  PAM_DYNAMIC_BONUS_BANNER_BORDER_GRADIENT: "Border gradient",
  PAM_DYNAMIC_BONUS_BANNER_GRADIENT_TOOLTIP:
    "Add one color for solid, or multiple for a gradient",
  PAM_DYNAMIC_BONUS_BANNER_DETAILS_LINK_HEADING: "Details link",
  PAM_DYNAMIC_BONUS_BANNER_DETAILS_COLOR: "Details color",
  PAM_DYNAMIC_BONUS_BANNER_SHOW_DETAILS_LINK: "Show details link",
  PAM_DYNAMIC_BONUS_BANNER_COUNTDOWN_TIMER: "Countdown timer",
  PAM_DYNAMIC_BONUS_BANNER_SHOW_TIMER: "Show timer",
  PAM_DYNAMIC_BONUS_BANNER_BG_COLOR: "Background color",
  PAM_DYNAMIC_BONUS_BANNER_SHORT_DESCRIPTION: "Short description",
  PAM_DYNAMIC_BONUS_BANNER_SHORT_DESCRIPTION_PLACEHOLDER:
    "Short banner description",
  PAM_DYNAMIC_BONUS_BANNER_SHORT_DESCRIPTION_REQUIRED:
    "Banner short description is required",
  PAM_DYNAMIC_BONUS_BANNER_SHORT_DESCRIPTION_COLOR: "Short description color",
  PAM_DYNAMIC_BONUS_BANNER_LONG_DESCRIPTION: "Long description",
  PAM_DYNAMIC_BONUS_BANNER_LONG_DESCRIPTION_PLACEHOLDER:
    "Full offer description",
  PAM_DYNAMIC_BONUS_BANNER_IMAGE_URL: "Image URL",
  PAM_DYNAMIC_BONUS_BANNER_IMAGE_URL_PLACEHOLDER:
    "https://cdn.example.com/banner.png",
  PAM_DYNAMIC_BONUS_BANNER_SHOW_CLAIM: "Show claim button",
  PAM_DYNAMIC_BONUS_BANNER_CLAIM_PLACEHOLDER: "Claim",
  PAM_DYNAMIC_BONUS_BANNER_HEX_COLOR_RULE: "Use #RRGGBB or #RRGGBBAA",
  PAM_DYNAMIC_BONUS_BANNER_HEX_COLOR_LIST_RULE:
    "Each stop must be a valid #RRGGBB or #RRGGBBAA color",
  PAM_DYNAMIC_BONUS_BANNER_HTTP_URL_RULE: "Enter a valid http(s) URL",
  PAM_DYNAMIC_BONUS_BANNER_THEME_BRAND: "Brand",
  PAM_DYNAMIC_BONUS_BANNER_THEME_LIGHT: "Brand - Light",
  PAM_DYNAMIC_BONUS_BANNER_THEME_DARK: "Brand - Dark",
  PAM_DYNAMIC_BONUS_BANNER_FIELDS_MESSAGE: "Banner Message",
  PAM_DYNAMIC_BONUS_BANNER_FIELDS_TITLE_PLACEHOLDER:
    "e.g. 20 Trivelta Free Cash Drops",
  PAM_DYNAMIC_BONUS_BANNER_FIELDS_MESSAGE_PLACEHOLDER:
    "e.g. Enjoy tailored offers with fewer restrictions and maximize your winnings.",
  PAM_DYNAMIC_BONUS_BANNER_PREVIEW_MESSAGE_FALLBACK:
    "Your banner message will appear here as you type.",
  PAM_DYNAMIC_BONUS_BANNER_TIMER_PREVIEW: "24 hr",
  PAM_DYNAMIC_BONUS_BANNER_PICK_COLOR: "Pick color",
  PAM_DYNAMIC_BONUS_BANNER_REMOVE_COLOR: "Remove color {index}",
  PAM_DYNAMIC_BONUS_BANNER_UPLOAD_FAIL: "Failed to upload image",
  PAM_DYNAMIC_BONUS_BANNER_UPLOAD_REJECT_TYPE: "Banner image must be a PNG",
  PAM_DYNAMIC_BONUS_BANNER_UPLOAD_REJECT_SIZE:
    "Banner image must be {maxKb} KB or smaller",
  PAM_DYNAMIC_BONUS_BANNER_UPLOADING: "Uploading…",
  PAM_DYNAMIC_BONUS_BANNER_UPLOAD_DROPZONE: "Drag and drop to upload image",
  PAM_DYNAMIC_BONUS_BANNER_UPLOAD_HINT: "Support: PNG up to {maxKb} KB",
  PAM_DYNAMIC_BONUS_BANNER_UPLOAD_ARIA: "Banner image upload",
  PAM_PROMOTIONS_STATUS_ACTIVE: "Active",
  PAM_PROMOTIONS_STATUS_NOT_STARTED: "Not Started",
  PAM_PROMOTIONS_STATUS_FINISHED: "Finished",
  PAM_PROMOTIONS_STATUS_DRAFTS: "Drafts",
  PAM_PROMOTIONS_STATUS_ARCHIVED: "Archived",
  PAM_PROMOTIONS_FROM_TOTAL_VOLUME: "from total volume",
  PAM_PROMOTIONS_FROM_TOTAL_WAGERED: "from total wagered",
  PAM_PROMOTIONS_PURCHASE_ICON_ALT: "Purchase icon",
  PAM_PROMOTIONS_CHART_PURCHASES: "PURCHASES",
  PAM_PROMOTIONS_CHART_PLAYERS_RECEIVED: "PLAYERS RECEIVED",
  PAM_PROMOTIONS_CHART_PLAYERS_USED: "PLAYERS USED",
  PAM_USER_PROMOTIONS_TAB: "User Promotions",
  PAM_USER_REFERRALS_TAB: "Referrals",
  PAM_USER_PROMOTIONS_SECTIONS: "User promotion sections",
  PAM_USER_PROMOTIONS_RECEIVED: "Number of promos received",
  PAM_USER_PROMOTIONS_CLAIMED_COUNT: "Number of promos claimed",
  PAM_USER_PROMOTIONS_SPORTSBOOK_CASH_CLAIMED:
    "Sportsbook free cash claimed",
  PAM_USER_PROMOTIONS_CASINO_CASH_CLAIMED: "Casino cash claimed",
  PAM_USER_PROMOTIONS_SENT_AT: "Date & time sent",
  PAM_USER_PROMOTIONS_PROMO_ID: "Promo ID",
  PAM_USER_PROMOTIONS_PROMO_TYPES: "Promo type(s)",
  PAM_USER_PROMOTIONS_POTENTIAL_BONUSES: "Potential bonuses",
  PAM_USER_PROMOTIONS_NOT_APPLICABLE: "—",
  PAM_USER_PROMOTIONS_EMPTY: "No promotions found",
  PAM_USER_PROMOTIONS_LOAD_ERROR: "Unable to load user promotions",
  PAM_USER_REFERRALS_TOTAL: "Total users referred",
  PAM_USER_REFERRALS_PURCHASING: "Total purchasing users referred",
  PAM_USER_REFERRALS_LIFETIME_VALUE:
    "Total lifetime value of users referred",
  PAM_USER_REFERRALS_DEPOSIT: "Deposit",
  PAM_USER_REFERRALS_DEPOSIT_DATE: "Deposit Date",
  PAM_USER_REFERRALS_IP_ADDRESS: "IP Address",
  PAM_USER_REFERRALS_REGISTRATION_SCORE: "Registration Score",
  PAM_USER_REFERRALS_INVITATION_DATE: "Invitation Date",
  PAM_USER_REFERRALS_EMPTY: "No referrals found",
  PAM_NEW_PROMOTION_SCHEDULE_DELIVERY: "Schedule Delivery",
  PAM_NEW_PROMOTION_SELECT_FREQUENCY: "Select frequency",
  PAM_NEW_PROMOTION_FREQ_ONCE: "Once",
  PAM_NEW_PROMOTION_FREQ_DAILY: "Daily",
  PAM_NEW_PROMOTION_FREQ_MONTHLY: "Monthly",
  PAM_NEW_PROMOTION_FREQ_WEEKLY: "Weekly",
  PAM_NEW_PROMOTION_ODDS_LIMIT: "Odds Limit",
  PAM_NEW_PROMOTION_EX_1: "ex: 1",
  PAM_NEW_PROMOTION_EX_DAY: "ex: day",
  PAM_NEW_PROMOTION_PURCHASE_MATCH_DESC:
    "Create a deposit bonus campaign to give players extra funds based on their deposit amount",
  PAM_NEW_PROMOTION_FREE_BETS_DESC:
    "Create a one-time free bet promotion to engage new players",
  PAM_NEW_PROMOTION_PROFIT_BOOST_DESC:
    "Create an odds boost for parlays with a specific number of legs",
  PAM_NEW_PROMOTION_PROMO_PREVIEW: "Promo Preview",
  PAM_NEW_PROMOTION_ACTION_BUTTON_ARIA: "Action button",
  PAM_NEW_PROMOTION_INFO_ARIA: "Information",
  PAM_NEW_PROMOTION_TARGETING_INTRO:
    "Target players by choosing multiple segments they must fall into. Further refine your audience by adding additional filters.",
  PAM_NEW_PROMOTION_DISTRIBUTE_VARIANTS_EVENLY: "Distribute Variants Evenly",
  PAM_NEW_PROMOTION_ALL_STATES: "All states",
  PAM_NEW_PROMOTION_SEND_AS_SOON_LOCAL:
    "Send as soon as Promo is launched to players in their local time zone",
  PAM_AFFILIATE_PROMO_CREATE_APPSONAIR_LINK: "Create AppsOnAir Link?",
  PAM_AFFILIATE_PROMO_CUSTOM_URL_PLACEHOLDER: "https://example.com",
  PAM_AFFILIATE_PROMO_VALIDATION_REQUIRED_CUSTOM_URL:
    "Please enter a custom URL.",
  PAM_AFFILIATE_PROMO_VALIDATION_INVALID_CUSTOM_URL:
    "Please enter a valid URL (including https://).",
  PAM_AFFILIATE_PROMO_REWARD_SPORTSBOOK_FREE_CASH: "Sportsbook Free Cash",
  PAM_AFFILIATE_PROMO_REWARD_CASINO_DEPOSIT_MATCH: "Casino Deposit Match",
  PAM_DYNAMIC_BONUS_SUMMARY_END: "End",
  PAM_DYNAMIC_BONUS_EDIT_TEMPLATE: "Edit Template",
  PAM_CAMPAIGNS_COLUMN_ENDS: "Ends",
  PAM_DYNAMIC_BONUS_TEMPLATE_LOAD_ERROR: "Failed to load template.",
  PAM_DYNAMIC_BONUS_SERIES_FALLBACK: "Series",
  PAM_DYNAMIC_BONUS_SERIES_CAMPAIGNS_COUNT: "Campaigns ({count})",
  PAM_DYNAMIC_BONUS_TEST_SEND_DESCRIPTION:
    "Send a test of this campaign's first step to specific users so you can validate it before launching. Enter one or more user IDs or usernames. Test sends don't affect the real audience or count toward campaign stats.",
  PAM_DYNAMIC_BONUS_TEST_SEND_DESCRIPTION_ALL_STEPS:
    "Send a test of every step in this campaign to specific users so you can validate it before launching. Each step is delivered on its own, so you can review them all without having to complete the campaign. Enter one or more user IDs or usernames. Test sends don't affect the real audience or count toward campaign stats.",
  PAM_DYNAMIC_BONUS_TEST_SEND_AWARD_WARNING:
    "Steps that award a bonus grant it for real to every recipient, and per-user award caps don't apply to a test send. Only send to accounts you're happy to credit.",
  PAM_DYNAMIC_BONUS_TEST_RECIPIENTS_PLACEHOLDER:
    "Add user ID or username, press Enter",
  PAM_DYNAMIC_BONUS_TEST_RECIPIENTS_ARIA: "Test recipients",
  PAM_DYNAMIC_BONUS_TEST_SEARCH_UNAVAILABLE:
    "User lookup is unavailable. Enter user IDs or usernames directly.",
  PAM_DYNAMIC_BONUS_TEST_INVALID_RECIPIENTS_TITLE:
    "Some recipients could not be found",
  PAM_DYNAMIC_BONUS_TEST_INVALID_RECIPIENTS_BODY:
    "These entries couldn't be matched to a user. Fix or remove them and try again:",
  PAM_DYNAMIC_BONUS_TEST_SENT_SINGULAR:
    "Test sent to 1 user ({steps}): {recipients}",
  PAM_DYNAMIC_BONUS_TEST_SENT_PLURAL:
    "Test sent to {count} users ({steps}): {recipients}",
  PAM_DYNAMIC_BONUS_TEST_SENT_STEPS_SINGULAR: "1 step",
  PAM_DYNAMIC_BONUS_TEST_SENT_STEPS_PLURAL: "{count} steps",
  PAM_DYNAMIC_BONUS_BRAZE_MODAL_HINT:
    "Braze campaigns never expire — they run until paused, and each subscribed user's run is tracked independently.",
  PAM_DYNAMIC_BONUS_CAMPAIGN_NAME_FROM_TEMPLATE: "{templateName} Campaign",
  DYNAMIC_BONUS_BANNER_RESET_IMAGE: "Reset to default",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_LABEL: "Deeplink Destination",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_PLACEHOLDER: "Select a Screen",
  PAM_DYNAMIC_BONUS_DEEPLINK_LABEL: "Deeplink",
  PAM_DYNAMIC_BONUS_DEEPLINK_REMOVE: "Remove",
  PAM_DYNAMIC_BONUS_DEEPLINK_VALUE_PLACEHOLDER: "Enter a value",
  PAM_DYNAMIC_BONUS_DEEPLINK_LEAGUE_ID_REQUIRED:
    "Enter a Tournament ID or Sport ID.",
  PAM_DYNAMIC_BONUS_DEEPLINK_CATALOG_ID_REQUIRED: "Enter an EID or Code.",
  PAM_DYNAMIC_BONUS_TOURNAMENT_ID: "Tournament ID",
  PAM_DYNAMIC_BONUS_SPORT_ID: "Sport ID",
  PAM_DYNAMIC_BONUS_PROVIDER_ID: "Provider ID",
  PAM_DYNAMIC_BONUS_EID: "EID",
  DELETE_CHALLENGE_CONFIRM_CTA: "Delete",
  DELETE_CHALLENGE_CONFIRM_PREFIX: "Are you sure you would like to delete",
  DELETE_CHALLENGE_GO_BACK: "Go Back",
  DELETE_CHALLENGE_MODAL_TITLE: "Delete",
  DELETE_SEASON_CONFIRM_BODY_PREFIX: "Are you sure you want to delete this season? (Reminder: Please duplicate the season to drafts before deletion)",
  DELETE_SEASON_CONFIRM_BODY_SUFFIX: "",
  DELETE_SEASON_CONFIRM_CTA: "Delete Season",
  DELETE_SEASON_GO_BACK: "Go Back",
  DELETE_SEASON_MODAL_TITLE: "Delete Season",
  DELETE_TASK_CONFIRM_CTA: "Delete",
  DELETE_TASK_CONFIRM_PREFIX: "Are you sure you would like to delete",
  DELETE_TASK_FAILED: "Failed to delete task",
  DELETE_TASK_GO_BACK: "Go Back",
  DELETE_TASK_MODAL_TITLE: "Delete",
  DRAFT_SEASON_EMPTY_TITLE: "You don't have any draft seasons",
  EDIT_SEASON_DELETE_SEASON: "Delete Season",
  EDIT_SEASON_DESCRIPTION_COUNTER_ARIA: "Season description character count",
  EDIT_SEASON_DESCRIPTION_LABEL: "Season Description",
  EDIT_SEASON_DESCRIPTION_PLACEHOLDER: "Description",
  EDIT_SEASON_GENERAL_HEADING: "General",
  EDIT_SEASON_GENERAL_INFO_ARIA: "General details for this season — name, description and which tiers it exposes.",
  EDIT_SEASON_MODAL_TITLE_PREFIX: "Edit",
  EDIT_SEASON_PREMIUM_PRICE_GC_LABEL: "Premium Price (GC)",
  EDIT_SEASON_PREMIUM_PRICE_GC_PLACEHOLDER: "Enter premium price (GC)",
  EDIT_SEASON_PREMIUM_PRICE_SC_LABEL: "Premium Price (SC)",
  EDIT_SEASON_PREMIUM_PRICE_SC_PLACEHOLDER: "Enter premium price (SC)",
  EDIT_SEASON_SAVE: "Save",
  EDIT_SEASON_SCHEDULING_HEADING: "Scheduling",
  EDIT_SEASON_SCHEDULING_INFO_ARIA: "Set when this season starts and ends, or chain it to a previous season.",
  EDIT_SEASON_TIERS_INFO_ARIA: "Toggle which player tiers this season is available to.",
  EDIT_SEASON_TIERS_LABEL: "Seasons Tiers",
  EDIT_SEASON_TIER_FREE: "Free Tier",
  EDIT_SEASON_TIER_PREMIUM: "Premium Tier",
  EDIT_SEASON_UNSCHEDULE_SEASON: "Unschedule Season",
  EDIT_TASK: "Edit Task",
  EDIT_TASK_DELETE: "Delete",
  EDIT_TASK_SUBMIT: "Save Task",
  END_TIME: "End Time",
  PASTE_TASK: "Paste Task",
  PASTE_TASK_CLEAR: "Clear copied task",
  PASTE_TASK_CLIPBOARD_LABEL: "Copied Task",
  PASTE_TASK_HINT: "Paste into this Challenge",
  PASTE_TASK_SUCCESS: "Task pasted successfully",
  PASTE_TASK_UNTITLED: "Untitled task",
  CHALLENGE_REWARD_PARAM_OPTIONAL: "optional",
  REMOVE_REWARD: "Remove reward",
  REWARD_AMOUNT_PLACEHOLDER: "Amount",
  REWARD_TYPE_PLACEHOLDER: "Reward type",
  SAME_XP_REWARD_AMOUNT_PLACEHOLDER: "XP Amount",
  SAME_XP_REWARD_FOR_ALL_TASKS: "Same XP reward for all tasks",
  SAME_XP_REWARD_FOR_ALL_TASKS_INFO: "When enabled, every task in this season is locked to the XP amount entered below. Each task's XP field is disabled in the task editor — turn this off to set XP per task.",
  SAME_XP_REWARD_HINT: "All tasks share this XP amount. Turn off the toggle to set XP individually per task.",
  SAVE_AS_DRAFT: "Save as Draft",
  SCHEDULE: "Schedule",
  SCHEDULED_SEASON_EMPTY_TITLE: "You don't have any scheduled seasons",
  SCHEDULE_SEASON: "Schedule Season",
  SCHEDULE_SEASON_DESCRIPTION: "Set when the season starts and ends.",
  SEASONS_FILTER_ALL: "All",
  SEASONS_FILTER_BAR_ARIA: "Season status filter",
  SEASONS_FILTER_CANCELED: "Canceled",
  SEASONS_FILTER_COMPLETED: "Completed",
  SEASONS_FILTER_DRAFTS: "Drafts",
  SEASONS_FILTER_NO_DATA: "No seasons to show yet.",
  SEASONS_FILTER_SCHEDULED: "Scheduled",
  SEASONS_FILTER_TIMELINE: "Timeline",
  SEASONS_LIST_LOADING: "Loading seasons...",
  SEASON_CARD_DUPLICATE: "Duplicate",
  SEASON_CARD_EDIT: "Edit",
  SEASON_CARD_LOCKED: "Locked",
  SEASON_CARD_SEE_REPORTS: "See Reports",
  SEASON_CARD_SEE_REPORTS_DISABLED_TOOLTIP: "Coming soon",
  SEASON_COUNTDOWN_LOCKS_IN: "Locks in",
  SEASON_DETAILS_ACTIVATE: "Activate Season",
  SEASON_DETAILS_ACTIVATE_ARIA: "Activate season",
  SEASON_DETAILS_BACK_ARIA: "Back to Game Pass seasons",
  SEASON_DETAILS_BACK_TO_LIST: "Back to Seasons",
  SEASON_DETAILS_BREADCRUMB_SEASONS: "Seasons",
  SEASON_DETAILS_CHALLENGES_HEADING: "Challenges",
  SEASON_DETAILS_END_SEASON: "End Season",
  SEASON_DETAILS_END_SEASON_CONFIRM_BODY_PREFIX: "Are you sure you would like to end",
  SEASON_DETAILS_END_SEASON_CONFIRM_BODY_SUFFIX: "? Players will no longer be able to make progress on this season.",
  SEASON_DETAILS_END_SEASON_CONFIRM_CTA: "Yes, End Season",
  SEASON_DETAILS_END_SEASON_CONFIRM_GO_BACK: "Go Back",
  SEASON_DETAILS_END_SEASON_CONFIRM_TITLE: "End Season",
  END_SEASON_PROD_BANNER: "Destructive action — production",
  END_SEASON_PROD_BADGE: "Production",
  END_SEASON_PROD_TITLE: "Take down Game Pass",
  END_SEASON_PROD_BODY: "You are taking Game Pass offline in production. This will immediately affect all users on the app. Complete all fields below to proceed.",
  END_SEASON_PROD_IMPACT: "All active users will lose access to Game Pass instantly. In-progress challenges and reward states are preserved but inaccessible until the service is restored.",
  END_SEASON_PROD_FIRST_NAME: "First Name",
  END_SEASON_PROD_FIRST_NAME_PLACEHOLDER: "First name",
  END_SEASON_PROD_LAST_NAME: "Last Name",
  END_SEASON_PROD_LAST_NAME_PLACEHOLDER: "Last name",
  END_SEASON_PROD_DATE: "Date of Takedown",
  END_SEASON_PROD_REQUIRED: "Required",
  END_SEASON_PROD_CONFIRM_KEYWORD: "CONFIRM",
  END_SEASON_PROD_CONFIRM_HINT_PREFIX: "Type",
  END_SEASON_PROD_CONFIRM_HINT_SUFFIX: "to enable the button",
  END_SEASON_PROD_CONFIRM_PLACEHOLDER: "Type CONFIRM",
  END_SEASON_PROD_AUDIT_NOTE: "This action will be sent for logging to an audit trail with your name, the date, and a timestamp.",
  SEASON_DETAILS_GENERAL: "General",
  SEASON_DETAILS_LOCKS_INFO_ARIA: "Locks once the start date is reached. After that the season can no longer be edited.",
  SEASON_DETAILS_METRIC_ALL_REPORTS: "ALL REPORTS",
  SEASON_DETAILS_METRIC_AVG_COMPLETION: "AVG COMPLETION",
  SEASON_DETAILS_METRIC_ENROLLED: "ENROLLED",
  SEASON_DETAILS_METRIC_SEE_ALL: "See all",
  SEASON_DETAILS_NOT_FOUND_DESCRIPTION: "We couldn't find a season with that id. It may have been removed.",
  SEASON_DETAILS_NOT_FOUND_TITLE: "Season not found",
  SEASON_DETAILS_SAVE_CHANGES: "Save Changes",
  SEASON_DETAILS_SCHEDULE: "Schedule",
  SEASON_DETAILS_SCHEDULE_ARIA: "Schedule season",
  SEASON_DETAILS_UNLOCK: "Unlock Season",
  SEASON_DETAILS_UNLOCK_ARIA: "Unlock season",
  SEASON_DETAILS_UNLOCK_ERROR: "Failed to unlock season",
  SEASON_DETAILS_UNLOCK_SUCCESS: "Season unlocked",
  SEASON_DUPLICATE_ADDED_TO: "added to",
  SEASON_DUPLICATE_ERROR: "Failed to duplicate season",
  SEASON_DUPLICATE_NAME_SUFFIX: " - Duplicate",
  SEASON_EDIT_ARIA: "Edit season",
  SEASON_NAME: "Season Name",
  SEASON_NAME_PLACEHOLDER: "Enter season name",
  SEASON_OPEN_ARIA: "View season details",
  SEASON_OVERVIEW: "Season Overview",
  SEASON_OVERVIEW_DRAFT_LOCKED_INFO: "These fields are locked — the season draft has already been created and cannot be edited here.",
  SEASON_STATUS_SCHEDULED: "Scheduled",
  SELECT_SEASON: "Select a season",
  TASKS_COUNT: "Tasks",
  TASK_COPIED_SUCCESS: "Task copied",
  TASK_REORDER_FAILED: "Failed to update task order",
  TASK_REORDER_SAVING: "Saving task order",
  TASK_REORDER_SUCCESS: "Task order updated",
  UNSCHEDULE_SEASON_CONFIRM_BODY_PREFIX: "Are you sure you would like to move",
  UNSCHEDULE_SEASON_CONFIRM_BODY_SUFFIX: " back to draft status?",
  UNSCHEDULE_SEASON_CONFIRM_CTA: "Unschedule Season",
  UNSCHEDULE_SEASON_MODAL_TITLE: "Unschedule Season",
  UPDATE_TASK_FAILED: "Failed to update task",
  USERS_MUST_COMPLETE_CHALLENGES_SEQUENTIALLY: "Users must complete challenges sequentially",
  VIEW_SEASON_MODAL_TITLE_PREFIX: "View",
  VIEW_TASK: "Task",
  BLOCK_REFER_A_FRIEND: "Block Refer a Friend",
  BLOCK_REFER_A_FRIEND_BLOCKED: "Referral bonus blocked.",
  BLOCK_REFER_A_FRIEND_CANCELLED_COUNT: "{count} active banner(s) cancelled",
  BLOCK_REFER_A_FRIEND_SKIPPED_COUNT: "{count} skipped",
  BLOCK_REFER_A_FRIEND_UNBLOCKED: "Referral bonus unblocked.",
  BLOCK_REFER_A_FRIEND_UPDATED: "Block Refer a Friend updated.",
  BLOCK_REFER_A_FRIEND_UPDATE_FAILED: "Failed to update Block Refer a Friend. Please try again.",
  CHALLENGE_REWARDS_LABEL: "Rewards",
  CURRENCY: "Currency",
  CURRENT_FOLLOWING: "Current Following",
  ERROR_FETCHING_USERS: "Error fetching users",
  EVENT_ID: "Event ID",
  FAILED_TO_CLEAR_2FA_COOLDOWN: "Failed to clear 2FA cooldown.",
  FREE_SPINS_QUEUED: "Free spins are being issued and will appear shortly.",
  FTD: "FTD",
  INITIAL_FOLLOWING: "Initial Following",
  LOCK_USER_LIMITS_UPDATED: "Lock user limits updated.",
  LOCK_USER_LIMITS_UPDATE_FAILED: "Failed to update lock user limits. Please try again.",
  MINIMUM_PARLEY_LEGS_MIN_VALIDATION: "Minimum Parley Legs must be greater than or equal to 2.",
  NOTES_LOAD_ERROR: "Couldn't load notes. Please try again.",
  NOTE_ACTION_FAILED: "Couldn't complete the action. Please try again.",
  NOTE_ADDED: "Note added",
  NOTE_ALREADY_PINNED: "This note is already pinned",
  NOTE_DELETED: "Note deleted",
  NOTE_PINNED: "Note pinned",
  NOTE_UNPINNED: "Note unpinned",
  NOTE_UPDATED: "Note updated",
  NO_NOTES_YET: "No notes yet",
  SEARCH_BY_PHONE: "Search by phone",
  SEARCH_BY_REFERRAL_CODE_OWN: "Search by Referral Code (Own)",
  SEARCH_BY_REFERRAL_CODE_USED: "Search by Referral Code (Used)",
  SEARCH_BY_UTM_SOURCE: "Search by UTM Source",
  SEARCH_BY_UTM_MEDIUM: "Search by UTM Medium",
  SEARCH_BY_UTM_CAMPAIGN: "Search by UTM Campaign",
  SEASON_STATUS_INCOMPLETE: "Incomplete",
  SEON_COOLDOWN_CLEARED: "SEON cooldown cleared",
  SPORTS_BET_ID: "Sports Bet ID",
  TWO_FA_COOLDOWN: "2FA Cooldown",
  TWO_FA_COOLDOWN_ENABLED: "2FA Cooldown Enabled",
  USER_BONUS_BLOCKED: "User Bonus Blocked",
  USER_BONUS_BLOCKED_UPDATED: "User bonus block updated.",
  USER_BONUS_BLOCKED_UPDATE_FAILED: "Failed to update user bonus block. Please try again.",
  UTM_SOURCE: "UTM Source",
  UTM_MEDIUM: "UTM Medium",
  UTM_CAMPAIGN: "UTM Campaign",
  WHEN_COOLDOWN_ENDS: "When Cooldown ends?",
  ACCOUNT_MENU: "Account menu",
  AFFILIATE_PORTAL: "Affiliate Portal",
  BANNER_AVAILABLE_TAGS: "Available Tags",
  BANNER_TEXT: "Banner Text",
  BANNER_TEXT_TEMPLATE: "Banner Text Template",
  BANNER_TEXT_TOOLTIP: "The banner message shown to users on the referral page. Use {variable} tags for dynamic values.",
  BANNER_UNSUPPORTED_TAGS: "Unsupported tags: ",
  BONUS_CONTROLS: "Bonus Controls",
  PAM_PROMOTION_CAMPAIGN_DETAILS_TITLE: "Profit Boost! 20% Extra",
  PAM_CAMPAIGNS: "Campaigns",
  CANCELLED: "Cancelled",
  CANCEL_CHANGES: "Cancel Changes",
  COULDNT_LOAD_YOUR_DATA_TRY_SIGNING_IN_AGAIN: "Couldn't load your data. Try signing in again.",
  FILTERS_TOGGLE_ARIA: "Toggle filters",
  MATCH_PERCENTAGE: "Match Percentage",
  OPEN_ACCOUNT_MENU: "Open account menu",
  PUSHED: "Pushed",
  QUALIFICATION: "Qualification",
  READ_ONLY_ACCESS_TOGGLE: "Read Only Access",
  READ_ONLY_ACCESS_TOGGLE_INFO: "When enabled, every action below is turned off and locked, so this role can view content without performing any write action. Turn it off to grant individual actions.",
  READ_ONLY_ACCESS_TOOLTIP: "Your role has read-only access. This action is unavailable.",
  READ_ONLY_PAGE_NOTICE: "Your role has read-only access, so this page is unavailable.",
  REBET: "Rebet",
  REFERRAL_BONUS: "Referral Bonus",
  REFERRAL_BONUS_ENABLED: "Referral Bonus Enabled",
  REFERRAL_MIN_LEGS_TOOLTIP: "Minimum number of legs for the parlay.",
  REFERRAL_MIN_REQUIRED_PURCHASE_TOOLTIP: "Minimum amount the referred user must purchase to receive a referral bonus.",
  ROLLOVER: "Rollover (x)",
  SECTION: "Section",
  PAM_SEGMENTS: "Segments",
  PAM_SIGNING_OUT: "Signing out...",
  SIGN_OUT: "Sign Out",
  PAM_TEMPLATES: "Templates",
  UNKNOWN_USER: "Unknown user",
  PAM_UTM_AVG_DEPOSIT: "Avg Deposit",
  PAM_UTM_AVG_NET_REVENUE: "Avg Net Revenue",
  PAM_UTM_AVG_WITHDRAWAL: "Avg Withdrawal",
  PAM_UTM_CATEGORIZATION: "UTM Categorization",
  PAM_UTM_DEPOSIT_AMOUNT: "Deposit Amount",
  PAM_UTM_NET_REVENUE: "Net Revenue",
  PAM_UTM_REVENUE: "Revenue",
  UTM_REPORTS: "UTM Reports",
  PAM_UTM_TOTAL_FTDS: "Total FTDs",
  PAM_UTM_TOTAL_USERS: "Total Users",
  PAM_UTM_WITHDRAWAL_AMOUNT: "Withdrawal Amount",
  WELCOME_BONUS_ENABLED: "Welcome Bonus Enabled",
  WELCOME_EXPIRATION_PERIOD_TOOLTIP: "Number of days before the welcome bonus Free Pick expires.",
  WELCOME_MAX_FREE_PLAY_CASH_TOOLTIP: "Maximum Free Pick value a user will receive with their purchase.",
  WELCOME_MIN_LEGS_TOOLTIP: "Minimum number of legs for the parlay.",
  WELCOME_ROLLOVER_TOOLTIP: "Wagering (rollover) multiplier applied to the welcome bonus.",
  CURRENT_ICON: "Current Icon",
  DEFAULT_ICON_WILL_BE_RESTORED: "Default icon will be restored",
  EDIT_SHORTCUT_ICON: "Edit Shortcut Icon",
  FAILED_TO_LOAD_FUTURE_MARKET_TABS: "Failed to load future market tabs",
  FAILED_TO_LOAD_SPORTS: "Failed to load sports",
  FAILED_TO_RESET_SHORTCUT_ICON: "Failed to reset shortcut icon",
  FAILED_TO_UPDATE_SHORTCUT_ICON: "Failed to update shortcut icon",
  FUTURES: "Futures",
  FUTURE_MARKET_TABS: "Future Market Tabs",
  MANAGE_FUTURE_TAB_TITLES: "Manage the tab titles displayed on the frontend for future picks. Drag to reorder tabs.",
  NO_MARKET_TABS_FOUND_FOR_THIS_LEAGUE: "No market tabs found for this league",
  NO_SHORTCUTS_CONFIGURED: "No shortcuts configured",
  NO_SPORTS_FOUND: "No sports found",
  ONLY_SHORTCUT_ICON_FILES_ALLOWED: "Only PNG, SVG, or WebP files are allowed.",
  RESET_TO_DEFAULT: "Reset to Default",
  SHORTCUT_ICON_RESET: "Shortcut icon reset",
  SHORTCUT_ICON_UPDATED: "Shortcut icon updated",
  SHORTCUT_ICON_UPLOAD_INSTRUCTIONS: "Upload icon size min 64x64px and max 120x120px. Support PNG, SVG, WebP",
  ACQUISITION_BY_STATE_LOAD_ERROR: "Failed to load acquisition by state. Please try again.",
  ACQUISITION_DAILY_LOAD_ERROR: "Failed to load daily users. Please try again.",
  ACQUISITION_DOWNLOAD_FULL_PAGE_ARIA: "Download Acquisition data as CSV",
  ACQUISITION_KPIS_LOAD_ERROR: "Failed to load Acquisition KPIs. Please try again.",
  ALL_GAMES: "All Games",
  ALL_PROVIDERS: "All Providers",
  DAILY_PERFORMANCE: "Daily Performance",
  FINANCIALS_BY_STATE_LOAD_ERROR: "Failed to load financials by state. Please try again later.",
  FINANCIALS_DAILY_EMPTY_STATE: "No data for the selected date range.",
  FINANCIALS_DAILY_LOAD_ERROR: "Failed to load daily performance. Please try again later.",
  FINANCIALS_MONTHLY_EMPTY_STATE: "No monthly data for the selected date range.",
  FINANCIALS_MONTHLY_LOAD_ERROR: "Failed to load monthly totals. Please try again later.",
  FINANCIALS_REDEEMABLE_EMPTY_STATE: "No data for the selected date range.",
  FINANCIALS_REDEEMABLE_LOAD_ERROR: "Failed to load redeemable balance. Please try again later.",
  PRODUCT_PERFORMANCE: "Product Performance",
  ROUNDS: "Rounds",
  SEE_ALL: "See All",
  TOP_5_PROVIDERS: "Top 5 Providers",
  TOP_5_SPORTS: "Top 5 Sports",
  PAM_TOP_RANKING_LIMIT: "Limit",
  PAM_CHART_EMPTY_STATE: "No data for the selected metric and date range.",
  TOTAL_ROUNDS: "Total Rounds",
  EXPORT_BUTTON_DEFAULT_ARIA: "Download export",
  EXPORT_DRAWER_CONFIRM: "Export",
  EXPORT_DRAWER_EMPTY_TOOLTIP: "Select at least one column to export.",
  EXPORT_DRAWER_SELECT_ALL: "Select All",
  EXPORT_DRAWER_TITLE: "Export",
  FAILED_TO_READ_IMAGE: "Failed to read file. Please try again.",
  MONTHLY_CHALLENGE_SCHEDULE_AUTO_START: "Auto start after",
  MONTHLY_CHALLENGE_SCHEDULE_DESCRIPTION: "Set the dates to match up and follow directly after your previous season. If you don't have dates ready yet just save this as a draft",
  MONTHLY_CHALLENGE_SCHEDULE_SEASON_TOOLTIP_PREFIX: "Is scheduled from",
  MONTHLY_CONFIGURATION_ACTIVE_EMPTY_TITLE: "No active monthly challenge",
  MONTHLY_CONFIGURATION_ACTIVE_MONTH: "Active Month",
  MONTHLY_CONFIGURATION_CANCELED_EMPTY_TITLE: "No cancelled monthly challenges.",
  MONTHLY_CONFIGURATION_COMPLETED_EMPTY_TITLE: "No completed monthly challenges yet.",
  MONTHLY_CONFIGURATION_CREATE_A_CHALLENGE: "Create a Monthly Challenge",
  MONTHLY_CONFIGURATION_CREATE_CTA: "Create Monthly Challenge",
  MONTHLY_CONFIGURATION_DRAFTS_EMPTY_TITLE: "No drafts — create a new Monthly Challenge to get started",
  MONTHLY_CONFIGURATION_FILTER_BAR_ARIA: "Monthly challenge status filter",
  MONTHLY_CONFIGURATION_NEXT_EMPTY_TITLE: "No upcoming monthly challenges",
  MONTHLY_CONFIGURATION_LOADING: "Loading monthly challenges...",
  MONTHLY_CONFIGURATION_NO_DATA: "No monthly challenges to show yet.",
  MONTHLY_CONFIGURATION_PAGE_TITLE: "Game Pass Monthly Configuration",
  USERS_EXPORT_BUTTON_ARIA: "Download users as CSV",
  USERS_EXPORT_COLUMNS_ERROR: "Couldn't load export columns. Try again in a moment.",
  USERS_EXPORT_COLUMNS_LOADING: "Loading export options…",
  USERS_EXPORT_FAILED_DEFAULT: "Export failed. Start a new export to retry.",
  USERS_EXPORT_START_ERROR: "Couldn't start the users export. Try again in a moment.",
  USERS_EXPORT_TIMEOUT: "Export is taking longer than expected. Start a new export to retry.",
  PAM_AAL_EXPORT_START_ERROR:
    "Couldn't start the audit log export. Try again in a moment.",
  PAM_AAL_EXPORT_FAILED_DEFAULT: "Audit log export failed. Start a new export to retry.",
  PAM_AAL_EXPORT_TIMEOUT:
    "Audit log export is taking longer than expected. Start a new export to retry.",
  PAM_AAL_EXPORT_DATE_WINDOW_TOO_LONG:
    "Exports are limited to 31 days. Narrow the date range and try again.",
  PAM_CLAIM_BONUS: "Claim Bonus",
  USERS_EXPORT_TOOLTIP_UNSUPPORTED_FILTERS: "Search and ID filters can't be included in exports — clear them to download.",
  USERS_REGISTRATION_DATE_FILTER_INFO: "Filters users based on Registration Date",
  ADDITIONAL_KPIS: "Additional KPIs",
  AFFILIATE_KPIS_FILTERS: "Affiliate KPIs filters",
  BET_CANCELLED: "Bet Cancelled",
  BET_ROLLED_BACK: "Bet Rolled Back",
  BET_SETTLED: "Bet Settled",
  CLAIMED: "Claimed",
  FREE_SPIN: "Free Spin",
  FREE_SPINS_REALIZED_VALUE: "Free Spins - Realized Value",
  FREE_SPINS_REALIZED_VALUE_TOOLTIP: "The amount of {currency} earned by the user as a result of the Free Spins.",
  LEG_SETTLED: "Leg Settled",
  PORTAL_VIEW_SECTION_FINANCIAL: "FINANCIAL",
  PORTAL_VIEW_SECTION_PERFORMANCE: "PERFORMANCE",
  PROFIT_BOOSTS: "# of Profit Boosts",
  PROFIT_BOOST_REALIZED_VALUE: "Profit Boost - Realized Value",
  PROFIT_BOOST_REALIZED_VALUE_TOOLTIP: "The amount of {currency} earned by the user as a result of the Profit Boost. Calculated as the difference in Bet payout as a result of the boosted odds from the profit boost.",
  PROMO_CODE_COUNT: "# of Codes",
  PROMO_PERCENTAGE: "Promo Percentage",
  REALIZED_VALUE: "Realized Value",
  REBET_CASH_TOOLTIP: "Change in user wallet as a result of PAM agents editing wallets (positive is with respect to the user wallet).",
  REMOVED: "Removed",
  REQUEST_DATE_TOOLTIP: "The timestamp when the user first requests the withdrawal.",
  REVIEW_TIME_TOOLTIP: "The timestamp when a PAM Agent begins reviewing the withdrawal. The trigger a PAM agent reviewing a withdrawal is clicking the information \"i\" to the right of the withdrawal accept/decline decisions.",
  TIME_OF_DECISION_TOOLTIP: "The Timestamp when a PAM agent makes a decision to Accept or Decline the withdrawal.",
  UNCLAIMED: "Unclaimed",
  USER_REALIZED_VALUE: "User Realized Value",
  USER_REALIZED_VALUE_TOOLTIP: "Amount gained by the User as a result of the manual bet settlement by a PAM agent.",
  APPROVAL_REASON: "Approval reason",
  APPROVE_MODAL_TITLE: "Approve Withdrawal",
  CONDITION: "Condition",
  EDITOR: "Editor",
  FLAGGED_USERS: "Flagged Users",
  FLAGGED_USERS_DOWNLOAD_FAILED: "Failed to download flagged users",
  LAST_MODIFIED: "Last modified",
  METHOD: "Method",
  PAM_REVIEWER: "PAM Reviewer",
  REVIEW_TIME: "Review Time",
  RULES: "Rules",
  RULES_DEBUG_GRAPH_EMPTY: "No decision graph has been published yet.",
  RULES_DEBUG_GRAPH_ERROR: "Failed to load the decision graph.",
  RULES_DEBUG_GRAPH_HIDE: "Hide graph",
  RULES_DEBUG_GRAPH_LOADING: "Loading decision graph…",
  RULES_DEBUG_GRAPH_PANEL_SUBTITLE: "Live view of the currently published rule graph.",
  RULES_DEBUG_GRAPH_PANEL_TITLE: "Decision graph",
  RULES_DEBUG_GRAPH_SECTION_ARIA_LABEL: "Decision graph debug panel",
  RULES_DEBUG_GRAPH_SHOW: "Show graph",
  RULES_EDITOR_CANCEL_LABEL: "Cancel changes",
  RULES_EDITOR_LOADING: "Loading published rules...",
  RULES_EDITOR_LOAD_ERROR: "Failed to load the active rules. Refresh the page to try again.",
  RULES_EDITOR_PUBLISHING_LABEL: "Publishing...",
  RULES_EDITOR_PUBLISH_CONFLICT_TOAST: "Someone else published while you were editing. Refresh to see the latest rules before republishing.",
  RULES_EDITOR_PUBLISH_ERROR_GENERIC_TOAST: "Failed to publish. Please try again.",
  RULES_EDITOR_PUBLISH_LABEL: "Publish rules",
  RULES_EDITOR_PUBLISH_SUCCESS_TOAST: "Rules published successfully.",
  RULES_EDITOR_PUBLISH_VALIDATION_TOAST: "The server rejected the published rules. Please review the flagged fields.",
  RULES_EDITOR_READONLY_BANNER_MESSAGE: "The active rules contain conditions that the toggle editor does not support yet. Reach out to engineering before making changes here.",
  RULES_EDITOR_READONLY_BANNER_TITLE: "Rules are locked",
  RULES_EDITOR_READONLY_START_FRESH_BUTTON: "Start fresh",
  RULES_EDITOR_READONLY_START_FRESH_HELPER: "Publishing will overwrite the current active rules.",
  RULES_EDITOR_STATUS_CLEAN: "No unpublished changes. Toggle a rule to enable Publish.",
  RULES_EDITOR_STATUS_DIRTY_VALID: "You have unpublished changes ready to go.",
  RULES_EDITOR_STATUS_INVALID_MANY: "{count} fields need attention before you can publish.",
  RULES_EDITOR_STATUS_INVALID_ONE: "1 field needs attention before you can publish.",
  RULES_VERSIONS_COLLAPSE_BUTTON: "Hide details",
  RULES_VERSIONS_CURRENT_BADGE: "Current",
  RULES_VERSIONS_DETAILS_ADVANCED: "This version uses an advanced rule graph that can't be summarised in the toggle view.",
  RULES_VERSIONS_DETAILS_REASON_LABEL: "Reason:",
  RULES_VERSIONS_DETAILS_REASON_UNEXPECTED_LITERAL: "Unexpected condition literal",
  RULES_VERSIONS_DETAILS_REASON_UNEXPECTED_OPERATOR: "Unexpected condition operator",
  RULES_VERSIONS_DETAILS_REASON_UNKNOWN_FEATURE: "Unknown rule feature",
  RULES_VERSIONS_DETAILS_REASON_UNRECOGNIZED_STRUCTURE: "Unrecognised graph structure",
  RULES_VERSIONS_DETAILS_TIER1_HEADING: "Tier 1 — Trigger rules",
  RULES_VERSIONS_DETAILS_TIER2_HEADING: "Tier 2 — Auto-approve rules",
  RULES_VERSIONS_DETAILS_TIER_EMPTY: "No rules were enabled in this tier.",
  RULES_VERSIONS_DRAWER_SUBTITLE: "Browse previously published versions. Expand a row to see which rules were active and what their settings were.",
  RULES_VERSIONS_DRAWER_TITLE: "Rule versions",
  RULES_VERSIONS_EMPTY: "No versions published yet.",
  RULES_VERSIONS_ERROR: "Failed to load the version history. Please try again.",
  RULES_VERSIONS_EXPAND_BUTTON: "Show details",
  RULES_VERSIONS_LOADING: "Loading versions...",
  RULES_VERSIONS_OPEN_BUTTON: "View versions",
  RULES_VERSIONS_SUMMARY_MAX_AMOUNT_DETAIL: "Trigger if withdrawal > {amount}",
  RULES_VERSIONS_SUMMARY_MIN_ACCOUNT_AGE_DETAIL: "Auto-approve if account age ≥ {days} days",
  RULES_VERSIONS_SUMMARY_PERIOD_DAY: "day",
  RULES_VERSIONS_SUMMARY_PERIOD_DAYS: "days",
  RULES_VERSIONS_SUMMARY_PERIOD_HOUR: "hour",
  RULES_VERSIONS_SUMMARY_PERIOD_HOURS: "hours",
  RULES_VERSIONS_SUMMARY_PERIOD_MONTH: "month",
  RULES_VERSIONS_SUMMARY_PERIOD_MONTHS: "months",
  RULES_VERSIONS_SUMMARY_PERIOD_WEEK: "week",
  RULES_VERSIONS_SUMMARY_PERIOD_WEEKS: "weeks",
  RULES_VERSIONS_SUMMARY_PERIOD_YEAR: "year",
  RULES_VERSIONS_SUMMARY_PERIOD_YEARS: "years",
  RULES_VERSIONS_SUMMARY_REVIEWED_X_TIMES_DETAIL: "Auto-approve if approved ≥ {reviews} times in the last {within} {period}",
  RULES_VERSIONS_SUMMARY_VIP_MATCHING_DETAIL: "Auto-approve VIPs using an instrument matched within the last {within} {period}",
  RULE_NAME: "Rule Name",
  THRESHOLD_GREATER_THAN_OR_EQUAL_HINT: "Rule triggers when the transaction amount is greater than or equal to (≥) this value.",
  TIME_OF_DECISION: "Time of Decision",
  TIME_TO_TRIGGER_FLAG: "Time to Trigger Flag",
  TRIGGER_ACTION: "Trigger action",
  VIOLATORS: "# of violators",
  RULES_EDITOR_PUBLISH_SUCCESS_NOTIFICATION_DESCRIPTION: "Your changes are already live in the Decision graph above. Heads up: it can take a few minutes for new withdrawals to pick up the updated rules.",
  RULES_EDITOR_PUBLISH_SUCCESS_NOTIFICATION_TITLE: "Rules updated",


  // Last-resort copy for request-outcome toasts: the backend renders a
  // localized `message` on every envelope, so these only surface when a
  // response arrives without one.
  PAM_GENERIC_REQUEST_FAILED: "Something went wrong. Please try again.",
  PAM_GENERIC_REQUEST_SUCCEEDED: "Action completed successfully.",
  PAM_LOADING: "Loading...",
  PAM_ICON_UPLOAD_REQUIRED: "Please upload an icon",
  PAM_UPLOADS_PERMISSION_REQUIRED: "Uploads permission required",
  PAM_ROLES_SYSTEM_ROLE_NOT_MODIFIABLE: "System roles cannot be modified.",
  PAM_ROLES_SYSTEM_ROLE_NOT_DELETABLE: "System roles cannot be deleted.",
  PAM_ROLES_INVALID_PERMISSIONS_STRIPPED:
    "Some permissions are not available for this brand and were removed: {permissions}. Retrying…",
  PAM_ROLES_COLOR_MUST_BE_UNIQUE:
    "Please choose a unique color not already used by another role.",
  PAM_DYNAMIC_BONUS_SAVE_AS_DRAFT: "Save as Draft",
  PAM_DYNAMIC_BONUS_SAVE_AS_TEMPLATE: "Save as Template",
  PAM_DYNAMIC_BONUS_ACTIVATE_CAMPAIGN: "Activate Campaign",
  PAM_DYNAMIC_BONUS_CREATE_SERIES: "Create Series",
  PAM_DYNAMIC_BONUS_CREATE_TEMPLATE: "Create Template",
  PAM_DYNAMIC_BONUS_SAVE_TEMPLATE: "Save Template",
  PAM_DYNAMIC_BONUS_SEND_TEST: "Send Test",
  PAM_DYNAMIC_BONUS_CAMPAIGN_SAVED_AS_DRAFT: "Campaign saved as draft",
  PAM_DYNAMIC_BONUS_CAMPAIGN_CREATED_AND_STARTED: "Campaign created and started",
  PAM_DYNAMIC_BONUS_CAMPAIGN_CREATED_NOT_STARTED:
    "Campaign created, but could not be started automatically",
  PAM_DYNAMIC_BONUS_SERIES_EMPTY:
    "Series has no active campaigns yet. Trigger a campaign through Braze or Edit the Series",
  PAM_DYNAMIC_BONUS_CAMPAIGN_STARTS_LABEL: "Campaign starts",
  PAM_DYNAMIC_BONUS_CAMPAIGN_STARTS_FALLBACK_NAME: "Campaign",
  PAM_DYNAMIC_BONUS_CREATE_CAMPAIGN_CUSTOM: "Custom",
  PAM_DYNAMIC_BONUS_CREATE_CAMPAIGN_CUSTOM_DESCRIPTION:
    "Start from scratch without a template.",
  PAM_DYNAMIC_BONUS_RULES_SECTION_TITLE: "Rules",
  PAM_DYNAMIC_BONUS_DISPLAY_SECTION_TITLE: "Display",
  PAM_DYNAMIC_BONUS_BANNER_TITLE_LABEL: "Banner Title",
  PAM_DYNAMIC_BONUS_BANNER_TITLE_PLACEHOLDER: "Enter",
  PAM_DYNAMIC_BONUS_BANNER_TITLE_PREVIEW_FALLBACK: "Banner title",
  PAM_DYNAMIC_BONUS_BANNER_TITLE_REQUIRED: "Banner title is required",
  PAM_DYNAMIC_BONUS_BANNER_DESCRIPTION_LABEL: "Banner Description",
  PAM_DYNAMIC_BONUS_BANNER_DESCRIPTION_REQUIRED:
    "Banner description is required",
  PAM_DYNAMIC_BONUS_BANNER_FULL_DESCRIPTION_LABEL: "Full Description",
  PAM_DYNAMIC_BONUS_BANNER_IMAGE_LABEL: "Image",
  PAM_DYNAMIC_BONUS_BANNER_IMAGE_PLACEHOLDER: "Enter URL or Upload",
  PAM_DYNAMIC_BONUS_BANNER_UPLOAD_IMAGE: "Upload Image",
  PAM_DYNAMIC_BONUS_BANNER_SELECT_THEME: "Select Theme",
  PAM_DYNAMIC_BONUS_BANNER_PREVIEW_LABEL: "Banner Preview",
  PAM_DYNAMIC_BONUS_BANNER_CUSTOMIZE: "Customize Banner",
  PAM_DYNAMIC_BONUS_BANNER_THEME_LABEL: "Theme",
  PAM_DYNAMIC_BONUS_BANNER_THEME_CUSTOM: "Custom",
  PAM_DYNAMIC_BONUS_BANNER_BODY_SECTION: "Body",
  PAM_DYNAMIC_BONUS_BANNER_BACKGROUND_LABEL: "Background",
  PAM_DYNAMIC_BONUS_BANNER_BORDER_LABEL: "Border",
  PAM_DYNAMIC_BONUS_BANNER_PRIMARY_CONTENT_SECTION: "Primary Content",
  PAM_DYNAMIC_BONUS_BANNER_TITLE_COLOR: "Title Color",
  PAM_DYNAMIC_BONUS_BANNER_DESCRIPTION_COLOR: "Description Color",
  PAM_DYNAMIC_BONUS_BANNER_LONG_DESCRIPTION_COLOR: "Long Description Color",
  PAM_DYNAMIC_BONUS_BANNER_SHADOW: "Shadow",
  PAM_DYNAMIC_BONUS_BANNER_EDIT_IMAGE: "Edit",
  PAM_DYNAMIC_BONUS_BANNER_DETAILS_LINK_SECTION: "Details Link",
  PAM_DYNAMIC_BONUS_BANNER_LINK_COLOR: "Link Color",
  PAM_DYNAMIC_BONUS_BANNER_COUNTDOWN_CHIP_SECTION: "Countdown Chip",
  PAM_DYNAMIC_BONUS_BANNER_CHIP_SHADOW: "Chip Shadow",
  PAM_DYNAMIC_BONUS_BANNER_TEXT_COLOR: "Text Color",
  PAM_DYNAMIC_BONUS_BANNER_ICON_COLOR: "Icon Color",
  PAM_DYNAMIC_BONUS_BANNER_BACKGROUND_COLOR: "Background Color",
  PAM_DYNAMIC_BONUS_BANNER_BORDER_COLOR: "Border Color",
  PAM_DYNAMIC_BONUS_BANNER_BORDER_WIDTH: "Border Width",
  PAM_DYNAMIC_BONUS_BANNER_CLAIM_BUTTON_SECTION: "Claim Button",
  PAM_DYNAMIC_BONUS_BANNER_CLAIM_TEXT: "Claim text",
  PAM_DYNAMIC_BONUS_BANNER_ADD_COLOR: "Add color",
  PAM_DYNAMIC_BONUS_BANNER_BACK: "Back",
  PAM_DYNAMIC_BONUS_ADD_RESTRICTION: "Add Restrictions",
  PAM_DYNAMIC_BONUS_ADD_CONDITION: "Add Conditions",
  PAM_DYNAMIC_BONUS_ADD_STEP: "Add Step",
  PAM_DYNAMIC_BONUS_PLACEHOLDER_EVENT_FIELD: "Event field",
  PAM_DYNAMIC_BONUS_PLACEHOLDER_OPERATOR: "Operator",
  PAM_DYNAMIC_BONUS_PLACEHOLDER_VALUE: "Value",
  PAM_DYNAMIC_BONUS_NO_CONDITIONS_FOR_EVENT: "No conditions for this event",
  PAM_DYNAMIC_BONUS_TRIGGER_RESTRICTIONS: "Trigger Conditions",
  PAM_DYNAMIC_BONUS_RESULTS_RESTRICTIONS: "Result Restrictions",
  PAM_DYNAMIC_BONUS_COLUMN_BANNER: "Banner",
  PAM_DYNAMIC_BONUS_COLUMN_SOURCE: "Source",
  PAM_DYNAMIC_BONUS_COLUMN_CAMPAIGN_START: "Start",
  PAM_DYNAMIC_BONUS_COLUMN_CAMPAIGN_END: "End",
  PAM_DYNAMIC_BONUS_COLUMN_REACHED: "Reached",
  PAM_DYNAMIC_BONUS_COLUMN_USED: "Used",
  PAM_DYNAMIC_BONUS_COLUMN_CONVERSION: "Conv.",
  PAM_DYNAMIC_BONUS_CAMPAIGN_ACTIONS_LABEL: "Campaign actions",
  PAM_DYNAMIC_BONUS_TEMPLATE_ACTIONS_LABEL: "Template actions",
  PAM_DYNAMIC_BONUS_CAMPAIGN_ACTION_DUPLICATE: "Duplicate",
  PAM_DYNAMIC_BONUS_TEMPLATE_ACTION_DUPLICATE: "Duplicate",
  PAM_DYNAMIC_BONUS_CAMPAIGN_ACTION_ACTIVATE: "Activate",
  PAM_DYNAMIC_BONUS_CAMPAIGN_ACTION_PAUSE: "Pause",
  PAM_DYNAMIC_BONUS_CAMPAIGN_ACTION_EXPIRE: "Expire",
  PAM_DYNAMIC_BONUS_CAMPAIGN_COPY_NAME: "{name} (Copy)",
  PAM_DYNAMIC_BONUS_CAMPAIGN_DUPLICATED:
    "Draft copy created — activate it when it's ready",
  PAM_DYNAMIC_BONUS_CAMPAIGN_DUPLICATE_CONFIRM_TITLE: "Duplicate this campaign?",
  PAM_DYNAMIC_BONUS_CAMPAIGN_DUPLICATE_CONFIRM_BODY:
    'Creates a draft copy of "{name}". The copy will not run until you activate it.',
  PAM_DYNAMIC_BONUS_CAMPAIGN_PAUSE_CONFIRM_TITLE: "Pause this campaign?",
  PAM_DYNAMIC_BONUS_CAMPAIGN_PAUSE_CONFIRM_BODY:
    '"{name}" will stop triggering until it is activated again.',
  PAM_DYNAMIC_BONUS_CAMPAIGN_EXPIRE_CONFIRM_TITLE: "Expire this campaign?",
  PAM_DYNAMIC_BONUS_CAMPAIGN_EXPIRE_CONFIRM_BODY:
    '"{name}" will end permanently. This cannot be undone.',
  PAM_DYNAMIC_BONUS_DELETE_CAMPAIGN_TITLE: "Delete campaign?",
  PAM_DYNAMIC_BONUS_DELETE_SERIES_TITLE: "Delete series?",
  PAM_DYNAMIC_BONUS_DELETE_TEMPLATE_TITLE: "Delete template?",
  PAM_DYNAMIC_BONUS_DELETE_WARNING:
    "This action cannot currently be undone.",
  PAM_DYNAMIC_BONUS_DELETE_CONFIRMATION_INSTRUCTION:
    'To confirm, type "{name}" in the box below.',
  PAM_DYNAMIC_BONUS_DELETE_CONFIRMATION_LABEL:
    "Type the exact name to confirm deletion",
  PAM_DYNAMIC_BONUS_DELETE_ACTION: "Delete",
  PAM_DYNAMIC_BONUS_DELETE_CANCEL: "Cancel",
  PAM_DYNAMIC_BONUS_TARGETING_CONDITION_DONE: "Done",
  PAM_DYNAMIC_BONUS_REMOVE_TARGETING_CONDITION: "Remove {label}",
  PAM_DYNAMIC_BONUS_TARGETING_CONDITION_CHIP: "{label}: {value}",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_SELECT_TOURNAMENT_FIRST: "Select a tournament first",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_SEARCH_PLACEHOLDER: "Search {label}…",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_NO_RESULTS: "No results",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_SEARCH_ERROR: "Unable to load search results. Try again.",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_FLOW_HEADING:
    "Pick a tournament first, then search matches in that tournament.",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_MULTI_SELECT_HINT: "Select multiple to apply \"any of\" logic.",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_REMOVE_RESTRICTION: "Remove {label}",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_SELECTED_RESTRICTIONS: "Selected {label}",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_REMOVE_ITEM: "Remove {name}",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_MATCH_DATE_HINT: "Showing matches scheduled within the next 4 days.",
  PAM_DYNAMIC_BONUS_SPORTSBOOK_MATCH_FIRST_TOURNAMENT_HINT: "Showing matches for the first selected tournament only.",
  PAM_DYNAMIC_BONUS_CASINO_DEEPLINK_SEARCH_PLACEHOLDER: "Search {label}…",
  PAM_STAFF_RESET_PASSWORD_ADMIN_NOT_FOUND:
    "Admin not found for password reset. The staff list may need to return an admin identifier (admin_id) that the backend recognizes.",
  PAM_COPIED_TO_CLIPBOARD: "Copied to clipboard",
  PAM_BET_ID_COPIED_TO_CLIPBOARD: "Bet ID copied to clipboard.",
  PAM_SESSION_REFRESHED: "Session refreshed",
  PAM_AUTH_TOKEN_NOT_FOUND: "Authentication token not found",
  PAM_FRAUD_RULE_NOT_FOUND: "Rule not found. Please navigate from the rules table.",
  PAM_UNSAVED_CHANGES_WARNING:
    "You have unsaved changes. Please click Save before leaving.",
  PAM_FILE_SIZE_LIMIT_EXCEEDED: "File must be {maxSizeMb}MB or smaller.",
  PAM_DYNAMIC_BONUS_TEST_RECIPIENT_REQUIRED:
    "Add at least one recipient (user ID or username).",
  PAM_DYNAMIC_BONUS_TEST_NOT_SENT:
    "No test was sent. Please check the campaign and try again.",
  PAM_DYNAMIC_BONUS_RESULT_BONUS_OFFER: "Bonus Offer",
  PAM_DYNAMIC_BONUS_RESULT_FREE_PICK: "Free Pick",
  PAM_DYNAMIC_BONUS_RESULT_FREE_CASH: "Free Cash",
  PAM_DYNAMIC_BONUS_RESULT_FREE_SPIN: "Free Spin",
  PAM_DYNAMIC_BONUS_RESULT_PROFIT_BOOST: "Profit Boost",
  PAM_DYNAMIC_BONUS_RESULT_REFUND_ON_LOSS: "Refund on Loss",
  PAM_DYNAMIC_BONUS_RESULT_CREDIT_WALLET: "Credit Wallet {currency}",
  PAM_DYNAMIC_BONUS_RESULT_SEND_NOTIFICATION: "Send Notification",
  PAM_DYNAMIC_BONUS_RESULT_DEPOSIT_MATCH: "Deposit Match",
  PAM_DYNAMIC_BONUS_RESULT_BONUS_BET: "Bonus Bet",
  PAM_DYNAMIC_BONUS_RESULT_FUTURE_BONUS: "Future Bonus",
  PAM_DYNAMIC_BONUS_RESULT_CASHBACK: "Cashback Offers",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_EXPIRY_ERROR:
    "Expiry must be on or after the expected settlement date for this trait.",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_EXPIRY_NO_TRAIT:
    "Select a trait with an expected settlement date before setting expiry.",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_EXPIRY_INVALID:
    "Expiry must be a valid date and time.",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_EXPIRY_PLACEHOLDER: "Select date & time",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_EXPIRY_LABEL: "Expiry",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_SETTLEMENT_LABEL: "Expected settlement",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_SPORT_PLACEHOLDER: "Select a sport",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_LEAGUE_PLACEHOLDER: "Select a league",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_LEAGUE_NEEDS_SPORT: "Select a sport first",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_TRAIT_PLACEHOLDER: "Select a trait",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_TRAIT_NEEDS_LEAGUE: "Select a league first",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_TRAIT_NO_DATE_SUFFIX: " (no settlement date)",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_SPORTS_LOAD_FAILED: "Failed to load sports",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_LEAGUES_LOAD_FAILED: "Failed to load leagues",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_TRAITS_LOAD_FAILED: "Failed to load traits",
  PAM_DYNAMIC_BONUS_FUTURE_BONUS_NO_SETTLEMENT:
    "This trait has no expected settlement date and cannot be saved.",
  PAM_DYNAMIC_BONUS_CONDITION_MIN_EVENT_AMOUNT: "Minimum Event Amount",
  PAM_DYNAMIC_BONUS_CONDITION_MIN_CUMULATIVE_DEPOSITS: "Minimum Cumulative Deposits",
  PAM_DYNAMIC_BONUS_CONDITION_IS_FIRST_DEPOSIT: "First Deposit",
  PAM_DYNAMIC_BONUS_CONDITION_USER_WAS_REFERRED: "User Referral",
  PAM_DYNAMIC_BONUS_CONDITION_EVENT_FIELD_EQUALS: "Event Field Equals",
  PAM_DYNAMIC_BONUS_CONDITION_EVENT_FIELD_COMPARE: "Event Field Compare",
  PAM_DYNAMIC_BONUS_CONDITION_FEATURE_FLAG_ENABLED: "Feature Flag Enabled",
  PAM_DYNAMIC_BONUS_CONDITION_NOT_ALREADY_AWARDED: "Not Already Awarded",
  PAM_DYNAMIC_BONUS_CONDITION_MAX_AWARDS_PER_USER: "Max Awards Per User",
  PAM_DYNAMIC_BONUS_CONDITION_COOLDOWN_SINCE_LAST_AWARD: "Cooldown Since Last Award",
  PAM_DYNAMIC_BONUS_CONDITION_USER_ATTRIBUTE_EQUALS: "User Attribute Equals",
  PAM_DYNAMIC_BONUS_CONDITION_USER_NOT_EXCLUDED: "User Not Excluded",
  PAM_DYNAMIC_BONUS_CONDITION_USER_IN_SEGMENT: "User In Segment",
  PAM_DYNAMIC_BONUS_CONDITION_REFERRAL_CODE_IS_AFFILIATE: "Affiliate Referral Code",
  PAM_DYNAMIC_BONUS_CONDITION_CAMPAIGN_AFFILIATE_CODE_MATCHES:
    "Campaign Affiliate Code Matches",
  PAM_DYNAMIC_BONUS_CONDITION_USER_SUBSCRIBED: "User Subscribed",
  PAM_DYNAMIC_BONUS_CONDITION_APPLIED_OFFER_MATCHES: "Applied Offer Matches",
  PAM_DYNAMIC_BONUS_RESULT_DISPLAY_BANNER: "Display Info Banner",
  PAM_DYNAMIC_BONUS_EVENT_CATEGORY_ACCOUNT: "Account",
  PAM_DYNAMIC_BONUS_EVENT_CATEGORY_PAYMENTS: "Payments",
  PAM_DYNAMIC_BONUS_EVENT_CATEGORY_ENGAGEMENT: "Engagement",
  PAM_DYNAMIC_BONUS_EVENT_CATEGORY_SPORTSBOOK: "Sportsbook",
  PAM_DYNAMIC_BONUS_EVENT_CATEGORY_CASINO: "Casino",
  PAM_DYNAMIC_BONUS_EVENT_CATEGORY_LIFECYCLE: "Lifecycle",
  PAM_DYNAMIC_BONUS_EVENT_USER_SIGNUP: "User signed up",
  PAM_DYNAMIC_BONUS_EVENT_FIRST_TIME_DEPOSIT: "First time deposit",
  PAM_DYNAMIC_BONUS_EVENT_MAKES_PURCHASE: "Makes a purchase",
  PAM_DYNAMIC_BONUS_EVENT_USER_WITHDRAWAL: "User withdrawal",
  PAM_DYNAMIC_BONUS_EVENT_TAX_PAID: "Tax paid",
  PAM_DYNAMIC_BONUS_EVENT_KYC_VERIFIED: "KYC verified",
  PAM_DYNAMIC_BONUS_EVENT_KYC_STATUS_CHANGED: "KYC status changed",
  PAM_DYNAMIC_BONUS_EVENT_VERIFIED_EMAIL: "Email verified",
  PAM_DYNAMIC_BONUS_EVENT_FIRST_LOGIN_POST_SIGNUP: "First login after sign-up",
  PAM_DYNAMIC_BONUS_EVENT_TENTH_LOGIN: "Tenth login",
  PAM_DYNAMIC_BONUS_EVENT_DAILY_LOGIN_STREAK_HIT: "Daily login streak hit",
  PAM_DYNAMIC_BONUS_EVENT_REFERRED_FRIEND: "Referred a friend",
  PAM_DYNAMIC_BONUS_EVENT_CLAIMS_REFERRAL_BONUS: "Claims referral bonus",
  PAM_DYNAMIC_BONUS_EVENT_FOLLOWED_USER: "Followed a user",
  PAM_DYNAMIC_BONUS_EVENT_SPIN_USED: "Daily spin used",
  PAM_DYNAMIC_BONUS_EVENT_GAME_PASS_STARTED: "Game pass started",
  PAM_DYNAMIC_BONUS_EVENT_CAMPAIGN_START: "Campaign starts",
  PAM_DYNAMIC_BONUS_EVENT_CASINO_BET_PLACED: "Casino bet placed",
  PAM_DYNAMIC_BONUS_EVENT_CASINO_BET_SETTLED: "Casino bet settled",
  PAM_DYNAMIC_BONUS_EVENT_CASINO_WIN: "Casino win",
  PAM_DYNAMIC_BONUS_EVENT_BET_PLACED: "Bet placed",
  PAM_DYNAMIC_BONUS_EVENT_PLACED_LIVE_BET: "Live bet placed",
  PAM_DYNAMIC_BONUS_EVENT_PLACES_FREE_BET: "Free bet placed",
  PAM_DYNAMIC_BONUS_EVENT_PLACES_BET_REBET_CASH: "Rebet cash bet placed",
  PAM_DYNAMIC_BONUS_EVENT_PLACES_PROFIT_BOOST_BET: "Profit boost bet placed",
  PAM_DYNAMIC_BONUS_EVENT_FAILED_BET_INSUFFICIENT_FUNDS:
    "Bet failed — insufficient funds",
  PAM_DYNAMIC_BONUS_EVENT_PARLAY_LOSS_BY_ONE: "Parlay lost by one leg",
  PAM_DYNAMIC_BONUS_EVENT_SETTLED_CASH_BET: "Cash bet settled",
  PAM_DYNAMIC_BONUS_EVENT_SETTLED_SWEAT_BET: "Cash bet settled (No Sweat Bet)",
  PAM_DYNAMIC_BONUS_EVENT_SETTLED_FREEBET: "Free bet settled",
  PAM_DYNAMIC_BONUS_EVENT_SETTLED_PROFIT_BOOST_BET: "Profit boost bet settled",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_BET_AMOUNT: "Bet amount",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_PAYOUT: "Payout",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_BET_RESULT: "Bet result",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_MARKET_ID: "Market ID",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_SPORT_ID: "Sport ID",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_TOURNAMENT_ID: "Tournament ID",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_MATCH_ID: "Match ID",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_LEAGUE_NAME: "League name",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_ODDS: "Odds",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_MONEY_TYPE: "Money type",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_PARLAY_LEGS: "Parlay legs",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_KYC_STATUS: "KYC status",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_AMOUNT: "Amount",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_CURRENCY: "Currency",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_USER_ID: "User ID",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_BET_ID: "Bet ID",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_TYPE_MONEY: "money",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_TYPE_STRING: "string",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_TYPE_NUMBER: "number",
  PAM_DYNAMIC_BONUS_EVENT_FIELD_TYPE_BOOLEAN: "boolean",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_SPORTSBOOK_LEAGUE: "Sportsbook league",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_SPORTSBOOK: "Sportsbook",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_SPORTSBOOK_MATCH: "Sportsbook match",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_CASINO: "Casino",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_CASINO_GAME: "Casino game",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_CASINO_PROVIDER: "Casino provider",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_CASINO_COLLECTION: "Casino collection",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_CASINO_CATEGORY: "Casino category",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_DEPOSIT: "Deposit",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_USER_PROFILE: "User profile",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_POKER_TABLE: "Poker table",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_POKER_LOBBY: "Poker lobby",
  PAM_DYNAMIC_BONUS_DEEPLINK_SCREEN_GAME_PASS: "Game pass",
  PAM_DYNAMIC_BONUS_INCLUDED_CONDITIONS: "Included Conditions",
  PAM_DYNAMIC_BONUS_REMOVE_STEP: "Remove Step",
  PAM_DYNAMIC_BONUS_FOLLOW_UP_SAME_EVENT:
    "All follow-up steps must trigger on the same event (the backend enforces this).",
  PAM_DYNAMIC_BONUS_FOLLOW_UP_OWN_EVENT:
    "Each step can trigger on its own event.",
  PAM_DYNAMIC_BONUS_AWARD_CONTINUES:
    "This award is paid and the campaign continues to the next step.",
  PAM_DYNAMIC_BONUS_AWARD_NO_FOLLOW_UP:
    "An award on campaign start completes the bonus — no follow-up steps.",
  PAM_DYNAMIC_BONUS_TRIGGER_EVENT_REQUIRED: "Trigger event is required",
  PAM_DYNAMIC_BONUS_RESULT_LABEL: "Result",
  PAM_DYNAMIC_BONUS_RESULT_TYPE_REQUIRED: "Result type is required",
  PAM_DYNAMIC_BONUS_REFERRAL_CODE_LABEL: "Referral Code",
  PAM_DATE_RANGE_LAST_7_DAYS: "Last 7 days",
  PAM_DATE_RANGE_LAST_30_DAYS: "Last 30 days",
  PAM_DATE_RANGE_CURRENT_MONTH: "Current Month",
  PAM_SEGMENTS_JOINED: "Joined",
  PAM_SEGMENTS_EXPIRES: "Expires",
  PAM_DYNAMIC_BONUS_LOADING_TRIGGER_EVENTS: "Loading trigger events…",
  PAM_SEGMENTS_LEGACY_TRIGGER_HINT:
    "This rule used a legacy trigger. Pick a catalog event to keep it.",
  PAM_SEGMENTS_ADD_FIELD_CHECK: "Add field check",
  PAM_AFFILIATE_EDIT_INFO_MODAL_TITLE: "Edit affiliate info",
  PAM_AFFILIATE_EDIT_PLAN_MODAL_TITLE: "Edit commission plan",
  PAM_AFFILIATE_SAVE_PLAN: "Save plan",
  PAM_EMPTY_VALUE: "—",
  PAM_AFFILIATE_PLAN_INCOMPLETE: "Complete the plan before saving",
  PAM_SET_PASSWORD_SIGN_IN_FIRST: "Please sign in first to set your password.",
  PAM_SET_PASSWORD_TITLE: "Create password",
  PAM_SET_PASSWORD_SUBTITLE: "Create your password",
  PAM_SET_PASSWORD_PLACEHOLDER: "Enter your password",
  PAM_PASSWORD_REQUIREMENTS_TITLE: "Password requirements:",
  PAM_PASSWORD_MIN_LENGTH: "At least {minLength} characters",
  PAM_PASSWORD_MIN_LENGTH_PENDING: "The required minimum number of characters - Awaiting validation",
  PAM_PASSWORD_LOWERCASE: "At least one lowercase letter",
  PAM_PASSWORD_UPPERCASE: "At least one uppercase letter",
  PAM_PASSWORD_NUMBER: "At least one number",
  PAM_PASSWORD_SYMBOL: "At least one symbol from: {acceptedSymbols}",
  PAM_PASSWORD_SYMBOL_PENDING: "At least one accepted symbol",
  PAM_PASSWORD_EMAIL_SIMILARITY:
    "Cannot contain your name or parts of your email address",
  PAM_PASSWORD_POLICY_CHECK_FAILED:
    "Unable to validate the password requirements. Please try again.",
  PAM_AFFILIATE_PASSWORD_MIN_LENGTH: "At least 8 characters",
  PAM_AFFILIATE_PASSWORD_SYMBOL: "At least one symbol (!@#$%^&*...)",
  PAM_SET_PASSWORD_CONFIRM_LABEL: "Confirm password",
  PAM_SET_PASSWORD_CONFIRM_PLACEHOLDER: "Confirm your password",
  PAM_SET_PASSWORD_FAILED: "Failed to set password.",
  PAM_RESET_PASSWORD_TITLE: "Reset password",
  PAM_RESET_PASSWORD_SUBTITLE: "Enter a new password for your account",
  PAM_RESET_PASSWORD_CONFIRMATION_CODE: "Confirmation Code",
  PAM_RESET_PASSWORD_NEW_LABEL: "New password",
  PAM_RESET_PASSWORD_NEW_PLACEHOLDER: "Enter your new password",
  PAM_RESET_PASSWORD_CONFIRM_LABEL: "Confirm new password",
  PAM_RESET_PASSWORD_CONFIRM_PLACEHOLDER: "Confirm your new password",
  PAM_RESET_PASSWORD_SUCCESS:
    "Password reset successfully! Please sign in with your new password.",
  PAM_RESET_PASSWORD_INVALID_OR_EXPIRED:
    "This reset link may have expired or the code is invalid.",
  PAM_PASSWORD_FIELDS_REQUIRED: "Please fill in all fields.",
  PAM_PASSWORD_REQUIREMENTS_NOT_MET: "Password does not meet all requirements.",
  PAM_PASSWORD_CREATED_SUCCESS:
    "Password created successfully! Sign in with your new password.",
  PAM_RESET_LINK_INVALID: "Invalid reset link. Redirecting to login.",

  // ===== BEGIN devolution fallbacks — PENDING DEPRECATION, DO NOT TRANSLATE =====
  // Each key below (and in the sibling devolution blocks in the other product
  // sections) is the English fallback for a toast that reports the result of
  // a single API call. Those endpoints will return a BE-localized `message`, and
  // `getApiSuccessMessage`/`getApiErrorMessage` already prefer it — the fallback
  // only fires because the message is missing today.
  //
  // English-only by design: held out of the TCM upload and tracked in
  // `toast-i18n-pending-deprecation.json` instead. Translating them FE-side would
  // give one string two independently-editable translations — this bundle and the
  // BE catalog — which drift apart silently.
  //
  // Delete these blocks once the corresponding BE msg_codes ship and the call
  // sites are rewrapped to read the response message. Do not add keys here unless
  // a single API response in scope will supply the copy.
  PAM_DYNAMIC_BONUS_SERIES_EDIT: "Edit",
  PAM_DYNAMIC_BONUS_SERIES_EDIT_TITLE: "Edit Series",
  PAM_DYNAMIC_BONUS_SERIES_SAVE: "Save Series",
  PAM_DYNAMIC_BONUS_EDIT_CAMPAIGN: "Edit Campaign",
  PAM_DYNAMIC_BONUS_SAVE_CAMPAIGN: "Save Campaign",
  PAM_DYNAMIC_BONUS_VIEW_CAMPAIGN: "View Campaign",
  PAM_DYNAMIC_BONUS_REVIEW_CAMPAIGN_CHANGES:
    "Review your campaign changes before saving.",
  PAM_DYNAMIC_BONUS_SERIES_RUN_READONLY_NOTICE:
    "This campaign was created by a series and cannot be edited.",
  PAM_DYNAMIC_BONUS_SERIES_RUN_REVIEW_HINT: "Series campaigns are view-only.",
  PAM_DYNAMIC_BONUS_BRAZE_PAYLOAD_BUTTON: "Braze payload",
  PAM_DYNAMIC_BONUS_BRAZE_PAYLOAD_TITLE: "Braze payload",
  PAM_DYNAMIC_BONUS_BRAZE_PAYLOAD_DESCRIPTION:
    "Copy this JSON and paste it as the webhook body in Braze. Adjust expiry below — the payload updates from the server.",
  PAM_DYNAMIC_BONUS_BRAZE_PAYLOAD_EXPIRY_LABEL: "Expiry (hours)",
  PAM_DYNAMIC_BONUS_BRAZE_PAYLOAD_COPY: "Copy",
  PAM_DYNAMIC_BONUS_BRAZE_PAYLOAD_NOT_ACTIVE_WARNING:
    "This series is not active. Subscriptions will fail until it is activated.",
  PAM_DYNAMIC_BONUS_BRAZE_PAYLOAD_WEBHOOK_HINT:
    "Paste as the webhook body for {webhookPath}.",
  PAM_DYNAMIC_BONUS_SERIES_ACTIONS_LABEL: "Series actions",

  PAM_REPORT_GENERATOR: "Report Generator",
  PAM_REPORT_PLATFORM_GATEWAY: "Platform/Gateway",
  PAM_REPORT_TYPE_WITHDRAW: "Withdraw",
  PAM_REPORT_STATUS_APPROVED: "Approved",
  PAM_REPORT_STATUS_NEEDS_REVIEW: "Needs Review",
  PAM_REPORT_STATUS_REJECTED: "Rejected",
  PAM_REPORT_STATUS_REQUIRES_ACTION: "Requires action",
  PAM_REPORT_COPY_ID: "Copy ID",
  PAM_REPORT_COPY_USER_ID: "Copy User ID",
  PAM_REPORT_SEARCH_PLACEHOLDER: "Search...",
  PAM_REPORT_SEARCH_FIELD: "Search field",
  PAM_REPORT_LAST_30_DAYS: "Last 30 Days",
  PAM_REPORT_LAST_X_DAYS: "Last {days} Days",
  PAM_REPORT_CURRENT_MONTH: "Current Month",
  PAM_REPORT_SELECTED_DATE_RANGE: "{start} – {end}",
  PAM_REPORT_FILTERS: "Filters",
  PAM_ACQUISITION_ALL_SOURCES: "All Sources",
  PAM_ACQUISITION_SOURCE_AFFILIATE_CODE: "Affiliate Code",
  PAM_ACQUISITION_SOURCE_UTM: "UTM",
  PAM_ACQUISITION_SOURCE_ORGANIC: "Organic",
  PAM_ACQUISITION_MONTHLY_USERS_TITLE: "Monthly Users",
  PAM_ACQUISITION_MONTHLY_USERS_TOOLTIP:
    "Shows new users and first-time deposits grouped by calendar month. By default, it covers the last 12 months, including the current month-to-date.",
  PAM_ACQUISITION_MONTHLY_USERS_ARIA: "Users monthly breakdown",
  PAM_ACQUISITION_MONTHLY_LOAD_ERROR:
    "Failed to load monthly users. Please try again.",
  PAM_REPORT_TABLE: "Table",
  PAM_REPORT_DEPOSIT_OR_WITHDRAWAL: "Deposit or Withdrawal",
  PAM_REPORT_MIN_PAYMENT_AMOUNT: "Min Payment Amount",
  PAM_REPORT_MAX_PAYMENT_AMOUNT: "Max Payment Amount",
  PAM_REPORT_AMOUNT_PLACEHOLDER: "000",
  PAM_REPORT_LOAD_ERROR: "Unable to load transactions. Please try again.",
  PAM_CONFIGURABLE_TABLE_COLUMNS_SHOWN: "Columns Shown",
  PAM_CONFIGURABLE_TABLE_REORDER_COLUMN: "Reorder {column}",
  PAM_CONFIGURABLE_TABLE_SETTINGS_UPDATED: "Table settings updated.",
  PAM_PAGINATION_RETURNING: "Returning",
  PAM_PAGINATION_OF: "of",

  // Configurations → State Configuration (PENG-78).
  PAM_STATE_CONFIGURATION_PAGE_TITLE: "State Configuration",
  PAM_STATE_CONFIGURATION_SEARCH_PLACEHOLDER: "Search",
  PAM_STATE_CONFIGURATION_FILTER_BUTTON: "Filter",
  PAM_STATE_CONFIGURATION_FILTER_MODE_LABEL: "Predictions or Sweeps",
  PAM_STATE_CONFIGURATION_FILTER_MODE_ALL: "All",
  PAM_STATE_CONFIGURATION_COLUMN_STATE: "State",
  PAM_STATE_CONFIGURATION_COLUMN_GROUP_PREDICTION: "Predictions",
  PAM_STATE_CONFIGURATION_COLUMN_GROUP_SWEEPSTAKES: "Sweepstakes",
  PAM_STATE_CONFIGURATION_COLUMN_SIGNUP_AGE: "Signup Age",
  PAM_STATE_CONFIGURATION_COLUMN_MODE: "Predictions or Sweeps",
  PAM_STATE_CONFIGURATION_COLUMN_SPORTS: "Sports",
  PAM_STATE_CONFIGURATION_COLUMN_SPORTSBOOK: "Sportsbook",
  PAM_STATE_CONFIGURATION_COLUMN_DISCOVER: "Discover",
  PAM_STATE_CONFIGURATION_COLUMN_CASINO: "Casino",
  PAM_STATE_CONFIGURATION_COLUMN_CURRENCIES: "Currencies",
  PAM_STATE_CONFIGURATION_SECTION_CURRENCIES: "Currencies",
  PAM_STATE_CONFIGURATION_SECTION_FEATURES: "Features",
  PAM_STATE_CONFIGURATION_COLUMN_RIPS: "Rips",
  PAM_STATE_CONFIGURATION_COLUMN_RIP_PACKS: "Rip Packs",
  PAM_STATE_CONFIGURATION_COLUMN_CULTURE: "Culture",
  PAM_STATE_CONFIGURATION_COLUMN_STATUS: "Status",
  PAM_STATE_CONFIGURATION_SIGNUP_AGE_VALUE: "{age}+",
  PAM_STATE_CONFIGURATION_CURRENCIES_EMPTY: "—",
  PAM_STATE_CONFIGURATION_EDIT_ACTION_LABEL: "Edit {state}",
  PAM_STATE_CONFIGURATION_LOAD_ERROR:
    "We couldn't load state configurations. Try again.",
  PAM_STATE_CONFIGURATION_EMPTY: "No states match your search.",
  PAM_STATE_CONFIGURATION_SAVE_SUCCESS: "State configuration updated.",
  PAM_STATE_CONFIGURATION_SAVE_ERROR:
    "We couldn't save this state's configuration. Try again.",
  PAM_STATE_CONFIGURATION_MODAL_TITLE: "Edit “{state}”",
  PAM_STATE_CONFIGURATION_MODE_LABEL: "Prediction or Sweeps?",
  PAM_STATE_CONFIGURATION_MODE_PREDICTION: "Predictions",
  PAM_STATE_CONFIGURATION_MODE_SWEEPSTAKES: "Sweeps",
  PAM_STATE_CONFIGURATION_SIGNUP_AGE_LABEL: "Signup Age",
  PAM_STATE_CONFIGURATION_TOGGLE_SPORTSBOOK_SWEEPS: "Sportsbook - Sweeps",
  PAM_STATE_CONFIGURATION_TOGGLE_SPORTS_PREDICTIONS: "Sports - Predictions",
  PAM_STATE_CONFIGURATION_TOGGLE_DISCOVER: "Discover",
  PAM_STATE_CONFIGURATION_TOGGLE_CASINO: "Casino",
  PAM_STATE_CONFIGURATION_TOGGLE_RIP_PACKS: "Rip packs",
  PAM_STATE_CONFIGURATION_TOGGLE_CULTURE: "Culture",
  PAM_STATE_CONFIGURATION_SAVE_CONFIRM: "Yes, Update",
  PAM_STATE_CONFIGURATION_PAGINATION_ITEMS: "states",

  PAM_REGULATOR_PORTAL: "Regulator Portal",
  PAM_REGULATOR_PORTAL_SIGN_IN_SUBTITLE: "Sign in to your regulator account",
  PAM_REGULATOR_PORTAL_CHECKING_ACCESS: "Checking your regulator access…",
  PAM_REGULATOR_PORTAL_PENDING_TITLE: "Your access is awaiting approval",
  PAM_REGULATOR_PORTAL_PENDING_BODY:
    "Your regulator account is set up, but an operator still has to approve it before the portal opens.",
  PAM_REGULATOR_PORTAL_PENDING_HINT:
    "Leave this page open — it unlocks on its own as soon as your access is approved, with no need to sign in again.",
  PAM_REGULATOR_PORTAL_DASHBOARD_TITLE: "Overview",
  PAM_REGULATOR_PORTAL_DASHBOARD_EMPTY:
    "Regulatory reporting for your jurisdiction will appear here.",
  PAM_REGULATOR_PORTAL_DASHBOARD_RESULTS:
    "Review archived compliance scans for your jurisdiction.",
  PAM_REGULATOR_PORTAL_DASHBOARD_RULES:
    "Review and update the monitoring rule that applies to this environment.",
  PAM_REGULATOR_PORTAL_DASHBOARD_SERVICES:
    "Review services that can be promoted for this environment.",
  PAM_REGULATOR_PORTAL_DASHBOARD_REPORTS:
    "Generate and download reporting packs for this jurisdiction.",
  PAM_REGULATOR_PORTAL_SERVICES: "Promotable Services",
  PAM_REGULATOR_PORTAL_SERVICES_EMPTY: "No promotable services",
  PAM_REGULATOR_PORTAL_SERVICES_LOAD_ERROR:
    "Could not load promotable services.",
  PAM_REGULATOR_PORTAL_APPROVE_RUNNING: "Approve all running services",
  PAM_REGULATOR_PORTAL_APPROVE_RUNNING_SUCCESS:
    "Approval of running services started.",
  PAM_REGULATOR_PORTAL_APPROVE_RUNNING_ERROR:
    "Could not approve running services.",
  PAM_REGULATOR_PORTAL_APPROVE_SELECTED: "Approve selected services",
  PAM_REGULATOR_PORTAL_APPROVE_SELECTED_SUCCESS:
    "Selected services submitted for approval.",
  PAM_REGULATOR_PORTAL_APPROVE_SELECTED_ERROR:
    "Could not approve the selected services.",
  PAM_REGULATOR_PORTAL_APPROVE_SELECTED_INVALID:
    "Selected services are missing a name or image digest.",
  PAM_REGULATOR_PORTAL_APPROVE_SELECTED_PARTIAL:
    "Some selected services could not be approved: {details}",
  PAM_REGULATOR_PORTAL_FILTER_SERVICES: "Filter services",
  PAM_REGULATOR_PORTAL_NOT_FOUND_TITLE:
    "This page isn't part of the regulator portal",
  PAM_REGULATOR_PORTAL_NOT_FOUND_BODY:
    "Check the address, or head back to your overview.",
  PAM_REGULATOR_PORTAL_BACK_TO_DASHBOARD: "Back to overview",
  PAM_REGULATOR_PORTAL_RESULTS: "Verification Results",
  PAM_REGULATOR_PORTAL_RULES: "Client Rules",
  PAM_REGULATOR_PORTAL_RESULTS_EMPTY: "No compliance results",
  PAM_REGULATOR_PORTAL_RULES_EMPTY: "No compliance rules",
  PAM_REGULATOR_PORTAL_RESULTS_LOAD_ERROR: "Could not load compliance results.",
  PAM_REGULATOR_PORTAL_START_VERIFICATION: "Start verification",
  PAM_REGULATOR_PORTAL_VERIFY_SUCCESS: "Verification job started.",
  PAM_REGULATOR_PORTAL_VERIFY_ERROR: "Could not start a verification job.",
  PAM_REGULATOR_PORTAL_START_MANIFEST: "Start manifest scan",
  PAM_REGULATOR_PORTAL_MANIFEST_SUCCESS: "Manifest scan started.",
  PAM_REGULATOR_PORTAL_MANIFEST_ERROR: "Could not start a manifest scan.",
  PAM_REGULATOR_PORTAL_RULES_LOAD_ERROR: "Could not load compliance rules.",
  PAM_REGULATOR_PORTAL_RESULT_LOAD_ERROR: "Could not load this result.",
  PAM_REGULATOR_PORTAL_RULE_LOAD_ERROR: "Could not load this rule.",
  PAM_REGULATOR_PORTAL_RESULT_NOT_FOUND: "Result not found",
  PAM_REGULATOR_PORTAL_RULE_NOT_FOUND: "Rule not found",
  PAM_REGULATOR_PORTAL_RESULT_DETAIL: "Result detail",
  PAM_REGULATOR_PORTAL_RULE_DETAIL: "Rule detail",
  PAM_REGULATOR_PORTAL_BACK_TO_RESULTS: "Back to verification results",
  PAM_REGULATOR_PORTAL_BACK_TO_RULES: "Back to client rules",
  PAM_REGULATOR_PORTAL_PREVIOUS: "Previous",
  PAM_REGULATOR_PORTAL_LOADING: "Loading…",
  PAM_REGULATOR_PORTAL_RESULT_RUNNING: "This run is still in progress",
  PAM_REGULATOR_PORTAL_FINDINGS_EMPTY: "No per-check results for this run.",
  PAM_REGULATOR_PORTAL_FINDINGS_SEARCH_EMPTY: "No services match that search.",
  PAM_REGULATOR_PORTAL_FINDINGS_COMPLIANT_EMPTY:
    "No compliant services for this run.",
  PAM_REGULATOR_PORTAL_FINDINGS_NON_COMPLIANT_EMPTY:
    "No non-compliant services for this run.",
  PAM_REGULATOR_PORTAL_SEARCH_SERVICES: "Search by service name",
  PAM_REGULATOR_PORTAL_SELECT_ALL_SERVICES: "Select all services",
  PAM_REGULATOR_PORTAL_SELECT_SERVICE: "Select {name}",
  PAM_REGULATOR_PORTAL_WORKLOADS_EMPTY: "No monitored workloads",
  PAM_REGULATOR_PORTAL_GAME_STOPS_EMPTY: "No Game Stops",
  PAM_REGULATOR_PORTAL_DB_CONFIGS_EMPTY: "No monitored DB configs",
  PAM_REGULATOR_PORTAL_EDIT_RULE: "Edit rule",
  PAM_REGULATOR_PORTAL_SAVE_RULE: "Save rule",
  PAM_REGULATOR_PORTAL_RULE_SAVE_SUCCESS: "Rule saved.",
  PAM_REGULATOR_PORTAL_RULE_SAVE_ERROR: "Could not save this rule.",
  PAM_REGULATOR_PORTAL_RULE_TARGET_REQUIRED: "Target account is required.",
  PAM_REGULATOR_PORTAL_RULE_BASELINE_REQUIRED: "Baseline account is required.",
  PAM_REGULATOR_PORTAL_RULE_ACCOUNT_LOCKED:
    "This account identifies the rule and cannot be changed.",
  PAM_REGULATOR_PORTAL_ADD_WORKLOAD: "Add workload",
  PAM_REGULATOR_PORTAL_REMOVE_WORKLOAD: "Remove workload",
  PAM_REGULATOR_PORTAL_ADD_GAME_STOP: "Add Game Stop",
  PAM_REGULATOR_PORTAL_REMOVE_GAME_STOP: "Remove Game Stop",
  PAM_REGULATOR_PORTAL_ADD_DB_CONFIG: "Add DB config",
  PAM_REGULATOR_PORTAL_REMOVE_DB_CONFIG: "Remove DB config",
  PAM_REGULATOR_PORTAL_GAME_STOP_NAME: "Game Stop name",
  PAM_REGULATOR_PORTAL_FIELDS_HINT: "Comma-separated field names",
  PAM_REGULATOR_PORTAL_RESOURCES_HINT: "Comma-separated resource names",
  PAM_REGULATOR_PORTAL_CONDITIONS_HINT: "key=value, comma-separated",
  PAM_REGULATOR_PORTAL_FILTER_FINDINGS: "Filter findings",
  PAM_REGULATOR_PORTAL_NAV: "Portal pages",
  PAM_REGULATOR_PORTAL_REPORTS: "Reports",
  PAM_REGULATOR_PORTAL_PAST_REPORTS: "Past reports",
  PAM_REGULATOR_PORTAL_START_REPORT: "Start report",
  PAM_REGULATOR_PORTAL_START_REPORT_SUCCESS: "Report run started.",
  PAM_REGULATOR_PORTAL_START_REPORT_ERROR: "Could not start a report run.",
  PAM_REGULATOR_PORTAL_REPORTS_EMPTY: "No downloadable reports",
  PAM_REGULATOR_PORTAL_REPORTS_LOAD_ERROR: "Could not load reports.",
  PAM_REGULATOR_PORTAL_REPORT_LOAD_ERROR: "Could not load this report.",
  PAM_REGULATOR_PORTAL_REPORT_NOT_FOUND: "Report not found",
  PAM_REGULATOR_PORTAL_REPORT_DETAIL: "Report files",
  PAM_REGULATOR_PORTAL_BACK_TO_REPORTS: "Back to reports",
  PAM_REGULATOR_PORTAL_REPORT_PACK: "Pack",
  PAM_REGULATOR_PORTAL_PACK_GLI: "GLI",
  PAM_REGULATOR_PORTAL_PACK_BRAZIL: "Brazil",
  PAM_REGULATOR_PORTAL_PACK_PERU: "Peru",
  PAM_REGULATOR_PORTAL_REPORT_BRAND: "Brand",
  PAM_REGULATOR_PORTAL_REPORT_REFERENCE_DATE: "Reference date",
  PAM_REGULATOR_PORTAL_REPORT_LAST_MODIFIED: "Last modified",
  PAM_REGULATOR_PORTAL_SORT_NEWEST: "Newest first",
  PAM_REGULATOR_PORTAL_SORT_OLDEST: "Oldest first",
  PAM_REGULATOR_PORTAL_DOWNLOAD_ERROR: "Could not download this file.",
  PAM_REGULATOR_PORTAL_FILES_EMPTY: "No files for this run.",
  PAM_REGULATOR_PORTAL_GROUPING_GLI: "GLI",
  PAM_REGULATOR_PORTAL_GROUPING_BRAZIL: "Brazil",
  PAM_REGULATOR_PORTAL_GROUPING_PERU: "Peru",
  PAM_REGULATOR_PORTAL_GROUPING_ZIP: "Zip pack",
  PAM_REGULATOR_PORTAL_GROUPING_OTHER: "Other",
  PAM_REGULATOR_PORTAL_CLIENT: "Client",
  PAM_REGULATOR_PORTAL_REGULATOR_NAME: "Regulator",
  PAM_REGULATOR_PORTAL_TRIGGER: "Trigger",
  PAM_REGULATOR_PORTAL_ARCHIVED: "Archived",
  PAM_REGULATOR_PORTAL_TARGET_ACCOUNT: "Target account",
  PAM_REGULATOR_PORTAL_BASELINE_ACCOUNT: "Baseline account",
  PAM_REGULATOR_PORTAL_MONITORED_WORKLOADS: "Monitored workloads",
  PAM_REGULATOR_PORTAL_MONITORED_WORKLOADS_TITLE: "Monitored workloads ({count})",
  PAM_REGULATOR_PORTAL_MONITORED_DB_CONFIGS: "Monitored DB configs",
  PAM_REGULATOR_PORTAL_MONITORED_DB_CONFIGS_TITLE: "Monitored DB configs ({count})",
  PAM_REGULATOR_PORTAL_GAME_STOPS: "Game Stops",
  PAM_REGULATOR_PORTAL_GAME_STOPS_TITLE: "Game Stops ({count})",
  PAM_REGULATOR_PORTAL_RESOURCE_TYPE: "Resource type",
  PAM_REGULATOR_PORTAL_REGION: "Region",
  PAM_REGULATOR_PORTAL_CLUSTER: "Cluster",
  PAM_REGULATOR_PORTAL_NAMESPACE: "Namespace",
  PAM_REGULATOR_PORTAL_DEPLOYMENT: "Deployment",
  PAM_REGULATOR_PORTAL_TABLE: "Table",
  PAM_REGULATOR_PORTAL_FIELDS: "Fields",
  PAM_REGULATOR_PORTAL_CONDITIONS: "Conditions",
  PAM_REGULATOR_PORTAL_RESOURCES: "Resources",
  PAM_REGULATOR_PORTAL_CHECKS: "Checks",
  PAM_REGULATOR_PORTAL_TARGET: "Target",
  PAM_REGULATOR_PORTAL_DETAILS: "Details",
  PAM_REGULATOR_PORTAL_SUCCESS_COUNT: "Success",
  PAM_REGULATOR_PORTAL_COMPLIANT: "Compliant",
  PAM_REGULATOR_PORTAL_NON_COMPLIANT: "Non-compliant",
  PAM_REGULATOR_PORTAL_FILTER_ALL: "All",
  PAM_REGULATOR_PORTAL_IMAGE_TAG: "Tag",
  PAM_REGULATOR_PORTAL_DEPLOYED_HASH: "Deployed hash",
  PAM_REGULATOR_PORTAL_LAST_SCANNED: "Last scanned: {timestamp}",
  PAM_REGULATOR_PORTAL_IMAGE_FALLBACK: "Image {index}",
  PAM_REGULATOR_PORTAL_STAGE: "Stage",
  PAM_REGULATOR_PORTAL_GENERATED_AT: "Generated",
  PAM_REGULATOR_PORTAL_SERVICE_NAME: "Service",
  PAM_REGULATOR_PORTAL_ECR_REPOSITORY: "ECR repository",
  PAM_REGULATOR_PORTAL_CURRENT_TAG: "Current tag",
  PAM_REGULATOR_PORTAL_VALUES_FILE: "Values file",
  PAM_REGULATOR_PORTAL_IMAGE_DIGEST: "Image digest",
  PAM_REGULATOR_PORTAL_REASON: "Reason",
  PAM_REGULATOR_PORTAL_APPROVED: "Approved",
  PAM_REGULATOR_PORTAL_PENDING: "Pending",
  PAM_REGULATOR_PORTAL_UNKNOWN: "Unknown",

  // =====================================================================
  // Casino
  // =====================================================================
  TURNOVER: "Turnover",
  PAID_FUNDS: "PAID FUNDS",
  UNPAID_FUNDS: "UNPAID FUNDS",
  RETURNED_FUNDS: "RETURNED FUNDS",
  GGR: "GGR",
  NGR: "NGR",
  GGR_MARGIN: "GGR MARGIN",
  NGR_MARGIN: "NGR MARGIN",
  Top_5_Games: "Top 5 Games",
  PROVIDER: "Provider",
  PROVIDERS: "Providers",
  GAME: "Game",
  GAME_CATEGORY: "Game Category",
  ACTIVE_FILTER_OPTION: "Active",
  ACTIVE_GAMES_HEADER: "Active Games",
  HIDDEN_FILTER_OPTION: "Hidden",
  MAINTENANCE_FILTER_OPTION: "Maintenance",
  MIN_GGR: "Min GGR",
  MIN_MARGIN: "Min Margin",
  MIN_TURNOVER: "Min Turnover",
  NET_PL_HEADER: "Net P/L",
  PROVIDER_NAME_HEADER: "Provider Name",
  TOTAL_GAMES_HEADER: "Total Games",
  TOTAL_PROVIDERS: "TOTAL PROVIDERS",
  TOTAL_GAMES: "TOTAL GAMES",
  CASINO_KPI: "Casino KPI",
  PROVIDERS_LIST: "Providers List",
  GAME_LIST: "Games List",
  CASINO: "Casino",
  ERROR_CHANGING_CASINO_GAME_ORDER: "error changing casino game order",
  COLLECTION_NAME: "Collection Name",
  ERROR_ADDING_CASINO_ENTITY: "Error adding casino entity",
  ERROR_ADDING_GAME_IN_CASINO_ENTITY: "Error adding game in casino entity",
  ERROR_TOGGLING_CASINO_ENTITY_STATUS: "Error toggling casino entity status",
  USER_CASINO_BETS: "User's Casino Bets",
  CASINO_WAGER_LIMITS: "Casino Wager Limits",
  EDIT_CASINO_LIMITS: "Edit Casino Limits",
  MAX_CASINO_WAGER_AMOUNT_OF: "Max Casino wager amount of",
  MAX_CASINO_WAGER_AMOUNT_OF_SECONDARY_CURRENCY_PER_DAY: "Max Casino wager amount of Trivelta Coin per Day",
  MAX_CASINO_WAGER_AMOUNT_OF_PRIMARY_CURRENCY_PER_DAY: "Max Casino wager amount of Trivelta Cash per Day",
  CASINO_LIMITS_UPDATED_SUCCESSFULLY: "Casino limits updated successfully.",
  CASINO_LIMITS: "Casino Limits",
  CASINO_BETS: "Casino Bets",
  DISPLAY_LOCATION_CASINO: "Casino",
  CASINO_BANNERS: "Casino Banners",
  LIVE_CASINO: "Live Casino",
  CASINO_GAMES_SHOWING_OF_TOTAL: "Showing {filteredCount} of {totalCount}",
  CASINO_GAMES_COUNT_SUMMARY: "{count} games",
  CASINO_FEATURE_MANAGEMENT: "Casino Feature Management",
  ERROR_DELETING_CASINO_ENTITY: "Error deleting casino entity",
  INITIALIZE_CASINO_PAGE: "Initialize Casino Page",
  INITIALIZE_CASINO_PAGE_SUCCESS: "Casino page initialized successfully.",
  INITIALIZE_CASINO_PAGE_FAILED: "Failed to initialize casino page. Please try again.",
  BACK_TO_PROVIDERS_LIST: "Back to Providers list",
  TOTAL_CASINO_CASH: "Casino Cash",
  CASINO_FREE_CASH_ADDED_SUCCESSFULLY: "Casino free cash added successfully.",
  CASINO_CASH: "Casino Cash",
  ADD_CASINO_FREE_CASH: "Add Casino Free Cash",
  CASINO_GAME: "Casino Game",
  CASINO_GGR: "Casino GGR",
  CASINO_REVENUE: "Casino Revenue",
  CASINO_FINANCE_COL_ACTIVE_GAMES: "Active Games",
  CASINO_FINANCE_COL_AVG_BET: "Avg. Bet Amount",
  CASINO_FINANCE_COL_DATE: "Date",
  CASINO_FINANCE_COL_GGR: "GGR",
  CASINO_FINANCE_COL_PLAYERS: "Players",
  CASINO_FINANCE_COL_ROUNDS: "Rounds",
  CASINO_FINANCE_COL_RTP: "RTP %",
  CASINO_FINANCE_COL_TOTAL_GAMES: "Total Games",
  CASINO_FINANCE_COL_TURNOVER: "Turnover",
  CASINO_FINANCE_COL_WINS: "Wins",
  CASINO_FINANCE_EXPORT_ERROR: "Could not export casino finance report. Try again or contact support.",
  CASINO_FINANCE_EXPORT_PENDING: "Export will be available when the API supports it.",
  CASINO_FINANCE_KPI_PLAYERS: "PLAYERS",
  CASINO_FINANCE_KPI_ROUNDS: "ROUNDS",
  CASINO_FINANCE_KPI_TURNOVER: "TURNOVER",
  CASINO_FINANCE_KPI_WINS: "WINS",
  CASINO_FINANCE_LOAD_ERROR: "Could not load casino finance data.",
  CASINO_FINANCE_PAGINATION_TOTAL_LABEL: "of {total} days",
  CASINO_FINANCE_REPORTS_TITLE: "Casino Finance Reports",
  CASINO_GAMES_COL_CATEGORY: "Category",
  CASINO_GAMES_COL_PROVIDER: "Provider",
  CASINO_GAMES_EXPORT_ERROR: "Could not export casino games report. Try again or contact support.",
  CASINO_GAMES_EXPORT_PENDING: "Nothing to export on this page.",
  CASINO_GAMES_FILTERS_APPLIED: "Filters applied.",
  CASINO_GAMES_FILTER_CATEGORY_PLACEHOLDER: "Category",
  CASINO_GAMES_FILTER_PROVIDER_PLACEHOLDER: "Provider",
  CASINO_GAMES_LOAD_ERROR: "Could not load casino games report.",
  CASINO_GAMES_NOT_SELECTED: "Not selected",
  CASINO_GAMES_PAGE_TITLE: "Casino Games",
  CASINO_GAMES_PAGINATION_TOTAL_LABEL: "of {total} games",
  CASINO_GAMES_SEARCH_PLACEHOLDER: "Search game name",
  CASINO_PROVIDERS_COL_AVG_ROUNDS: "Avg. Rounds",
  CASINO_PROVIDERS_COL_UNIQUE_PLAYERS: "Unique Players",
  CASINO_PROVIDERS_EXPORT_ERROR: "Could not export casino providers report. Try again or contact support.",
  CASINO_PROVIDERS_EXPORT_NO_ROWS: "No data to export for the selected period.",
  CASINO_PROVIDERS_LOAD_ERROR: "Could not load casino providers report.",
  CASINO_PROVIDERS_PAGE_TITLE: "Casino Providers",
  CASINO_PROVIDERS_PAGINATION_TOTAL_LABEL: "of {total} providers",
  CASINO_PROVIDERS_SEARCH_PLACEHOLDER: "Search provider name",
  // Casino → Scheduled Tasks (CASENG-1048 block kept verbatim so the branch
  // merges clean; CASENG-1058 adds the RUN_*/UPDATE_LOG keys).
  CASINO_SCHEDULED_TASKS: "Scheduled Tasks",
  CASINO_SCHEDULED_TASKS_COL_CORRELATION_ID: "Correlation ID",
  CASINO_SCHEDULED_TASKS_COL_CREATED: "Created",
  CASINO_SCHEDULED_TASKS_COL_ERROR: "Error",
  CASINO_SCHEDULED_TASKS_COL_FINISHED: "Finished",
  CASINO_SCHEDULED_TASKS_COL_STARTED: "Started",
  CASINO_SCHEDULED_TASKS_COL_STATUS: "Status",
  CASINO_SCHEDULED_TASKS_CONSUMER_DISABLED:
    "The scheduled task runner is disabled. Contact platform support to enable it.",
  CASINO_SCHEDULED_TASKS_LAST_RUN: "Last triggered run",
  CASINO_SCHEDULED_TASKS_LOAD_ERROR: "Could not load scheduled task runs.",
  CASINO_SCHEDULED_TASKS_LOG_EMPTY: "No runs recorded yet.",
  CASINO_SCHEDULED_TASKS_LOG_FORBIDDEN:
    "Your account doesn't have access to scheduled task history. Ask an admin for scheduled-task read access.",
  CASINO_SCHEDULED_TASKS_PURPOSE_CREATE_DEFAULT_CASINO_ENTITIES:
    "Create Default Casino Entities",
  CASINO_SCHEDULED_TASKS_PURPOSE_GENERATE_BETCORE_ACCESS_TOKEN:
    "Generate Betcore Access Token",
  CASINO_SCHEDULED_TASKS_PURPOSE_LABEL: "Task",
  CASINO_SCHEDULED_TASKS_PURPOSE_LOAD_CASINO_GAMES: "Load Casino Games",
  CASINO_SCHEDULED_TASKS_PURPOSE_NOT_ALLOWED:
    "This task is not allowed to be triggered.",
  CASINO_SCHEDULED_TASKS_PURPOSE_OVERWRITE_CASINO_GAME_IMAGES:
    "Overwrite Casino Game Images",
  CASINO_SCHEDULED_TASKS_PURPOSE_OVERWRITE_CASINO_GAME_IMAGES_FORCE_REFRESH:
    "Overwrite Casino Game Images (Force Refresh)",
  CASINO_SCHEDULED_TASKS_QUEUE_UNAVAILABLE:
    "The task queue is unavailable. Try again in a moment.",
  CASINO_SCHEDULED_TASKS_REFRESH: "Refresh",
  CASINO_SCHEDULED_TASKS_RUN_FAILED:
    "Scheduled task failed. Check the update log for details.",
  CASINO_SCHEDULED_TASKS_RUN_SCHEDULER: "Run Scheduler",
  CASINO_SCHEDULED_TASKS_RUN_SUCCEEDED: "Scheduled task completed.",
  CASINO_SCHEDULED_TASKS_STATUS_FAILED: "Failed",
  CASINO_SCHEDULED_TASKS_STATUS_ORPHANED: "Orphaned",
  CASINO_SCHEDULED_TASKS_STATUS_PENDING: "Pending",
  CASINO_SCHEDULED_TASKS_STATUS_RUNNING: "Running",
  CASINO_SCHEDULED_TASKS_STATUS_SUCCESS: "Success",
  CASINO_SCHEDULED_TASKS_TRIGGER: "Trigger",
  CASINO_SCHEDULED_TASKS_TRIGGERED: "Task triggered.",
  CASINO_SCHEDULED_TASKS_TRIGGER_CONFIRM_DESCRIPTION:
    "This runs {purpose} against external providers immediately.",
  CASINO_SCHEDULED_TASKS_TRIGGER_CONFIRM_TITLE: "Trigger this task now?",
  CASINO_SCHEDULED_TASKS_TRIGGER_ERROR:
    "Could not trigger the task. Try again or contact support.",
  CASINO_SCHEDULED_TASKS_UPDATE_LOG: "Update Log",
  CREATE_TASK_TASK_TYPE_CASINO: "Casino",
  CASINO_CONFIGURATION_FEATURES: "Features",
  CASINO_CONFIGURATION_GAMES: "Games",
  CASINO_CONFIGURATION_PAGES: "Pages",
  CASINO_CONFIGURATION_PREVIEW: "Preview",
  CASINO_CONFIGURATION_PROVIDERS: "Providers",
  CASINO_CONFIGURATION_TAGS: "Tags",
  CASINO_CONFIGURATION_VIEWS: "Views",
  CREATE_TASK_CASINO_TAB_ALL: "All Providers",
  CREATE_TASK_CASINO_TAB_JACKPOT: "Jackpot",
  CREATE_TASK_CASINO_TAB_LIVE_CASINO: "Live Casino",
  CREATE_TASK_CASINO_TAB_SLOTS: "Slots",
  CREATE_TASK_CASINO_TAB_TABLE_GAMES: "Table Games",
  CREATE_SEASON_CASINO_TASK_SUBMISSION_INFO_ARIA: "Casino tasks always use automatic submission at the season level.",
  CREATE_SEASON_CASINO_TASK_SUBMISSION_LABEL: "Casino Task Submission",
  MONTHLY_CHALLENGE_TASK_TYPE_CASINO_PICKS: "Casino Picks",
  CREATE_TASK_CASINO_ERROR: "Couldn't load casino games.",
  CREATE_TASK_CASINO_LOADING: "Loading…",
  CREATE_TASK_CASINO_MORE_SELECTIONS: "+{count} more",
  CREATE_TASK_CASINO_NO_GAMES: "No games found.",
  CREATE_TASK_CASINO_NO_PROVIDERS: "No providers found.",
  CREATE_TASK_CASINO_PROVIDERS: "Casino Provider and Games",
  CREATE_TASK_CASINO_PROVIDERS_ARIA: "Casino providers and games",
  CREATE_TASK_CASINO_PROVIDERS_PLACEHOLDER: "Search Providers",
  CREATE_TASK_CASINO_REMOVE_SELECTION: "Remove {name}",
  CREATE_TASK_CASINO_RETRY: "Retry",
  CREATE_TASK_CASINO_SHOW_LESS_SELECTIONS: "Show less",
  CREATE_TASK_CASINO_SHOW_MORE: "Show More",
  CREATE_TASK_CASINO_TASK_SUBMISSION_INFO_ARIA: "Choose whether this casino task's progress is submitted automatically or requires a manual pass.",
  CASINO_BET_ID: "Casino Bet ID",
  CASINO_CASH_BONUS_AMOUNT: "Casino Cash Bonus Amount",
  MAX_CASINO_CASH: "Max Casino Cash",
  REFERRAL_CASINO_CASH_TOOLTIP: "The amount of Casino Cash granted from the Referral Bonus.",
  WELCOME_MATCH_PERCENTAGE_CASINO_TOOLTIP: "The percentage of the first purchase that is matched as Casino Cash.",
  WELCOME_MAX_CASINO_CASH_TOOLTIP: "Maximum Casino Cash a user will receive with their purchase.",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES: "+ Add games",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES_CANCEL: "Cancel",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES_COLLECTION: "Collection",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES_FAILED: "Failed to add games",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES_GAME: "Game",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES_GAMES: "Games",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES_NO_RESULTS: "No games found",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES_SEARCH: "Search by name",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES_SELECTED: "selected",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES_SUCCESS: "{count} {unit} added",
  CASINO_CONFIG_COLLECTIONS_ADD_GAMES_TITLE: "Add Games To",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS: "+ Add providers",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS_CANCEL: "Cancel",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS_FAILED: "Failed to add providers",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS_NO_RESULTS: "No providers found",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS_PROVIDER: "Provider",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS_PROVIDERS: "Providers",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS_SEARCH: "Search by name or slug...",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS_SUBMIT: "Add {count} {unit}",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS_SUCCESS_PLURAL: "{count} Providers Added",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS_SUCCESS_SINGULAR: "1 Provider Added",
  CASINO_CONFIG_COLLECTIONS_ADD_PROVIDERS_TITLE: "Add Providers To",
  CASINO_CONFIG_COLLECTIONS_ANIMATE_ICON_HINT: "Play the icon's built-in animation in the live UI. Off = static.",
  CASINO_CONFIG_COLLECTIONS_ANIMATE_ICON_TITLE: "Animate Icon",
  CASINO_CONFIG_COLLECTIONS_ARIA_ACTIVATE: "Activate",
  CASINO_CONFIG_COLLECTIONS_ARIA_COLLAPSE: "Collapse",
  CASINO_CONFIG_COLLECTIONS_ARIA_DEACTIVATE: "Deactivate",
  CASINO_CONFIG_COLLECTIONS_ARIA_EXPAND: "Expand",
  CASINO_CONFIG_COLLECTIONS_BADGE_AGG: "agg",
  CASINO_CONFIG_COLLECTIONS_BADGE_PINNED: "pinned",
  CASINO_CONFIG_COLLECTIONS_BADGE_POPULAR: "popular",
  CASINO_CONFIG_COLLECTIONS_CLEAR_PARENT_ARIA: "Clear parent",
  CASINO_CONFIG_COLLECTIONS_CODE_LABEL: "Code",
  CASINO_CONFIG_COLLECTIONS_DEFAULT_VIEW_HINT: "Tab the admin lands on when opening this collection.",
  CASINO_CONFIG_COLLECTIONS_DEFAULT_VIEW_LABEL: "Default view",
  CASINO_CONFIG_COLLECTIONS_DELETE_BUTTON: "Delete",
  CASINO_CONFIG_COLLECTIONS_DELETE_FAILED: "Failed to delete collection",
  CASINO_CONFIG_COLLECTIONS_DELETE_MEMBERS_SUFFIX: "members",
  CASINO_CONFIG_COLLECTIONS_DELETE_MODAL_CANCEL: "Cancel",
  CASINO_CONFIG_COLLECTIONS_DELETE_MODAL_SUBTITLE: "This is permanent. The collection and all of its game/provider memberships will be removed.",
  CASINO_CONFIG_COLLECTIONS_DELETE_MODAL_TITLE: "Delete collection",
  CASINO_CONFIG_COLLECTIONS_DELETE_MODAL_WARNING: "Subcollections and storefront placements must be removed first. If anything still references this collection you'll get a specific reason and nothing will be deleted.",
  CASINO_CONFIG_COLLECTIONS_DELETE_ROW_ARIA: "Delete {name}",
  CASINO_CONFIG_COLLECTIONS_DELETE_SUCCESS: "Collection deleted",
  CASINO_CONFIG_COLLECTIONS_DRILL_BADGE: "drill-down",
  CASINO_CONFIG_COLLECTIONS_DRILL_CLOSE: "Close",
  CASINO_CONFIG_COLLECTIONS_DRILL_DESCRIPTION: "Order and pin individual games of",
  CASINO_CONFIG_COLLECTIONS_DRILL_DESCRIPTION_SUFFIX: "inside this collection.",
  CASINO_CONFIG_COLLECTIONS_DRILL_FAILED_MOVE: "Failed to move item",
  CASINO_CONFIG_COLLECTIONS_DRILL_GAMES: "games",
  CASINO_CONFIG_COLLECTIONS_DRILL_NO_GAMES: "No games found",
  CASINO_CONFIG_COLLECTIONS_DRILL_SEARCH: "Search games...",
  CASINO_CONFIG_COLLECTIONS_DRILL_TRUNCATION: "Showing {shown} of {total} games. Use search to find more.",
  CASINO_CONFIG_COLLECTIONS_EDIT_ROW_ARIA: "Edit {name}",
  CASINO_CONFIG_COLLECTIONS_EDIT_SPECIAL_TOOLTIP: "This is a placement-only collection. Its games are managed on the Features page and can't be edited here.",
  CASINO_CONFIG_COLLECTIONS_EMPTY: "No collections found",
  CASINO_CONFIG_COLLECTIONS_EXPAND_PROVIDER_ARIA: "Expand {name}",
  CASINO_CONFIG_COLLECTIONS_FAILED_LOAD_GAMES: "Failed to load games",
  CASINO_CONFIG_COLLECTIONS_FAILED_LOAD_PROVIDERS: "Failed to load providers",
  CASINO_CONFIG_COLLECTIONS_FAILED_LOAD_PROVIDER_GAMES: "Failed to load provider games",
  CASINO_CONFIG_COLLECTIONS_FAILED_LOAD_PROVIDER_GROUPS: "Failed to load provider groups",
  CASINO_CONFIG_COLLECTIONS_FAILED_MOVE_GAME: "Failed to move game",
  CASINO_CONFIG_COLLECTIONS_FAILED_MOVE_PROVIDER: "Failed to move provider",
  CASINO_CONFIG_COLLECTIONS_FAILED_PIN_GAME: "Failed to pin game",
  CASINO_CONFIG_COLLECTIONS_FAILED_PIN_PROVIDER: "Failed to pin provider",
  CASINO_CONFIG_COLLECTIONS_FAILED_SET_TAG: "Failed to set tag",
  CASINO_CONFIG_COLLECTIONS_FAILED_UPDATE_POPULAR: "Failed to update popular",
  CASINO_CONFIG_COLLECTIONS_FULL_LIST: "Full List",
  CASINO_CONFIG_COLLECTIONS_GAMES_COLLECTION: "Games collection",
  CASINO_CONFIG_COLLECTIONS_GAMES_SUFFIX: "games",
  CASINO_CONFIG_COLLECTIONS_GAMES_TAB: "Games",
  CASINO_CONFIG_COLLECTIONS_GAME_REMOVED: "{name} removed",
  CASINO_CONFIG_COLLECTIONS_GAME_SUFFIX: "game",
  CASINO_CONFIG_COLLECTIONS_GENERAL_TAB: "General",
  CASINO_CONFIG_COLLECTIONS_GROUPED_BY_PROVIDER: "Grouped by provider",
  CASINO_CONFIG_COLLECTIONS_ICON_HINT: "PNG, SVG, or WebP, up to 5 MB. Uploading replaces the live icon.",
  CASINO_CONFIG_COLLECTIONS_ICON_LABEL: "Icon",
  CASINO_CONFIG_COLLECTIONS_ICON_UPLOADED: "Icon uploaded",
  CASINO_CONFIG_COLLECTIONS_IMMUTABLE: "Immutable.",
  CASINO_CONFIG_COLLECTIONS_KIND_LABEL: "Kind",
  CASINO_CONFIG_COLLECTIONS_LOAD_ERROR: "Failed to load collections",
  CASINO_CONFIG_COLLECTIONS_NAME_LABEL: "Name",
  CASINO_CONFIG_COLLECTIONS_NEST_FAILED: "Failed to nest collection: {codes}",
  CASINO_CONFIG_COLLECTIONS_NEST_LINK_BUTTON: "Link ({count})",
  CASINO_CONFIG_COLLECTIONS_NEST_NO_RESULTS: "No collections found",
  CASINO_CONFIG_COLLECTIONS_NEST_SEARCH: "Filter by name or code...",
  CASINO_CONFIG_COLLECTIONS_NEST_SUCCESS_PLURAL: "{count} Sub-Collections Successfully Linked!",
  CASINO_CONFIG_COLLECTIONS_NEST_SUCCESS_SINGULAR: "1 Sub-Collection Successfully Linked!",
  CASINO_CONFIG_COLLECTIONS_NEST_TITLE: "Nest under",
  CASINO_CONFIG_COLLECTIONS_NEW: "New Collection",
  CASINO_CONFIG_COLLECTIONS_NEW_ACTIVE: "Active",
  CASINO_CONFIG_COLLECTIONS_NEW_ANIMATE_ICON_HINT: "Play the icon's built-in animation in the live UI. Off = static.",
  CASINO_CONFIG_COLLECTIONS_NEW_ANIMATE_ICON_TITLE: "Animate Icon",
  CASINO_CONFIG_COLLECTIONS_NEW_CANCEL: "Cancel",
  CASINO_CONFIG_COLLECTIONS_NEW_CODE_PLACEHOLDER: "e.g. slots",
  CASINO_CONFIG_COLLECTIONS_NEW_CODE_REQUIRED: "Code is required",
  CASINO_CONFIG_COLLECTIONS_NEW_CREATE: "Create",
  CASINO_CONFIG_COLLECTIONS_NEW_CREATED: "Collection created",
  CASINO_CONFIG_COLLECTIONS_NEW_CREATE_FAILED: "Failed to create collection",
  CASINO_CONFIG_COLLECTIONS_NEW_CREATING: "Creating...",
  CASINO_CONFIG_COLLECTIONS_NEW_DEFAULT_VIEW_ALL: "All",
  CASINO_CONFIG_COLLECTIONS_NEW_DEFAULT_VIEW_HINT: "Tab the admin lands on when opening this collection.",
  CASINO_CONFIG_COLLECTIONS_NEW_DEFAULT_VIEW_POPULAR: "Popular",
  CASINO_CONFIG_COLLECTIONS_NEW_DEFAULT_VIEW_PROVIDER: "Grouped by provider",
  CASINO_CONFIG_COLLECTIONS_NEW_FILE_TOO_LARGE: "Icon must be 5 MB or less",
  CASINO_CONFIG_COLLECTIONS_NEW_FILE_TYPE_INVALID: "Icon must be a PNG, SVG, or WebP file",
  CASINO_CONFIG_COLLECTIONS_NEW_ICON_HINT_AFTER: "PNG, SVG, or WebP, up to 5 MB.",
  CASINO_CONFIG_COLLECTIONS_NEW_ICON_HINT_BEFORE: "Enter a code first, then upload · PNG, SVG, or WebP, up to 5 MB.",
  CASINO_CONFIG_COLLECTIONS_NEW_ICON_UPLOAD: "Upload",
  CASINO_CONFIG_COLLECTIONS_NEW_KIND_GAMES: "games",
  CASINO_CONFIG_COLLECTIONS_NEW_KIND_PROVIDERS: "providers",
  CASINO_CONFIG_COLLECTIONS_NEW_NAME_PLACEHOLDER: "e.g. Slots",
  CASINO_CONFIG_COLLECTIONS_NEW_PARENT_CLOSE: "Close",
  CASINO_CONFIG_COLLECTIONS_NEW_PARENT_NO_RESULTS: "No collections found",
  CASINO_CONFIG_COLLECTIONS_NEW_PARENT_REQUIRED: "Pick a parent collection or turn the toggle off",
  CASINO_CONFIG_COLLECTIONS_NEW_PARENT_SEARCH: "Search by name or code...",
  CASINO_CONFIG_COLLECTIONS_NEW_PARENT_SELECTED: "selected",
  CASINO_CONFIG_COLLECTIONS_NEW_PARENT_SUBTITLE: "Same-kind only — only {kind} collections are listed.",
  CASINO_CONFIG_COLLECTIONS_NEW_PARENT_TITLE: "Pick a parent collection",
  CASINO_CONFIG_COLLECTIONS_NEW_PARENT_TOP_LEVEL: "Top-level",
  CASINO_CONFIG_COLLECTIONS_NEW_PARENT_TOP_LEVEL_HINT: "No parent — sits at the root of the tree.",
  CASINO_CONFIG_COLLECTIONS_NEW_SUBTITLE_NESTED: "Nested under {parent}",
  CASINO_CONFIG_COLLECTIONS_NEW_SUBTITLE_TOP_LEVEL: "Top-level",
  CASINO_CONFIG_COLLECTIONS_NEW_SUB_CHANGE: "Change",
  CASINO_CONFIG_COLLECTIONS_NEW_SUB_PARENT_LABEL: "Parent:",
  CASINO_CONFIG_COLLECTIONS_NEW_SUB_TOGGLE_HINT: "Nest this under another games collection. Off = top-level.",
  CASINO_CONFIG_COLLECTIONS_NEW_SUB_TOGGLE_TITLE: "Sub-collection",
  CASINO_CONFIG_COLLECTIONS_NEW_TITLE: "New collection",
  CASINO_CONFIG_COLLECTIONS_NOT_FOUND: "Collection not found",
  CASINO_CONFIG_COLLECTIONS_NO_GAMES: "No games in this collection",
  CASINO_CONFIG_COLLECTIONS_NO_PROVIDERS: "No providers in this collection",
  CASINO_CONFIG_COLLECTIONS_PIN_ARIA: "Pin {name}",
  CASINO_CONFIG_COLLECTIONS_POPULAR: "Popular",
  CASINO_CONFIG_COLLECTIONS_PRESIGNED_URL_FAILED: "Failed to get presigned URL",
  CASINO_CONFIG_COLLECTIONS_PROVIDERS_COLLECTION: "Providers collection",
  CASINO_CONFIG_COLLECTIONS_PROVIDERS_SUFFIX: "providers",
  CASINO_CONFIG_COLLECTIONS_PROVIDERS_TAB: "Providers",
  CASINO_CONFIG_COLLECTIONS_PROVIDER_GAMES_ARIA: "Games {name}",
  CASINO_CONFIG_COLLECTIONS_PROVIDER_REMOVED: "Removed {name}",
  CASINO_CONFIG_COLLECTIONS_REMOVE_GAME_CONTENT: "This game will be removed from the collection.",
  CASINO_CONFIG_COLLECTIONS_REMOVE_GAME_TITLE: 'Remove "{name}"?',
  CASINO_CONFIG_COLLECTIONS_REMOVE_OK: "Remove",
  CASINO_CONFIG_COLLECTIONS_REMOVE_PROVIDER_CONTENT: "This provider will be removed from the collection.",
  CASINO_CONFIG_COLLECTIONS_REMOVE_PROVIDER_TITLE: "Remove {name}?",
  CASINO_CONFIG_COLLECTIONS_REMOVE_ROW_ARIA: "Remove {name}",
  CASINO_CONFIG_COLLECTIONS_SAVE: "Save changes",
  CASINO_CONFIG_COLLECTIONS_SAVED: "Saved",
  CASINO_CONFIG_COLLECTIONS_SAVE_FAILED: "Save failed",
  CASINO_CONFIG_COLLECTIONS_SEARCH_GAMES: "Search games...",
  CASINO_CONFIG_COLLECTIONS_SEARCH_PLACEHOLDER: "Search",
  CASINO_CONFIG_COLLECTIONS_SEARCH_PROVIDERS: "Search providers...",
  CASINO_CONFIG_COLLECTIONS_STATUS_ACTIVE: "active",
  CASINO_CONFIG_COLLECTIONS_STATUS_INACTIVE: "inactive",
  CASINO_CONFIG_COLLECTIONS_STAT_ACTIVE: "Active",
  CASINO_CONFIG_COLLECTIONS_STAT_COLLECTIONS: "Collections",
  CASINO_CONFIG_COLLECTIONS_SUBCOLLECTIONS_TAB: "Subcollections",
  CASINO_CONFIG_COLLECTIONS_SUBTITLE: "Top level catalogs. Each one can hold child catalogs as well.",
  CASINO_CONFIG_COLLECTIONS_SUB_CHILDREN: "children",
  CASINO_CONFIG_COLLECTIONS_SUB_COLLECTION_HINT: "Nest under another games collection. Off = top-level.",
  CASINO_CONFIG_COLLECTIONS_SUB_COLLECTION_TITLE: "Sub-collection",
  CASINO_CONFIG_COLLECTIONS_SUB_FAILED_UNNEST: "Failed to unnest",
  CASINO_CONFIG_COLLECTIONS_SUB_NEST_DESCRIPTION: "Nest an existing",
  CASINO_CONFIG_COLLECTIONS_SUB_NEST_DESCRIPTION_SUFFIX: "collection here, or create a new one from the Collections page.",
  CASINO_CONFIG_COLLECTIONS_SUB_NEST_EXISTING: "Nest existing",
  CASINO_CONFIG_COLLECTIONS_SUB_NO_SUBCOLLECTIONS: "No subcollections",
  CASINO_CONFIG_COLLECTIONS_SUB_OPEN: "Open",
  CASINO_CONFIG_COLLECTIONS_SUB_SUFFIX: "sub-collections",
  CASINO_CONFIG_COLLECTIONS_SUB_UNNEST: "Unnest",
  CASINO_CONFIG_COLLECTIONS_SUB_UNNESTED: "{name} unnested",
  CASINO_CONFIG_COLLECTIONS_SUB_UNNEST_CANCEL: "Cancel",
  CASINO_CONFIG_COLLECTIONS_SUB_UNNEST_CONFIRM: "Confirm unnest",
  CASINO_CONFIG_COLLECTIONS_SUB_UNNEST_CONFIRM_PREFIX: "Unnest",
  CASINO_CONFIG_COLLECTIONS_SUB_UNNEST_CONFIRM_SUFFIX: "? It will become a top-level collection — items and storefront placements stay intact.",
  CASINO_CONFIG_COLLECTIONS_TAG_REMOVED: "Tag removed",
  CASINO_CONFIG_COLLECTIONS_TAG_SET: "Tag set",
  CASINO_CONFIG_COLLECTIONS_TITLE: "Casino Collections",
  CASINO_CONFIG_COLLECTIONS_TOGGLE_FAILED: "Failed to toggle {name}",
  CASINO_CONFIG_COLLECTIONS_TOGGLE_OFF: "Off",
  CASINO_CONFIG_COLLECTIONS_TOGGLE_ON: "On",
  CASINO_CONFIG_COLLECTIONS_TOGGLE_POPULAR_ARIA: "Toggle popular {name}",
  CASINO_CONFIG_COLLECTIONS_TOTAL_SUFFIX: "total",
  CASINO_CONFIG_COLLECTIONS_UNPIN_ARIA: "Unpin {name}",
  CASINO_CONFIG_COLLECTIONS_UNPIN_ICON_ALT: "Unpin",
  CASINO_CONFIG_COLLECTIONS_UNSAVED: "Unsaved changes",
  CASINO_CONFIG_COLLECTIONS_UPLOAD_FAILED: "Upload failed",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_DESCRIPTION: "Surface recent high value wins to players on the casino home.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_DISABLE_CONFIRM_BTN: "Yes, Disable",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_DISABLE_CONFIRM_DESC: "Disabling this feature will hide 'Big Winners' from players' view.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_DISABLE_CONFIRM_TITLE: "Are You Sure You Want To Disable Big Winners?",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_DISABLE_ERROR: "Failed to disable Big Winners.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_DISABLE_SUCCESS: "Big Winners is now disabled.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_ENABLE_CONFIRM_BTN: "Yes, Enable",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_ENABLE_CONFIRM_DESC: "Enabling this feature will show 'Big Winners' in players' view.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_ENABLE_CONFIRM_TITLE: "Are You Sure You Want To Enable Big Winners?",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_ENABLE_ERROR: "Failed to enable Big Winners.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_ENABLE_SUCCESS: "Big Winners is now enabled.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_FETCH_ERROR: "Failed to load Big Winners settings.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_MAX_ITEMS_HINT: "Maximum number of wins shown in the carousel.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_MAX_ITEMS_LABEL: "Max # of user card items",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_MAX_ITEMS_PLACEHOLDER: "#",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_NAME: "Big Winners",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_REFRESH_BTN: "Refresh now",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_REFRESH_CARDS: "cards generated",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_REFRESH_ERROR: "Failed to refresh Big Winners.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_REFRESH_HINT: "How often the list refreshes.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_REFRESH_LABEL: "Refresh interval",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_REFRESH_PLACEHOLDER: "How often the list refreshes",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_REFRESH_SKIPPED: "Refresh skipped — the Big Winners showcase was not updated.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_REFRESH_SUCCESS: "Big Winners refreshed",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_SAVE_ERROR: "Failed to save Big Winners settings.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_THRESHOLD_HINT: "Win amount which counts as a big win.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_THRESHOLD_LABEL: "Big Winners money threshold",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_THRESHOLD_PLACEHOLDER: "Win amount which counts as a big win",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_TIME_WINDOW_HINT: "How far in the past we pull big wins from.",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_TIME_WINDOW_LABEL: "Time window",
  CASINO_CONFIG_FEATURES_BIG_WINNERS_TIME_WINDOW_PLACEHOLDER: "How far in the past we pull big wins from",
  CASINO_CONFIG_FEATURES_COLLAPSE: "Collapse",
  CASINO_CONFIG_FEATURES_CONFIRM_CANCEL: "Cancel",
  CASINO_CONFIG_FEATURES_EXPAND: "Expand",
  CASINO_CONFIG_FEATURES_JACKPOT_ACTIVE: "Active",
  CASINO_CONFIG_FEATURES_JACKPOT_ADD_GAME: "+ Add game",
  CASINO_CONFIG_FEATURES_JACKPOT_ADDED: "Added",
  CASINO_CONFIG_FEATURES_JACKPOT_ADD_MODAL_TITLE: "Add game to jackpot",
  CASINO_CONFIG_FEATURES_JACKPOT_ADD_STEP1_SUBTITLE:
    "Pick a game, then set its jackpot amount.",
  CASINO_CONFIG_FEATURES_JACKPOT_ADD_STEP2_SUBTITLE:
    "Set the cash amount for {name}.",
  CASINO_CONFIG_FEATURES_JACKPOT_ADD_TO_JACKPOT: "Add to jackpot",
  CASINO_CONFIG_FEATURES_JACKPOT_ADD_SUCCESS: "Game added to Jackpot.",
  CASINO_CONFIG_FEATURES_JACKPOT_ALEA_HELPER:
    "Only Alea games are eligible for the jackpot rail.",
  CASINO_CONFIG_FEATURES_JACKPOT_AMOUNT_ERROR:
    "Amount must be a number greater than 0.",
  CASINO_CONFIG_FEATURES_JACKPOT_AMOUNT_HELPER:
    "Baseline cash amount shown on the storefront card. Must be greater than 0.",
  CASINO_CONFIG_FEATURES_JACKPOT_AMOUNT_LABEL: "Amount *",
  CASINO_CONFIG_FEATURES_JACKPOT_BACK: "Back",
  CASINO_CONFIG_FEATURES_JACKPOT_CATALOG_ERROR: "Failed to load Alea games.",
  CASINO_CONFIG_FEATURES_JACKPOT_DESCRIPTION:
    "Curated cash-jackpot showcase on the storefront's social carousels.",
  CASINO_CONFIG_FEATURES_JACKPOT_DISABLE_CONFIRM_BTN: "Yes, Disable",
  CASINO_CONFIG_FEATURES_JACKPOT_DISABLE_CONFIRM_DESC:
    "Turning Jackpot off removes the Jackpots collection placement and all player-facing tile markings. Configured games and amounts are kept and restored if you re-enable later.",
  CASINO_CONFIG_FEATURES_JACKPOT_DISABLE_CONFIRM_TITLE:
    "Disable Jackpot and remove player-facing markings?",
  CASINO_CONFIG_FEATURES_JACKPOT_EDIT_AMOUNT: "Edit amount",
  CASINO_CONFIG_FEATURES_JACKPOT_EDIT_SAVE: "Save",
  CASINO_CONFIG_FEATURES_JACKPOT_EMPTY:
    "No games yet. Click \"Add game\" to start the rail.",
  CASINO_CONFIG_FEATURES_JACKPOT_EXPLAINER:
    "Games featured with the Jackpot design configuration in the app. The baseline value is configured by the operator, and the increases are read directly from the current jackpot status.",
  CASINO_CONFIG_FEATURES_JACKPOT_FETCH_ERROR:
    "Failed to load Jackpot settings.",
  CASINO_CONFIG_FEATURES_JACKPOT_GAMES_HEADING: "Jackpot games",
  CASINO_CONFIG_FEATURES_JACKPOT_INACTIVE: "Inactive",
  CASINO_CONFIG_FEATURES_JACKPOT_NAME: "Jackpot",
  CASINO_CONFIG_FEATURES_JACKPOT_NO_MATCH: "No games match",
  CASINO_CONFIG_FEATURES_JACKPOT_SEARCHING: "Searching…",
  CASINO_CONFIG_FEATURES_JACKPOT_PARTIAL_SAVE_ERROR:
    "Jackpot settings partially saved: {succeeded} of {total} game updates succeeded; {failed} failed. Refresh and retry the remaining changes.",
  CASINO_CONFIG_FEATURES_JACKPOT_REMOVE: "Remove?",
  CASINO_CONFIG_FEATURES_JACKPOT_REMOVE_CONFIRM: "Confirm",
  CASINO_CONFIG_FEATURES_JACKPOT_RESET: "Reset",
  CASINO_CONFIG_FEATURES_JACKPOT_RESET_CONFIRM_DESC:
    "Discard all unsaved Jackpot changes and restore the last saved configuration?",
  CASINO_CONFIG_FEATURES_JACKPOT_RESET_CONFIRM_TITLE: "Discard unsaved changes?",
  CASINO_CONFIG_FEATURES_JACKPOT_SAVE: "Save Changes",
  CASINO_CONFIG_FEATURES_JACKPOT_SAVE_ERROR: "Failed to save Jackpot settings.",
  CASINO_CONFIG_FEATURES_JACKPOT_SEARCH_CATALOG: "Search by name…",
  CASINO_CONFIG_FEATURES_JACKPOT_SEARCH_RAIL: "Search games…",
  CASINO_CONFIG_FEATURES_JACKPOT_UNSAVED_EDIT:
    "You have unsaved amount edits on another row. Discard them?",
  CASINO_CONFIG_FEATURES_JACKPOT_UNSAVED_EDIT_CONFIRM: "Discard",
  CASINO_CONFIG_FEATURES_JACKPOT_UNSAVED_EDIT_TITLE:
    "Discard unsaved amount edit?",
  CASINO_CONFIG_FEATURES_RESET: "Reset",
  CASINO_CONFIG_FEATURES_SAVE: "Save Changes",
  CASINO_CONFIG_FEATURES_SAVE_ERROR: "Failed to save changes.",
  CASINO_CONFIG_FEATURES_SAVE_SUCCESS: "Changes saved.",
  CASINO_CONFIG_FEATURES_SAVING: "Saving…",
  CASINO_CONFIG_FEATURES_SUBTITLE: "Enable and tune optional casino home features for your platform.",
  CASINO_CONFIG_FEATURES_TITLE: "Features",
  CASINO_CONFIG_FEATURES_UNIT_DAYS: "Days",
  CASINO_CONFIG_FEATURES_UNIT_HOURS: "Hours",
  CASINO_CONFIG_GAMES_ACTION_CANCEL: "Cancel",
  CASINO_CONFIG_GAMES_ACTION_SAVE: "Save",
  CASINO_CONFIG_GAMES_BULK_BAR_ARIA: "Bulk game actions",
  CASINO_CONFIG_GAMES_BULK_CLEAR: "Clear",
  CASINO_CONFIG_GAMES_BULK_DISABLE: "Disable Selected Games",
  CASINO_CONFIG_GAMES_BULK_DISABLE_SUCCESS: "Disabled {affected} of {requested} game(s)",
  CASINO_CONFIG_GAMES_BULK_ENABLE: "Enable Selected Games",
  CASINO_CONFIG_GAMES_BULK_ENABLE_SUCCESS: "Enabled {affected} of {requested} game(s)",
  CASINO_CONFIG_GAMES_BULK_ERROR: "Failed to update the selected games",
  CASINO_CONFIG_GAMES_BULK_LIMIT: "You can select up to {max} games at once.",
  CASINO_CONFIG_GAMES_BULK_NO_CHANGE: "No games changed state",
  CASINO_CONFIG_GAMES_BULK_SELECTED: "{count} selected",
  CASINO_CONFIG_GAMES_COL_ACTIVE: "ACTIVE",
  CASINO_CONFIG_GAMES_COL_FLAGS: "FLAGS",
  CASINO_CONFIG_GAMES_COL_GAME_ID: "GAME ID",
  CASINO_CONFIG_GAMES_COL_NAME: "NAME",
  CASINO_CONFIG_GAMES_COL_TAGS: "TAGS",
  CASINO_CONFIG_GAMES_COL_THUMB: "THUMB",
  CASINO_CONFIG_GAMES_DOWNLOAD_CSV: "Download CSV",
  CASINO_CONFIG_GAMES_EDIT_ARIA: "Edit {name}",
  CASINO_CONFIG_GAMES_EDIT_GAME_ID: "Game ID: {id}",
  CASINO_CONFIG_GAMES_EDIT_MODAL_TITLE: "Edit Game",
  CASINO_CONFIG_GAMES_EMPTY: "No games found",
  CASINO_CONFIG_GAMES_EXPORT_EMPTY:
    "No games to export — clear the search and try again.",
  CASINO_CONFIG_GAMES_EXPORT_EXPAND:
    "Expand a provider group to export its games.",
  CASINO_CONFIG_GAMES_EXPORT_FAILED: "Export failed. Please try again.",
  CASINO_CONFIG_GAMES_EXPORT_PREPARING: "Preparing…",
  CASINO_CONFIG_GAMES_FLAG_AGG: "agg",
  CASINO_CONFIG_GAMES_FORM_ACTIVE_LABEL: "Active",
  CASINO_CONFIG_GAMES_FORM_DELETE: "Delete",
  CASINO_CONFIG_GAMES_FORM_ICON_HINT: "PNG or WebP, up to 5MB",
  CASINO_CONFIG_GAMES_FORM_ICON_LABEL: "Icon",
  CASINO_CONFIG_GAMES_FORM_NAME_LABEL: "Name*",
  CASINO_CONFIG_GAMES_FORM_NAME_PLACEHOLDER: "Game name",
  CASINO_CONFIG_GAMES_FORM_NAME_REQUIRED: "Name is required",
  CASINO_CONFIG_GAMES_FORM_REPLACE: "Replace",
  CASINO_CONFIG_GAMES_GROUP_STATUS_ALL_ON: "All on",
  CASINO_CONFIG_GAMES_GROUP_STATUS_MIXED: "Mixed",
  CASINO_CONFIG_GAMES_GROUP_STATUS_OFF: "Off",
  CASINO_CONFIG_GAMES_IMAGE_UPLOAD_FAILED: "Image upload failed",
  CASINO_CONFIG_GAMES_IMAGE_UPLOAD_INCOMPLETE:
    "Image upload did not complete, so the game was not saved. Replace the image and try again.",
  CASINO_CONFIG_GAMES_LOADING: "Loading...",
  CASINO_CONFIG_GAMES_LOAD_MORE: "Load More",
  CASINO_CONFIG_GAMES_PAGE_TITLE: "Casino Games",
  CASINO_CONFIG_GAMES_SAVE_ERROR: "Failed to save game",
  CASINO_CONFIG_GAMES_SAVE_SUCCESS: "Game updated",
  CASINO_CONFIG_GAMES_SEARCH_PLACEHOLDER: "Search",
  CASINO_CONFIG_GAMES_SELECT_ALL_ARIA: "Select all games in this group",
  CASINO_CONFIG_GAMES_SELECT_ROW_ARIA: "Select {name}",
  CASINO_CONFIG_GAMES_SORT_BY_LABEL: "Sort By",
  CASINO_CONFIG_GAMES_SORT_PROVIDER: "Provider",
  CASINO_CONFIG_GAMES_SORT_SUBPROVIDER: "Subprovider",
  CASINO_CONFIG_GAMES_STATUS_OFF: "Off",
  CASINO_CONFIG_GAMES_STATUS_ON: "On",
  CASINO_CONFIG_GAMES_TAG_ADD: "+ Tag",
  CASINO_CONFIG_GAMES_TAG_ATTACHED: "ATTACHED",
  CASINO_CONFIG_GAMES_TAG_CLOSE: "Close",
  CASINO_CONFIG_GAMES_TAG_CURRENT: "current tag",
  CASINO_CONFIG_GAMES_TAG_LEGACY_WARNING: "Legacy state: this game has multiple tags. Detach extras until one remains.",
  CASINO_CONFIG_GAMES_TAG_MANAGE: "Manage",
  CASINO_CONFIG_GAMES_TAG_MODAL_DESC: "Each game can carry one tag. Picking a different tag replaces the current one.",
  CASINO_CONFIG_GAMES_TAG_MODAL_TITLE: "Tag for {id}",
  CASINO_CONFIG_GAMES_TAG_MULTIPLE_LABEL: "(MULTIPLE — PICK ONE TO KEEP)",
  CASINO_CONFIG_GAMES_TAG_NONE: "No tag attached.",
  CASINO_CONFIG_GAMES_TAG_NO_TAGS: "No tags attached.",
  CASINO_CONFIG_GAMES_TAG_REPLACE: "Replace tag",
  CASINO_CONFIG_GAMES_TAG_REPLACES: "Replaces {name}",
  CASINO_CONFIG_GAMES_TAG_SEARCH: "Search tags...",
  CASINO_CONFIG_GAMES_TAG_SEEDED: "SEEDED",
  CASINO_CONFIG_GAMES_TAG_SET: "Set tag",
  CASINO_CONFIG_GAMES_TAG_SET_ERROR: "Failed to update tag",
  CASINO_CONFIG_GAMES_TAG_SET_SUCCESS: "Tag updated",
  CASINO_CONFIG_GAMES_UPLOAD_SIZE_ERROR: "Icon size must be 5MB or less",
  CASINO_CONFIG_GAMES_UPLOAD_TYPE_ERROR: "Only PNG or WebP files are allowed",
  CASINO_CONFIG_PAGES_ADD: "Add page",
  CASINO_CONFIG_PAGES_CANCEL: "Cancel",
  CASINO_CONFIG_PAGES_CODE_LABEL: "Code (slug)",
  CASINO_CONFIG_PAGES_CODE_PLACEHOLDER: "live",
  CASINO_CONFIG_PAGES_CREATE_FALLBACK: "Failed to create page",
  CASINO_CONFIG_PAGES_CREATE_SUCCESS: "Page created.",
  CASINO_CONFIG_PAGES_DEFAULT_BADGE: "default",
  CASINO_CONFIG_PAGES_DELETE_ARIA: "Delete page",
  CASINO_CONFIG_PAGES_DELETE_CONFIRM: "Delete",
  CASINO_CONFIG_PAGES_DELETE_FALLBACK: "Failed to delete page",
  CASINO_CONFIG_PAGES_DELETE_SUCCESS: "Page deleted.",
  CASINO_CONFIG_PAGES_DELETE_TITLE: "Delete this page?",
  CASINO_CONFIG_PAGES_DESCRIPTION_LABEL: "Description",
  CASINO_CONFIG_PAGES_DESCRIPTION_PLACEHOLDER: "Live dealer tables and game shows.",
  CASINO_CONFIG_PAGES_EDIT_ARIA: "Edit page",
  CASINO_CONFIG_PAGES_EMPTY: "No pages yet",
  CASINO_CONFIG_PAGES_INFO: "Each page is a storefront tab players can switch between. The default page is served when no page is selected.",
  CASINO_CONFIG_PAGES_INFO_ARIA: "About casino pages",
  CASINO_CONFIG_PAGES_LOAD_ERROR: "Failed to load pages",
  CASINO_CONFIG_PAGES_NAME_LABEL: "Name",
  CASINO_CONFIG_PAGES_NAME_PLACEHOLDER: "Live Casino",
  CASINO_CONFIG_PAGES_SAVE: "Save",
  CASINO_CONFIG_PAGES_STATUS_ACTIVE: "Active",
  CASINO_CONFIG_PAGES_STATUS_INACTIVE: "Inactive",
  CASINO_CONFIG_PAGES_SUBTITLE: "Additional pages are extra tabs shown to players. Hidden pages stay curatable but aren't shown.",
  CASINO_CONFIG_PAGES_TITLE: "Pages",
  CASINO_CONFIG_PAGES_UPDATE_FALLBACK: "Failed to update page",
  CASINO_CONFIG_PAGES_UPDATE_SUCCESS: "Page updated.",
  CASINO_CONFIG_PAGES_VALIDATION_REQUIRED: "Code and name are required.",
  CASINO_CONFIG_PROVIDERS_ACTION_CANCEL: "Cancel",
  CASINO_CONFIG_PROVIDERS_ACTION_REGISTER: "Register",
  CASINO_CONFIG_PROVIDERS_ACTION_UPDATE: "Update",
  CASINO_CONFIG_PROVIDERS_ACTIVE: "Active",
  CASINO_CONFIG_PROVIDERS_DISCOVER_ACTIVE_SUFFIX: "active",
  CASINO_CONFIG_PROVIDERS_DISCOVER_COUNT: "{total} providers",
  CASINO_CONFIG_PROVIDERS_DISCOVER_COUNT_FILTERED: "Showing {shown} of {total}",
  CASINO_CONFIG_PROVIDERS_DISCOVER_EMPTY: "No discoverable providers",
  CASINO_CONFIG_PROVIDERS_DISCOVER_ERROR: "Failed to load providers",
  CASINO_CONFIG_PROVIDERS_DISCOVER_HIDE_REGISTERED: "Hide pairs whose subprovider is already registered",
  CASINO_CONFIG_PROVIDERS_DISCOVER_SEARCH_PLACEHOLDER: "Search by provider or subprovider",
  CASINO_CONFIG_PROVIDERS_DISCOVER_SUBTITLE: "Providers referenced by games that aren't registered",
  CASINO_CONFIG_PROVIDERS_DISCOVER_TITLE: "Discover Providers",
  CASINO_CONFIG_PROVIDERS_DISCOVER_VIA_PREFIX: "via",
  CASINO_CONFIG_PROVIDERS_EMPTY: "No providers found",
  CASINO_CONFIG_PROVIDERS_FORM_ACTIVE_HINT: "Inactive games stay in the catalog but are hidden from the storefront.",
  CASINO_CONFIG_PROVIDERS_FORM_ACTIVE_LABEL: "Active",
  CASINO_CONFIG_PROVIDERS_FORM_DELETE: "Delete",
  CASINO_CONFIG_PROVIDERS_FORM_ICON_HINT: "PNG, SVG, or WebP, up to 5MB",
  CASINO_CONFIG_PROVIDERS_FORM_ICON_LABEL: "Icon",
  CASINO_CONFIG_PROVIDERS_FORM_NAME_LABEL: "Name*",
  CASINO_CONFIG_PROVIDERS_FORM_NAME_PLACEHOLDER: "Text",
  CASINO_CONFIG_PROVIDERS_FORM_NAME_REQUIRED: "Name is required",
  CASINO_CONFIG_PROVIDERS_FORM_REPLACE: "Replace",
  CASINO_CONFIG_PROVIDERS_GAMES_SUFFIX: "games",
  CASINO_CONFIG_PROVIDERS_ICON_PREVIEW_ALT: "Provider icon preview",
  CASINO_CONFIG_PROVIDERS_ICON_UPLOAD_FAILED: "Icon upload failed",
  CASINO_CONFIG_PROVIDERS_INACTIVE: "Inactive",
  CASINO_CONFIG_PROVIDERS_MODAL_EDIT_TITLE: "Edit Provider",
  CASINO_CONFIG_PROVIDERS_MODAL_REGISTER_TITLE: "Register Provider",
  CASINO_CONFIG_PROVIDERS_NEW_PROVIDER: "New Provider",
  CASINO_CONFIG_PROVIDERS_REGISTERED: "Registered",
  CASINO_CONFIG_PROVIDERS_REGISTERED_BUTTON: "Registered",
  CASINO_CONFIG_PROVIDERS_REGISTER_BUTTON: "+ Register",
  CASINO_CONFIG_PROVIDERS_SAVE_CREATE_SUCCESS: "Provider registered",
  CASINO_CONFIG_PROVIDERS_SAVE_ERROR: "Failed to save provider",
  CASINO_CONFIG_PROVIDERS_SAVE_UPDATE_SUCCESS: "Provider updated",
  CASINO_CONFIG_PROVIDERS_SEARCH_PLACEHOLDER: "Search",
  CASINO_CONFIG_PROVIDERS_TITLE: "Casino Providers",
  CASINO_CONFIG_PROVIDERS_TOGGLE_ROW_ARIA: "Toggle {name}",
  CASINO_CONFIG_PROVIDERS_UPLOAD_SIZE_ERROR: "Icon size must be 5MB or less",
  CASINO_CONFIG_PROVIDERS_UPLOAD_TYPE_ERROR: "Only PNG, SVG, or WebP files are allowed",
  CASINO_CONFIG_TAGS_COUNT_SUFFIX: "total",
  CASINO_CONFIG_TAGS_CREATE_ERROR: "Failed to create tag",
  CASINO_CONFIG_TAGS_CREATE_SUCCESS: "Tag created",
  CASINO_CONFIG_TAGS_EDIT_SUBTITLE: "Adjust display fields for this tag. Seed tag — recolour cascades to all attached games & providers.",
  CASINO_CONFIG_TAGS_EDIT_TITLE_PREFIX: "Edit",
  CASINO_CONFIG_TAGS_EMPTY: "No tags found",
  CASINO_CONFIG_TAGS_FORM_CANCEL: "Cancel",
  CASINO_CONFIG_TAGS_FORM_COLOR_HINT: "6-digit hex. Drives the storefront halo + label.",
  CASINO_CONFIG_TAGS_FORM_COLOR_LABEL: "Color",
  CASINO_CONFIG_TAGS_FORM_CREATE: "Create",
  CASINO_CONFIG_TAGS_FORM_ID_HINT_CREATE: "Stable URL-safe slug. Letters, digits, and underscores only.",
  CASINO_CONFIG_TAGS_FORM_ID_HINT_EDIT: "Immutable — used by every attached game and provider.",
  CASINO_CONFIG_TAGS_FORM_ID_LABEL: "Tag ID",
  CASINO_CONFIG_TAGS_FORM_INVALID_COLOR: "Color must be a 6-digit hex starting with #.",
  CASINO_CONFIG_TAGS_FORM_INVALID_SLUG: "Tag ID must be a URL-safe slug (letters, digits, underscores).",
  CASINO_CONFIG_TAGS_FORM_NAME_LABEL: "Name",
  CASINO_CONFIG_TAGS_FORM_NAME_REQUIRED: "Name is required",
  CASINO_CONFIG_TAGS_FORM_PREVIEW_BODY: "Storefront draws this color as a halo around tagged games and providers, plus an uppercase label in the top-left of the artwork.",
  CASINO_CONFIG_TAGS_FORM_PREVIEW_LABEL: "Preview",
  CASINO_CONFIG_TAGS_FORM_PREVIEW_SAMPLE_GAME: "Sample game",
  CASINO_CONFIG_TAGS_FORM_SAVE: "Save",
  CASINO_CONFIG_TAGS_FORM_SAVING: "Saving…",
  CASINO_CONFIG_TAGS_LOAD_ERROR: "Failed to load tags",
  CASINO_CONFIG_TAGS_NEW_BUTTON: "New tag",
  CASINO_CONFIG_TAGS_NEW_SUBTITLE: "Tag definitions are admin-created and shared across all games and providers.",
  CASINO_CONFIG_TAGS_NEW_TITLE: "New tag",
  CASINO_CONFIG_TAGS_PREVIEW_FALLBACK: "preview",
  CASINO_CONFIG_TAGS_SEARCH_PLACEHOLDER: "Search tags...",
  CASINO_CONFIG_TAGS_SEEDED_BADGE: "seeded",
  CASINO_CONFIG_TAGS_SEEDED_SUFFIX: "seeded",
  CASINO_CONFIG_TAGS_SUBTITLE: "Tag definitions are shared across all games and providers. Seeded tags ship with the platform — they can be recoloured or renamed but not deleted.",
  CASINO_CONFIG_TAGS_TITLE: "Tags",
  CASINO_CONFIG_TAGS_UPDATE_ERROR: "Failed to update tag",
  CASINO_CONFIG_TAGS_UPDATE_SUCCESS: "Tag updated",
  CASINO_CONFIG_PREVIEW_TITLE: "Casino Preview",
  CASINO_CONFIG_PREVIEW_SUBTITLE: "Preview and validate the end-user storefront experience across devices.",
  CASINO_CONFIG_PREVIEW_DESKTOP: "Desktop",
  CASINO_CONFIG_PREVIEW_MOBILE: "Mobile",
  CASINO_CONFIG_PREVIEW_SYNC_NOW: "Sync now",
  CASINO_CONFIG_PREVIEW_LAST_SYNCED: "Last synced: {timestamp}",
  CASINO_CONFIG_PREVIEW_LAST_SYNCED_NEVER: "Last synced: Never",
  CASINO_CONFIG_PREVIEW_FOOTER_ENV: "Previewing: Public Storefront (Production)",
  CASINO_CONFIG_PREVIEW_FOOTER_ENV_MOBILE: "Previewing: Mobile Storefront (Production)",
  CASINO_CONFIG_PREVIEW_FOOTER_READONLY: "This is a read-only preview of the end-user experience.",
  CASINO_CONFIG_PREVIEW_FOOTER_VARIANCE: "Some content may vary by country or configuration.",
  CASINO_CONFIG_PREVIEW_DEVICE_TOGGLE_ARIA: "Preview device",
  CASINO_CONFIG_PREVIEW_IFRAME_TITLE_DESKTOP: "Casino Preview Desktop",
  CASINO_CONFIG_PREVIEW_IFRAME_TITLE_MOBILE: "Casino Preview Mobile",
  CASINO_CONFIG_PREVIEW_URL_MISSING:
    "Casino preview is not configured for this environment.",
  CASINO_CONFIG_VIEWS_ADD_CANCEL: "Cancel",
  CASINO_CONFIG_VIEWS_ADD_COLLECTION: "Add collection",
  CASINO_CONFIG_VIEWS_ADD_FAILED: "Failed to add collections",
  CASINO_CONFIG_VIEWS_ADD_NO_RESULTS: "No collections found",
  CASINO_CONFIG_VIEWS_ADD_PLACEMENTS_FALLBACK: "Failed to add placements",
  CASINO_CONFIG_VIEWS_ADD_SEARCH: "Search catalog by name or code...",
  CASINO_CONFIG_VIEWS_ADD_SELECTED: "{count} selected",
  CASINO_CONFIG_VIEWS_ADD_SUBMIT: "+ Add",
  CASINO_CONFIG_VIEWS_ADD_SUBMIT_WITH_COUNT: "+ Add ({count})",
  CASINO_CONFIG_VIEWS_ADD_SUCCESS_PLURAL: "{count} collections added",
  CASINO_CONFIG_VIEWS_ADD_SUCCESS_SINGULAR: "Collection added",
  CASINO_CONFIG_VIEWS_ADD_TITLE_PREFIX: "Add to",
  CASINO_CONFIG_VIEWS_DELETE_PLACEMENT_FALLBACK: "Failed to remove placement",
  CASINO_CONFIG_VIEWS_EMPTY: "No placements yet",
  CASINO_CONFIG_VIEWS_EMPTY_FILTERED: "No placements match this filter",
  CASINO_CONFIG_VIEWS_FETCH_PAGES_FALLBACK: "Failed to fetch casino pages",
  CASINO_CONFIG_VIEWS_FETCH_PLACEMENTS_FALLBACK: "Failed to fetch view placements",
  CASINO_CONFIG_VIEWS_FETCH_VIEWS_FALLBACK: "Failed to fetch views",
  CASINO_CONFIG_VIEWS_GAMES_COLLECTION: "Games collection",
  CASINO_CONFIG_VIEWS_GAMES_SUFFIX: "games",
  CASINO_CONFIG_VIEWS_INFO_AFTER_CAROUSELS: " are horizontal strips on the home page (e.g. Top Picks). Each slot points at one collection and inherits its items.",
  CASINO_CONFIG_VIEWS_INFO_AFTER_SHORTCUTS: " are top-level tabs (e.g. Slots, Live). ",
  CASINO_CONFIG_VIEWS_INFO_AFTER_SLOT: " is a place the player-facing site renders. ",
  CASINO_CONFIG_VIEWS_INFO_ARIA: "About the Storefront page",
  CASINO_CONFIG_VIEWS_INFO_LEAD: "Each ",
  CASINO_CONFIG_VIEWS_INFO_TERM_CAROUSELS: "Carousels",
  CASINO_CONFIG_VIEWS_INFO_TERM_SHORTCUTS: "Shortcuts",
  CASINO_CONFIG_VIEWS_INFO_TERM_SLOT: "storefront slot",
  CASINO_CONFIG_VIEWS_LOAD_ERROR: "Failed to load placements",
  CASINO_CONFIG_VIEWS_MOVE_FAILED: "Failed to update order",
  CASINO_CONFIG_VIEWS_MOVE_PLACEMENT_FALLBACK: "Failed to move placement",
  CASINO_CONFIG_VIEWS_PAGE_DEFAULT_SUFFIX: "(Default)",
  CASINO_CONFIG_VIEWS_PAGE_SELECTOR_LABEL: "Casino page",
  CASINO_CONFIG_VIEWS_PATCH_PLACEMENT_FALLBACK: "Failed to update placement",
  CASINO_CONFIG_VIEWS_PIN_BADGE: "pinned",
  CASINO_CONFIG_VIEWS_PIN_FAILED: "Failed to update pin state",
  CASINO_CONFIG_VIEWS_PIN_SUCCESS: "Pinned",
  CASINO_CONFIG_VIEWS_PROVIDERS_COLLECTION: "Providers collection",
  CASINO_CONFIG_VIEWS_PROVIDERS_SUFFIX: "providers",
  CASINO_CONFIG_VIEWS_REMOVED_SUCCESS: "Placement removed",
  CASINO_CONFIG_VIEWS_REMOVE_CANCEL: "Cancel",
  CASINO_CONFIG_VIEWS_REMOVE_CONFIRM: "Yes, I'm Sure",
  CASINO_CONFIG_VIEWS_REMOVE_FAILED: "Failed to remove placement",
  CASINO_CONFIG_VIEWS_REMOVE_TITLE_PREFIX: "Are you sure you want to remove",
  CASINO_CONFIG_VIEWS_REMOVE_TITLE_SUFFIX: "catalog from category view?",
  CASINO_CONFIG_VIEWS_ROW_DRAG_LABEL: "Drag handle",
  CASINO_CONFIG_VIEWS_ROW_DRAG_TOOLTIP: "Drag to reorder",
  CASINO_CONFIG_VIEWS_ROW_PIN: "Pin",
  CASINO_CONFIG_VIEWS_ROW_PIN_TOOLTIP: "Pin to top",
  CASINO_CONFIG_VIEWS_ROW_REMOVE_PREFIX: "Remove",
  CASINO_CONFIG_VIEWS_ROW_REMOVE_TOOLTIP: "Remove from view",
  CASINO_CONFIG_VIEWS_ROW_TOGGLE_HIDE_PREFIX: "Hide",
  CASINO_CONFIG_VIEWS_ROW_TOGGLE_SHOW_PREFIX: "Show",
  CASINO_CONFIG_VIEWS_ROW_TOGGLE_TOOLTIP: "Show / hide",
  CASINO_CONFIG_VIEWS_ROW_UNPIN: "Unpin",
  CASINO_CONFIG_VIEWS_ROW_UNPIN_TOOLTIP: "Unpin",
  CASINO_CONFIG_VIEWS_SEARCH_PLACEHOLDER: "Filter by collection name or code...",
  CASINO_CONFIG_VIEWS_SHOW_HIDDEN: "Show hidden",
  CASINO_CONFIG_VIEWS_STATUS_HIDDEN: "hidden",
  CASINO_CONFIG_VIEWS_STATUS_SHOWN: "shown",
  CASINO_CONFIG_VIEWS_SUBTITLE: "Place a collection on a shortcut or carousel, then drag to reorder. A collection can appear in multiple slots, each with its own order and on/off toggle.",
  CASINO_CONFIG_VIEWS_SUB_COLLECTIONS_SUFFIX: "sub-collections",
  CASINO_CONFIG_VIEWS_TAB_CAROUSELS: "Carousels",
  CASINO_CONFIG_VIEWS_TAB_INFO_CAROUSELS: "This refers to the horizontal strips you'll see on the home page of the Casino.",
  CASINO_CONFIG_VIEWS_TAB_INFO_SHORTCUTS: "This refers to the Icon Tabs you'll see at the top of Casino page.",
  CASINO_CONFIG_VIEWS_TAB_SHORTCUTS: "Shortcuts",
  CASINO_CONFIG_VIEWS_TITLE: "Views",
  CASINO_CONFIG_VIEWS_TOGGLE_FAILED: "Failed to update visibility",
  CASINO_CONFIG_VIEWS_TOGGLE_ROW_ARIA: "Toggle {name}",
  CASINO_CONFIG_VIEWS_TOGGLE_SUCCESS_HIDDEN: "Placement hidden",
  CASINO_CONFIG_VIEWS_TOGGLE_SUCCESS_SHOWN: "Placement shown",
  CASINO_CONFIG_VIEWS_UNPIN_SUCCESS: "Unpinned",
  CASINO_BY_STATE: "Casino by State",
  CASINO_BY_STATE_EMPTY_STATE: "No state-level data for the selected date range.",
  CASINO_BY_STATE_LOAD_ERROR: "Failed to load Casino by state data. Please try again later.",
  CASINO_DAILY_EMPTY_STATE: "No daily performance data for the selected date range.",
  CASINO_DAILY_LOAD_ERROR: "Failed to load daily performance. Please try again later.",
  CASINO_KPI_ALL_CURRENCY_TYPES: "All Currency Types",
  CASINO_KPI_CARDS_ERROR: "Failed to load KPI data. Please try again.",
  CASINO_KPI_CURRENCY_TYPE: "Currency Type",
  CASINO_TOP_FIVE_LOAD_ERROR: "Failed to load top ranking data. Please try again later.",
  CASINO_TOP_PROVIDERS: "Top Providers",
  CASINO_TOP_GAMES: "Top Games",
  // Casino → Reports → Top Users (src/components/Casino/TopUsers). Column
  // titles / filter placeholders reuse the shared USERNAME / USER_ID /
  // TURNOVER / GGR / MARGIN_PCT / ROUNDS / PROVIDER / GAME / STATE keys.
  CASINO_TOP_USERS_VIEW_TOP_WINNERS: "Top Winners",
  CASINO_TOP_USERS_VIEW_TOP_LOSERS: "Top Losers",
  CASINO_TOP_USERS_VIEW_TOP_TURNOVER: "Top Turnover",
  CASINO_TOP_USERS_LIMIT_OPTION: "{count} Users",
  CASINO_TOP_USERS_PROVIDER_PRAGMATIC_PLAY: "Pragmatic Play",
  CASINO_TOP_USERS_PROVIDER_EVOLUTION: "Evolution",
  CASINO_TOP_USERS_PROVIDER_NETENT: "NetEnt",
  CASINO_TOP_USERS_PROVIDER_HACKSAW: "Hacksaw",
  CASINO_TOP_USERS_PROVIDER_PLAYNGO: "Play'n GO",
  CASINO_TOP_USERS_GAME_SWEET_BONANZA: "Sweet Bonanza",
  CASINO_TOP_USERS_GAME_GATES_OF_OLYMPUS: "Gates of Olympus",
  CASINO_TOP_USERS_GAME_BIG_BASS_BONANZA: "Big Bass Bonanza",
  CASINO_TOP_USERS_GAME_BOOK_OF_DEAD: "Book of Dead",
  CASINO_TOP_USERS_GAME_CRAZY_TIME: "Crazy Time",
  CASINO_TOP_USERS_STATE_CALIFORNIA: "California",
  CASINO_TOP_USERS_STATE_NEW_JERSEY: "New Jersey",
  CASINO_TOP_USERS_STATE_NEW_YORK: "New York",
  CASINO_TOP_USERS_STATE_PENNSYLVANIA: "Pennsylvania",
  CASINO_TOP_USERS_METRIC_TURNOVER: "turnover",
  CASINO_TOP_USERS_METRIC_GGR: "gross gaming revenue",
  CASINO_TOP_USERS_METRIC_ROUNDS: "rounds",
  CASINO_TOP_USERS_PCT_CHANGE_TOOLTIP: "The percent change metric compares the {metric} for the top user against the {metric} for all users with respect to the time filter. This shows how the Top Users affect this metric for the entire application.",
  CASINO_TOP_USERS_LOAD_ERROR: "Failed to load Top Users data. Please try again.",
  CASINO_TOP_USERS_TABLE_LOAD_ERROR: "Failed to load the Top Users table. Please try again.",
  CASINO_TOP_USERS_KPIS_LOAD_ERROR: "Failed to load the Top Users KPI tiles. Please try again.",
  TOP_5_GAMES: "Top 5 Games",
  CASINO_CASH_TOOLTIP: "Change in user's Casino cash as a result of PAM agents editing the user's Casino Cash wallet (positive is with respect to the user wallet).",


  CASINO_FM_SUBCATEGORY_NOT_FOUND: "Subcategory not found",
  CASINO_FM_GAME_PROVIDER_NOT_FOUND:
    "Provider information not found for this game",
  CASINO_FM_MISSING_CATEGORY_OR_GAME: "Missing category or game information",
  CASINO_FM_MISSING_CATEGORY_PROVIDER_OR_GAME:
    "Missing category, provider or game information",
  CASINO_FM_MISSING_PROVIDER_GAME_PROVIDER_ID:
    "Missing real provider_id for provider game",
  CASINO_FM_MISSING_PROVIDER_OR_GAME: "Missing provider or game information",
  CASINO_FM_MISSING_POPULAR_GAME_PROVIDER_ID:
    "Missing real provider_id for popular game",
  CASINO_FM_MISSING_GAME_ID: "Missing game id",
  CASINO_FM_MISSING_IMAGE_UPLOAD_DATA: "Missing required data for image upload",
  CASINO_FM_MISSING_CATEGORY_FOR_GAME_ICON:
    "Missing category for updating game icon",
  CASINO_FM_SUBCATEGORY_NAME_REQUIRED: "Please enter a subcategory name",
  CASINO_FM_CATEGORY_NAME_REQUIRED: "Please enter a category name",
  CASINO_FM_CATEGORY_CREATED_ICON_FAILED:
    "Category created successfully, but failed to upload icon.",
  CASINO_FM_PRESIGNED_URL_MISSING: "Failed to generate pre-signed URL",
  CASINO_FM_SUBCATEGORY_ICON_UPLOAD_FAILED:
    "Failed to upload subcategory icon.",

  // ===== BEGIN design-gated toast copy — DO NOT TRANSLATE YET =====
  // No single BE response can supply these, for two different reasons. They
  // stay English-only and held out of the TCM upload until each reason is
  // resolved. Tracked externally with per-key reasons (i18n follow-ups
  // worklist).
  //
  // Batch fan-outs: each summarizes a Promise.all over N per-item requests
  // whose responses are discarded, because the per-item BE messages are
  // name-bearing and quoting one of N would mislead. Resolved when the casino
  // bulk endpoints land, each returning one localized count-bearing message
  // the call site can quote instead.
  CASINO_FM_CATEGORIES_REORDERED: "Categories reordered successfully",
  CASINO_FM_SUBCATEGORIES_REORDERED: "Subcategories reordered successfully",
  CASINO_FM_GAMES_REORDERED: "Games reordered successfully",
  CASINO_FM_PROVIDER_GAMES_UPDATED: "Provider games updated",
  CASINO_FM_PROVIDER_ORDER_UPDATED: "Provider order updated",
  //
  // FE-interpolated provider-game copy: the casino catalog does carry
  // localized per-item messages for these two operations, but they are served
  // by casino v2 routes that are pending deprecation, so the FE must not adopt
  // new quoting against them. Parked until the replacement routes exist — not
  // waiting on a BE message that is already there.
  CASINO_FM_GAME_REMOVED_SUCCESS: 'Game "{name}" removed successfully',
  CASINO_FM_GAME_ADDED_TO_PROVIDER: "Game added to {provider} successfully",
  CASINO_FM_GAME_ADDED_TO_PROVIDER_GENERIC:
    "Game added to provider successfully",
  // ===== END design-gated toast copy =====

  // =====================================================================
  // Sportsbook
  // =====================================================================
  SPORTSBOOK_KPI_ALL_BET_TYPES: "All Bet Types",
  SPORTSBOOK_KPI_ALL_CURRENCY_TYPES: "All Currency Types",
  SPORTSBOOK_PROFITABILITY_BET_TYPE: "Bet Type",
  SPORTSBOOK_PROFITABILITY_BY_TURNOVER: "by Turnover",
  SPORTSBOOK_PROFITABILITY_CURRENCY_TYPE: "Currency Type",
  SPORTSBOOK_PROFITABILITY_PREMATCH_LIVE: "Prematch/Live",
  SPORTSBOOK_PROFITABILITY_SPORTS: "Sports",
  SPORTSBOOK_PROFITABILITY_SUMMARY: "Summary",
  SPORTSBOOK_PROFITABILITY_TABLE: "Table",
  SPORTSBOOK_PROFITABILITY_TOP_EVENTS: "Top Events",
  SPORTSBOOK_REPORTING_SUMMARY: "Reporting Summary",
  SPORTSBOOK_SGP_RISK: "SGP Risk",
  SPORTSBOOK_SGP_LIMITS: "SGP Limits",
  SPORTSBOOK_FM: "Sportsbook FM",
  LEAGUES: "Leagues",
  ACCEPTED_BETS_HEADER: "Accepted Bets",
  MIN_ACCEPTED_BETS: "Min Accepted Bets",
  SPORTSBOOK_TURNOVER: "Sportsbook Turnover",
  SPORTSBOOK_GGR: "Sportsbook GGR",
  ALL_LEAGUES: "All Leagues",
  ODDS_CHECKER: "OddsChecker",
  ALLOCATED_TIME_TO_USE_THE_FREE_BET: "Allocated Time To Use The Free Bet",
  SPORTSBOOK_REQUIREMENTS: "Sportsbook Requirements",
  ODDS_BOOST_PERCENTAGE: "Odds boost %",
  FREE_BETS: "Free Bets",
  SGP_RISK_EXPOSURE_CONTROLS_UPDATED: "Exposure controls updated.",
  SGP_RISK_EXPOSURE_CONTROLS_UPDATE_ERROR: "Unable to update exposure controls.",
  SGP_RISK_MIN_LEGS_PLACEHOLDER: "Enter minimum legs",
  SGP_RISK_SPORT_PLACEHOLDER: "Select sport",
  SGP_RISK_MIN_SETTLED_PAYOUT_PLACEHOLDER: "Enter minimum settled payout",
  SGP_RISK_MIN_PL_PLACEHOLDER: "Enter minimum P/L",
  SGP_RISK_MIN_ROI_PLACEHOLDER: "Enter minimum ROI %",
  SPORTSBOOK_KPI: "Sportsbook KPI",
  SPORTSBOOK_AAL_BET_TYPE_FLEX: "Flex",
  ODDS_PROVIDER: "Odds Provider",
  PARLAY: "Parlay",
  ALT_ODDS_SETTING: "Alt-Odds setting",
  SPORTSBOOK: "Sportsbook",
  USER_SPORTS_BETS: "User's Sports Bets",
  FREE_BET: "Sportsbook Free Bet",
  ADD_FREE_BET: "Add Free Bet",
  FREE_BET_ADDED_SUCCESSFULLY: "Free bet added successfully.",
  SPORTS_BETS: "Sports Bets",
  DISPLAY_LOCATION_SPORTSBOOK: "Sportsbook",
  ACCEPTED_BETS: "Accepted Bets",
  SPORTSBOOK_TOP_SPORTS: "Top Sports",
  SPORTSBOOK_TOP_LEAGUES: "Top Leagues",
  TOP_LEAGUES: "Top Leagues",
  NO_LEAGUES_FOUND: "No leagues found",
  TOP_LEAGUES_PER_SPORT: "Top Leagues Per Sport",
  SEARCH_SPORTS_LEAGUES_MATCHES: "Search sports, leagues, or matches...",
  SEARCH_LEAGUES: "Search leagues...",
  SEARCH_SPORTS_OR_LEAGUES: "Search sports or leagues",
  BET_SLIP: "Bet Slip",
  SPORTS_BETS_SETTLED: "Sportsbook Free Pick Value",
  SPORTS_BETS_SETTLED_TITLE: "Sports Bets Settled",
  TURNOVER_SPORTS_BETS_REVIEWED: "Turnover of Sports Bets Reviewed",
  SPORTSBOOK_FREE_PICK_VALUE: "Sportsbook Free Pick Value",
  SB_FREE_PICK_VALUE: "SB Free Pick Value",
  NUMBER_OF_SB_FREE_PICKS: "# of SB FREE PICKS",
  SPORTSBOOK_VIP: "Sportsbook VIP",
  SPORTSBOOK_PERFORMANCE: "Sportsbook Performance",
  MINIMUM_ODDS_POPOVER_TEXT: "The odds in decimal form required for the total parlay or straight bet. E.g. A bet with odds of 1.50 would return $150 on a $100 bet if won.",
  SPORTSBOOK_CASINO_REVENUE: "Sportsbook & Casino Revenue",
  SPORTSBOOK_PNL: "Sportsbook P&L",
  SPORTSBOOK_REVENUE: "Sportsbook Revenue",
  CREATE_TASK_TASK_TYPE_SPORTSBOOK: "Sportsbook",
  REPORTING_FILTERS_ODDS_PROVIDER: "Odds Provider",
  SPORTSBOOK_TIER_AFFILIATE: "Affiliate",
  SPORTSBOOK_TIER_DEFAULT: "Default",
  SPORTSBOOK_TIER_VIP: "VIP",
  CREATE_SEASON_SPORTSBOOK_TASK_SUBMISSION_INFO_ARIA: "Choose whether sportsbook task progress is submitted automatically or requires manual pass.",
  CREATE_SEASON_SPORTSBOOK_TASK_SUBMISSION_LABEL: "Sportsbook Task Submission",
  MONTHLY_CHALLENGE_TASK_TYPE_SPORTSBOOK_PICKS: "Sportsbook Picks",
  MONTHLY_CHALLENGE_MIN_ODDS_LABEL: "Minimum Odds",
  MONTHLY_CHALLENGE_MIN_ODDS_PLACEHOLDER: "e.g. -200",
  MONTHLY_CHALLENGE_MIN_ODDS_INFO: "Only picks placed at this minimum odds value or higher will count toward the challenge",
  MONTHLY_CHALLENGE_LEAGUES_LABEL: "Leagues",
  MONTHLY_CHALLENGE_LEAGUES_PLACEHOLDER: "Select Leagues",
  MONTHLY_CHALLENGE_LEAGUES_SELECT_SPORT_FIRST: "Select a sport first",
  CREATE_TASK_MAX_ODDS_PLACEHOLDER: "e.g. 250",
  CREATE_TASK_MAX_ODDS_PLACEHOLDER_DECIMAL: "e.g. 3.00",
  CREATE_TASK_MIN_ODDS_PLACEHOLDER: "e.g. -100",
  CREATE_TASK_MIN_ODDS_PLACEHOLDER_DECIMAL: "e.g. 1.50",
  CREATE_TASK_ODDS_FORMAT_HINT_AMERICAN: "Enter odds in American format (e.g. -110 or +250).",
  CREATE_TASK_ODDS_FORMAT_HINT_DECIMAL: "Enter odds in Decimal format (e.g. 1.91 or 3.50).",
  FAILED_TO_UPDATE_SPORTSBOOK_TIER: "Failed to update Sportsbook tier.",
  SPORTSBOOK_AFFILIATE: "Affiliate",
  SPORTSBOOK_TIER: "Sportsbook Tier",
  SPORTSBOOK_TOGGLES: "Sportsbook Toggles",
  FREE_PICK_BONUS_AMOUNT: "Free Pick Bonus Amount",
  REFERRAL_FREE_PICK_BONUS_TOOLTIP: "Value of the Free Pick granted from the Referral Bonus.",
  REFERRAL_MIN_ODDS_TOOLTIP: "Minimum total odds for the bet slip.",
  WELCOME_MATCH_PERCENTAGE_SPORTSBOOK_TOOLTIP: "The percentage of the first purchase that is matched as a Free Pick.",
  WELCOME_MIN_ODDS_TOOLTIP: "Minimum total odds for the bet slip.",
  FAILED_TO_LOAD_LEAGUES: "Failed to load leagues",
  NO_LEAGUES_CONFIGURED: "No leagues configured for this sport",
  SPORTSBOOK_DAILY_EMPTY_STATE: "No daily performance data for the selected date range.",
  SPORTSBOOK_DAILY_LOAD_ERROR: "Failed to load daily performance. Please try again later.",
  SPORTSBOOK_KPI_CARDS_ERROR: "Failed to load KPI data. Please try again.",
  FREE_PICK: "Free Pick",
  FREE_PICKS_AMOUNT: "Free Picks Amount",
  FREE_PICKS_AMOUNT_TOOLTIP: "The amount of Sportsbook Free Cash added to a User account (positive is with respect to the user).",
  FREE_PICKS_REALIZED_VALUE: "Free Picks - Realized Value",
  FREE_PICKS_REALIZED_VALUE_TOOLTIP: "The amount of {currency} earned by a user as a result of the Free Pick placed on a bet that won.",
  FREE_PICK_AMOUNT: "Free Pick Amount",
  NUMBER_OF_FREE_PICKS: "# of Free Picks",


  SPORTSBOOK_OUTRIGHT_EVENTS_SPORT_REQUIRED: "Sport is required for outright events",
  SPORTSBOOK_MATCH_EVENTS_DATE_RANGE_REQUIRED:
    "Start date and end date are required for match events",

  // Sportsbook Feature Management — FE-owned copy only. Toast outcomes quote
  // the backend's localized message and fall back to the PAM generics.
  SPORTSBOOK_FM_PAGE_TITLE: "Sportsbook Feature Management",
  SPORTSBOOK_FM_SHORTCUTS_TAB: "Shortcuts",
  // Displayed names come from the backend name-translation overlay; rename
  // inputs still write the canonical English name (see the overlay design doc).
  SPORTSBOOK_FM_TRANSLATED_NAMES_WARNING:
    "Sport, league and market names are shown in your language. Renaming one edits the canonical English name.",
  // Appended to a backend error message, which supplies only the first clause.
  SPORTSBOOK_FM_REVERTING_CHANGE: "Reverting change.",
  SPORTSBOOK_FM_PLEASE_TRY_AGAIN: "Please try again.",
  SPORTSBOOK_FM_LEAGUE_NOT_SEEDED:
    "League not available under All Sports yet (backend seeding pending).",
  SPORTSBOOK_FM_NO_SPORT_DATA: "No data found for this sport.",
  SPORTSBOOK_FM_RENAME_SPORT: "Rename sport",
  SPORTSBOOK_FM_SPORT_NAME: "Sport name",
  SPORTSBOOK_FM_PINNED_LEAGUES_HEADING: "{name} Pinned leagues",
  SPORTSBOOK_FM_ENTITY_LOGO_ALT: "{name} logo",
  SPORTSBOOK_FM_COUNTRY_FLAG_ALT: "{name} flag",
  SPORTSBOOK_FM_PIN_LEAGUE_ARIA: "Pin league {name}",
  SPORTSBOOK_FM_UNPIN_LEAGUE_ARIA: "Unpin league {name}",
  SPORTSBOOK_FM_TRANSLATION: "Translation",
  SPORTSBOOK_FM_TRANSLATION_LOCALES: "Translation locales",
  SPORTSBOOK_FM_SPANISH: "Spanish",
  SPORTSBOOK_FM_FRENCH: "French",
  SPORTSBOOK_FM_GERMAN: "German",
  SPORTSBOOK_FM_PORTUGUESE: "Portuguese",
  SPORTSBOOK_FM_PORTUGUESE_BRAZIL: "Portuguese (Brazil)",
  SPORTSBOOK_FM_PORTUGUESE_PORTUGAL: "Portuguese (Portugal)",
  SPORTSBOOK_FM_NO_TRANSLATION: "No translation",
  SPORTSBOOK_FM_RESET_TRANSLATION: "Reset translation",
  SPORTSBOOK_FM_RESET_TRANSLATION_ARIA:
    "Revert unsaved {locale} translation changes",
  SPORTSBOOK_FM_CLOSE: "Close",
  SPORTSBOOK_FM_LOADING_TRANSLATIONS: "Loading translations...",
  SPORTSBOOK_FM_LOAD_TRANSLATIONS_ERROR: "Failed to load translations.",
  SPORTSBOOK_FM_TRANSLATIONS_UNAVAILABLE:
    "Translations are unavailable for this tab.",
  SPORTSBOOK_FM_NO_CONFIGURED_LOCALES:
    "No translation locales are configured.",
  SPORTSBOOK_FM_RETRY: "Retry",
  SPORTSBOOK_FM_BASE_VALUE: "Base ({locale}): {value}",
  SPORTSBOOK_FM_MACHINE_VALUE: "Machine: {value}",
  SPORTSBOOK_FM_STATUS_TRANSLATED: "Translated",
  SPORTSBOOK_FM_STATUS_PENDING: "Pending",
  SPORTSBOOK_FM_STATUS_MISSING: "Missing",
  SPORTSBOOK_FM_STATUS_STALE: "Stale",
  SPORTSBOOK_FM_SELECT_LOCALE_ARIA: "Select {locale} translation locale",
  SPORTSBOOK_FM_STALE_TRANSLATION_DESCRIPTION:
    "The base value changed after this override was saved.",
  SPORTSBOOK_FM_OVERRIDE_METADATA: "Override updated by {user} at {date}",
  SPORTSBOOK_FM_CONFIRM_OVERRIDE: "Confirm override",
  SPORTSBOOK_FM_CONFIRM_OVERRIDE_ARIA: "Confirm stale override for {locale}",
  SPORTSBOOK_FM_DISCARD_OVERRIDE: "Discard override",
  SPORTSBOOK_FM_DISCARD_OVERRIDE_ARIA: "Discard override for {locale}",
  SPORTSBOOK_FM_REMOVE_OVERRIDE: "Remove override",
  SPORTSBOOK_FM_REMOVE_OVERRIDE_ARIA: "Remove override for {locale}",
  SPORTSBOOK_FM_SAVE_TRANSLATION_ARIA:
    "Save market tab and translation changes for {locale}",
  SPORTSBOOK_FM_SAVE_TRANSLATION_ERROR:
    "Failed to save the {locale} translation. Please try again.",
  SPORTSBOOK_FM_DELETE_TRANSLATION_ERROR:
    "Failed to discard the {locale} override. Please try again.",
  SPORTSBOOK_FM_EMPTY_TRANSLATION_ERROR:
    "Translation cannot be empty. Revert the draft or enter a value.",
  SPORTSBOOK_FM_UNSAVED_TRANSLATIONS:
    "Save or reset translation changes before closing.",

  // =====================================================================
  // Game Pass
  // =====================================================================
  GAME_PASS_TOGGLE: "Game Pass Toggle",
  GAME_PASS: "Game Pass",
  GAME_PASS_BET_SUBMITTED: "Submitted",
  GAME_PASS_BET_NOT_SUBMITTED: "Not Submitted",
  GAME_PASS_ENABLED_FOR: "Is Game Pass Enabled for {username}?",
  GAME_PASS_PREMIUM_ENABLED: "Game Pass Premium Enabled",
  GAME_PASS_ENABLED: "Game Pass Enabled",
  GAME_PASS_DAILY: "Daily",
  GAME_PASS_MONTHLY: "Monthly",
  GAME_PASS_MONTHLY_SCHEDULE_NO_ACTIVE_CHALLENGE:
    "There's no active monthly challenge to auto-start after.",
  GAME_PASS_MONTHLY_CHALLENGE_CARD_DUPLICATE: "Duplicate",
  GAME_PASS_MONTHLY_CHALLENGE_DUPLICATE_ADDED_TO: "added to",
  GAME_PASS_MONTHLY_CHALLENGE_DUPLICATE_ERROR: "Failed to duplicate monthly challenge",
  GAME_PASS_MONTHLY_CHALLENGE_DUPLICATE_NAME_SUFFIX: " - Duplicate",
  GAME_PASS_MONTHLY_DETAILS_SCHEDULE_PARTIAL_ERROR:
    "Your changes were saved, but scheduling failed. Please try scheduling again.",
  GAME_PASS_MONTHLY_DETAILS_EDIT_TITLE_PREFIX: "Edit",
  GAME_PASS_MONTHLY_DETAILS_EDIT_GENERAL_HEADING: "General",
  GAME_PASS_MONTHLY_DETAILS_EDIT_SAVE: "Save",
  GAME_PASS_MONTHLY_DETAILS_EDIT_SUCCESS: "Monthly challenge updated",
  GAME_PASS_MONTHLY_DETAILS_EDIT_ERROR: "Failed to update monthly challenge",
  GAME_PASS_MONTHLY_CHALLENGE_TIER_XP_LABEL: "XP Reward",
  GAME_PASS_MONTHLY_CHALLENGE_TIER_XP_PLACEHOLDER: "e.g. 25",
  GAME_PASS_MONTHLY_CHALLENGE_TIER_PARAM_MIN_LEGS: "min {min}",
  GAME_PASS_MONTHLY_CHALLENGE_TIER_MIN_LEGS_ERROR: "Min legs must be {min} or more",
  GAME_PASS_MONTHLY_SCHEDULE_NO_CHALLENGES: "Add at least 1 challenge before scheduling this monthly challenge.",
  GAME_PASS_MONTHLY_SCHEDULE_CHALLENGE_INCOMPLETE: "Complete every field in the challenge \"{challengeName}\" before scheduling this monthly challenge.",
  GAME_PASS_MONTHLY_SCHEDULE_CHALLENGE_INCOMPLETE_GENERIC: "Complete every challenge's fields before scheduling this monthly challenge.",
  GAME_PASS_SEASONS: "Seasons",
  GAME_PASS_STYLE: "Style",
  CREATE_A_GAME_PASS_SEASON: "Create a Game Pass season",
  DRAFT_A_GAME_PASS_SEASON: "Draft a Game Pass season",
  GAME_PASS_SEASON_CONFIGURATION: "Game Pass Season Configuration",
  GAME_PASS_SEASON_BANNER_LABEL: "Banner Image",
  // Ticket FE-2840 copy. "16:9" here is 16 tall / 9 wide (portrait), not
  // landscape. The dropzone is a usable portrait tile, not a locked ratio,
  // and files are not aspect-validated.
  GAME_PASS_SEASON_BANNER_HINT: "Dimensions: 16:9",
  GAME_PASS_SEASON_BANNER_INFO_ARIA:
    "Banner image shown as the Game Pass opt-in background.",
  GAME_PASS_SEASON_BANNER_UPLOAD_ERROR: "Failed to upload banner image",
  GAME_PASS_STYLE_ASSETS_ASPECT_RATIO: "1:1 Aspect Ratio",
  GAME_PASS_STYLE_ASSETS_DELETE_ARIA: "Remove image",
  GAME_PASS_STYLE_ASSETS_DELETE_CONFIRM_CTA: "Delete",
  GAME_PASS_STYLE_ASSETS_DELETE_CONFIRM_PREFIX: "Are you sure you would like to delete",
  GAME_PASS_STYLE_ASSETS_DELETE_GO_BACK: "Go Back",
  GAME_PASS_STYLE_ASSETS_DELETE_MODAL_TITLE: "Delete",
  GAME_PASS_STYLE_ASSETS_DRAG_AND_DROP: "Drag-and-Drop",
  GAME_PASS_STYLE_ASSETS_REPLACE_ARIA: "Replace image",
  GAME_PASS_STYLE_ASSETS_TITLE: "Assets",
  GAME_PASS_STYLE_ASSETS_TOGGLE_ARIA: "Toggle assets section",
  GAME_PASS_STYLE_ASSETS_UPLOAD: "Upload File",
  GAME_PASS_STYLE_ASSET_CARBON_FIBRE_BACKGROUND: "Carbon Fibre Background",
  GAME_PASS_STYLE_ASSET_CHALLENGE_COMPLETE: "Challenge Complete Icon",
  GAME_PASS_STYLE_ASSET_DEPOSIT_MATCH: "Deposit Match",
  GAME_PASS_STYLE_ASSET_FREE_CASH_PICK: "Free Cash Pick",
  GAME_PASS_STYLE_ASSET_FREE_SPINS: "Free Spins",
  GAME_PASS_STYLE_ASSET_GAME_PASS_COMPLETED_BACKGROUND: "Game Pass Completed Background",
  GAME_PASS_STYLE_ASSET_GAME_PASS_OPT_IN_BACKGROUND: "Game Pass Opt-In Background",
  GAME_PASS_STYLE_ASSET_LEADERBOARD_FIRST_PLACE: "Leaderboard First Place",
  GAME_PASS_STYLE_ASSET_LEADERBOARD_NO_RANK: "Leaderboard No Rank",
  GAME_PASS_STYLE_ASSET_LEADERBOARD_SECOND_PLACE: "Leaderboard Second Place",
  GAME_PASS_STYLE_ASSET_LEADERBOARD_THIRD_PLACE: "Leaderboard Third Place",
  GAME_PASS_STYLE_ASSET_PROFIT_BOOST: "Profit Boost",
  GAME_PASS_STYLE_ASSET_SEASON_CONCLUDED: "Season Concluded",
  GAME_PASS_STYLE_COLOR_COMPLETED_ACCENT: "Completed Accent",
  GAME_PASS_STYLE_COLOR_COMPLETED_BADGE_BG: "Completed Badge Background",
  GAME_PASS_STYLE_COLOR_HEX_PLACEHOLDER: "Hex",
  GAME_PASS_STYLE_COLOR_MATCH_DEFAULTS: "Match Trivelta Defaults",
  GAME_PASS_STYLE_COLOR_PICKER_ARIA: "color picker",
  GAME_PASS_STYLE_COLOR_PICKER_TITLE: "Select a Color",
  GAME_PASS_STYLE_COLOR_TEXT_PRIMARY: "Text Primary",
  GAME_PASS_STYLE_COLOR_TEXT_SECONDARY: "Text Secondary",
  GAME_PASS_STYLE_COLOR_THEME_PRIMARY: "Theme Primary",
  GAME_PASS_STYLE_COLOR_THEME_SECONDARY: "Theme Secondary",
  GAME_PASS_STYLE_COLOR_TITLE: "Color",
  GAME_PASS_STYLE_PAGE_TITLE: "Game Pass Style",
  GAME_PASS_STYLE_PREVIEW_BACK_ARIA: "Back",
  GAME_PASS_STYLE_PREVIEW_BADGE_ALT: "Challenge badge",
  GAME_PASS_STYLE_PREVIEW_CASH_ALT: "Cash reward",
  GAME_PASS_STYLE_PREVIEW_CHALLENGE_DESCRIPTION: "Basic XP rewards and beginner challenges.",
  GAME_PASS_STYLE_PREVIEW_CHALLENGE_NUMBER: "1",
  GAME_PASS_STYLE_PREVIEW_CHALLENGE_TITLE: "Challenge 1",
  GAME_PASS_STYLE_PREVIEW_CLAIM_REWARDS: "Claim Rewards",
  GAME_PASS_STYLE_PREVIEW_COINS_ALT: "Coin reward",
  GAME_PASS_STYLE_PREVIEW_COUNTDOWN: "23d 11h 58m",
  GAME_PASS_STYLE_PREVIEW_INFO_ARIA: "Game Pass info",
  GAME_PASS_STYLE_PREVIEW_NEXT_POSITION: "Next position",
  GAME_PASS_STYLE_PREVIEW_NEXT_XP: "10 XP",
  GAME_PASS_STYLE_PREVIEW_PREVIOUS_POSITION: "Previous position",
  GAME_PASS_STYLE_PREVIEW_PREVIOUS_XP: "23 XP",
  GAME_PASS_STYLE_PREVIEW_PROGRESS_CURRENT: "1",
  GAME_PASS_STYLE_PREVIEW_PROGRESS_SEPARATOR: "/",
  GAME_PASS_STYLE_PREVIEW_PROGRESS_TOTAL: "25",
  GAME_PASS_STYLE_PREVIEW_RAIL_XP: "100 XP",
  GAME_PASS_STYLE_PREVIEW_REWARDS: "Rewards",
  GAME_PASS_STYLE_PREVIEW_REWARD_CASH: "15",
  GAME_PASS_STYLE_PREVIEW_REWARD_COINS: "15K",
  GAME_PASS_STYLE_PREVIEW_SEASON: "Season 2",
  GAME_PASS_STYLE_PREVIEW_TASK_DESCRIPTION: "Task Description",
  GAME_PASS_STYLE_PREVIEW_TASK_ICON_ALT: "Task reward",
  GAME_PASS_STYLE_PREVIEW_TASK_PROGRESS_CURRENT: "0",
  GAME_PASS_STYLE_PREVIEW_TASK_PROGRESS_TOTAL: "1",
  GAME_PASS_STYLE_PREVIEW_TASK_TITLE: "Task Title",
  GAME_PASS_STYLE_PREVIEW_TASK_XP: "100 XP",
  GAME_PASS_STYLE_PREVIEW_TASK_XP_COMPLETED: "+ 100 XP",
  GAME_PASS_STYLE_PREVIEW_TITLE: "Game Pass",
  GAME_PASS_STYLE_PREVIEW_TROPHY_ALT: "Reward trophy",
  GAME_PASS_STYLE_PREVIEW_XP_LEFT_AMOUNT: "100 XP",
  GAME_PASS_STYLE_PREVIEW_XP_LEFT_SUFFIX: "left to claim rewards",
  GAME_PASS_STYLE_SAVE_BUTTON: "Save",
  GAME_PASS_STYLE_SAVE_ERROR: "Couldn't save the theme. Please try again.",
  GAME_PASS_STYLE_SAVE_PUBLISHED_PENDING: "Saved, but not yet published. Save again to retry.",
  GAME_PASS_STYLE_SAVE_SUCCESS: "Theme saved.",
  SCHEDULE_A_GAME_PASS_SEASON: "Schedule a Game Pass season",
  USER_GAME_PASS_CHALLENGE_NO_TASKS: "No tasks for this challenge",
  USER_GAME_PASS_CURRENT_SEASON_PROGRESS: "Current Season",
  USER_GAME_PASS_ENROLLED_ON: "Enrolled on:",
  USER_GAME_PASS_ENROLLED_SEASONS_NOTE: "Only seasons this user has enrolled in are shown below.",
  USER_GAME_PASS_NOT_ENROLLED_ACTIVE_SEASON_COPY: "Summary stats are only available for the active season. Past enrolled seasons are shown below.",
  USER_GAME_PASS_NOT_ENROLLED_ACTIVE_SEASON_TITLE: "This user is not enrolled in the current Game Pass season.",
  USER_GAME_PASS_NOT_ENROLLED_ANY_SEASON_COPY: "There is no progress, rewards, or challenge history to show yet.",
  USER_GAME_PASS_NOT_ENROLLED_ANY_SEASON_TITLE: "This user is not enrolled in any Game Pass season.",
  USER_GAME_PASS_NO_ACTIVE_SEASON_SUMMARY_TITLE: "There is no active Game Pass season right now.",
  USER_GAME_PASS_SEASON_PROGRESS: "Season Progress",
  USER_GAME_PASS_TASK_ACCORDION_EMPTY: "no results",
  USER_GAME_PASS_TASK_BETS_LOADING: "Loading...",
  USER_GAME_PASS_TASK_BETS_SEE_LESS: "See less",
  USER_GAME_PASS_TASK_BETS_SEE_MORE: "See more",
  USER_GAME_PASS_TASK_BETS_SUBMITTABLE: "Submitted Bets",
  USER_GAME_PASS_TASK_BET_AMOUNT: "Bet Amount",
  USER_GAME_PASS_TASK_BET_DATE: "Date",
  USER_GAME_PASS_TASK_BET_GAME: "Game",
  USER_GAME_PASS_TASK_BET_GAME_TYPE: "Game Type",
  USER_GAME_PASS_TASK_BET_RESULT: "Result",
  USER_GAME_PASS_TASK_NAME: "Task Name",
  USER_GAME_PASS_TASK_PASS: "Pass",
  USER_GAME_PASS_TASK_PASS_ALREADY_COMPLETED: "Task was already completed. Progress refreshed.",
  USER_GAME_PASS_TASK_PASS_ERROR: "Failed to pass task. Please try again.",
  USER_GAME_PASS_TASK_PASS_INACTIVE_SEASON: "Tasks can only be passed for the active Game Pass season.",
  USER_GAME_PASS_TASK_PASS_SUCCESS: "Task passed successfully.",
  USER_GAME_PASS_MONTHLY_ADJUSTMENT: "Adjustment",
  USER_GAME_PASS_MONTHLY_CASINO_HISTORY: "Casino History",
  USER_GAME_PASS_MONTHLY_CASINO_HISTORY_EMPTY: "No casino history to show yet.",
  USER_GAME_PASS_MONTHLY_CASINO_SUBTITLE: "Play 10 casino hands",
  USER_GAME_PASS_MONTHLY_CASINO_TITLE: "Casino Challenge",
  USER_GAME_PASS_MONTHLY_CHALLENGES_SUFFIX: "challenges",
  USER_GAME_PASS_MONTHLY_COL_BET_SIZE: "Bet Size",
  USER_GAME_PASS_MONTHLY_COL_DATE_FIRST_FOLLOW: "Date of First Follow",
  USER_GAME_PASS_MONTHLY_COL_DATE_PLACED: "Date Placed",
  USER_GAME_PASS_MONTHLY_COL_DATE_SETTLED: "Date Settled",
  USER_GAME_PASS_MONTHLY_COL_FIRST_PURCHASE: "First Purchase",
  USER_GAME_PASS_MONTHLY_COL_FOLLOWER_COUNT: "Follower Count",
  USER_GAME_PASS_MONTHLY_COL_GAME_TITLE: "Game Title",
  USER_GAME_PASS_MONTHLY_COL_HAND_SPIN_COUNT: "Hand/Spin Count",
  USER_GAME_PASS_MONTHLY_COL_MIN_ODDS_OF_BET: "Min Odds of Bet",
  USER_GAME_PASS_MONTHLY_COL_PICK_TYPE: "Pick Type",
  USER_GAME_PASS_MONTHLY_COL_PROVIDER: "Provider",
  USER_GAME_PASS_MONTHLY_COL_QUALIFYING_ACTION: "Qualifying Action Completed",
  USER_GAME_PASS_MONTHLY_COL_REBET_VALIDITY: "Rebet Validity Flag",
  USER_GAME_PASS_MONTHLY_COL_REFERRED_USER_ID: "Referred User ID",
  USER_GAME_PASS_MONTHLY_COL_RESULT: "Result",
  USER_GAME_PASS_MONTHLY_COL_REWARD_ISSUED: "Reward Issued",
  USER_GAME_PASS_MONTHLY_COL_SIGNUP_TIMESTAMP: "Signup Timestamp",
  USER_GAME_PASS_MONTHLY_COL_SPORT: "Sport",
  USER_GAME_PASS_MONTHLY_COL_TIER_REACHED: "Tier Reached",
  USER_GAME_PASS_MONTHLY_COL_TIMESTAMP_PER_SESSION: "Timestamp Per Session",
  USER_GAME_PASS_MONTHLY_COL_USERNAME_FOLLOW: "Username of Follow",
  USER_GAME_PASS_MONTHLY_COL_USERNAME_REFERRAL: "Username of Referral",
  USER_GAME_PASS_MONTHLY_CURRENT_TIER_PROGRESS: "Current Tier Progress",
  USER_GAME_PASS_MONTHLY_EDIT_PROGRESS: "Edit Progress",
  USER_GAME_PASS_MONTHLY_FOLLOW_HISTORY: "Follow History",
  USER_GAME_PASS_MONTHLY_FOLLOW_HISTORY_EMPTY: "No follows to show yet.",
  USER_GAME_PASS_MONTHLY_FOLLOW_SUBTITLE: "Follow 10 people",
  USER_GAME_PASS_MONTHLY_FOLLOW_TITLE: "Follow for Follow Challenge",
  USER_GAME_PASS_MONTHLY_HISTORY_EMPTY: "No rebet history to show yet.",
  USER_GAME_PASS_MONTHLY_MOVE_USER_TO_TIER: "Move user to tier",
  USER_GAME_PASS_MONTHLY_PARLAY_HISTORY: "Parlay History",
  USER_GAME_PASS_MONTHLY_PARLAY_HISTORY_EMPTY: "No parlay history to show yet.",
  USER_GAME_PASS_MONTHLY_PARLAY_SUBTITLE: "Win 10 parlays",
  USER_GAME_PASS_MONTHLY_PARLAY_TITLE: "Parlay Challenge",
  USER_GAME_PASS_MONTHLY_REBET_HISTORY: "Rebet History",
  USER_GAME_PASS_MONTHLY_REBET_SUBTITLE: "Rebet 10 picks",
  USER_GAME_PASS_MONTHLY_REBET_TITLE: "Rebets Challenge",
  USER_GAME_PASS_MONTHLY_REFERRAL_HISTORY: "Referral History",
  USER_GAME_PASS_MONTHLY_REFERRAL_HISTORY_EMPTY: "No referrals to show yet.",
  USER_GAME_PASS_MONTHLY_REFERRAL_SUBTITLE: "Refer 10 people",
  USER_GAME_PASS_MONTHLY_REFERRAL_TITLE: "Referral Challenge",
  USER_GAME_PASS_MONTHLY_REWARD_CLAIMED: "(Claimed)",
  USER_GAME_PASS_MONTHLY_REWARD_NOT_CLAIMED: "(Not Claimed)",
  USER_GAME_PASS_MONTHLY_SPORTSBOOK_HISTORY: "Pick History",
  USER_GAME_PASS_MONTHLY_SPORTSBOOK_HISTORY_EMPTY: "No pick history to show yet.",
  USER_GAME_PASS_MONTHLY_SPORTSBOOK_SUBTITLE: "Pick 10 bets",
  USER_GAME_PASS_MONTHLY_SPORTSBOOK_TITLE: "Sportsbook Picks Challenge",
  USER_GAME_PASS_MONTHLY_STATUS_ACTIVE: "Active",
  GAME_PASS_MONTHLY_STATUS_NOT_STARTED: "Not Started",
  GAME_PASS_MONTHLY_EMPTY_TITLE: "No Monthly Challenges for this user",
  GAME_PASS_MONTHLY_EMPTY_COPY:
    "There is no active or past Monthly Challenge progress to show yet.",
  GAME_PASS_MONTHLY_LOAD_ERROR_TITLE: "Couldn't load Monthly Challenges",
  GAME_PASS_MONTHLY_LOAD_ERROR_COPY:
    "Something went wrong loading this user's Monthly Challenge progress. Try again.",
  GAME_PASS_MONTHLY_PROGRESS_SAVE_SUCCESS: "Progress updated successfully.",
  GAME_PASS_MONTHLY_PROGRESS_SAVE_ERROR:
    "Failed to update progress. Please try again.",
  GAME_PASS_MONTHLY_PROGRESS_DECREASE_UNSUPPORTED:
    "Progress can only be increased. Use a higher tier or refresh and try again.",
  GAME_PASS_MONTHLY_SOCIAL_HISTORY: "Social History",
  GAME_PASS_MONTHLY_SOCIAL_HISTORY_EMPTY: "No social history to show yet.",
  // FE-2436 Rebet History columns. New keys must use the GAME_PASS_ prefix —
  // the sibling USER_GAME_PASS_MONTHLY_COL_* keys are baseline-grandfathered.
  GAME_PASS_MONTHLY_COL_REBET_AMOUNT: "Rebet Amount",
  GAME_PASS_MONTHLY_COL_USERNAME_REBETTER: "Username of Rebetter",
  // FE-2579 Rebet History redesign columns (match Figma).
  GAME_PASS_MONTHLY_COL_DATE_OF_REBET: "Date of Rebet",
  GAME_PASS_MONTHLY_COL_REBET_TYPE: "Rebet Type",
  GAME_PASS_MONTHLY_COL_REBET_ODDS: "Rebet Odds",
  GAME_PASS_MONTHLY_COL_SPORTS: "Sports",
  // FE-2582 Follower History (match Figma).
  GAME_PASS_MONTHLY_FOLLOWER_HISTORY: "Follower History",
  GAME_PASS_MONTHLY_FOLLOWERS: "Monthly Followers",
  GAME_PASS_MONTHLY_COL_USER_ID_OF_FOLLOW: "User ID of Follow",
  GAME_PASS_MONTHLY_COL_COUNTED_FOR_CURRENT_MONTH: "Counted for Current Month",
  // FE-2557 card header progress readout — mirrors the client widget's
  // "5/6 to next reward · Tier 1 of 3" so CS agents see the same numbers the
  // player does.
  GAME_PASS_MONTHLY_TO_NEXT_REWARD: "{count}/{threshold} to next reward",
  GAME_PASS_MONTHLY_TIER_OF: "Tier {current} of {total}",
  // FE-2590 Manual Pass modal — Edit steps vs Move to tier. Forward-only
  // (increment API); the last number on the stepper is the task's total steps.
  GAME_PASS_MONTHLY_EDIT_STEPS: "Edit steps",
  GAME_PASS_MONTHLY_MOVE_TO_TIER: "Move to tier",
  GAME_PASS_MONTHLY_MOVE_USER_PROGRESS_TO: "Move user progress to",
  GAME_PASS_MONTHLY_ADJUSTMENT_RANGE: "{from} → {to} (out of {total})",
  GAME_PASS_MONTHLY_TIER_NODE_LABEL: "Tier {tier} - {threshold}",
  GAME_PASS_MONTHLY_GRANTS_TIER: "Grants tier {tier}",
  GAME_PASS_MONTHLY_GRANTS_TIERS: "Grants tiers {from}–{to}",
  GAME_PASS_MONTHLY_DECREASE_STEPS: "Decrease steps",
  GAME_PASS_MONTHLY_INCREASE_STEPS: "Increase steps",
  GAME_PASS_MONTHLY_PROGRESS_REASON_PLACEHOLDER: "Completed but didn't register",
  // FE-2647 Login Streak monthly challenge (task type + User Manager history).
  GAME_PASS_MONTHLY_TASK_TYPE_LOGIN_STREAK: "Login Streak",
  GAME_PASS_MONTHLY_LOGIN_STREAK_INFO:
    "Players earn progress for the first login of each calendar day. Tiers are consecutive-day milestones — a missed day resets the streak.",
  GAME_PASS_MONTHLY_STREAK_RESET_HOUR_LABEL: "Daily reset hour (UTC)",
  GAME_PASS_MONTHLY_STREAK_RESET_HOUR_INFO:
    "Hour of day in UTC (0–23) when the login streak window resets. e.g. 21 is 9:00 PM UTC.",
  GAME_PASS_MONTHLY_STREAK_RESET_HOUR_PLACEHOLDER: "Select hour",
  GAME_PASS_MONTHLY_STREAK_RESET_HOUR_OPTION: "{hour}:00 UTC",
  GAME_PASS_MONTHLY_LOGIN_STREAK_HISTORY: "Login History",
  GAME_PASS_MONTHLY_LOGIN_STREAK_HISTORY_EMPTY: "No login history to show yet.",
  GAME_PASS_MONTHLY_COL_USERNAME: "Username",
  GAME_PASS_MONTHLY_COL_LOGIN_DATE: "Login Date",
  GAME_PASS_MONTHLY_COL_CONSECUTIVE_STREAK: "Consecutive Streak",
  GAME_PASS_MONTHLY_COL_STREAK_BROKEN_ON: "Streak Broken On",
  GAME_PASS_MONTHLY_DAYS_IN_A_ROW: "{count} days in a row",
  // FE-2663 Daily Login Challenge card (header, summary, history chrome).
  GAME_PASS_MONTHLY_DAILY_LOGIN_TITLE: "Daily Login Challenge",
  GAME_PASS_MONTHLY_DAILY_LOGIN_SUBTITLE:
    "Log in once per day — resets daily at {resetTime}",
  GAME_PASS_MONTHLY_DAILY_LOGIN_SUBTITLE_NO_TIME:
    "Log in once per day — resets daily",
  GAME_PASS_MONTHLY_LOGIN_TIME_LEFT_IN_WINDOW: "Time Left in Window",
  GAME_PASS_MONTHLY_LOGIN_CURRENT_STREAK: "Current Streak",
  GAME_PASS_MONTHLY_LOGIN_FIRST_LOGIN_THIS_MONTH: "First Login This Month",
  GAME_PASS_MONTHLY_LOGIN_STREAKS_BROKEN: "Streaks Broken",
  GAME_PASS_MONTHLY_LOGIN_DAYS: "{count} days",
  GAME_PASS_MONTHLY_LOGIN_SINCE: "Since {date}",
  GAME_PASS_MONTHLY_LOGIN_STREAK_CLOCK_STARTED: "Streak clock started",
  GAME_PASS_MONTHLY_LOGIN_LAST_BREAK: "Last break: {date}",
  GAME_PASS_MONTHLY_LOGIN_NOT_LOGGED_IN_YET: "Not logged in yet",
  GAME_PASS_MONTHLY_LOGIN_WINDOW_CLOSES: "closes {date}",
  GAME_PASS_MONTHLY_LOGIN_COUNTDOWN: "{hours}h {minutes}m",
  GAME_PASS_MONTHLY_LOGIN_COUNTDOWN_MINUTES: "{minutes}m",
  GAME_PASS_MONTHLY_LOGIN_TIME_LEFT: "{countdown} left",
  GAME_PASS_MONTHLY_LOGIN_EXPIRES_IN: "Expires in {countdown}",
  GAME_PASS_MONTHLY_LOGIN_WINDOW_CLOSED: "closed {date}",
  GAME_PASS_MONTHLY_LOGIN_CUT_IT_CLOSE: "cut it close",
  GAME_PASS_MONTHLY_LOGIN_LOGGED_IN_LEFT:
    "Logged in · {countdown} left in window",
  GAME_PASS_MONTHLY_LOGIN_WINDOW_BOUNDS: "{start} – {end}",
  GAME_PASS_MONTHLY_COL_LOGIN_DATE_TIME: "Login Date & Time",
  GAME_PASS_MONTHLY_COL_TYPE: "Type",
  GAME_PASS_MONTHLY_COL_COUNTS_TOWARD: "Counts Toward",
  GAME_PASS_MONTHLY_COL_CONSECUTIVE_DAYS: "Consecutive Days",
  GAME_PASS_MONTHLY_COL_TIME_LEFT_IN_WINDOW: "Time Left in Window",
  GAME_PASS_MONTHLY_COL_STATUS: "Status",
  GAME_PASS_MONTHLY_COL_STREAK_BROKEN: "Streak Broken",
  GAME_PASS_MONTHLY_COL_REWARD_HIT: "Reward Hit",
  GAME_PASS_MONTHLY_LOGIN_TYPE_LOGGED_IN: "Logged In",
  GAME_PASS_MONTHLY_LOGIN_TYPE_OPENED_GAME_PASS: "Opened Game Pass",
  GAME_PASS_MONTHLY_LOGIN_TYPE_ENROLLED: "Enrolled",
  GAME_PASS_MONTHLY_LOGIN_COUNTS_TOWARD: "{date} window",
  GAME_PASS_MONTHLY_LOGIN_STATUS_FIRST: "First login of month",
  GAME_PASS_MONTHLY_LOGIN_STATUS_CONTINUED: "Streak continued",
  GAME_PASS_MONTHLY_LOGIN_STATUS_RESTARTED: "Streak restarted",
  GAME_PASS_MONTHLY_LOGIN_STATUS_WINDOW_OPEN: "Window open",
  GAME_PASS_MONTHLY_LOGIN_LEGEND_STREAK_DAY: "Streak day",
  GAME_PASS_MONTHLY_LOGIN_LEGEND_WINDOW: "Window open / close call",
  GAME_PASS_MONTHLY_LOGIN_LEGEND_BROKEN: "Streak broken",
  GAME_PASS_MONTHLY_LOGIN_STREAK_BROKEN_ROW:
    "Streak broken — no login in the {date} window",
  GAME_PASS_MONTHLY_LOGIN_MISSED: "Missed {date}",
  GAME_PASS_MONTHLY_SEARCH_BY_DATE: "Search by date",
  GAME_PASS_MONTHLY_LOGIN_HISTORY_FOOTNOTE:
    "Each challenge day is a window from the configured reset time to the next. A day counts if the user signs in, opens Game Pass, or is credited on campaign enroll — whichever happens first in the window credits it, and the Type column shows which one did. Time Left in Window shows how much of that window was still remaining when the user logged in. If a window closes with no login, the streak breaks and the next login restarts it at 1.",
  USER_GAME_PASS_VIEW_TOGGLE_ARIA: "Game Pass view",

// =====================================================================
// Payments
// =====================================================================
PAYMENTS_ROUTING: "Routing",
AVERAGE_DEPOSIT: "Average Deposit",
TOTAL_PRIZE_REDEMPTIONS: "Total Prize Redemptions",
WITHDRAWALS: "Withdrawals",
PAYMENT_PROCESSOR: "Payment Processor",
FINIX: "Finix",
PAYMENT_IS_PROCESSED_BY: "Payment is processed by",
PRIZE_REDEMPTIONS: "Prize Redemptions",
DEPOSIT_ATTEMPTS: "Deposit Attempts",
PRIZE_REDEMPTION_MANUAL_REVIEW: "Prize Redemption Manual Review",
FINIX_DELAYED_PAYMENT: "Finix Delayed Payment",
DEPOSIT: "Deposit",
WITHDRAWAL: "Withdrawal",
MINIMUM_DEPOSIT_AMOUNT: "Minimum Deposit Amount",
MAXIMUM_DEPOSIT_AMOUNT: "Maximum Deposit Amount",
MINIMUM_WITHDRAWAL_AMOUNT: "Minimum Withdrawal Amount",
MAXIMUM_WITHDRAWAL_AMOUNT: "Maximum Withdrawal Amount",
MAXIMUM_DAILY_WITHDRAWALS: "Maximum Daily Withdrawals",
PAYMENTS_LIMITS_ZERO_MEANS_NO_LIMIT: "A value of 0 means there is no limit applied to this field.",
PAYMENTS_LIMITS_MAX_MUST_BE_GTE_MIN: "Maximum must be greater than or equal to the minimum.",
PAYMENTS_LIMITS_SAVE_SUCCESS: "Payment limits saved successfully.",
DEPOSIT_MATCH_PERCENTAGE: "Deposit Match Percentage",
MAX_DEPOSIT_MATCH_AMOUNT: "Max Deposit Match Amount",
MONTHLY_DEPOSIT_RATIO: "Monthly Deposit Ratio",
TOTAL_DEPOSIT_RATIO: "Total Deposit Ratio",
DEPOSITED: "DEPOSITED",
WITHDRAWN: "WITHDRAWN",
TOTAL_WITHDRAWN: "Total Withdrawn",
EDIT_USERNAMES_PAYMENT_METHODS: "Edit {username}'s Payment Methods",
WILL_ALLOW_YOURSELF_TO_LOSE_EACH_DAY: "will allow yourself to lose each day",
MAX_AMOUNT_OF_SECONDARY_CURRENCY_YOU_WILL_ALLOW_YOURSELF_TO_LOSE_EACH_DAY: "Max amount of Trivelta Coins you will allow yourself to lose each day",
MAX_AMOUNT_OF_PRIMARY_CURRENCY_YOU_WILL_ALLOW_YOURSELF_TO_LOSE_EACH_DAY: "Max amount of Trivelta Cash you will allow yourself to lose each day",
ACH_LAST_API_ERROR_MESSAGE: "There was an incredibly bad super terrible error with this process. Burn your computer.",
ACH_ON: "ACH On",
ACH_OFF: "ACH Off",
ACH_STATUS: "ACH Status",
FINIX_BANK_ACCOUNT: "Finix Bank Account",
PAYMENT_INSTRUMENTS: "Payment Instruments",
PAYMENT_DETAILS: "Payment Details",
PAYMENT_PROVIDER: "Payment provider",
PAYMENT_INSTRUMENT: "Payment Instrument",
PAYMENT_CEP_LINK: "CEP Link",
PAYMENT_BILLING_ADDRESS: "Billing Address",
PAYMENT_CLABE: "Clabe",
PAYMENT_DATE_ADDED: "Date Added",
PAYMENT_DATE_ADDED_TOOLTIP: "Date of when the payment method was added",
PAYMENT_USER_DETAILS: "User Details",
PAYMENT_STATUS_SUCCESSFUL: "Successful",
PAYMENT_STATUS_REFUNDED: "Refunded",
PAYMENT_COPY: "Copy",
PAYMENT_COPY_SUCCESS: "Copied to clipboard",
WITHDRAWAL_REVIEW_TITLE: "Withdrawal Review",
LAST_DEPOSIT_AMOUNT: "Last Deposit Amount",
WITHDRAWAL_AMOUNT: "Withdrawal Amount",
PAYMENT_GATEWAY: "Payment Gateway",
PAYMENT_TYPE: "Payment Type",
WITHDRAWAL_APPROVED: "Withdrawal Approved",
WITHDRAWAL_DECLINED: "Withdrawal Declined",
WITHDRAWAL_REFUND_ACTION: "Refund",
WITHDRAWAL_REFUND_MODAL_TITLE: "Refund Withdrawal",
WITHDRAWAL_REFUND_AMOUNT: "Refund Amount",
WITHDRAWAL_REFUND_AMOUNT_PLACEHOLDER: "Enter the amount to refund",
WITHDRAWAL_REFUND_AMOUNT_INVALID: "Enter an amount greater than 0 with no more than 2 decimal places.",
WITHDRAWAL_REFUND_AMOUNT_EXCEEDS_WITHDRAWAL: "Refund amount cannot exceed the withdrawal amount.",
WITHDRAWAL_REFUND_AMOUNT_UNAVAILABLE: "The withdrawal amount is unavailable. Close this dialog and refresh the withdrawal review.",
WITHDRAWAL_REFUND_NOTES: "Notes",
WITHDRAWAL_REFUND_NOTES_PLACEHOLDER: "Enter the reason for this refund",
WITHDRAWAL_REFUND_NOTES_REQUIRED: "Notes are required.",
WITHDRAWAL_REFUND_DISCLAIMER: "I understand the withdrawal will not be paid out and the held funds will leave the withdrawal flow. This action does not process a refund automatically. I must manually refund the deposits in the payment provider and manually credit any winnings difference back to the user's wallet.",
WITHDRAWAL_REFUND_SUCCESS: "Withdrawal marked for refund.",
WITHDRAWAL_EXPORT_TRUNCATED: "Export reached the 50,000 row limit. The downloaded file is incomplete.",
WITHDRAWAL_EXPORT_FAILED: "Failed to export withdrawal review data.",
DISPLAY_LOCATION_DEPOSIT: "Deposit",
DELAYED_PAYMENT: "Delayed Payment",
WITHDRAWALS_REVIEWED: "Withdrawals Reviewed",
NUMBER_OF_WITHDRAWALS_REVIEWED: "Number of Withdrawals Reviewed",
WITHDRAWALS_REVIEW: "Withdrawal Review",
TOTAL_WITHDRAWAL_AMOUNT_APPROVED: "Total Withdrawal Amount Approved",
NUMBER_OF_WITHDRAWALS_REVIEWED_SHORT: "# of Withdrawals Reviewed",
NUMBER_OF_WITHDRAWALS_APPROVED: "# of Withdrawals APPROVED",
NUMBER_OF_WITHDRAWALS_DECLINED: "# of Withdrawals Declined",
TOTAL_WITHDRAWAL_AMOUNT_REVIEWED: "Total Withdrawal Amount Reviewed",
EDIT_PAYMENT_INSTRUMENTS: "Edit Payment Instruments",
EDIT_USER_PAY_INSTRUMENTS: "Edit User Pay Instruments",
DEPOSIT_PAYMENT_OPTIONS: "Deposit Payment Options",
WITHDRAWAL_PAYMENT_OPTIONS: "Withdrawal Payment Options",
FIRST_TIME_WITHDRAWAL: "First Time Withdrawal",
FIRST_TIME_WITHDRAWAL_YES: "Yes",
FIRST_TIME_WITHDRAWAL_NO: "No",
CHARGEBACK_REPORTED_FINIX: "Chargeback reported - Finix",
FIRST_TIME_DEPOSITS: "First Time Deposits",
CARD_PAYMENTS: "Card Payments",
APPLE_PAY: "Apple Pay",
APPLE_PAY_ROUTING: "Apple Pay Routing",
ABOUT_PAYMENT_TYPE: "About payment type",
COMPLETE_PAYMENT_BEFORE_ADDING: "Complete Payment before adding the affiliate.",
PAYMENT_PER_ACTION: "Payment per Action",
TOTAL_DEPOSITS: "Total Deposits",
TOTAL_WITHDRAWALS: "Total Withdrawals",
DEPOSITS: "Deposits",
DEPOSIT_AMOUNT: "Deposit Amount",
PAYMENT_REPORTS: "Payment Reports",
PAYMENT_RAW_STATUS: "Raw Status",
PAYMENTS_TRANSACTIONS_EXPORT_START_ERROR: "Unable to start the transactions export. Please try again.",
PAYMENTS_TRANSACTIONS_EXPORT_FAILED_DEFAULT: "The transactions export failed.",
PAYMENTS_TRANSACTIONS_EXPORT_TIMEOUT: "The transactions export is taking too long. Please try again.",
TOTAL_DEPOSIT_AMOUNT: "Total Deposit Amount",
TOTAL_NUMBER_OF_DEPOSITS: "Total Number of Deposits",
TOTAL_NUMBER_OF_WITHDRAWALS: "Total Number of Withdrawals",
TOTAL_WITHDRAWAL_AMOUNT: "Total Withdrawal Amount",
FRAUD_DETECTION: "Fraud Detection",
OVERVIEW_ACTIVE_DEPOSIT_USERS: "TOTAL ACTIVE USERS (DEPOSIT)",
OVERVIEW_DEPOSIT_AMOUNT: "DEPOSIT AMOUNT",
OVERVIEW_WITHDRAWAL_AMOUNT: "WITHDRAWAL AMOUNT",
BLOCK_WITHDRAWALS: "Block Withdrawals",
BLOCK_WITHDRAWALS_UPDATED: "Block Withdrawals updated.",
BLOCK_WITHDRAWALS_UPDATE_FAILED: "Failed to update Block Withdrawals. Please try again.",
PAYMENTS: "Payments",
PAYMENT_USERNAME_PAYMENTS: "{username}'s Payments",
PAYMENT_SEARCH_PAYMENTS: "Search payments...",
PAYMENT_MIN_PAYMENT: "Min payment",
PAYMENT_MAX_PAYMENT: "Max payment",
PAYMENT_DIRECTION_FILTER: "Deposit / Withdrawal",
APPLE_PAY_ROUTING_BOTH_MATCH: "both match",
APPLE_PAY_ROUTING_DESCRIPTION: "Each provider processes purchases in its amount range. Turn one off and the adjacent provider absorbs its range.",
APPLE_PAY_ROUTING_DISCARD: "Discard",
APPLE_PAY_ROUTING_EMPTY: "No providers available for routing.",
APPLE_PAY_ROUTING_FILL_ALL_RANGES: "Please set an amount range for all enabled providers.",
APPLE_PAY_ROUTING_GAPS_BLOCK_SAVE: "Please close the coverage gaps between provider ranges before saving.",
APPLE_PAY_ROUTING_GAP_BETWEEN: "No provider covers deposits between",
APPLE_PAY_ROUTING_GAP_FIX: "adjust the ranges to close the gap",
APPLE_PAY_ROUTING_INVALID_BLOCK_SAVE: "Please fix the invalid provider ranges before saving.",
APPLE_PAY_ROUTING_INVALID_RANGE: "minimum must be less than or equal to maximum",
APPLE_PAY_ROUTING_LOAD_ERROR: "Failed to load Apple Pay routing settings.",
APPLE_PAY_ROUTING_POSITIVE_AMOUNTS: "Please use amounts greater than zero for all enabled providers.",
APPLE_PAY_ROUTING_ROUTES: "Routes",
APPLE_PAY_ROUTING_SAVE_ERROR: "Failed to save Apple Pay routing settings.",
APPLE_PAY_ROUTING_SAVE_SUCCESS: "Apple Pay routing settings saved successfully.",
APPLE_PAY_ROUTING_UNSAVED_CHANGES: "Unsaved changes",
APPLE_PAY_ROUTING_WINS_OVERLAP: "wins the overlap",
FINANCIALS_DEPOSITS_BY_PLATFORM_EMPTY_STATE: "No deposit data for the selected date range.",
FINANCIALS_DEPOSITS_BY_PLATFORM_LOAD_ERROR: "Failed to load deposits by platform. Please try again later.",
PAYMENT_ROUTING: "Payment Routing",
RULES_VERSIONS_SUMMARY_FIRST_TIME_WITHDRAWAL_DETAIL: "Trigger on the user's first withdrawal",
RULES_VERSIONS_SUMMARY_SAME_INSTRUMENT_X_TIMES_DETAIL: "Auto-approve if same instrument used ≥ {uses} times in the last {within} {period}",
RULES_VERSIONS_SUMMARY_WITHDRAWALS_SINCE_DEPOSIT_DETAIL: "Trigger after {withdrawals} withdrawals since last deposit",
RULES_VERSIONS_SUMMARY_WITHDRAWAL_PER_DAY_DETAIL: "Trigger if {threshold} withdrawals in {days} days",
RULES_VERSIONS_SUMMARY_X_TIMES_LAST_DEPOSIT_DETAIL: "Trigger if withdrawal ≥ {multiplier}× last deposit",
THRESHOLD_APPLIES_TO_DEPOSIT_WAGER_WITHDRAWAL: "Threshold (applies to deposit, wager & withdrawal)",
TIER_1_RULE_FIRST_TIME_WITHDRAWAL_DESCRIPTION: "Flag the first time withdrawal of any user",
TIER_1_RULE_FIRST_TIME_WITHDRAWAL_NAME: "First Time Withdrawal",
TIER_1_RULE_WITHDRAWALS_SINCE_DEPOSIT_DESCRIPTION: "Flag once the set number of withdrawals since the user's last deposit is exceeded.",
TIER_1_RULE_WITHDRAWALS_SINCE_DEPOSIT_LABEL: "Withdrawals",
TIER_1_RULE_WITHDRAWALS_SINCE_DEPOSIT_NAME: "Withdrawals since last deposit",
TIER_1_RULE_WITHDRAWALS_SINCE_DEPOSIT_PLACEHOLDER: "5",
TIER_1_RULE_WITHDRAWAL_PER_DAY_DESCRIPTION: "Flag when daily withdrawals exceed a threshold across a rolling day window.",
TIER_1_RULE_WITHDRAWAL_PER_DAY_LABEL: "Number of days",
TIER_1_RULE_WITHDRAWAL_PER_DAY_NAME: "Withdrawal per day for X days",
TIER_1_RULE_WITHDRAWAL_PER_DAY_PLACEHOLDER: "14 days",
TIER_1_RULE_WITHDRAWAL_PER_DAY_THRESHOLD_LABEL: "Threshold",
TIER_1_RULE_WITHDRAWAL_PER_DAY_THRESHOLD_PLACEHOLDER: "5",
TIER_1_RULE_X_TIMES_LAST_DEPOSIT_DESCRIPTION: "Flag when a withdrawal is a multiple of the users most recent deposit.",
TIER_1_RULE_X_TIMES_LAST_DEPOSIT_LABEL: "Multiplier",
TIER_1_RULE_X_TIMES_LAST_DEPOSIT_NAME: "Withdrawal is X times the last deposit",
TIER_1_RULE_X_TIMES_LAST_DEPOSIT_PLACEHOLDER: "5",
TIER_1_ALL_ON: "All On",
TIER_1_COLUMN_CONFIGURATION: "Configuration",
TIER_1_COLUMN_RULE: "Rule",
TIER_1_COLUMN_STATUS: "Status",
TIER_1_RULE_MAX_AMOUNT_DESCRIPTION: "Flag if withdrawal exceeds set level.",
TIER_1_RULE_MAX_AMOUNT_LABEL: "Maximum Amount",
TIER_1_RULE_MAX_AMOUNT_NAME: "Maximum Transaction Amount",
TIER_1_RULE_MAX_AMOUNT_NUMBER_PLACEHOLDER: "Numbers",
TIER_1_RULE_MAX_AMOUNT_PERIOD_PLACEHOLDER: "Period",
TIER_1_RULE_TOGGLE_ARIA: "Enable rule",
TIER_1_TO_TIER_2_CONNECTOR: "Flagged by Tier one rule, reviewed against Tier 2 rules",
TIER_1_TO_TIER_2_CONNECTOR_ARROW_LABEL: "Flow continues to Tier 2",
TIER_1_TRIGGER_RULES_SUBTITLE: "If flagged, the withdrawal will move to Tier 2",
TIER_1_TRIGGER_RULES_TITLE: "Tier 1 - Trigger Rules",
TIER_1_TRIGGER_RULES_TOOLTIP: "Configure the triggers that flag a withdrawal for manual review. If any enabled rule matches, the withdrawal is sent to Tier 2.",
TIER_1_TRIGGER_RULES_TOOLTIP_LABEL: "About Tier 1 Trigger Rules",
TIER_2_ALL_ON: "All On",
TIER_2_AUTO_APPROVE_SUBTITLE: "Flagged withdrawals that get approved by these set of rules will be auto-passed",
TIER_2_AUTO_APPROVE_TITLE: "Tier 2 - Auto Approve",
TIER_2_AUTO_APPROVE_TOOLTIP: "Configure auto-approval rules. Withdrawals flagged by Tier 1 that match any enabled Tier 2 rule are auto-approved without manual review.",
TIER_2_AUTO_APPROVE_TOOLTIP_LABEL: "About Tier 2 Auto Approve",
TIER_2_LOCKED_BY_TIER_1_MESSAGE: "Enable at least one Tier 1 rule before activating Tier 2 auto-approve.",
TIER_2_RULE_MIN_ACCOUNT_AGE_DESCRIPTION: "Auto-approve when the player's account is at least this many days old.",
TIER_2_RULE_MIN_ACCOUNT_AGE_LABEL: "Minimum age (days)",
TIER_2_RULE_MIN_ACCOUNT_AGE_NAME: "Minimum account age",
TIER_2_RULE_MIN_ACCOUNT_AGE_PLACEHOLDER: "30",
TIER_2_RULE_REVIEWED_X_TIMES_DESCRIPTION: "Auto-approve when already manually approved this many times in the window without a decline.",
TIER_2_RULE_REVIEWED_X_TIMES_NAME: "Approved X times within Y time frame",
TIER_2_RULE_REVIEWED_X_TIMES_REVIEWS_LABEL: "Reviews",
TIER_2_RULE_REVIEWED_X_TIMES_REVIEWS_PLACEHOLDER: "10",
TIER_2_RULE_SAME_INSTRUMENT_WINDOW_DESCRIPTION: "Auto-approve when the same instrument completed a successful withdrawal inside this window.",
TIER_2_RULE_SAME_INSTRUMENT_WINDOW_LABEL: "Time Period",
TIER_2_RULE_SAME_INSTRUMENT_WINDOW_NAME: "Same Payment instrument within X time period",
TIER_2_RULE_SAME_INSTRUMENT_WINDOW_PLACEHOLDER: "30",
TIER_2_RULE_SAME_INSTRUMENT_X_TIMES_DESCRIPTION: "Auto-approve when the same payment instrument has been used successfully this many times in the window.",
TIER_2_RULE_SAME_INSTRUMENT_X_TIMES_NAME: "Same payment instrument used X times within Y time frame",
TIER_2_RULE_SAME_INSTRUMENT_X_TIMES_USES_LABEL: "Successful Uses",
TIER_2_RULE_SAME_INSTRUMENT_X_TIMES_USES_PLACEHOLDER: "10",
TIER_2_RULE_TOGGLE_ARIA: "Enable auto-approve rule",
TIER_2_RULE_VIP_MATCHING_DESCRIPTION: "Auto-approve when the player is a VIP and the instrument matches a prior successful redemption.",
TIER_2_RULE_VIP_MATCHING_NAME: "VIP player with matching payment instrument",
TIER_2_RULE_WITHIN_LABEL: "Within",
TIER_2_RULE_WITHIN_PLACEHOLDER: "14",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_NAME: "Deposit history by payment instrument",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_DESCRIPTION: "Auto-approve when all successful deposits in the lookback period used SPEI.",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_INSTRUMENT_LABEL: "Payment instrument",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_SPEI_VALUE: "SPEI",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_PERIOD_LABEL: "Time period",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_PERIOD_PLACEHOLDER: "Select a time period",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_24_HOURS: "24 hours",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_7_DAYS: "7 days",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_30_DAYS: "30 days",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_90_DAYS: "90 days",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_FORMAT: "{count} {period}",
WITHDRAWAL_TIER_2_PAYMENT_INSTRUMENT_LOOKBACK_SUMMARY_DETAIL: "Auto-approve when SPEI was the sole successful deposit payment instrument in the last {lookback}",

  // =====================================================================
  // Peer to peer
  // =====================================================================
  P2P_WINS: "p2p Wins",
  CREATE_TASK_SOCIAL_TASK_TYPE_P2P_WINS: "P2P Wins",
  PEER: "Peer",

  // =====================================================================
  // Pikkem
  // =====================================================================
  PIKKEM_CASH: "Pikkem Cash",
  PIKKEM: "Pikkem",
  PIKKEM_REDEEMABLE: "Pikkem Redeemable",
  PIKKEM_BETS: "Pikkem Bets",

  // =====================================================================
  // Poker
  // =====================================================================
  USER_POKER_GAMES: "User's Poker Games",
  SEARCH_BY_POKER_GAME_ID: "Search by Poker Game ID",
  USERNAME_POKER_GAMES: "{username}'s Poker Games",
  POKER: "Poker",
  // Sidebar labels for the Poker → Configuration pages. English must stay in
  // sync with `title` in poker/pokerConfigurationData.ts, which still feeds
  // the page headings and breadcrumbs.
  POKER_CASH_GAME_LIMITS: "Cash Game Limits",
  POKER_PRIVATE_GAMES: "Private Games",
  POKER_TOURNAMENTS: "Tournaments",
  POKER_TIMEBANK: "Timebank",
  POKER_FEATURES: "Features",
  POKER_CONFIG_COMING_SOON: "Coming soon",
  POKER_CASH_GAME_TABLE_SIZE: "Table Size",
  POKER_CASH_GAME_MAX_SEATS: "Maximum Number of Seats",
  POKER_CASH_GAME_MIN_PLAYERS: "Minimum Players to Start",
  POKER_CASH_GAME_STAKES: "Stakes",
  POKER_CASH_GAME_SMALL_BLIND: "Small Blind",
  POKER_CASH_GAME_BIG_BLIND: "Big Blind",
  POKER_CASH_GAME_BUY_IN: "Buy In",
  POKER_CASH_GAME_MIN_BUY_IN_MULTIPLIER: "Minimum Buy In Multiplier",
  POKER_CASH_GAME_MAX_BUY_IN_MULTIPLIER: "Maximum Buy In Multiplier",
  POKER_CASH_GAME_MIN_BUY_IN_HINT: "x of big blind",
  POKER_CASH_GAME_MAX_BUY_IN_HINT: "x of big blind",
  POKER_CASH_GAME_TABLE_PACING: "Table Pacing",
  POKER_CASH_GAME_GAME_START_DELAY: "Game Start Delay",
  POKER_CASH_GAME_HAND_START_DELAY: "Hand Start Delay",
  POKER_CASH_GAME_SECONDS_HINT: "seconds",
  POKER_CASH_GAME_RAKE: "Rake",
  POKER_CASH_GAME_RAKE_PERCENTAGE: "Rake Percentage",
  POKER_CASH_GAME_RAKE_PERCENT_HINT: "% of pot",
  POKER_CASH_GAME_RAKE_CAP: "Rake Cap",
  POKER_CASH_GAME_NO_FLOP_NO_DROP: "No Flop, No Drop",
  POKER_CASH_GAME_NO_FLOP_NO_DROP_HINT: "Waive the rake on hands that end before the flop",
  POKER_CASH_GAME_CURRENCY: "Currency",
  POKER_CASH_GAME_CURRENCY_CASH: "Cash",
  POKER_CASH_GAME_CURRENCY_COIN: "Coin",
  POKER_CASH_GAME_VISIBILITY: "Visibility",
  POKER_CASH_GAME_VISIBILITY_PUBLIC: "Public",
  POKER_CASH_GAME_VISIBILITY_PRIVATE: "Private",
  POKER_CASH_GAME_SWITCH_BLOCKED: "Save or discard your changes before switching configurations.",
  POKER_CASH_GAME_STEP_UP: "Increase",
  POKER_CASH_GAME_STEP_DOWN: "Decrease",
  POKER_CASH_GAME_VERSION: "Version",
  POKER_CASH_GAME_LAST_UPDATED: "Last updated",
  POKER_CASH_GAME_ENVIRONMENT: "Environment",
  POKER_CASH_GAME_UNSAVED_CHANGES: "Unsaved changes",
  POKER_CASH_GAME_DISCARD: "Discard",
  POKER_CASH_GAME_LOAD_ERROR: "Failed to load the cash game configuration.",
  POKER_CASH_GAME_LOAD_ERROR_HINT: "Fields are shown blank until the current values can be loaded.",
  POKER_CASH_GAME_TRY_AGAIN: "Try again",
  POKER_CASH_GAME_SAVE_SUCCESS: "Cash game configuration saved.",
  POKER_CASH_GAME_SAVE_ERROR: "Failed to save the cash game configuration.",
  POKER_CASH_GAME_REQUIRED: "Required",
  POKER_CASH_GAME_NUMBER: "Must be a number",
  POKER_CASH_GAME_POSITIVE: "Must be greater than 0",
  POKER_CASH_GAME_NON_NEGATIVE: "Must be 0 or greater",
  POKER_CASH_GAME_INTEGER: "Must be a whole number",
  POKER_CASH_GAME_BIG_BLIND_RATIO_RULE: "Big blind must be between 2x and 3x the small blind",
  POKER_CASH_GAME_TWO_DECIMALS: "Use at most 2 decimal places",
  POKER_CASH_GAME_BUY_IN_RULE: "Minimum buy-in multiplier cannot exceed the maximum",
  POKER_CASH_GAME_MIN_BUY_IN_FLOOR_RULE: "Minimum buy-in must be at least 20 big blinds",
  POKER_CASH_GAME_MAX_BUY_IN_CEILING_RULE: "Maximum buy-in cannot exceed 250 big blinds",
  POKER_CASH_GAME_MIN_PLAYERS_RULE: "Minimum players cannot exceed the maximum number of seats",
  POKER_CASH_GAME_PERCENT_RANGE: "Must be between 0 and 100",

  // =====================================================================
  // Predictions
  // =====================================================================
  PREDICTIONS: "Predictions",
  PREDICTION_CASH: "Prediction Cash",
  PREDICTION_REDEEMABLE: "Redeemable Prediction Cash",

  // =====================================================================
  // Profile
  // =====================================================================
  CHECK_USERS_PROFILE: "Check User's Profile",
  DISPLAY_LOCATION_PROFILE: "Profile",
  PROFILE_CONFIGURATION_PAGE_TITLE: "Profile",
  PROFILE_USERS_REFERRED: "Users Referred",
  PROFILE_VIEW_REFERRED_USERS: "View referred users",
  SELF_EXCLUSION: "Self Exclusion",
  NEW_AFFILIATE_CONFIRMATION_GO_TO_PROFILE: "Go to affiliate detail",
  SHARE_AFFILIATE_PROFILE_LABEL: "Affiliate Profile:",

  // =====================================================================
  // KYC
  // =====================================================================
  PLAID_STATUS_BY_DAY: "KYC Status By Day",
  PLAID_STATUS: "KYC Status",
  KYC_CHECKPOINTS_DEPOSIT: "Deposit",
  KYC_CHECKPOINTS_WITHDRAWAL: "Withdrawal",
  EMAIL_VERIFICATIONS_BY_DAY: "Email Verifications By Day",
  EMAIL_VERIFICATIONS: "Email Verifications",
  PLAID_VERIFICATIONS: "KYC Verifications",
  KYC: "KYC",
  SEND_VERIFICATION_EMAIL: "Send Verification Email",
  KYC_NAME: "KYC Name",
  KYC_MANUAL_PASS: "KYC Manual Pass",
  SEND_VERIFICATION_EMAIL_MESSAGE: "Send an email to this user asking them to verify their account?",
  EMAIL_VERIFICATION_SENT_SUCCESSFULLY: "Email verification sent successfully",
  KYC_FAILURE: "KYC failure",
  KYC_CONFIGURATION: "KYC Configuration",
  KYC_CHECKPOINTS: "KYC Checkpoints",
  KYC_CHECKPOINTS_CHECKPOINT_ID: "Checkpoint ID",
  KYC_CHECKPOINTS_ENABLED: "Enabled",
  KYC_CHECKPOINTS_FEATURE_DISABLED: "The SURT checkpoints feature is turned off, so this change was not saved.",
  KYC_CHECKPOINTS_FEATURE_DISABLED_NOTICE: "SURT checkpoints are turned off for this environment.",
  KYC_CHECKPOINTS_FLOW: "Flow",
  KYC_CHECKPOINTS_ID_REQUIRED: "Enter a Checkpoint ID before enabling this flow.",
  KYC_CHECKPOINTS_LOAD_ERROR: "Could not load KYC checkpoints.",
  KYC_CHECKPOINTS_ONBOARDING: "Onboarding",
  KYC_CHECKPOINTS_RETRY: "Retry",
  KYC_CHECKPOINTS_SAVE_ERROR: "Could not save checkpoint.",
  KYC_CHECKPOINTS_SAVE_SUCCESS: "Checkpoint updated.",
  KYC_CHECKPOINTS_SIGN_IN: "Sign In",
  KYC_CHECKPOINTS_SURT_DISABLED: "SURT is turned off for this environment, so KYC checkpoints are unavailable.",
  KYC_STATUS: "KYC Status",
  KYC_DUPLICATE_IDENTITY_REVIEW_TITLE: "Duplicate Identity Review",
  KYC_DUPLICATE_IDENTITY_PENDING_TAB: "Pending Review",
  KYC_DUPLICATE_IDENTITY_ACTIONED_TAB: "Actioned",
  KYC_DUPLICATE_IDENTITY_TENANT: "Tenant",
  KYC_DUPLICATE_IDENTITY_DUP_TYPE: "Duplicate type",
  KYC_DUPLICATE_IDENTITY_CLASSIFICATION: "Classification",
  KYC_DUPLICATE_IDENTITY_GROUP_SIZE: "Group size",
  KYC_DUPLICATE_IDENTITY_DETECTED_AT: "Detected at",
  KYC_DUPLICATE_IDENTITY_STATUS: "Status",
  KYC_DUPLICATE_IDENTITY_LOAD_ERROR: "Could not load duplicate identity groups.",
  KYC_DUPLICATE_IDENTITY_DETAIL_LOAD_ERROR:
    "Could not load duplicate identity group details.",
  KYC_DUPLICATE_IDENTITY_EMPTY: "No duplicate identity groups found.",
  KYC_DUPLICATE_IDENTITY_MEMBER_IDS: "Member user IDs",
  KYC_DUPLICATE_IDENTITY_PROPOSED_SURVIVOR: "Proposed survivor",
  KYC_DUPLICATE_IDENTITY_PROPOSED_SURVIVOR_HINT:
    "Proposed only — confirmed after a merge dry-run or execution.",
  KYC_DUPLICATE_IDENTITY_NEVER_CLOBBER_TITLE: "Never-clobber fields",
  KYC_DUPLICATE_IDENTITY_NEVER_CLOBBER_BODY:
    "curp, rfc, surt_first_name, surt_last_name, email, and phone_number already set on the survivor are never overwritten by a losing row.",
  KYC_DUPLICATE_IDENTITY_NOTES: "Notes",
  KYC_DUPLICATE_IDENTITY_MARK_SUPPORT_CONTACTED: "Mark support-contacted",
  KYC_DUPLICATE_IDENTITY_ESCALATE: "Escalate",
  KYC_DUPLICATE_IDENTITY_IGNORE: "Ignore",
  KYC_DUPLICATE_IDENTITY_RUN_MERGE_DRY_RUN: "Run merge dry-run",
  KYC_DUPLICATE_IDENTITY_UPDATE_SUCCESS: "Group updated.",
  KYC_DUPLICATE_IDENTITY_UPDATE_ERROR: "Could not update group.",
  KYC_DUPLICATE_IDENTITY_MERGE_DRY_RUN_SUCCESS: "Merge dry-run queued.",
  KYC_DUPLICATE_IDENTITY_MERGE_DRY_RUN_ERROR: "Could not queue merge dry-run.",
  KYC_DUPLICATE_IDENTITY_CORRELATION_ID: "Correlation ID",
  KYC_DUPLICATE_IDENTITY_CHECK_BACK_LATER:
    "Check back later for dry-run results using this correlation ID.",
  KYC_DUPLICATE_IDENTITY_DUP_TYPE_PHONE_RAW: "Phone (raw)",
  KYC_DUPLICATE_IDENTITY_DUP_TYPE_PHONE_NORMALIZED: "Phone (normalized)",
  KYC_DUPLICATE_IDENTITY_DUP_TYPE_EMAIL_CASE_FOLDED: "Email (case-folded)",
  KYC_DUPLICATE_IDENTITY_DUP_TYPE_F9_MALFORMED: "F9 malformed",
  KYC_DUPLICATE_IDENTITY_CLASSIFICATION_MERGE_CANDIDATE: "Merge candidate",
  KYC_DUPLICATE_IDENTITY_CLASSIFICATION_SUPPORT_CONTACT: "Support contact",
  KYC_DUPLICATE_IDENTITY_CLASSIFICATION_F9_MANUAL: "F9 manual",
  KYC_DUPLICATE_IDENTITY_STATUS_PENDING_REVIEW: "Pending review",
  KYC_DUPLICATE_IDENTITY_STATUS_DRY_RUN_PLANNED: "Dry-run planned",
  KYC_DUPLICATE_IDENTITY_STATUS_MERGED: "Merged",
  KYC_DUPLICATE_IDENTITY_STATUS_SUPPORT_CONTACTED: "Support contacted",
  KYC_DUPLICATE_IDENTITY_STATUS_ESCALATED: "Escalated",
  KYC_DUPLICATE_IDENTITY_STATUS_IGNORED: "Ignored",

  // =====================================================================
  // Compliance
  // =====================================================================
  COMPLIANCE_REGULATORS: "Regulators",
  COMPLIANCE_REGULATORS_NEW: "New Regulator",
  COMPLIANCE_REGULATORS_SEARCH: "Search by email or name",
  COMPLIANCE_REGULATORS_EMPTY: "No regulators yet.",
  COMPLIANCE_REGULATORS_LOAD_ERROR: "Could not load regulators.",
  COMPLIANCE_REGULATOR_LOADING: "Loading…",
  COMPLIANCE_REGULATORS_NOT_ALLOWED: "You don't have access to this action.",
  COMPLIANCE_REGULATOR_PROFILE: "Regulator",
  COMPLIANCE_REGULATOR_BACK: "Back to regulators",
  COMPLIANCE_REGULATOR_GIVEN_NAME: "Given name",
  COMPLIANCE_REGULATOR_FAMILY_NAME: "Family name",
  COMPLIANCE_REGULATOR_TIMEZONE: "Timezone",
  COMPLIANCE_REGULATOR_WHITELISTED_IPS: "Whitelisted IPs",
  COMPLIANCE_REGULATOR_WHITELISTED_IPS_PLACEHOLDER: "192.0.2.1, 2001:db8::1",
  COMPLIANCE_REGULATOR_WHITELISTED_IPS_HELP:
    "Optional. Separate with commas or new lines.",
  COMPLIANCE_REGULATOR_WHITELISTED_IPS_INVALID:
    "Enter valid IP addresses.",
  COMPLIANCE_REGULATOR_STATUS_PENDING: "Pending",
  COMPLIANCE_REGULATOR_STATUS_APPROVED: "Approved",
  COMPLIANCE_REGULATOR_APPROVE: "Approve",
  COMPLIANCE_REGULATOR_REVOKE: "Revoke",
  COMPLIANCE_REGULATOR_SUBMIT: "Create regulator",
  COMPLIANCE_REGULATOR_LOAD_ERROR: "Could not load this regulator.",
  COMPLIANCE_REGULATOR_CREATE_SUCCESS: "Regulator created.",
  COMPLIANCE_REGULATOR_CREATE_ERROR: "Could not create the regulator.",
  COMPLIANCE_REGULATOR_APPROVE_SUCCESS: "Regulator approved.",
  COMPLIANCE_REGULATOR_REVOKE_SUCCESS: "Regulator access revoked.",
  COMPLIANCE_REGULATOR_ACTION_ERROR: "Could not update this regulator.",
  COMPLIANCE_REGULATOR_VALIDATION_REQUIRED_GIVEN_NAME: "Given name is required.",
  COMPLIANCE_REGULATOR_VALIDATION_REQUIRED_FAMILY_NAME:
    "Family name is required.",
  COMPLIANCE_REGULATOR_VALIDATION_REQUIRED_TIMEZONE: "Timezone is required.",

  // =====================================================================
  // Wallet
  // =====================================================================
  SECONDARY_CURRENCY: "Coin",
  TOTAL_APP_FREE_CASH_BETS: "Total trivelta free cash bets",
  TOTAL_APP_FREE_CASH_WAGERED: "Total trivelta free cash wagered",
  TOTAL_APP_CASH_BALANCE: "Total trivelta cash balance",
  AMOUNT_OF_APP_FREE_CASH_WAGERED: "Amount Of Trivelta Free Cash Wagered",
  AMOUNT_OF_PRIMARY_CURRENCY_WAGERED_ON_PROFIT_BOOST: "Amount Of Trivelta Cash Wagered On Profit Boost",
  SECONDARY_CURRENCY_ONLY: "Coins only",
  PRIMARY_CURRENCY_ONLY: "Cash only",
  PRIMARY_CURRENCY_AND_SECONDARY_CURRENCY: "Cash & Coins",
  TOTAL_PRIMARY_CURRENCY_ADDED: "Total Trivelta Cash Added",
  TOTAL_PRIMARY_CURRENCY_SUBTRACTED: "Total Trivelta Cash Subtracted",
  TOTAL_APP_FREE_CASH_ADDED: "Total Trivelta Free Cash Added",
  TOTAL_PRIMARY_CURRENCY_BALANCE: "Total Trivelta Cash Balance",
  NON_WAGERED_PRIMARY_CURRENCY: "Non-wagered Trivelta Cash",
  REDEEMABLE_PRIMARY_CURRENCY: "Redeemable Trivelta Cash",
  GO_TO_WALLET: "Go to Wallet",
  SECONDARY_CURRENCY_VALIDATION: "Trivelta Coins value must be between {min} and {max}",
  PRIMARY_CURRENCY_VALIDATION: "Trivelta Cash value must be between {min} and {max}",
  EDIT_WALLET: "Edit Wallet",
  WALLET: "Wallet",
  PRIMARY_CURRENCY_BALANCE: "Trivelta Cash Balance",
  REDEEMABLE_PRIMARY_CURRENCY_BALANCE: "Redeemable Trivelta Cash Balance",
  EDIT_WALLET_USERNAME: "Edit {username}'s Wallet",
  PRIMARY_CURRENCY: "Trivelta Cash",
  FREE_PRIMARY_CURRENCY: "Free Trivelta Cash",
  WALLET_USERNAME: "{username}'s Wallet",
  SECONDARY_CURRENCY_PER_DAY: "Trivelta Coin per Day",
  PRIMARY_CURRENCY_PER_DAY: "Trivelta Cash per Day",
  MAX_PRIMARY_CURRENCY_BONUS_PER_DAY: "Max Trivelta Cash bonus per day",
  MAX_AMOUNT_OF_SECONDARY_CURRENCY_YOU: "Max amount of Trivelta Coins you",
  MAX_AMOUNT_OF_PRIMARY_CURRENCY_YOU: "Max amount of Trivelta Cash you",
  MAX_PURCHASE_AMOUNT_OF_SECONDARY_CURRENCY_CAN_BE_WAGERED_PER_DAY: "Max purchase amount of Trivelta Coins can be wagered per day",
  MAX_AMOUNT_OF_PRIMARY_CURRENCY_CAN_BE_WAGERED_PER_DAY: "Max amount of Trivelta Cash can be wagered per day",
  MAX_PURCHASE_AMOUNT_OF_SECONDARY_CURRENCY_PER_DAY: "Max purchase amount of Trivelta Coins per day",
  WALLET_UPDATED_SUCCESSFULLY: "Wallet updated successfully.",
  TO_USER_WALLET: "To user wallet",
  FAILED_TO_LOAD_WALLET_GRAPH: "Failed to load wallet graph.",
  WALLET_7D_CHANGE_TOOLTIP: "The percent change metric compares the current user wallet amount against the amount 7 days in the past.",

};

const setAppString = (value: InterfaceAppString) => {
  if (value) {
    AppStrings = {
      ...AppStrings,
      ...value,
    };
  }
};

export { AppStrings, setAppString };
